export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Json: { input: any; output: any; }
  Upload: { input: File; output: File; }
};

/** Autogenerated return type of AcceptLineItems. */
export type AcceptLineItemsPayload = {
  __typename?: 'AcceptLineItemsPayload';
  orders?: Maybe<Array<Order>>;
};

/** Autogenerated return type of AcceptOfferAsSupplier. */
export type AcceptOfferAsSupplierPayload = {
  __typename?: 'AcceptOfferAsSupplierPayload';
  /** The counter offer that was accepted */
  counterOffer?: Maybe<Offer>;
  /** What went wrong when accepting the counter offer */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Fields available on an account statement */
export type AccountStatement = {
  __typename?: 'AccountStatement';
  /** The company that made the transaction */
  company?: Maybe<Company>;
  /** The contact involved in the transaction */
  contact?: Maybe<Contact>;
  /** Unique payment identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** Object containing information on the document generated for this account statement */
  templateOutput?: Maybe<TemplateOutput>;
};

export type AccountingExport = {
  __typename?: 'AccountingExport';
  /** Errors that occurred during the export for individual invoices */
  exportErrors?: Maybe<Array<AccountingExportError>>;
  /** File attached to the accounting export */
  exportFile: Document;
  /** Status of the accounting export */
  exportStatus: Scalars['String']['output'];
  /** Date and time the accounting export was exported */
  exportedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the accounting export */
  id: Scalars['ID']['output'];
  /** Invoices attached to the accounting export */
  invoices: Array<Invoice>;
  /** User who exported the accounting export */
  user: User;
};

/** Errors that occurred during the accounting export */
export type AccountingExportError = {
  __typename?: 'AccountingExportError';
  /** Error message describing what went wrong */
  errorMessage: Scalars['String']['output'];
  /** Type of error that occurred during accounting export */
  errorType: AccountingExportErrorTypeEnum;
  /** Unique identifier for the invoice */
  invoiceId: Scalars['ID']['output'];
  /** Number of the invoice */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
};

/** Type of error that occurred during accounting export */
export enum AccountingExportErrorTypeEnum {
  /** Error related to customer data or configuration */
  Customer = 'CUSTOMER',
  /** Error related to inventory data or configuration */
  Inventory = 'INVENTORY',
  /** Non-blocking warning: a vendor invoice line exported without a short code suffix */
  VendorCodeMissing = 'VENDOR_CODE_MISSING',
  /** Error related to Pastel detail line description configuration or length */
  Description = 'DESCRIPTION',
  /** Non-blocking warning: a description template variable had no source value on the invoice */
  DescriptionDataMissing = 'DESCRIPTION_DATA_MISSING',
  /** Error related to Pastel exchange rate configuration */
  ExchangeRate = 'EXCHANGE_RATE',
  /** Unknown error type */
  Unknown = 'UNKNOWN'
}

/** Attributes for adding an internal packhouse */
export type AddInternalPackhouseAttributes = {
  /** The ID of the packhouse (FBO) to add */
  packhouseId: Scalars['ID']['input'];
  /** The ID of the packhouse connection selected by the user */
  packhouseConnectionId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the user is unsure about the packhouse connection or not */
  isUserUnsure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the packhouse should be connected to a new server or not */
  isPackhouseConnectedToNewServer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of AddInternalPackhouse. */
export type AddInternalPackhousePayload = {
  __typename?: 'AddInternalPackhousePayload';
  /** The created client change request */
  clientChangeRequest?: Maybe<InternalPackhouseClientChangeRequest>;
  /** The errors that occurred while creating the client change request */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type AddendumHeader = {
  __typename?: 'AddendumHeader';
  /** Line items on the Addendum */
  addendumLineItems?: Maybe<Array<AddendumLineItem>>;
  /** Actual Addendum Progress Status */
  addendumStatus?: Maybe<Scalars['String']['output']>;
  /** Airwaybill number (master waybill) from Air Freight shipment associated with the addendum header */
  airwaybillNumber?: Maybe<Scalars['String']['output']>;
  /** Clearing and forwarding agent code */
  cfCode?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field for specifying when the department of inspection services agent was specified */
  disAgentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PPECB specific field for specifying who the department of inspection services agent is */
  disAgentName?: Maybe<Scalars['String']['output']>;
  /** Five character location code */
  dischargePort?: Maybe<Scalars['String']['output']>;
  /** eCert Agreement Code */
  eCertAgreementCode?: Maybe<Scalars['String']['output']>;
  /** eCert progress status */
  ecertStatus?: Maybe<Scalars['String']['output']>;
  /** PPECB Error for Addendum */
  errorReason?: Maybe<Scalars['String']['output']>;
  /** Estimated date of departure from load port */
  estimatedDepartureDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Export Certificate Place of Issue */
  exportCertPlaceOfIssue?: Maybe<Scalars['String']['output']>;
  /** Export Certificate Product Type */
  exportCertProductType?: Maybe<Scalars['String']['output']>;
  /** Export Certificate Serial Number */
  exportCertSerialNumber?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field for specifying the Export Certificate Number */
  exportCertificateNumber?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromCapeTown?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromDurban?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromMaputo?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromOther?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromPortElizabeth?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field for specifying when the exporter agent was specified */
  exporterAgentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PPECB specific field for specifying who the exporter agent is */
  exporterAgentName?: Maybe<Scalars['String']['output']>;
  /** Exporter FBO code */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** Flight number received from Air Freight shipment associated with the addendum header */
  flightNumber?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field for specifying when the forwarding agent was specified */
  forwardingAgentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PPECB specific field for specifying who the forwarding agent is */
  forwardingAgentName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the Addendum */
  id: Scalars['ID']['output'];
  /** PPECB specific field for specifying when the inland inspector was specified */
  inlandInspectorDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PPECB specific field for specifying who the inland inspector is */
  inlandInspectorName?: Maybe<Scalars['String']['output']>;
  /** Load out instructions linked to air freight shipment line items */
  loadOutInstructions?: Maybe<Array<LoadOutInstruction>>;
  /** Five character location code */
  loadPort?: Maybe<Scalars['String']['output']>;
  /** Activity Point code where cert will be issued */
  locationOfIssue?: Maybe<Scalars['String']['output']>;
  /** Logistics Service Provider code */
  lspCode?: Maybe<Scalars['String']['output']>;
  /** Pallet out linked to addendum header */
  palletOut?: Maybe<PalletOut>;
  /** PPECB specific field for specifying when the port inspector was specified */
  portInspectorDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PPECB specific field for specifying who the port inspector is */
  portInspectorName?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field for specifying the PPECB Certificate Number */
  ppecbCertificateNumber?: Maybe<Scalars['String']['output']>;
  /** PPECB specific field for specifying some name (in print) */
  printedName?: Maybe<Scalars['String']['output']>;
  /** Regime Code linked to load port and phc */
  regimeCode?: Maybe<Scalars['String']['output']>;
  /** Unique id for the request */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Final country of destination */
  shippedTargetCountry?: Maybe<Scalars['String']['output']>;
  /** Full name of the shipped_target_country */
  shippedTargetCountryName?: Maybe<Scalars['String']['output']>;
  /** Target shipping region for addendum */
  shippedTargetRegion?: Maybe<Scalars['String']['output']>;
  /** Vessel booking reference */
  shippingBookingReference?: Maybe<Scalars['String']['output']>;
  /** Internal State of the Addendum */
  state?: Maybe<AddendumHeaderStateEnum>;
  /** Object containing information on the document generated for this addendum header */
  templateOutput?: Maybe<Array<TemplateOutput>>;
  /** eCert progress status */
  transactionId?: Maybe<Scalars['Int']['output']>;
  /** Type of Transport */
  transportType?: Maybe<Scalars['String']['output']>;
  /** Verification Status When Submitting Addendum */
  verificationStatus?: Maybe<Scalars['String']['output']>;
  /** Name of the Vessel */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** Type of vessel */
  vesselType?: Maybe<Scalars['String']['output']>;
  /** Voyage Number for vessels */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export type AddendumHeaderAttributes = {
  /** Unique identifier for the Addendum */
  id: Scalars['ID']['input'];
  /** Unique id for the request */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Exporter FBO code */
  exporterCode?: InputMaybe<Scalars['String']['input']>;
  /** Clearing and forwarding agent code */
  cfCode?: InputMaybe<Scalars['String']['input']>;
  /** Logistics Service Provider code */
  lspCode?: InputMaybe<Scalars['String']['input']>;
  /** Type of Transport */
  transportType?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Vessel */
  vesselName?: InputMaybe<Scalars['String']['input']>;
  /** Type of vessel */
  vesselType?: InputMaybe<Scalars['String']['input']>;
  /** Voyage Number for vessels */
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Regime Code linked to load port and phc */
  regimeCode?: InputMaybe<Scalars['String']['input']>;
  /** Vessel booking reference */
  shippingBookingReference?: InputMaybe<Scalars['String']['input']>;
  /** Five character location code */
  loadPort?: InputMaybe<Scalars['String']['input']>;
  /** Five character location code */
  dischargePort?: InputMaybe<Scalars['String']['input']>;
  /** Final country of destination */
  shippedTargetCountry?: InputMaybe<Scalars['String']['input']>;
  /** Target shipping region for addendum */
  shippedTargetRegion?: InputMaybe<Scalars['String']['input']>;
  /** Activity Point code where cert will be issued */
  locationOfIssue?: InputMaybe<Scalars['String']['input']>;
  /** Estimated date of departure from load port */
  estimatedDepartureDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** eCert Agreement Code */
  eCertAgreementCode?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying the Export Certificate Number */
  exportCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromCapeTown?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromDurban?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromMaputo?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromOther?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromPortElizabeth?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying when the exporter agent was specified */
  exporterAgentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB specific field for specifying who the exporter agent is */
  exporterAgentName?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying when the forwarding agent was specified */
  forwardingAgentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB specific field for specifying who the forwarding agent is */
  forwardingAgentName?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying some name (in print) */
  printedName?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying when the department of inspection services agent was specified */
  disAgentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB specific field for specifying who the department of inspection services agent is */
  disAgentName?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying when the inland inspector was specified */
  inlandInspectorDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB specific field for specifying who the inland inspector is */
  inlandInspectorName?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying when the port inspector was specified */
  portInspectorDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB specific field for specifying who the port inspector is */
  portInspectorName?: InputMaybe<Scalars['String']['input']>;
  /** PPECB specific field for specifying the PPECB Certificate Number */
  ppecbCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  /** Export Certificate Product Type */
  exportCertProductType?: InputMaybe<Scalars['String']['input']>;
  /** Export Certificate Serial Number */
  exportCertSerialNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum AddendumHeaderStateEnum {
  /** The state of the addendum header is GENERATING */
  Generating = 'GENERATING',
  /** The state of the addendum header is READY */
  Ready = 'READY',
  /** The state of the addendum header is SUBMITTING */
  Submitting = 'SUBMITTING',
  /** The state of the addendum header is SUBMITTED */
  Submitted = 'SUBMITTED',
  /** The state of the addendum header is ERRORED */
  Errored = 'ERRORED'
}

export type AddendumLineItem = {
  __typename?: 'AddendumLineItem';
  /** Carton Quantity */
  cartonQuantity?: Maybe<Scalars['Int']['output']>;
  /** Client Reference for pallet */
  clientRef?: Maybe<Scalars['String']['output']>;
  /** PPECB Commodity code */
  commodityCode?: Maybe<Scalars['String']['output']>;
  /** Consignment number for pallet */
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  /** Container Number */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** The color of the flesh of the fruit, specifically stone fruit */
  fleshColor?: Maybe<Scalars['String']['output']>;
  /** Gross Weight */
  grossWeight?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the Addendum Line */
  id: Scalars['ID']['output'];
  /** Inspected pallet number */
  inspectedSscc?: Maybe<Scalars['String']['output']>;
  /** Target Country for pallet */
  inspectedTargetCountry?: Maybe<Scalars['String']['output']>;
  /** Target Region for pallet */
  inspectedTargetRegion?: Maybe<Scalars['String']['output']>;
  /** Date of inspection as on PO */
  inspectionDate?: Maybe<Scalars['String']['output']>;
  /** The inspection manifest number for the shipment line item */
  inspectionManifestNumber?: Maybe<Scalars['String']['output']>;
  /** PPECB Actvitiy Point Code for inspection */
  inspectionPoint?: Maybe<Scalars['String']['output']>;
  /** PPECB registered inspector code */
  inspectorCode?: Maybe<Scalars['String']['output']>;
  /** PPECB Activity Point Code */
  loadPointFboCode?: Maybe<Scalars['String']['output']>;
  /** Nett Weight */
  nettWeight?: Maybe<Scalars['Float']['output']>;
  /** Orchard code */
  orchard?: Maybe<Scalars['String']['output']>;
  /** Pack Code */
  packCode?: Maybe<Scalars['String']['output']>;
  /** Pallet Quantity */
  palletQuantity?: Maybe<Scalars['Float']['output']>;
  /** Packhouse code for pallet */
  phc?: Maybe<Scalars['String']['output']>;
  /** Phyto Data */
  phytoData?: Maybe<Scalars['String']['output']>;
  /** Product Class code */
  productClass?: Maybe<Scalars['String']['output']>;
  /** Production Area */
  productionArea?: Maybe<Scalars['String']['output']>;
  /** DALRRD PUC Code */
  puc?: Maybe<Scalars['String']['output']>;
  /** Pallet sequence number */
  sequenceNumberOfInspectedSscc?: Maybe<Scalars['Int']['output']>;
  /** Size Count or Berry Size */
  sizeCountBerrySize?: Maybe<Scalars['String']['output']>;
  /** Pallet Gross Weight */
  ssccGrossWeight?: Maybe<Scalars['Float']['output']>;
  /** Pallet Nett Weight */
  ssccNettWeight?: Maybe<Scalars['Float']['output']>;
  /** Container loading date */
  stuffLoadDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Unique number issued by PPECB */
  upn?: Maybe<Scalars['String']['output']>;
  /** Variety Code */
  varietyCode?: Maybe<Scalars['String']['output']>;
};

export type AddendumLineItemAttributes = {
  /** Unique identifier for the Addendum Line */
  id: Scalars['ID']['input'];
  /** Container loading date */
  stuffLoadDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB Activity Point Code */
  loadPointFboCode?: InputMaybe<Scalars['String']['input']>;
  /** Consignment number for pallet */
  consignmentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Packhouse code for pallet */
  phc?: InputMaybe<Scalars['String']['input']>;
  /** Inspected pallet number */
  inspectedSscc?: InputMaybe<Scalars['String']['input']>;
  /** Client Reference for pallet */
  clientRef?: InputMaybe<Scalars['String']['input']>;
  /** Unique number issued by PPECB */
  upn?: InputMaybe<Scalars['String']['input']>;
  /** Target Region for pallet */
  inspectedTargetRegion?: InputMaybe<Scalars['String']['input']>;
  /** Target Country for pallet */
  inspectedTargetCountry?: InputMaybe<Scalars['String']['input']>;
  /** PPECB Commodity code */
  commodityCode?: InputMaybe<Scalars['String']['input']>;
  /** Variety Code */
  varietyCode?: InputMaybe<Scalars['String']['input']>;
  /** Product Class code */
  productClass?: InputMaybe<Scalars['String']['input']>;
  /** Nett Weight */
  nettWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Gross Weight */
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Pallet Nett Weight */
  ssccNettWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Pallet Gross Weight */
  ssccGrossWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Carton Quantity */
  cartonQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** PPECB Actvitiy Point Code for inspection */
  inspectionPoint?: InputMaybe<Scalars['String']['input']>;
  /** PPECB registered inspector code */
  inspectorCode?: InputMaybe<Scalars['String']['input']>;
  /** Date of inspection as on PO */
  inspectionDate?: InputMaybe<Scalars['String']['input']>;
  /** Container Number */
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Pallet sequence number */
  sequenceNumberOfInspectedSscc?: InputMaybe<Scalars['Int']['input']>;
  /** DALRRD PUC Code */
  puc?: InputMaybe<Scalars['String']['input']>;
  /** Orchard code */
  orchard?: InputMaybe<Scalars['String']['input']>;
  /** Production Area */
  productionArea?: InputMaybe<Scalars['String']['input']>;
  /** Phyto Data */
  phytoData?: InputMaybe<Scalars['String']['input']>;
  /** Size Count or Berry Size */
  sizeCountBerrySize?: InputMaybe<Scalars['String']['input']>;
  /** Pack Code */
  packCode?: InputMaybe<Scalars['String']['input']>;
  /** Pallet Quantity */
  palletQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** The color of the flesh of the fruit, specifically stone fruit */
  fleshColor?: InputMaybe<Scalars['String']['input']>;
  /** The inspection manifest number for the shipment line item */
  inspectionManifestNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalField = {
  __typename?: 'AdditionalField';
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPackingInstruction?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['String']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Address = {
  __typename?: 'Address';
  /** The first line of the address */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the address */
  country?: Maybe<Scalars['String']['output']>;
  /** The timestamp of the creation of the address */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the address */
  id?: Maybe<Scalars['ID']['output']>;
  /** The Google place ID of the address */
  placeId?: Maybe<Scalars['ID']['output']>;
  /** The postal code of the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The timestamp of the last update to the address */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AddressAttributes = {
  addressline1: Scalars['String']['input'];
  addressline2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  postalcode?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
};

/** Attributes for creating or editing an address */
export type AddressInput = {
  /** The first line of the address */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of the address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the address */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The country of the address */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The Google place ID of the address */
  placeId?: InputMaybe<Scalars['String']['input']>;
};

/** Field attributes for AG1 table component */
export type Ag1TableFieldAttribute = {
  /** Used to show/hide the field */
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mapped name for display purposes */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The order the field is grouped in */
  groupOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if this field can be grouped */
  groupable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this field is grouped */
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the field */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used to order the fields */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** The direction the field is sorted */
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this field can be sorted */
  sortable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates a custom width for this field */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Ag1TableOutputFileResult = {
  __typename?: 'Ag1TableOutputFileResult';
  error?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  tableName: Scalars['String']['output'];
};

export type AirFreightShipment = {
  __typename?: 'AirFreightShipment';
  /** When the shipment actually arrived */
  actualArrivalTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the shipment actually departed */
  actualDepartureTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** List of line items for the air freight shipment */
  airFreightShipmentLineItems?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Who the shipment is billed to */
  billToParty?: Maybe<Scalars['String']['output']>;
  /** Carrier name of the shipment */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Company of the shipment */
  company?: Maybe<Scalars['String']['output']>;
  /** Receiver of the shipment */
  consignee?: Maybe<Scalars['String']['output']>;
  /** Sender of the shipment */
  consignor?: Maybe<Scalars['String']['output']>;
  /** Controller of the shipment */
  controller?: Maybe<Scalars['String']['output']>;
  /** When the shipment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Where the shipment departs from */
  departureAirport?: Maybe<Scalars['String']['output']>;
  /** When the shipment is estimated to arrive */
  estimatedArrivalTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the shipment is estimated to depart */
  estimatedDepartureTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Exporter code of the shipment */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** External transport master ID of the shipment */
  externalTransportMasterId?: Maybe<Scalars['String']['output']>;
  /** FBO code of the shipment */
  fboCode?: Maybe<Scalars['String']['output']>;
  /** Flight number of the shipment */
  flightNumber?: Maybe<Scalars['String']['output']>;
  /** Name of forwarder */
  forwarderName?: Maybe<Scalars['String']['output']>;
  /** Unique ID for the shipment */
  id: Scalars['ID']['output'];
  /** Master waybill number of the shipment */
  masterWaybillNumber?: Maybe<Scalars['String']['output']>;
  /** Phone number of the shipment */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Which port the shipment is headed */
  portOfDestination?: Maybe<Scalars['String']['output']>;
  /** Port code of where the shipment is loaded */
  portOfLoadingCode?: Maybe<Scalars['String']['output']>;
  /** Port location name of where the shipment is loaded */
  portOfLoadingLocation?: Maybe<Scalars['String']['output']>;
  /** Type of shipment */
  shipmentType?: Maybe<Scalars['String']['output']>;
  /** Shipper of the shipment */
  shipper?: Maybe<Scalars['String']['output']>;
  /** State of the shipment */
  state?: Maybe<Scalars['String']['output']>;
  /** When the shipment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User name of the shipment */
  userName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for AirFreightShipment. */
export type AirFreightShipmentConnection = {
  __typename?: 'AirFreightShipmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AirFreightShipmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AirFreightShipment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AirFreightShipmentEdge = {
  __typename?: 'AirFreightShipmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AirFreightShipment>;
};

export type AirFreightShipmentLineItem = {
  __typename?: 'AirFreightShipmentLineItem';
  /** The Air Freight Shipment the SLI belongs to */
  airFreightShipment?: Maybe<AirFreightShipment>;
  /** Booking reference for the goods on the SLI */
  bookingReference?: Maybe<Scalars['String']['output']>;
  /** Collection Date for the SLI */
  collectionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Comments related to the SLI */
  comments?: Maybe<Scalars['String']['output']>;
  /** Commodity code */
  commodityCode?: Maybe<Scalars['String']['output']>;
  /** Company of the Air Freight Shipment Line Item */
  company?: Maybe<Company>;
  /** The consignee of the goods on the SLI */
  consignee?: Maybe<Scalars['String']['output']>;
  /** The consignor of the goods on the SLI */
  consignor?: Maybe<Scalars['String']['output']>;
  /** when the air freight shipment line item was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Estimated Time of Arrival for the SLI */
  eta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** External ID for the SLI */
  externalShipmentId: Scalars['ID']['output'];
  /** The code identifier for the final destination of the goods on the SLI */
  finalDestinationCode?: Maybe<Scalars['String']['output']>;
  /** The final destination of the goods on the SLI */
  finalDestinationLocation?: Maybe<Scalars['String']['output']>;
  /** The code identifier for final port of discharge of the SLI */
  finalPortOfDischargeCode?: Maybe<Scalars['String']['output']>;
  /** The final port of discharge of the SLI */
  finalPortOfDischargeLocation?: Maybe<Scalars['String']['output']>;
  /** Description of goods */
  goodsDescription?: Maybe<Scalars['String']['output']>;
  /** Gross dimensions */
  grossDimensions?: Maybe<Scalars['String']['output']>;
  /** Gross weight */
  grossWeight?: Maybe<Scalars['String']['output']>;
  /** Housebill */
  housebill?: Maybe<Scalars['String']['output']>;
  /** Unique ID for the shipment */
  id: Scalars['ID']['output'];
  /** Whether the SLI is part of a transshipment */
  isTransshipment?: Maybe<Scalars['Boolean']['output']>;
  /** Last status message received */
  lastStatusMessage?: Maybe<Scalars['String']['output']>;
  /** Nature of goods */
  natureOfGoods?: Maybe<Scalars['String']['output']>;
  /** Order reference for the vessel */
  orderReference?: Maybe<Scalars['String']['output']>;
  /** Quantity of packages */
  packageQuantity?: Maybe<Scalars['String']['output']>;
  /** Type of package */
  packageType?: Maybe<Scalars['String']['output']>;
  /** Any special handling instructions on the SLI */
  specialHandling?: Maybe<Scalars['String']['output']>;
  /** State of the Air Freight Shipment Line Item */
  state?: Maybe<Scalars['String']['output']>;
  /** The name of the transshipment carrier */
  transshipmentCarrierName?: Maybe<Scalars['String']['output']>;
  /** The flight number of the transshipment vessel */
  transshipmentFlightNumber?: Maybe<Scalars['String']['output']>;
  /** The port for the transshipment vessel */
  transshipmentPort?: Maybe<Scalars['String']['output']>;
  /** when the air freight shipment line item was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Volume */
  volume?: Maybe<Scalars['String']['output']>;
};

/** The connection type for AirFreightShipmentLineItem. */
export type AirFreightShipmentLineItemConnection = {
  __typename?: 'AirFreightShipmentLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AirFreightShipmentLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AirFreightShipmentLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AirFreightShipmentLineItemEdge = {
  __typename?: 'AirFreightShipmentLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AirFreightShipmentLineItem>;
};

export type AirFreightShipmentsFilter = {
  /** The carriers to filter on */
  carrierNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The controllers to filter on */
  controllers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The flight numbers to filter on */
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The states to filter on */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The shippers to filter on */
  shippers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The master waybills to filter on */
  masterWaybillNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Attributes for filtering air freight shipments */
export type AirFreightShipmentsFilterAttribute = {
  __typename?: 'AirFreightShipmentsFilterAttribute';
  /** Carriers of the shipment */
  carrierNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Controllers of the shipment */
  controllers?: Maybe<Array<Scalars['String']['output']>>;
  /** Flight numbers of the shipment */
  flightNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Master Waybills of the shipment */
  masterWaybillNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Shippers of the shipment */
  shippers?: Maybe<Array<Scalars['String']['output']>>;
  /** States of the shipment */
  states?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of AllocatePayments. */
export type AllocatePaymentsPayload = {
  __typename?: 'AllocatePaymentsPayload';
  /** What went wrong when assigning payments */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns true if the payment was successfully assigned */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of AllocateShipmentController. */
export type AllocateShipmentControllerPayload = {
  __typename?: 'AllocateShipmentControllerPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of AllocateSliContainer. */
export type AllocateSliContainerPayload = {
  __typename?: 'AllocateSliContainerPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveNotifications. */
export type ArchiveNotificationsPayload = {
  __typename?: 'ArchiveNotificationsPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** The IDs of the notifications that were archived */
  ids?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ArrivalQcGeneration = {
  __typename?: 'ArrivalQcGeneration';
  /** ID of the container claim generated for the containerable */
  containerClaimId?: Maybe<Scalars['ID']['output']>;
  /** Container number of the container the arrival qc is being generated for */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** ID of the containerable the arrival qc is being generated for */
  containerableId: Scalars['ID']['output'];
  /** Type of the containerable the arrival qc is being generated for (BreakBulkContainer OR Container) */
  containerableType?: Maybe<ContainerableTypeEnum>;
  /** The counter party specifies the recipient of the break bulk container, as the recipient is not always the buyer */
  counterParty?: Maybe<Company>;
  /** Error message if the container's arrival qc generation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Generation status of the container's arrival qc */
  status: ArrivalQcGenerationStatesEnum;
  /** Vessel name of the containerable the arrival qc is being generated for (BreakBulkContainer) */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** Voyage number of the containerable the arrival qc is being generated for (BreakBulkContainer) */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export enum ArrivalQcGenerationStatesEnum {
  /** The Arrival QC generation state: loading */
  Loading = 'loading',
  /** The Arrival QC generation state: error */
  Error = 'error',
  /** The Arrival QC generation state: success */
  Success = 'success',
  /** The Arrival QC generation state: queued */
  Queued = 'queued'
}

export enum ArrivalQcGradeEnum {
  /** The Arrival QC grade: black */
  Black = 'black',
  /** The Arrival QC grade: red */
  Red = 'red',
  /** The Arrival QC grade: amber */
  Amber = 'amber',
  /** The Arrival QC grade: green */
  Green = 'green'
}

export enum ArrivalQcStateEnum {
  /** The Arrival QC state: arrival_qc_outstanding */
  ArrivalQcOutstanding = 'arrival_qc_outstanding',
  /** The Arrival QC state: arrival_qc_in_progress */
  ArrivalQcInProgress = 'arrival_qc_in_progress',
  /** The Arrival QC state: green */
  Green = 'green',
  /** The Arrival QC state: amber */
  Amber = 'amber',
  /** The Arrival QC state: red */
  Red = 'red',
  /** The Arrival QC state: black */
  Black = 'black'
}

export enum ArrivalQcTabEnum {
  /** The Arrival QC tab: containers */
  Containers = 'containers',
  /** The Arrival QC tab: breakbulk */
  Breakbulk = 'breakbulk',
  /** The Arrival QC tab: completed_qcs */
  CompletedQcs = 'completed_qcs'
}

export type Audit = {
  __typename?: 'Audit';
  action?: Maybe<Scalars['String']['output']>;
  associatedId?: Maybe<Scalars['Int']['output']>;
  associatedType?: Maybe<Scalars['String']['output']>;
  auditableId?: Maybe<Scalars['Int']['output']>;
  auditableType?: Maybe<Scalars['String']['output']>;
  auditedChanges?: Maybe<Array<Scalars['Json']['output']>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type Badge = {
  __typename?: 'Badge';
  /** The color of the badge to be used in UI */
  color?: Maybe<ColorEnum>;
  /** The date and time the badge was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the badge */
  id?: Maybe<Scalars['Int']['output']>;
  /** The text to be displayed on the badge */
  text?: Maybe<Scalars['String']['output']>;
  /** The date and time the badge was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum BankChargeSplitEnum {
  MyCompany = 'my_company',
  OtherParty = 'other_party',
  FiftyFifty = 'fifty_fifty'
}

export type BreakBulkContainer = {
  __typename?: 'BreakBulkContainer';
  /** Agent Code on the mates file */
  agentCode?: Maybe<Scalars['String']['output']>;
  /** Carton groupings of the container */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** The counterparty specifies the recipient of the break bulk container, as the recipient is not always the buyer */
  counterParty?: Maybe<Company>;
  /** Internal Id of the Break Bulk Container */
  id: Scalars['ID']['output'];
  /** Concatted Break Bulk Name */
  name?: Maybe<Scalars['String']['output']>;
  /** vessel name that the break bulk is loaded on */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** vessel voyage number that the break bulk is loaded on */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CalculateCommercials. */
export type CalculateCommercialsPayload = {
  __typename?: 'CalculateCommercialsPayload';
  advanceCreditTerm?: Maybe<Scalars['Int']['output']>;
  advancePayment?: Maybe<Scalars['BigDecimal']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  finalCreditTerm?: Maybe<Scalars['Int']['output']>;
  finalPayment?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Autogenerated return type of CalculateInvoiceIncoterm. */
export type CalculateInvoiceIncotermPayload = {
  __typename?: 'CalculateInvoiceIncotermPayload';
  invoice?: Maybe<Invoice>;
};

/** Autogenerated return type of CalculatePalletCosts. */
export type CalculatePalletCostsPayload = {
  __typename?: 'CalculatePalletCostsPayload';
  errors?: Maybe<Scalars['String']['output']>;
  estimatePalletCosts: Scalars['Float']['output'];
};

/** Autogenerated return type of CancelAddendum. */
export type CancelAddendumPayload = {
  __typename?: 'CancelAddendumPayload';
  /** The internal ID of the Addendum */
  id?: Maybe<Scalars['Int']['output']>;
  /** Response message from PPECB */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CancelAirAddendum. */
export type CancelAirAddendumPayload = {
  __typename?: 'CancelAirAddendumPayload';
  /** The internal ID of the air addendum */
  id?: Maybe<Scalars['Int']['output']>;
  /** Delete message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CaptureAccountSale. */
export type CaptureAccountSalePayload = {
  __typename?: 'CaptureAccountSalePayload';
  /** Any errors from capturing account sale */
  errors?: Maybe<Scalars['String']['output']>;
  /** id of the created account sale */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CaptureDefectPercentages. */
export type CaptureDefectPercentagesPayload = {
  __typename?: 'CaptureDefectPercentagesPayload';
  /** Errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']['output']>;
};

export type CargoDue = {
  __typename?: 'CargoDue';
  /** Booking reference for this Cargo Due */
  bookingReference?: Maybe<Scalars['String']['output']>;
  /** When the Cargo Dues was first created in the system */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for this Cargo Dues */
  id: Scalars['ID']['output'];
  /** Shipment line items associated with this Cargo Due */
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
  /** Submission status of this Cargo Due */
  status?: Maybe<Scalars['String']['output']>;
  /** Datetime that the Cargo Dues was submitted */
  submissionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the Cargo Dues was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User that submitted the Cargo Dues */
  user?: Maybe<User>;
};

export type CargoDuesFilterAttributes = {
  /** status of the cargo dues; use "not_started" for SLIs without cargo dues */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** start of cargo dues submission you want to filter by */
  submissionDateStart?: InputMaybe<Scalars['String']['input']>;
  /** end of cargo dues submission you want to filter by */
  submissionDateEnd?: InputMaybe<Scalars['String']['input']>;
  /** start of estimated time of departure you want to filter by */
  estimatedTimeOfDepartureStart?: InputMaybe<Scalars['String']['input']>;
  /** end of estimated time of departure you want to filter by */
  estimatedTimeOfDepartureEnd?: InputMaybe<Scalars['String']['input']>;
  /** start of actual time of departure you want to filter by */
  actualTimeOfDepartureStart?: InputMaybe<Scalars['String']['input']>;
  /** end of actual time of departure you want to filter by */
  actualTimeOfDepartureEnd?: InputMaybe<Scalars['String']['input']>;
};

export type CartonConversion = {
  __typename?: 'CartonConversion';
  /** Actual Mass */
  actualMass?: Maybe<Scalars['Float']['output']>;
  /** The commodity record associated with the carton conversion record */
  commodity?: Maybe<Commodity>;
  /** The commodity name associated with the carton conversion record */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** Conversion Factor */
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  /** Conversion Type */
  conversionType?: Maybe<Scalars['String']['output']>;
  /** Converted Size Count */
  convertedSizeCount?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the carton conversion record */
  id: Scalars['ID']['output'];
  /** Hidden field */
  isSoftDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Mass Conversion */
  massConversion?: Maybe<Scalars['Float']['output']>;
  /** Pack */
  pack?: Maybe<Scalars['String']['output']>;
  /** Size Count */
  sizeCount?: Maybe<Scalars['String']['output']>;
};

/** Carton Conversion filter attribute for populating frontend filters */
export type CartonConversionFilterAttribute = {
  __typename?: 'CartonConversionFilterAttribute';
  /** List of available commodities */
  commodityName?: Maybe<Array<Scalars['String']['output']>>;
  /** List of available conversion types */
  conversionType?: Maybe<Array<Scalars['String']['output']>>;
};

export type CartonConversionFilters = {
  /** The conversion types to filter on */
  conversionType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The commodities to filter on */
  commodityName?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CartonCount = {
  __typename?: 'CartonCount';
  cartonTypeId?: Maybe<Scalars['Int']['output']>;
  commodityId?: Maybe<Scalars['Int']['output']>;
  counts?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceMetric?: Maybe<Scalars['String']['output']>;
  stackSizes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type CartonGrouping = {
  __typename?: 'CartonGrouping';
  advanceDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  advancePrice?: Maybe<Scalars['Float']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Company>;
  buyerId?: Maybe<Scalars['Int']['output']>;
  cartons?: Maybe<Scalars['Int']['output']>;
  coldStore?: Maybe<Scalars['String']['output']>;
  commercialTerm?: Maybe<CommercialTerm>;
  commercialTermId?: Maybe<Scalars['Int']['output']>;
  commodity?: Maybe<Commodity>;
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Container>;
  containerId?: Maybe<Scalars['Int']['output']>;
  containerNumber?: Maybe<Scalars['String']['output']>;
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** extended (additional) fields per CG */
  extendedFields?: Maybe<ExtendedField>;
  farmCode?: Maybe<Scalars['String']['output']>;
  /** FBO related CG Farm */
  farmFbo?: Maybe<FoodBusinessOperator>;
  finalDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  finalPrice?: Maybe<Scalars['Float']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inspectionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /** The invoice line items for this carton grouping */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  lineItem?: Maybe<LineItem>;
  lineItemId?: Maybe<Scalars['Int']['output']>;
  loadOutInstructions?: Maybe<Array<LoadOutInstruction>>;
  mark?: Maybe<Scalars['String']['output']>;
  netMass?: Maybe<Scalars['Float']['output']>;
  orchard?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<Scalars['String']['output']>;
  /** The datetime the carton grouping was packed */
  packedDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  packhouseCode?: Maybe<Scalars['String']['output']>;
  /** FBO related CG Packhouse */
  packhouseFbo?: Maybe<FoodBusinessOperator>;
  packingWeek?: Maybe<Scalars['String']['output']>;
  palletAge?: Maybe<Scalars['Int']['output']>;
  palletGrossMass?: Maybe<Scalars['Float']['output']>;
  palletNumber?: Maybe<Scalars['String']['output']>;
  palletRejected?: Maybe<Scalars['Boolean']['output']>;
  /** The pallet rule errors  */
  palletRuleErrors?: Maybe<Array<PalletRuleError>>;
  palletStack?: Maybe<Scalars['Int']['output']>;
  productCharacteristic?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<Company>;
  sellerId?: Maybe<Scalars['Int']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sizeCount?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  targetCountry?: Maybe<Scalars['String']['output']>;
  targetMarket?: Maybe<Scalars['String']['output']>;
  targetRegion?: Maybe<Scalars['String']['output']>;
  tempDeviceId?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<Variety>;
  varietyId?: Maybe<Scalars['Int']['output']>;
  voyage?: Maybe<Voyage>;
};

export type CartonGroupingAudit = {
  __typename?: 'CartonGroupingAudit';
  /** Description of change */
  changeDescription?: Maybe<Scalars['String']['output']>;
  /** Value after change */
  currentValue?: Maybe<Scalars['String']['output']>;
  /** ID of the carton grouping audit */
  id?: Maybe<Scalars['ID']['output']>;
  /** Value before change */
  oldValue?: Maybe<Scalars['String']['output']>;
  /** The user IDs who viewed the audit */
  viewedByIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Filter values for a provided list of carton_groupings */
export type CartonGroupingFilters = {
  __typename?: 'CartonGroupingFilters';
  /** batch numbers found on this list of carton groupings */
  batchNumber?: Maybe<Array<Scalars['String']['output']>>;
  /** buyers found on this list of carton groupings */
  buyer?: Maybe<Array<Company>>;
  /** consignment numbers found on this list of carton groupings */
  consignmentNumber?: Maybe<Array<Scalars['String']['output']>>;
  /** exporter codes found on this list of carton groupings */
  exporterCode?: Maybe<Array<Scalars['String']['output']>>;
  /** packing weeks found on this list of carton groupings */
  packingWeek?: Maybe<Array<Scalars['String']['output']>>;
  /** sellers found on this list of carton groupings */
  seller?: Maybe<Array<Company>>;
  /** target markets found on this list of carton groupings */
  targetMarket?: Maybe<Array<Scalars['String']['output']>>;
  /** varieties found on this list of carton groupings */
  variety?: Maybe<Array<Variety>>;
  /** vessel names found on this list of carton groupings tracking events */
  vessel?: Maybe<Array<Vessel>>;
  /** voyage numbers found on this list of carton groupings tracking events */
  voyageNumber?: Maybe<Array<Scalars['String']['output']>>;
};

export type CartonGroupingSearch = {
  __typename?: 'CartonGroupingSearch';
  /** Carton Groupings for the provided context */
  cartonGroupings: Array<CartonGrouping>;
  /** Carton Grouping Filter Values for the provided context */
  filterValues?: Maybe<CartonGroupingFilters>;
  /** Total count of carton groupings */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Total count of pallets */
  totalCountPallets?: Maybe<Scalars['Int']['output']>;
};

/** Attributes for filtering carton groupings */
export type CartonGroupingSearchAttributes = {
  /** carton groupings with these ids */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** carton groupings with these pallet numbers */
  includePallets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** carton groupings with these batch numbers */
  batchNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whether to include carton groupings that are break bulk */
  breakBulk?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether to include carton groupings with no invoice associations */
  invoiceUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether these carton groupings have a financial invoice */
  financialInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** document type if there is one */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /** carton groupings belonging to these companies */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** carton groupings with these consignment numbers */
  consignmentNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** carton groupings with these container ids */
  containerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** carton groupings with these container numbers */
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** currency you would like to filter on */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** filter up to the end due date */
  endDueDate?: InputMaybe<Scalars['String']['input']>;
  /** filter events after this date */
  eventsAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** carton groupings you would like to exclude */
  excludeCartonGroupingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** pallets you would like to exclude */
  excludePallets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** states you would like to exclude */
  excludeStates?: InputMaybe<Array<CartonGroupingStateEnum>>;
  /** limit the number of items returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** limit the number of pallets returned */
  limitPallets?: InputMaybe<Scalars['Int']['input']>;
  /** cgs associated with a specific load out instruction */
  loadOutInstructionId?: InputMaybe<Scalars['Int']['input']>;
  /** whether to include carton groupings with no load out instruction associations */
  loadOutInstructionsUnallocated?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether to order by pallet number */
  orderByPalletNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** order id you would like to filter on */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** range of packing weeks you would like to filter on */
  packingWeeks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter from the start packing week */
  packingWeekFrom?: InputMaybe<Scalars['String']['input']>;
  /** filter up to the end packing week */
  packingWeekTo?: InputMaybe<Scalars['String']['input']>;
  /** search field you would like to match the search term to */
  searchField?: InputMaybe<CartonGroupingSearchableFieldEnum>;
  /** search term you would like to match on */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** season ids you would like to filter on */
  seasonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** seller ids you would like to filter on */
  sellerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** buyer ids you would like to filter on */
  buyerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** exporter codes you would like to filter on */
  exporterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter from the start due date */
  startDueDate?: InputMaybe<Scalars['String']['input']>;
  /** states you would like to filter on */
  states?: InputMaybe<Array<CartonGroupingStateEnum>>;
  /** target markets you would like to filter on */
  targetMarkets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whether to include carton groupings with tracking disabled */
  trackingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** varieties you would like to filter on */
  varietyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** field you would like to order by */
  orderByField?: InputMaybe<Scalars['String']['input']>;
  /** direction you would like to order by */
  orderByDirection?: InputMaybe<Scalars['String']['input']>;
  /** vessel name for the carton grouping voyage */
  vesselIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** voyage number for the carton grouping voyage */
  voyageNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CartonGroupingSearchableFieldEnum {
  /** Search on Everything */
  All = 'all',
  /** The batch number of the carton grouping */
  BatchNumber = 'batch_number',
  /** The name of the company buying the carton grouping */
  BuyerName = 'buyer_name',
  /** the container number of the carton grouping */
  ContainerNumber = 'container_number',
  /** The commodity name of the carton grouping */
  CommodityName = 'commodity_name',
  /** The consignment number of the carton grouping */
  ConsignmentNumber = 'consignment_number',
  /** The exporter code of the carton grouping */
  ExporterCode = 'exporter_code',
  /** The farm code of the carton grouping */
  FarmCode = 'farm_code',
  /** The grade of the carton grouping */
  Grade = 'grade',
  /** The inventory code of the carton grouping */
  InventoryCode = 'inventory_code',
  /** The mark of the carton grouping */
  Mark = 'mark',
  /** The orchard of the carton grouping */
  Orchard = 'orchard',
  /** The pack of the carton grouping */
  Pack = 'pack',
  /** The packhouse code of the carton grouping */
  PackhouseCode = 'packhouse_code',
  /** The packing week of the carton grouping */
  PackingWeek = 'packing_week',
  /** Start packing week of the carton grouping */
  PackingWeekFrom = 'packing_week_from',
  /** End packing week of the carton grouping */
  PackingWeekTo = 'packing_week_to',
  /** The pallet number of the carton grouping */
  PalletNumber = 'pallet_number',
  /** The name of the company selling the carton grouping */
  SellerName = 'seller_name',
  /** The size count of the carton grouping */
  SizeCount = 'size_count',
  /** The state of the carton grouping */
  State = 'state',
  /** The sub commodity of the carton grouping */
  SubCommodityName = 'sub_commodity_name',
  /** The target country of the carton grouping */
  TargetCountry = 'target_country',
  /** The target market of the carton grouping */
  TargetMarket = 'target_market',
  /** The target region of the carton grouping */
  TargetRegion = 'target_region',
  /** The variety name of the carton grouping */
  VarietyName = 'variety_name'
}

export enum CartonGroupingStateEnum {
  /** The carton grouping state is created */
  Created = 'created',
  /** The carton grouping state is packed */
  Packed = 'packed',
  /** The carton grouping state is departed_packhouse */
  DepartedPackhouse = 'departed_packhouse',
  /** The carton grouping state is at_cold_store */
  AtColdStore = 'at_cold_store',
  /** The carton grouping state is at_rail_depot */
  AtRailDepot = 'at_rail_depot',
  /** The carton grouping state is loaded_into_container */
  LoadedIntoContainer = 'loaded_into_container',
  /** The carton grouping state is departed_cold_store */
  DepartedColdStore = 'departed_cold_store',
  /** The carton grouping state is departed_for_cold_store */
  DepartedForColdStore = 'departed_for_cold_store',
  /** The carton grouping state is departed_rail_depot */
  DepartedRailDepot = 'departed_rail_depot',
  /** The carton grouping state is at_origin_port */
  AtOriginPort = 'at_origin_port',
  /** The carton grouping state is delivered */
  Delivered = 'delivered',
  /** The carton grouping is in transit */
  InTransit = 'in_transit'
}

/** Transaction representation/ aspect of a carton grouping */
export type CartonGroupingTransaction = {
  __typename?: 'CartonGroupingTransaction';
  /** The account type of this CGT */
  accountType?: Maybe<Scalars['String']['output']>;
  /** The unit price of the advance transaction */
  advanceTransactionUnitPrice?: Maybe<Scalars['BigDecimal']['output']>;
  /** The VAT-exclusive amount for this CGT */
  amountExclVatMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** The total amount including VAT for this CGT (copy of amount_major_unit). Prefer this field for clarity. */
  amountInclVatMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Total Amount for this CGT (VAT-inclusive). Deprecated: prefer amount_incl_vat_major_unit.
   * @deprecated Use amount_incl_vat_major_unit instead. amount_major_unit is VAT-inclusive; both are kept in sync.
   */
  amountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** Carton Grouping Associted to this CGT */
  cartonGrouping?: Maybe<CartonGrouping>;
  /** ID of the associated carton grouping */
  cartonGroupingId?: Maybe<Scalars['ID']['output']>;
  /** Cartons for the CGT */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** Transaction Type related to this CGT */
  costCode?: Maybe<CostCode>;
  /** Created At for the CGT */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Currency the CGT was captured as */
  currency?: Maybe<CurrencyEnum>;
  /** Currency that this should be exchanged to */
  exchangeCurrency?: Maybe<Scalars['String']['output']>;
  /** Exchange Rate for the currency on the CGT */
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  /** External Reference to identify the CGT */
  externalReferenceNum?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the CGT */
  id?: Maybe<Scalars['Int']['output']>;
  /** Distinction whether this transaction is an estimate or actual */
  isActual: Scalars['Boolean']['output'];
  /** The net mass of the CGT */
  netMass?: Maybe<Scalars['Float']['output']>;
  /** The number of pallets in this CGT */
  palletCount?: Maybe<Scalars['Float']['output']>;
  /** The pallet gross mass of the CGT */
  palletGrossMass?: Maybe<Scalars['Float']['output']>;
  /** The actual quantity amount of the CGT */
  quantityAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** The price per quantity for this CGT */
  quantityPriceMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** The quantity type eg. 'kg', 'cartons', 'pallets', 'containers', 'percentage', 'percentage_of_incoterm' */
  quantityType?: Maybe<Scalars['String']['output']>;
  /** Target Market for the CGT */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** Transaction Date the CGT took place */
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date when the CGT was last updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The VAT amount for this CGT */
  vatAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** The VAT type applied to this CGT */
  vatType?: Maybe<VatType>;
};

export type CartonGroupingTransactionAttributes = {
  /** Total Amount for this CGT */
  amountMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Carton Grouping Associated to this CGT */
  cartonGroupingId: Scalars['ID']['input'];
  /** Associated Invoice line item */
  invoiceLineItemId?: InputMaybe<Scalars['Int']['input']>;
  /** Created At for the CGT */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Currency the CGT was captured as */
  currency?: InputMaybe<CurrencyEnum>;
  /** Exchange Rate for the currency on the CGT */
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  /** External Reference to identify the CGT */
  externalReferenceNum?: InputMaybe<Scalars['String']['input']>;
  /** ID of the CGT */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Transaction Date the CGT took place */
  transactionDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Date when the CGT was last updated at */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Currency that this should be exchanged to */
  exchangeCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The Quantity type that applies to the CGT */
  quantityType?: InputMaybe<Scalars['String']['input']>;
  /** The Quantity amount that was part of this CGT */
  quantityAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The price per quantity for this CGT */
  quantityPriceMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Target Market for the CGT */
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  /** Cartons for the CGT */
  cartons?: InputMaybe<Scalars['Int']['input']>;
  /** The net mass of the CGT */
  netMass?: InputMaybe<Scalars['Float']['input']>;
  /** The gross mass of the CGT */
  palletGrossMass?: InputMaybe<Scalars['Float']['input']>;
};

/** Returns the name of the location and CG states at that location. */
export type CartonGroupingWithLocation = {
  __typename?: 'CartonGroupingWithLocation';
  /** The actual arrival time */
  actualArrivalTime?: Maybe<Scalars['String']['output']>;
  /** The actual departure time */
  actualDepartureTime?: Maybe<Scalars['String']['output']>;
  /** The batch number */
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** The buyer id number */
  buyerId?: Maybe<Scalars['String']['output']>;
  /** The buyer number */
  buyerName?: Maybe<Scalars['String']['output']>;
  /** The number of cartons */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** The commodity id */
  commodityId?: Maybe<Scalars['String']['output']>;
  /** The commodity name */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** The Consignment number */
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  /** The container number */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** The country of the current location */
  currentLocationCountry?: Maybe<Scalars['String']['output']>;
  /** The id of the current location */
  currentLocationId?: Maybe<Scalars['String']['output']>;
  /** The name of the current location */
  currentLocationName?: Maybe<Scalars['String']['output']>;
  /** The type of the current location */
  currentLocationType?: Maybe<Scalars['String']['output']>;
  /** The document status */
  documentStatus?: Maybe<Scalars['String']['output']>;
  /** The estimated arrival time */
  estimatedArrivalTime?: Maybe<Scalars['String']['output']>;
  /** The estimated departure time */
  estimatedDepartureTime?: Maybe<Scalars['String']['output']>;
  /** The exporter code */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** The extended fields for the pallet */
  extendedFields?: Maybe<Scalars['Json']['output']>;
  /** The farm code */
  farmCode?: Maybe<Scalars['String']['output']>;
  /** The cg audits */
  fileUpdates?: Maybe<Array<CartonGroupingAudit>>;
  /** The carton grouping grade */
  grade?: Maybe<Scalars['String']['output']>;
  /** The ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** The inspection date */
  inspectionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The inventory code */
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /** The load out instruction id */
  loadOutInstructionId?: Maybe<Scalars['String']['output']>;
  /** The load out reference */
  loadOutReference?: Maybe<Scalars['String']['output']>;
  /** The mark */
  mark?: Maybe<Scalars['String']['output']>;
  /** The net mass */
  netMass?: Maybe<Scalars['Float']['output']>;
  /** The country of the next location */
  nextLocationCountry?: Maybe<Scalars['String']['output']>;
  /** The id of the next location */
  nextLocationId?: Maybe<Scalars['String']['output']>;
  /** The name of the next location */
  nextLocationName?: Maybe<Scalars['String']['output']>;
  /** The type of the next location */
  nextLocationType?: Maybe<Scalars['String']['output']>;
  /** The orchard */
  orchard?: Maybe<Scalars['String']['output']>;
  /** The pack type */
  pack?: Maybe<Scalars['String']['output']>;
  /** The packhouse code */
  packhouseCode?: Maybe<Scalars['String']['output']>;
  /** The packing week */
  packingWeek?: Maybe<Scalars['String']['output']>;
  /** The pallet age measured in days */
  palletAge?: Maybe<Scalars['Int']['output']>;
  /** The pallet gross mass */
  palletGrossMass?: Maybe<Scalars['Float']['output']>;
  /** The pallet number */
  palletNumber?: Maybe<Scalars['String']['output']>;
  /** Errors from pallet rule validations */
  palletRulesErrors?: Maybe<Scalars['String']['output']>;
  /** Whether this CG passed the pallet rules check */
  palletRulesPassed?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the previous location */
  previousLocationId?: Maybe<Scalars['String']['output']>;
  /** The name of the previous location */
  previousLocationName?: Maybe<Scalars['String']['output']>;
  /** The type of the previous location */
  previousLocationType?: Maybe<Scalars['String']['output']>;
  /** The product characteristic */
  productCharacteristic?: Maybe<Scalars['String']['output']>;
  /** The seller id */
  sellerId?: Maybe<Scalars['String']['output']>;
  /** The seller name */
  sellerName?: Maybe<Scalars['String']['output']>;
  /** The sequence number */
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  /** The size count */
  sizeCount?: Maybe<Scalars['String']['output']>;
  /** The state of the carton grouping */
  state?: Maybe<Scalars['String']['output']>;
  /** The status of the carton grouping at the location */
  status?: Maybe<Scalars['String']['output']>;
  /** The commodity id */
  subCommodityId?: Maybe<Scalars['String']['output']>;
  /** The commodity name */
  subCommodityName?: Maybe<Scalars['String']['output']>;
  /** The target country */
  targetCountry?: Maybe<Scalars['String']['output']>;
  /** The target market */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** The target region */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** The variety id */
  varietyId?: Maybe<Scalars['String']['output']>;
  /** The variety name */
  varietyName?: Maybe<Scalars['String']['output']>;
  /** The variety code */
  varietyVarietyCode?: Maybe<Scalars['String']['output']>;
  /** The eta for the vessel */
  vesselEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the vessel */
  vesselId?: Maybe<Scalars['Int']['output']>;
  /** The name of the vessel */
  vesselName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for CartonGroupingWithLocation. */
export type CartonGroupingWithLocationConnection = {
  __typename?: 'CartonGroupingWithLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CartonGroupingWithLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CartonGroupingWithLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CartonGroupingWithLocationEdge = {
  __typename?: 'CartonGroupingWithLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CartonGroupingWithLocation>;
};

export type CartonType = {
  __typename?: 'CartonType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Certificate Transport Instruction */
export type CertificateTransportInstruction = {
  __typename?: 'CertificateTransportInstruction';
  /** Booking reference */
  bookingRef?: Maybe<Scalars['String']['output']>;
  /** Company associated with this certificate transport instruction */
  company?: Maybe<Company>;
  /** Container number */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** Delivery address */
  deliverTo?: Maybe<Scalars['String']['output']>;
  /** Description information */
  description?: Maybe<Scalars['String']['output']>;
  /** Empty depot information */
  emptyDepot?: Maybe<Scalars['String']['output']>;
  /** Exporter information */
  exporter?: Maybe<Scalars['String']['output']>;
  /** Gross weight */
  grossWeight?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the certificate transport instruction */
  id: Scalars['ID']['output'];
  /** Loadout reference */
  loadoutRef?: Maybe<Scalars['String']['output']>;
  /** Packstore name */
  packstore?: Maybe<Scalars['String']['output']>;
  /** Port of discharge details */
  portOfDischarge?: Maybe<Scalars['String']['output']>;
  /** Port of loading details */
  portOfLoading?: Maybe<Scalars['String']['output']>;
  /** Seal number */
  sealNumber?: Maybe<Scalars['String']['output']>;
  /** Second Packstore name */
  secondPackstore?: Maybe<Scalars['String']['output']>;
  /** Shipment Line Item Id reference */
  shipmentLineItemId?: Maybe<Scalars['ID']['output']>;
  /** Tare weight */
  tareWeight?: Maybe<Scalars['String']['output']>;
  /** Temperature code settings */
  tempCode?: Maybe<Scalars['String']['output']>;
  /** Temperature settings */
  tempSettings?: Maybe<Scalars['String']['output']>;
  /**
   * Object containing information on the document
   *            generated for this certificate transport instruction
   */
  templateOutput?: Maybe<TemplateOutput>;
  /** Transporter details */
  transporter?: Maybe<Scalars['String']['output']>;
  /** Vent settings */
  vents?: Maybe<Scalars['String']['output']>;
  /** Vessel information */
  vessel?: Maybe<Scalars['String']['output']>;
  /** Voyage details */
  voyage?: Maybe<Scalars['String']['output']>;
};

export type CertificateType = {
  __typename?: 'CertificateType';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CgError = {
  __typename?: 'CgError';
  /** The context for the client to resolve the Cg Error */
  errorContext?: Maybe<Scalars['Json']['output']>;
  /** The error message of the Cg Error */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The subtype of the Cg Error */
  errorSubtype?: Maybe<Scalars['String']['output']>;
  /** The error type of the Cg Error */
  errorType?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the Cg Error */
  id?: Maybe<Scalars['ID']['output']>;
  /** The state of the Cg Error */
  state?: Maybe<Scalars['String']['output']>;
};

/** Cg Error filter attribute for populating frontend filters */
export type CgErrorFilterAttribute = {
  __typename?: 'CgErrorFilterAttribute';
  /** List of available error types */
  errorType?: Maybe<Array<Scalars['String']['output']>>;
  /** List of available states */
  state?: Maybe<Array<Scalars['String']['output']>>;
};

export type CgErrorFilters = {
  /** The error types to filter on */
  errorType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The state to filter on */
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CgErrorResolutionInput = {
  resolutionType: Scalars['String']['input'];
  resolutionId: Scalars['ID']['input'];
};

/** returns details channel notification model */
export type ChannelNotification = {
  __typename?: 'ChannelNotification';
  /** the date and time the channel notification was archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the body of the channel notification */
  body?: Maybe<Scalars['String']['output']>;
  /** the metadata for the channel notification */
  channelMetadata?: Maybe<Scalars['JSON']['output']>;
  /** the date and time the channel notification was deleted */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the date and time the channel notification was delivered */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the unique identifier for the channel notification */
  id?: Maybe<Scalars['ID']['output']>;
  /** the notification items that are associated with the channel notification */
  notificationItems?: Maybe<Array<NotificationItem>>;
  /** the notification rule that created the channel notification */
  notificationRule?: Maybe<NotificationRule>;
  /** the date and time the channel notification was read */
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the date and time the channel notification was sent */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the title of the channel notification */
  title?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ChannelNotification. */
export type ChannelNotificationConnection = {
  __typename?: 'ChannelNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChannelNotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChannelNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChannelNotificationEdge = {
  __typename?: 'ChannelNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChannelNotification>;
};

/** Attributes to filter channel notifications by */
export type ChannelNotificationFilterAttributes = {
  /** filter by severity of the notification rule */
  severity?: InputMaybe<NotificationRuleSeverityEnum>;
  /** filter by archived channel notifications */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by unread and read channel notifications */
  unreadAndRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by unread channel notifications */
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeApplied = {
  __typename?: 'ChargeApplied';
  moneyAmount: Money;
  name: Scalars['String']['output'];
};

export type ChildInvoice = {
  __typename?: 'ChildInvoice';
  /** Errors preventing invoice creation (e.g., pallets already invoiced) */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  invoice?: Maybe<Invoice>;
  revenueLineItems?: Maybe<Array<InvoiceLineItem>>;
};

export type ClaimLineItem = {
  __typename?: 'ClaimLineItem';
  /** The arrival qc grade of the claim line item */
  arrivalQcGrade?: Maybe<ArrivalQcGradeEnum>;
  /** The expected claim of the claim line item */
  expectedClaim?: Maybe<ExpectedClaimEnum>;
  /** The unique identifier for a claim line item */
  id: Scalars['ID']['output'];
};

export type ClaimLineItemDefect = {
  __typename?: 'ClaimLineItemDefect';
  /** The defect on the claim line item */
  defect: Defect;
  /** The percentage of the defect */
  defectPercentage?: Maybe<Scalars['Float']['output']>;
};

export type ClaimLineItemDefectInput = {
  /** Defect */
  defect: DefectInput;
  /** Defect Percentage */
  defectPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type ClaimLineItemGrouping = {
  __typename?: 'ClaimLineItemGrouping';
  /** The Arrival QC grade of the claim line item grouping */
  arrivalQcGrade?: Maybe<ArrivalQcGradeEnum>;
  /** The comment placed on a claim line item grouping */
  comment?: Maybe<Scalars['String']['output']>;
  /** The commodity of the claim line item grouping */
  commodity?: Maybe<Commodity>;
  /** The cosmetic defects of the claim line item grouping */
  cosmeticClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The cosmetic defect options of the claim line item grouping */
  cosmeticDefectOptions?: Maybe<Array<Defect>>;
  /** The cosmetic defect percentage of the claim line item grouping */
  cosmeticDefectPercentage?: Maybe<Scalars['Float']['output']>;
  /** The expected claim of the claim line item grouping */
  expectedClaims?: Maybe<Array<ExpectedClaimEnum>>;
  /** The farm code of the claim line item grouping */
  farmCode?: Maybe<Scalars['String']['output']>;
  /** The grade og the claim line item grouping */
  grade?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the claim line item grouping */
  id: Scalars['ID']['output'];
  /** The other defects of the claim line item grouping */
  otherClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The other defect options of the claim line item grouping */
  otherDefectOptions?: Maybe<Array<Defect>>;
  /** The other defect percentage of the claim line item grouping */
  otherDefectPercentage?: Maybe<Scalars['Float']['output']>;
  /** The number of pallets that belong to the claim line item grouping */
  palletCount?: Maybe<Scalars['Int']['output']>;
  /** The progressive defects of the claim line item grouping */
  progressiveClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The progressive defect options of the claim line item grouping */
  progressiveDefectOptions?: Maybe<Array<Defect>>;
  /** The progressive defect percentage of the claim line item grouping */
  progressiveDefectPercentage?: Maybe<Scalars['Float']['output']>;
  /** The size count of the claim line item grouping */
  sizeCount?: Maybe<Scalars['String']['output']>;
  /** The variety of the claim line item grouping */
  variety?: Maybe<Variety>;
};

export type ClaimLineItemPallet = {
  __typename?: 'ClaimLineItemPallet';
  /** The arrival qc grade of the claim line items pallet */
  arrivalQcGrade?: Maybe<ArrivalQcGradeEnum>;
  /** The claim line item grouping id of the claim line item pallet */
  claimLineItemGroupingId?: Maybe<Scalars['ID']['output']>;
  /** The claim line items that belong to the claim line item's pallet */
  claimLineItems?: Maybe<Array<ClaimLineItem>>;
  /** The commodity of the claim line item pallet */
  commodity?: Maybe<Commodity>;
  /** The cosmetic defects of the claim line item pallet */
  cosmeticClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The cosmetic defect options of the claim line item pallet */
  cosmeticDefectOptions?: Maybe<Array<Defect>>;
  /** The expected claim of the claim line items pallet  */
  expectedClaim?: Maybe<ExpectedClaimEnum>;
  /** The uniques identifier for the claim line item pallet which is the pallet's id */
  id: Scalars['ID']['output'];
  /** The other defects of the claim line item pallet */
  otherClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The other defect options of the claim line item pallet */
  otherDefectOptions?: Maybe<Array<Defect>>;
  /** The pallet number of the pallet */
  palletNumber: Scalars['String']['output'];
  /** The progressive defects of the claim line item pallet */
  progressiveClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The progressive defect options of the claim line item pallet */
  progressiveDefectOptions?: Maybe<Array<Defect>>;
};

export type Claims = {
  __typename?: 'Claims';
  /** The claim line item groupings returned by the resolver */
  claimLineItemGroupings: Array<ClaimLineItemGrouping>;
  /** The claim line item's pallets returned by the resolver */
  claimLineItemPallets: Array<ClaimLineItemPallet>;
  /** The container claims returned by the resolver */
  containerClaims: ContainerClaimConnection;
};


export type ClaimsContainerClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientChangeRequest = {
  __typename?: 'ClientChangeRequest';
  /** Unique identifier for the client change request */
  id?: Maybe<Scalars['ID']['output']>;
  /** The context of the error */
  userContext?: Maybe<Scalars['String']['output']>;
};

/** Attributes for confirming a relation between cold stores and a client change request */
export type ClientChangeRequestExportColdStoreAttributes = {
  /** The ID of the client change request */
  clientChangeRequestId: Scalars['ID']['input'];
  /** The IDs of the cold stores */
  coldStoreIds: Array<Scalars['ID']['input']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CloseOfferAsSupplier. */
export type CloseOfferAsSupplierPayload = {
  __typename?: 'CloseOfferAsSupplierPayload';
  /** What went wrong when closing the offer */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The offer that was closed */
  offer?: Maybe<Offer>;
};

/** The color of the badge to be used in UI */
export enum ColorEnum {
  Red = 'red',
  Orange = 'orange',
  Amber = 'amber',
  Yellow = 'yellow',
  Lime = 'lime',
  Green = 'green',
  Emerald = 'emerald',
  Teal = 'teal',
  Cyan = 'cyan',
  Sky = 'sky',
  Blue = 'blue',
  Indigo = 'indigo',
  Violet = 'violet',
  Purple = 'purple',
  Fuchsia = 'fuchsia',
  Pink = 'pink',
  Rose = 'rose',
  Slate = 'slate'
}

/** Attributes to order on */
export type ColumnOrderAttributes = {
  /** field you want to order on */
  orderField: Scalars['String']['input'];
  /** direction you want to order on */
  orderDirection: ColumnOrderDirectionEnum;
};

export enum ColumnOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type Command = {
  __typename?: 'Command';
  batchId?: Maybe<Scalars['String']['output']>;
  command?: Maybe<Scalars['String']['output']>;
  commandType?: Maybe<CommandTypeEnum>;
  connectorName?: Maybe<Scalars['String']['output']>;
};

/** Attributes for an on premises batch result */
export type CommandResultAttributes = {
  batchid: Scalars['String']['input'];
  state: CommandStateEnum;
  jsonresult?: InputMaybe<Scalars['Json']['input']>;
  /** base64 encoded, zlib compressed, json string */
  zippedjson?: InputMaybe<Scalars['String']['input']>;
};

export enum CommandStateEnum {
  OnPremisesSuccess = 'on_premises_success',
  OnPremisesError = 'on_premises_error',
  OnPremisesUnknown = 'on_premises_unknown'
}

export enum CommandTypeEnum {
  MssqlQuery = 'MSSQL_QUERY',
  CheckForUpdate = 'CHECK_FOR_UPDATE',
  Restart = 'RESTART',
  ReconnectDb = 'RECONNECT_DB',
  SystemReport = 'SYSTEM_REPORT',
  SetConnector = 'SET_CONNECTOR'
}

export type Comment = {
  __typename?: 'Comment';
  commentText?: Maybe<Scalars['String']['output']>;
  commentable?: Maybe<CommentableUnion>;
  commentableId?: Maybe<Scalars['Int']['output']>;
  commentableType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CommentableUnion = LineItem | Order;

export type CommercialTerm = {
  __typename?: 'CommercialTerm';
  /** Amount for advance payment */
  advanceAmount?: Maybe<Scalars['Float']['output']>;
  /** Credit term for advance payment */
  advanceCreditTerm?: Maybe<Scalars['Int']['output']>;
  /** Currency for advance payment */
  advanceCurrency?: Maybe<Scalars['String']['output']>;
  /** Event triggering advance payment */
  advanceEvent?: Maybe<Scalars['String']['output']>;
  /** Type of advance payment */
  advanceType?: Maybe<Scalars['String']['output']>;
  /** Unit for advance payment */
  advanceUnit?: Maybe<Scalars['String']['output']>;
  /** The buyer company */
  buyer?: Maybe<Company>;
  /** ID of the buyer company */
  buyerId?: Maybe<Scalars['Int']['output']>;
  /** The name of the buyer company */
  buyerName?: Maybe<Scalars['String']['output']>;
  /** The commodity associated with this commercial term */
  commodity?: Maybe<Commodity>;
  /** The name of the commodity associated with this commercial term */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** Whether this commercial term is deleted */
  deleted: Scalars['Boolean']['output'];
  /** End date of the commercial term */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Exporter code associated with this commercial term */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** Credit term for final payment */
  finalCreditTerm?: Maybe<Scalars['Int']['output']>;
  /** Currency for final payment */
  finalCurrency?: Maybe<Scalars['String']['output']>;
  /** Event triggering final payment */
  finalEvent?: Maybe<Scalars['String']['output']>;
  /** Grade specification */
  grade?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the commercial term */
  id?: Maybe<Scalars['Int']['output']>;
  /** Pack specification */
  pack?: Maybe<Scalars['String']['output']>;
  /** Payment term specification */
  paymentTerm?: Maybe<Scalars['String']['output']>;
  /** Rank one advance event trigger */
  rankOneAdvanceEvent?: Maybe<Scalars['String']['output']>;
  /** Rank one final event trigger */
  rankOneFinalEvent?: Maybe<Scalars['String']['output']>;
  /** The seller company */
  seller?: Maybe<Company>;
  /** ID of the seller company */
  sellerId?: Maybe<Scalars['Int']['output']>;
  /** Start date of the commercial term */
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The target country associated with this commercial term */
  targetCountry?: Maybe<Scalars['String']['output']>;
  /** Target region for the commercial term */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** The variety associated with this commercial term */
  variety?: Maybe<Variety>;
  /** The name of the variety associated with this commercial term */
  varietyName?: Maybe<Scalars['String']['output']>;
};

/** Attributes for upserting a commercial term */
export type CommercialTermAttributes = {
  /** The ID of the commercial term to upsert */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the seller */
  sellerId: Scalars['ID']['input'];
  /** The ID of the buyer */
  buyerId: Scalars['ID']['input'];
  /** The ID of the commodity */
  commodityId: Scalars['ID']['input'];
  /** The ID of the variety */
  varietyId?: InputMaybe<Scalars['ID']['input']>;
  /** The target region */
  targetRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** The target country */
  targetCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** The pack */
  packId?: InputMaybe<Scalars['ID']['input']>;
  /** The grade */
  grade?: InputMaybe<Scalars['String']['input']>;
  /** The exporter code */
  exporterCode?: InputMaybe<Scalars['String']['input']>;
  /** The payment term */
  paymentTerm: Scalars['String']['input'];
  /** The advance type */
  advanceType?: InputMaybe<Scalars['String']['input']>;
  /** The advance amount */
  advanceAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The advance currency */
  advanceCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The advance credit term */
  advanceCreditTerm?: InputMaybe<Scalars['Float']['input']>;
  /** The final credit term */
  finalCreditTerm?: InputMaybe<Scalars['Float']['input']>;
  /** The final currency */
  finalCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The start date */
  startDate: Scalars['ISO8601DateTime']['input'];
  /** The end date */
  endDate: Scalars['ISO8601DateTime']['input'];
  /** The advance unit */
  advanceUnit?: InputMaybe<Scalars['String']['input']>;
};

export type CommercialTermChangeRequest = {
  __typename?: 'CommercialTermChangeRequest';
  commercialTerm?: Maybe<CommercialTerm>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** The connection type for CommercialTerm. */
export type CommercialTermConnection = {
  __typename?: 'CommercialTermConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommercialTermEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CommercialTerm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommercialTermEdge = {
  __typename?: 'CommercialTermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CommercialTerm>;
};

/** Attributes to filter commercial terms by */
export type CommercialTermFilterAttribute = {
  __typename?: 'CommercialTermFilterAttribute';
  /** advance types you want to filter by */
  advanceTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** advance units you want to filter by */
  advanceUnits?: Maybe<Array<Scalars['String']['output']>>;
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** events you want to filter by */
  events?: Maybe<Array<Scalars['String']['output']>>;
  /** target region you want to filter by */
  targetRegions?: Maybe<Array<Scalars['String']['output']>>;
};

/** Attributes to filter commercial terms by */
export type CommercialTermFilterAttributes = {
  /** buyers you want to filter by */
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** commodities you want to filter by */
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** target region you want to filter by */
  targetRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** events from rank 1 advance and final events to filter by */
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Packing Week to filter on */
  endWeek?: InputMaybe<Scalars['String']['input']>;
  /** Packing Week to filter on */
  startWeek?: InputMaybe<Scalars['String']['input']>;
  /** advance types to filter by */
  advanceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** advance units to filter by */
  advanceUnits?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Commodity = {
  __typename?: 'Commodity';
  commodityGroup?: Maybe<CommodityGroupEnum>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  icon?: Maybe<Image>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  varieties?: Maybe<Array<Variety>>;
};

export type CommodityDefaultSeason = {
  __typename?: 'CommodityDefaultSeason';
  commodityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxWeek: Scalars['String']['output'];
  minWeek: Scalars['String']['output'];
};


export type CommodityDefaultSeasonMaxWeekArgs = {
  year?: Scalars['Int']['input'];
};


export type CommodityDefaultSeasonMinWeekArgs = {
  year?: Scalars['Int']['input'];
};

export enum CommodityGroupEnum {
  TableGrapes = 'TableGrapes',
  Citrus = 'Citrus',
  Subtropical = 'Subtropical',
  Exotic = 'Exotic',
  Stone = 'Stone',
  Pome = 'Pome',
  Tropical = 'Tropical',
  Vegetable = 'Vegetable'
}

export type CommoditySeason = {
  __typename?: 'CommoditySeason';
  commodity?: Maybe<Commodity>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Company = {
  __typename?: 'Company';
  about?: Maybe<Scalars['String']['output']>;
  activeUsers?: Maybe<Array<User>>;
  additionalFields?: Maybe<Array<AdditionalField>>;
  address?: Maybe<Address>;
  /** all associated companies */
  allCompanies?: Maybe<Array<Company>>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  buyers?: Maybe<Array<Company>>;
  certificates?: Maybe<Array<CompanyCertificate>>;
  /** The commodities associated with the company */
  commodities?: Maybe<Array<Commodity>>;
  commoditySeasons?: Maybe<Array<CommoditySeason>>;
  /** @deprecated Companies has been replaced with Buyers and Sellers */
  companies?: Maybe<Array<Company>>;
  /** The URL of the company logo */
  companyLogoImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /** List of exporter codes associated with this company */
  exporterCodes?: Maybe<Array<ExporterCode>>;
  exporters?: Maybe<Array<Company>>;
  id?: Maybe<Scalars['Int']['output']>;
  invites?: Maybe<Array<Invite>>;
  isBuyer?: Maybe<Scalars['Boolean']['output']>;
  isSeller?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Doesn't provide a full URL. Use logoImage instead */
  logo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by logoImage */
  logoFile?: Maybe<Document>;
  logoImage?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfRatings?: Maybe<Scalars['Int']['output']>;
  /** The current step of the onboarding process */
  onboardingStep?: Maybe<CompanyOnboardingStepEnum>;
  packhouseConnections?: Maybe<Array<PackhouseConnection>>;
  /** Yield persona: buyer, producer, or agent */
  persona?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  sellerVarieties?: Maybe<Array<Variety>>;
  sellers?: Maybe<Array<Company>>;
  /** The state of the company */
  state?: Maybe<CompanyStateEnum>;
  tradeRegions?: Maybe<Array<TradeRegion>>;
  users?: Maybe<Array<User>>;
  varieties?: Maybe<Array<FarmVariety>>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type CompanyAssociation = {
  __typename?: 'CompanyAssociation';
  /** The child company in the association */
  childCompany?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for the company association */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of the company association */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the association is facilitated by OneSwitch */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']['output']>;
  /** The parent company in the association */
  parentCompany?: Maybe<Company>;
  /** The type of relationship between the companies */
  relation?: Maybe<CompanyAssociationRelationTypeEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Attributes for confirming a relation between cold stores and a supplier-exporter association */
export type CompanyAssociationExportColdStoreAttributes = {
  /** The ID of the supplier-exporter association */
  companyAssociationId: Scalars['ID']['input'];
  /** The IDs of the cold stores */
  coldStoreIds: Array<Scalars['ID']['input']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The type of relationship between the companies */
export enum CompanyAssociationRelationTypeEnum {
  /** Company association is seller buyer */
  SellerBuyer = 'SELLER_BUYER',
  /** Company association is supplier packhouse */
  SupplierPackhouse = 'SUPPLIER_PACKHOUSE',
  /** Company association is supplier exporter */
  SupplierExporter = 'SUPPLIER_EXPORTER',
  /** Company association is consignor consignee */
  ConsignorConsignee = 'CONSIGNOR_CONSIGNEE',
  /** Company association is invoice */
  Invoice = 'INVOICE',
  /** Company association is notify */
  Notify = 'NOTIFY',
  /** Company association is market marketsection */
  MarketMarketsection = 'MARKET_MARKETSECTION'
}

export type CompanyCertificate = {
  __typename?: 'CompanyCertificate';
  certificate?: Maybe<Document>;
  certificateType?: Maybe<CertificateType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The current step of the onboarding process */
export enum CompanyOnboardingStepEnum {
  /** Onboarding step is start */
  Start = 'START',
  /** Onboarding step is packhouse connections */
  PackhouseConnections = 'PACKHOUSE_CONNECTIONS',
  /** Onboarding step is data confirmations */
  DataConfirmations = 'DATA_CONFIRMATIONS',
  /** Onboarding step is supply chain confirmations */
  SupplyChainConfirmations = 'SUPPLY_CHAIN_CONFIRMATIONS',
  /** Onboarding step is complete */
  Complete = 'COMPLETE'
}

/** Fields available on a company payment */
export type CompanyPayment = {
  __typename?: 'CompanyPayment';
  /** The company recording the payment, this can either be the recipient or the payer */
  company?: Maybe<Company>;
  /** The id of the company recording the payment, this can either be the recipient or the payer */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** The name of the company recording the payment, this can either be the recipient or the payer */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The contact involved in the transaction */
  contact?: Maybe<Contact>;
  /** The id of the contact involved in the transaction */
  contactId?: Maybe<Scalars['ID']['output']>;
  /** The name of the contact involved in the transaction */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Currency allows us to group payments and invoices of the same currency together */
  currency?: Maybe<Scalars['String']['output']>;
  /** Amount of money needed to pay outstanding incoming invoices in major unit */
  incomingAmountDueMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** Amount of incoming money not yet allocated to invoices in major unit */
  incomingUnallocatedAmountMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** Number of invoices due for this company */
  invoicesDue?: Maybe<Scalars['Int']['output']>;
  /** Amount of money needed to pay outstanding outgoing invoices in major unit */
  outgoingAmountDueMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** Amount of outgoing money not yet allocated to invoices in major unit */
  outgoingUnallocatedAmountMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** Number of unallocated payments for this company */
  unallocatedPayments?: Maybe<Scalars['Int']['output']>;
  /** When the associated invoice or payment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Company payment filter attribute for populating frontend filters */
export type CompanyPaymentFilterAttribute = {
  __typename?: 'CompanyPaymentFilterAttribute';
  /** contacts linked to this user's payments */
  contacts?: Maybe<Array<Contact>>;
};

/** Filtering options for company payments */
export type CompanyPaymentFilters = {
  /** currency of the company payments */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id of the contacts associated */
  contactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** filter payments (by payment_date) and invoices (by invoice_date) on or after this date (inclusive) */
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** filter payments (by payment_date) and invoices (by invoice_date) on or before this date (inclusive) */
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export enum CompanyPersonaEnum {
  Producer = 'producer',
  Agent = 'agent',
  Buyer = 'buyer'
}

/** The state of a company used to control platform access */
export enum CompanyStateEnum {
  /** Company state is onboarding */
  Onboarding = 'onboarding',
  /** Company state is in season */
  InSeason = 'in_season',
  /** Company state is re onboarding */
  ReOnboarding = 're_onboarding',
  /** Company state is suspended */
  Suspended = 'suspended'
}

/** Autogenerated return type of CompleteAirFreightShipment. */
export type CompleteAirFreightShipmentPayload = {
  __typename?: 'CompleteAirFreightShipmentPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CompleteShipmentLineItem. */
export type CompleteShipmentLineItemPayload = {
  __typename?: 'CompleteShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CompleteShipment. */
export type CompleteShipmentPayload = {
  __typename?: 'CompleteShipmentPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type Config = {
  __typename?: 'Config';
  /** name of the config */
  name?: Maybe<Scalars['String']['output']>;
  /** value of the config */
  value?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ConfirmExportNotificationLineItem. */
export type ConfirmExportNotificationLineItemPayload = {
  __typename?: 'ConfirmExportNotificationLineItemPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The current shipment */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of ConfirmExporterColdStores. */
export type ConfirmExporterColdStoresPayload = {
  __typename?: 'ConfirmExporterColdStoresPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the cold stores were confirmed successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of ConfirmMasterfileConfigCompanyAssociations. */
export type ConfirmMasterfileConfigCompanyAssociationsPayload = {
  __typename?: 'ConfirmMasterfileConfigCompanyAssociationsPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

/** Autogenerated return type of ConfirmMasterfileConfigFarmVarieties. */
export type ConfirmMasterfileConfigFarmVarietiesPayload = {
  __typename?: 'ConfirmMasterfileConfigFarmVarietiesPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

/** Autogenerated return type of ConfirmMasterfileConfigFbo. */
export type ConfirmMasterfileConfigFboPayload = {
  __typename?: 'ConfirmMasterfileConfigFboPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

/** Autogenerated return type of ConfirmMasterfileConfigPackhouseConnections. */
export type ConfirmMasterfileConfigPackhouseConnectionsPayload = {
  __typename?: 'ConfirmMasterfileConfigPackhouseConnectionsPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

export type Contact = {
  __typename?: 'Contact';
  /** The company associated with the contact */
  company?: Maybe<Company>;
  /** The type of contact */
  contactType?: Maybe<ContactTypeEnum>;
  /** The date and time the contact was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The User ID of the User that created this contact */
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the contact */
  id?: Maybe<Scalars['Int']['output']>;
  /** Additional information about the contact */
  info?: Maybe<Scalars['String']['output']>;
  /** The name of the contact */
  name?: Maybe<Scalars['String']['output']>;
  /** The date and time the contact was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ContactAttributes = {
  contactType?: InputMaybe<ContactTypeEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The type of contact to be used in templates */
export enum ContactTypeEnum {
  Consignee = 'consignee',
  Consignor = 'consignor',
  InvoiceParty = 'invoice_party',
  NotifyParty = 'notify_party'
}

/** Containers */
export type Container = {
  __typename?: 'Container';
  /** Container carrier name */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Carton groupings of the container */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** Container number */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** Container size */
  containerSize?: Maybe<Scalars['String']['output']>;
  /** Container type */
  containerType?: Maybe<Scalars['String']['output']>;
  /** Container ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Origin port of the container */
  originPort?: Maybe<SeaPort>;
  /** Container seal number */
  sealNumber?: Maybe<Scalars['String']['output']>;
  /** Container stuff date */
  stuffDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ContainerClaim = {
  __typename?: 'ContainerClaim';
  /** The date that the arrival qc was caprtured */
  arrivalQcDatetime?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The associated break bulk container */
  breakBulkContainer?: Maybe<BreakBulkContainer>;
  /** Unique identifier for the Company associated with this container claim */
  companyId: Scalars['ID']['output'];
  /** The date that the container claim was marked as completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The associated container's container number */
  container?: Maybe<Container>;
  /** The date that the container arrived */
  containerArrivalDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The id of the containerable associated with the container claim */
  containerableId: Scalars['ID']['output'];
  /** The type of containerable associated with the container claim */
  containerableType: ContainerableTypeEnum;
  /** The counterparty specifies the recipient of the break bulk container, as the recipient is not always the buyer */
  counterParty?: Maybe<Company>;
  /** The uploaded documents associated with the container claim */
  documents?: Maybe<Array<Document>>;
  /** Unique identifier for the container claim */
  id: Scalars['ID']['output'];
  /** The notes stored on the container claim */
  notes?: Maybe<Scalars['String']['output']>;
  /** The uploaded photos associated with the container claim */
  photos?: Maybe<Array<Image>>;
  /** The arrival qc state of the container claim */
  state?: Maybe<ArrivalQcStateEnum>;
  /** When the shipment line item was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The vessel name associated with the container claim */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** The voyage number associated with the container claim */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ContainerClaim. */
export type ContainerClaimConnection = {
  __typename?: 'ContainerClaimConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContainerClaimEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContainerClaim>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContainerClaimEdge = {
  __typename?: 'ContainerClaimEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContainerClaim>;
};

export enum ContainerableTypeEnum {
  /** The containerable type: Container */
  Container = 'Container',
  /** The containerable type: BreakBulkContainer */
  BreakBulkContainer = 'BreakBulkContainer'
}

export type ContainersForArrivalQc = {
  __typename?: 'ContainersForArrivalQc';
  /** The Container number of the container eligible for arrival QC */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** The ID of the Container eligible for arrival QC */
  id: Scalars['ID']['output'];
  /** The Vessel name */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** The Voyage number */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export type CostCode = {
  __typename?: 'CostCode';
  /** The company associated with this cost code */
  company?: Maybe<Company>;
  /** Type of cost */
  costType: Scalars['String']['output'];
  /** Field name used for the cost code */
  fieldName: Scalars['String']['output'];
  /** General ledger name */
  generalLedgerName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the cost code */
  id: Scalars['Int']['output'];
  /** Whether this is a default cost code */
  isDefault: Scalars['Boolean']['output'];
  /** Display name of the cost code */
  name: Scalars['String']['output'];
  /** The supply chain segment where this cost code applies */
  supplyChainLeg?: Maybe<Scalars['String']['output']>;
};

export type CostCodeFilterAttribute = {
  __typename?: 'CostCodeFilterAttribute';
  /** Cost type to filter by. */
  costTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Field name to filter by. */
  fieldNames?: Maybe<Array<Scalars['String']['output']>>;
  /** List of finance rule IDs to filter by. */
  financeRules?: Maybe<Array<FinanceRule>>;
  /** General ledger name to filter by. */
  generalLedgerNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by default status. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Name to filter by. */
  names?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the screen should display active or historic costs */
  pageType?: Maybe<Scalars['String']['output']>;
  /** Supply chain leg to filter by. */
  supplyChainLegs?: Maybe<Array<Scalars['String']['output']>>;
};

/** Attributes used to create a counter offer */
export type CounterOfferAttributes = {
  /** The items associated with the counter offer */
  offerItems: Array<CounterOfferItemAttributes>;
};

/** Attributes used to create an offer item on a counter offer */
export type CounterOfferItemAttributes = {
  /** The size counts for the offer item */
  sizeCounts: Array<Scalars['String']['input']>;
  /** The grade for the offer item (A, B, C, etc.) */
  grade: Scalars['String']['input'];
  /** The quantity for the offer item, must be greater than 0 */
  quantity: Scalars['Int']['input'];
  /** The CIF price per carton for this counter offer item. Required on every counter — only the supplier-initial offer may defer CIF to the buyer. */
  cifPriceAmountMajorUnit: Scalars['BigDecimal']['input'];
};

/** Basic attributes for adding additional fields to a company's new order template */
export type CreateAdditionalFieldAttributes = {
  companyid: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fieldtype: Scalars['String']['input'];
  ispackinginstruction?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateAdditionalField. */
export type CreateAdditionalFieldPayload = {
  __typename?: 'CreateAdditionalFieldPayload';
  additionalField?: Maybe<AdditionalField>;
};

/** Autogenerated return type of CreateCargoDue. */
export type CreateCargoDuePayload = {
  __typename?: 'CreateCargoDuePayload';
  /** The created cargo due */
  cargoDue?: Maybe<CargoDue>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CreateCartonConversion. */
export type CreateCartonConversionPayload = {
  __typename?: 'CreateCartonConversionPayload';
  cartonConversion?: Maybe<CartonConversion>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateClientChangeRequest. */
export type CreateClientChangeRequestPayload = {
  __typename?: 'CreateClientChangeRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']['output']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<ClientChangeRequest>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

export type CreateCommentAttributes = {
  commentabletype: Scalars['String']['input'];
  commentableid: Scalars['Int']['input'];
  userid: Scalars['Int']['input'];
  commenttext: Scalars['String']['input'];
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  comment?: Maybe<Comment>;
};

export type CreateCommercialTermChangeRequestAttributes = {
  commercialtermsid: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  flag: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCommercialTermChangeRequest. */
export type CreateCommercialTermChangeRequestPayload = {
  __typename?: 'CreateCommercialTermChangeRequestPayload';
  changeRequest?: Maybe<CommercialTermChangeRequest>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateContact. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCounterOfferAsSupplier. */
export type CreateCounterOfferAsSupplierPayload = {
  __typename?: 'CreateCounterOfferAsSupplierPayload';
  /** The counter offer that was created */
  counterOffer?: Maybe<Offer>;
  /** What went wrong when creating the counter offer */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CreateCustomField. */
export type CreateCustomFieldPayload = {
  __typename?: 'CreateCustomFieldPayload';
  /** The custom field */
  customField?: Maybe<CustomField>;
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateExportNotificationBooking. */
export type CreateExportNotificationBookingPayload = {
  __typename?: 'CreateExportNotificationBookingPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateExportNotificationLineItem. */
export type CreateExportNotificationLineItemPayload = {
  __typename?: 'CreateExportNotificationLineItemPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateExporterAndColdStoreClientRequest. */
export type CreateExporterAndColdStoreClientRequestPayload = {
  __typename?: 'CreateExporterAndColdStoreClientRequestPayload';
  /** The exporter client change request created */
  clientChangeRequest?: Maybe<SupplierExporterClientChangeRequest>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CreateExporterColdStoreRequest. */
export type CreateExporterColdStoreRequestPayload = {
  __typename?: 'CreateExporterColdStoreRequestPayload';
  /** Client change requests created for requested exporter cold store records */
  clientChangeRequests?: Maybe<Array<ExporterColdStoreClientChangeRequest>>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the operation succeeded */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Attributes for creating a farm */
export type CreateFarmAttribute = {
  /** The name of the farm */
  farmName: Scalars['String']['input'];
  /** The FBO code of the farm */
  farmCode: Scalars['String']['input'];
  /** The Global Gap number of the farm */
  globalGapNumber: Scalars['String']['input'];
  /** The producer name of the farm */
  producerName: Scalars['String']['input'];
  /** The ID of the production region of the farm */
  productionRegionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFarmFbo. */
export type CreateFarmFboPayload = {
  __typename?: 'CreateFarmFboPayload';
  /** The errors that occurred while creating the farm FBO */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The created farm FBO */
  foodBusinessOperator?: Maybe<FoodBusinessOperator>;
  /** The created masterfile config */
  masterfileConfig?: Maybe<MasterfileConfig>;
};

/** Basic attributes for adding Varieties to a Company */
export type CreateFarmVarietyAttributes = {
  companyId: Scalars['Int']['input'];
  hectares?: InputMaybe<Scalars['Float']['input']>;
  packingend: Scalars['String']['input'];
  packingstart: Scalars['String']['input'];
  peakcount?: InputMaybe<Scalars['String']['input']>;
  varietyid: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateFarmVariety. */
export type CreateFarmVarietyPayload = {
  __typename?: 'CreateFarmVarietyPayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of CreateFarmVarietyRequest. */
export type CreateFarmVarietyRequestPayload = {
  __typename?: 'CreateFarmVarietyRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']['output']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<FarmVarietyRequest>;
  /** The commodity id associated with the requested farm variety */
  commodityId?: Maybe<Scalars['Int']['output']>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
  /** The variety id associated with the requested farm variety */
  varietyId?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of CreateFinanceRule. */
export type CreateFinanceRulePayload = {
  __typename?: 'CreateFinanceRulePayload';
  /** Error information when attempting to create finance rules */
  errors?: Maybe<Scalars['String']['output']>;
  /** Finance rules created */
  financeRules?: Maybe<Array<FinanceRule>>;
};

/** Autogenerated return type of CreateFoodBusinessOperatorRequest. */
export type CreateFoodBusinessOperatorRequestPayload = {
  __typename?: 'CreateFoodBusinessOperatorRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']['output']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<FoodBusinessOperatorRequest>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateIgnoreErrorRequest. */
export type CreateIgnoreErrorRequestPayload = {
  __typename?: 'CreateIgnoreErrorRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']['output']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<ClientChangeRequest>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateIncotermLineItem. */
export type CreateIncotermLineItemPayload = {
  __typename?: 'CreateIncotermLineItemPayload';
  errors?: Maybe<Scalars['String']['output']>;
  lineItem?: Maybe<LineItem>;
};

/** Autogenerated return type of CreateIncotermLineItems. */
export type CreateIncotermLineItemsPayload = {
  __typename?: 'CreateIncotermLineItemsPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  lineItems?: Maybe<Array<LineItem>>;
};

/** Autogenerated return type of CreateInvoiceFromBatch. */
export type CreateInvoiceFromBatchPayload = {
  __typename?: 'CreateInvoiceFromBatchPayload';
  /** Any errors from creating the new invoice */
  errors?: Maybe<Scalars['String']['output']>;
  /** Created invoice from batch */
  invoice?: Maybe<Invoice>;
};

/** Autogenerated return type of CreateInvoice. */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  /** What went wrong when creating an invoice */
  errors?: Maybe<Scalars['String']['output']>;
  /** The invoice that was created */
  invoice?: Maybe<Invoice>;
};

/** Attributes for creating a line item */
export type CreateLineItemAttributes = {
  /** The id of the buyer associated with the line item */
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the seller associated with the line item */
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the variety associated with the line item */
  varietyId: Scalars['Int']['input'];
  /** The id of the commodity associated with the line item */
  commodityId: Scalars['Int']['input'];
  /** The quantity of the line item */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The unit of quantity of the line item */
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  /** The price of the line item per minor unit */
  priceMinorUnit?: InputMaybe<Scalars['Int']['input']>;
  /** The unit of price of the line item */
  priceUnit?: InputMaybe<Scalars['String']['input']>;
  /** The currency of the line item */
  currency: Scalars['String']['input'];
  /** The size counts of the line item */
  sizeCounts: Array<Scalars['String']['input']>;
  /** The pack of the line item */
  pack: Scalars['String']['input'];
  /** The price term of the line item */
  priceTerm: Scalars['String']['input'];
  /** The priority of the line item */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** The additional fields of the line item */
  additionalFields: Scalars['String']['input'];
  /** The pallet stack of the line item */
  palletStack: Scalars['Int']['input'];
  /** Whether the line item is unlimited */
  unlimited: Scalars['Boolean']['input'];
  /** The target market of the line item */
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  /** The target region of the line item */
  targetRegion: Scalars['String']['input'];
  /** The target country of the line item */
  targetCountry?: InputMaybe<Scalars['String']['input']>;
  /** The packing week of the line item */
  packingWeek?: InputMaybe<Scalars['String']['input']>;
  /** The start week of the line item */
  startWeek?: InputMaybe<Scalars['String']['input']>;
  /** The end week of the line item */
  endWeek?: InputMaybe<Scalars['String']['input']>;
  /** The incoterm of the line item */
  incoterm: Scalars['String']['input'];
  /** The grade of the line item */
  grade?: InputMaybe<Scalars['String']['input']>;
  /** The mark of the line item */
  mark?: InputMaybe<Scalars['String']['input']>;
  /** The reference number of the line item */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** The rank/ order of the line item */
  rank?: InputMaybe<Scalars['Int']['input']>;
  /** The batch number of the line item */
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  /** The inventory code of the line item */
  inventoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The id of the departure port of the line item */
  departurePortId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the destination port of the line item */
  destinationPortId?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for creating a line item grouping */
export type CreateLineItemGroupingAttributes = {
  /** The cumulative quantity of the line item grouping */
  cumulativeQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The type of quantity of the line item grouping */
  quantityType?: InputMaybe<Scalars['String']['input']>;
  /** The common fields associated with the line item grouping */
  commonFields: Array<Scalars['String']['input']>;
  /** The line items associated with the line item grouping */
  lineItems: Array<CreateLineItemAttributes>;
  /** The rank/ order of the line item grouping */
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateLoadOutInstruction. */
export type CreateLoadOutInstructionPayload = {
  __typename?: 'CreateLoadOutInstructionPayload';
  errors?: Maybe<Array<LoadOutInstructionError>>;
  loadOutInstruction?: Maybe<LoadOutInstruction>;
};

/** Autogenerated return type of CreateNetReturnProgram. */
export type CreateNetReturnProgramPayload = {
  __typename?: 'CreateNetReturnProgramPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  netReturnProgram?: Maybe<NetReturnProgram>;
};

/** Autogenerated return type of CreateOfferAsSupplier. */
export type CreateOfferAsSupplierPayload = {
  __typename?: 'CreateOfferAsSupplierPayload';
  /** What went wrong when creating the offer */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The offer that was created */
  offer?: Maybe<Offer>;
};

/** Attributes for creating an order */
export type CreateOrderAttributes = {
  /** The id of the buyer associated with the order */
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  /** The common fields associated with the order */
  commonFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the order is a packhouse run */
  isPackhouseRun: Scalars['Boolean']['input'];
  /** The line item groupings associated with the order */
  lineItemGroupings?: InputMaybe<Array<CreateLineItemGroupingAttributes>>;
  /** The id of the seller associated with the order */
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the user associated with the order */
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateOrder. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /** Errors that occurred while creating the order */
  errors?: Maybe<Scalars['String']['output']>;
  /** The order that was created */
  order?: Maybe<Order>;
};

/** Autogenerated return type of CreateOrderProgram. */
export type CreateOrderProgramPayload = {
  __typename?: 'CreateOrderProgramPayload';
  /** What went wrong when creating an order program */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The order program that was created */
  orderProgram?: Maybe<OrderProgram>;
};

/** Attributes for creating packhouse connections */
export type CreatePackhouseConnectionsAttribute = {
  /** The IDs of the packhouses we need to connect our company to */
  packhouseIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePackhouseConnectionsRequest. */
export type CreatePackhouseConnectionsRequestPayload = {
  __typename?: 'CreatePackhouseConnectionsRequestPayload';
  /** The packhouse connection client change requests */
  clientChangeRequests?: Maybe<Array<PackhouseConnectionClientChangeRequest>>;
  /** The errors that occurred while creating the packhouse connection requests */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CreatePayment. */
export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  /** What went wrong when creating a payment */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The payment that was created */
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of CreateQuickCost. */
export type CreateQuickCostPayload = {
  __typename?: 'CreateQuickCostPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateReportGroup. */
export type CreateReportGroupPayload = {
  __typename?: 'CreateReportGroupPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The report group */
  reportGroup?: Maybe<ReportGroup>;
};

/** Autogenerated return type of CreateShipmentLineItem. */
export type CreateShipmentLineItemPayload = {
  __typename?: 'CreateShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shipmentLineItem?: Maybe<ShipmentLineItem>;
};

/** Autogenerated return type of CreateShipment. */
export type CreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload';
  /** A list of error messages encountered during the mutation execution. Null if the creation is successful. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The created shipment object. Null if the creation fails. */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of CreateSoftwareUpdateReport. */
export type CreateSoftwareUpdateReportPayload = {
  __typename?: 'CreateSoftwareUpdateReportPayload';
  /** The client change request that was created */
  clientChangeRequest?: Maybe<SoftwareUpdateReportRequest>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Attributes for creating a supplier-exporter request */
export type CreateSupplierExporterRequestAttribute = {
  /** The IDs of the food business operators */
  foodBusinessOperatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of CreateSupplierExporterRequest. */
export type CreateSupplierExporterRequestPayload = {
  __typename?: 'CreateSupplierExporterRequestPayload';
  /** The created client change request */
  clientChangeRequests?: Maybe<Array<SupplierExporterClientChangeRequest>>;
  /** The errors that occurred while creating the client change request */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CreateUiConfig. */
export type CreateUiConfigPayload = {
  __typename?: 'CreateUiConfigPayload';
  config?: Maybe<UiConfig>;
};

export type CreateUpdateUiConfigAttributes = {
  configType: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  /** Required when updating a config item */
  id?: InputMaybe<Scalars['Int']['input']>;
  visibility: UiConfigVisibilityEnum;
};

/** A summary of the results of a tabular mutation */
export type CudSummary = {
  __typename?: 'CudSummary';
  /** Unique list of errors relating to failed changes. */
  errors: Array<Scalars['String']['output']>;
  /** Count of failed changes. */
  failed: Scalars['Int']['output'];
  /** Count of successful changes. */
  succeeded: Scalars['Int']['output'];
};

/** A currency as defined by the ISO 4217 standard. */
export type Currency = {
  __typename?: 'Currency';
  /** The currency format as defined by IS0 4217. */
  isoCode: Iso4217;
  /** The smallest denomination of the currency. */
  smallestDenomination: Scalars['Int']['output'];
  /** Factor used to convert a subunit to a unit. */
  subunitToUnit: Scalars['Int']['output'];
  /** The symbol for the currency (i.e. "€"). */
  symbol: Scalars['String']['output'];
};

/** Collection of Currency Conversions rates for a particular day */
export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  /** Unique indentifier for each currency conversion entry */
  id?: Maybe<Scalars['ID']['output']>;
  /** Currency conversion exchange rates */
  rates?: Maybe<Scalars['Json']['output']>;
  /** When exchange rates were stored */
  timestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes for loading a currency conversion */
export type CurrencyConversionAttributes = {
  /** Whether the conversion is a spot rate. i.e a daily rate */
  isSpotRate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the conversion is a fixed rate. i.e a company-specific rate */
  isFixedRate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the exchange */
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export enum CurrencyEnum {
  /** The currency with code USD */
  Usd = 'USD',
  /** The currency with code EUR */
  Eur = 'EUR',
  /** The currency with code GBP */
  Gbp = 'GBP',
  /** The currency with code CAD */
  Cad = 'CAD',
  /** The currency with code ZAR */
  Zar = 'ZAR',
  /** The currency with code JPY */
  Jpy = 'JPY',
  /** The currency with code CNY */
  Cny = 'CNY',
  /** The currency with code NAD */
  Nad = 'NAD'
}

/** Currency exchange rate type represents the exchange rate with parameters for a given resource. eg. Invoice, Payment, etc. */
export type CurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  /** The currency conversion associated with the set exchange rate, can be null for custom rates */
  currencyConversion?: Maybe<CurrencyConversion>;
  /** The currency conversion id associated with the set exchange rate, can be null for custom rates */
  currencyConversionId?: Maybe<Scalars['ID']['output']>;
  /** The actual exchange rate value */
  exchangeRate: Scalars['BigDecimal']['output'];
  /** The date of the exchange rate */
  exchangeRateDate: Scalars['ISO8601Date']['output'];
  /** The type of exchange rate eg. "custom", "fixed", "spot" */
  exchangeRateType: Scalars['String']['output'];
  /** The id of the exchangeable object */
  exchangeableId: Scalars['ID']['output'];
  /** The type of exchangeable object eg. "Invoice", "Payment" */
  exchangeableType: Scalars['String']['output'];
  /** The currency code of the currency being converted from */
  fromCurrency: Scalars['String']['output'];
  /** Unique identifier for the Currency Exchange Rate */
  id: Scalars['ID']['output'];
  /** The currency code of the currency being converted to */
  toCurrency: Scalars['String']['output'];
};

/** Attributes to set a currency exchange rate */
export type CurrencyExchangeRateAttributes = {
  /** Unique identifier for the Currency Exchange Rate */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The date of the exchange rate */
  exchangeRateDate: Scalars['ISO8601Date']['input'];
  /** The exchange rate */
  exchangeRate: Scalars['BigDecimal']['input'];
  /** The currency conversion id associated with the set exchange rate */
  currencyConversionId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of exchange rate eg. "custom", "fixed", "spot" */
  exchangeRateType: ExchangeRateTypeEnum;
  /** The currency code of the currency being converted from */
  fromCurrency: Scalars['String']['input'];
  /** The currency code of the currency being converted to */
  toCurrency: Scalars['String']['input'];
  /** The id of the exchangeable object */
  exchangeableId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of exchangeable object eg. "Invoice", "Payment" */
  exchangeableType: ExchangeableTypeEnum;
};

export type CustomField = {
  __typename?: 'CustomField';
  defaultValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFieldAttributes = {
  /** The id of the customField */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the custom field */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the custom field is required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the custom field should appear by default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The default value of the custom field */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardCartonGrouping = {
  __typename?: 'DashboardCartonGrouping';
  batchNumber?: Maybe<Scalars['String']['output']>;
  cartons?: Maybe<Scalars['Int']['output']>;
  commodityName?: Maybe<Scalars['String']['output']>;
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  containerId?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique sequence made up of 4 letters and 7 numbers, the container \
   *           number is displayed on the top right part of the container door
   */
  containerNumber?: Maybe<Scalars['String']['output']>;
  exporterCode?: Maybe<Scalars['String']['output']>;
  farmCode?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inspectionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  inventoryCode?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  netMass?: Maybe<Scalars['Float']['output']>;
  orchard?: Maybe<Scalars['String']['output']>;
  packhouseCode?: Maybe<Scalars['String']['output']>;
  packingWeek?: Maybe<Scalars['String']['output']>;
  palletGrossMass?: Maybe<Scalars['Float']['output']>;
  palletNumber?: Maybe<Scalars['String']['output']>;
  productCharacteristic?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  targetCountry?: Maybe<Scalars['String']['output']>;
  targetMarket?: Maybe<Scalars['String']['output']>;
  targetRegion?: Maybe<Scalars['String']['output']>;
  varietyName?: Maybe<Scalars['String']['output']>;
};

export type DashboardContainer = {
  __typename?: 'DashboardContainer';
  /** Actual arrival date of goods at current location, blank for goods on a vessel */
  arrivalDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Delivery event classifier. States if the arrival date is an estimate or an actual */
  arrivalEventClassifier?: Maybe<Scalars['String']['output']>;
  /** Number of cartons inside container or bulk grouping */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** Number of cartons inside container or bulk grouping that are in transit */
  cartonsInTransit?: Maybe<Scalars['Int']['output']>;
  /** Collection date of the goods at the current location */
  collectionDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Original unique identifier of an actual container, used for debugging purposes */
  containerId?: Maybe<Scalars['Int']['output']>;
  /** A unique sequence made up of 4 letters and 7 numbers, the container number is displayed on the top right part of the container door */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the container is a bulk grouping or an actual container */
  containerType?: Maybe<Scalars['String']['output']>;
  /** Actual or planned departure date of goods on a vessel, or actual or planned from current location */
  departureDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Collection event classifier. States if the departure Date is an estimate or an actual */
  departureEventClassifier?: Maybe<Scalars['String']['output']>;
  /** Actual or planned delivery date of the goods at the final location */
  finalDeliveryDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Identifier that combined with final_destination_type uniquely identifies a final destination */
  finalDestinationId?: Maybe<Scalars['Int']['output']>;
  /** Latitude of the final destination */
  finalDestinationLatitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude of the final destination */
  finalDestinationLongitude?: Maybe<Scalars['Float']['output']>;
  /** Name of the final destination */
  finalDestinationName?: Maybe<Scalars['String']['output']>;
  /** Describes the type of the final destination, e.g. SeaPort */
  finalDestinationType?: Maybe<Scalars['String']['output']>;
  /** Uniquely identifies this container */
  id?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier of the location this container was last seen or is currently situated at */
  locationId?: Maybe<Scalars['Int']['output']>;
  /** actual or planned delivery date of the goods at the next location */
  nextDeliveryDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Identifier that combined with next_destination_type uniquely identifies a final destination */
  nextDestinationId?: Maybe<Scalars['Int']['output']>;
  /** Latitude of the next destination */
  nextDestinationLatitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude of the next destination */
  nextDestinationLongitude?: Maybe<Scalars['Float']['output']>;
  /** Name of the next destination */
  nextDestinationName?: Maybe<Scalars['String']['output']>;
  /** Describes the type of the next destination, e.g. SeaPort */
  nextDestinationType?: Maybe<Scalars['String']['output']>;
  /** Number of pallets inside container or bulk grouping */
  pallets?: Maybe<Scalars['Int']['output']>;
  /** Number of pallets inside container or bulk grouping that are in transit */
  palletsInTransit?: Maybe<Scalars['Int']['output']>;
  /** Representative of the container's current state as a sequence of states representing the overall supply chain */
  state?: Maybe<Scalars['String']['output']>;
  /** Representative of the container's estimated state based on unallocated cartons in transit */
  stateInTransit?: Maybe<Scalars['String']['output']>;
};

export type DashboardFilters = {
  __typename?: 'DashboardFilters';
  commodities?: Maybe<Array<Commodity>>;
};

export type DashboardLocation = {
  __typename?: 'DashboardLocation';
  /** Number of cartons at location */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** Number of cartons at location that are in transit */
  cartonsInTransit?: Maybe<Scalars['Int']['output']>;
  /** Number of containers at location */
  containers?: Maybe<Scalars['Int']['output']>;
  /** Number of containers at location that are in transit */
  containersInTransit?: Maybe<Scalars['Int']['output']>;
  /** Coordinates of the location */
  geoLocation?: Maybe<GeoLocation>;
  /** Location identifier */
  id?: Maybe<Scalars['Int']['output']>;
  /**
   * Location latitude
   * @deprecated Replaced by geo_location
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Location identifier */
  locationId?: Maybe<Scalars['Int']['output']>;
  /** Location type */
  locationType?: Maybe<Scalars['String']['output']>;
  /**
   * Location longitude
   * @deprecated Replaced by geo_location
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Location name */
  name?: Maybe<Scalars['String']['output']>;
  /** Number of pallets at location */
  pallets?: Maybe<Scalars['Int']['output']>;
  /** Number of pallets at location that are in transit */
  palletsInTransit?: Maybe<Scalars['Int']['output']>;
  /** Number of unallocated containers or carton groupings at location */
  unallocated?: Maybe<Scalars['Int']['output']>;
  /** Number of unallocated containers or carton groupings at location that are in transit */
  unallocatedInTransit?: Maybe<Scalars['Int']['output']>;
};

export enum DashboardSearchFieldsEnum {
  BatchNumber = 'batch_number',
  ArrivalEventClassifier = 'arrival_event_classifier',
  CommodityName = 'commodity_name',
  ConsignmentNumber = 'consignment_number',
  ContainerNumber = 'container_number',
  ContainerType = 'container_type',
  DepartureDate = 'departure_date',
  DepartureEventClassifier = 'departure_event_classifier',
  ExporterCode = 'exporter_code',
  FarmCode = 'farm_code',
  Grade = 'grade',
  FinalDeliveryDatetime = 'final_delivery_datetime',
  FinalDestinationName = 'final_destination_name',
  FinalDestinationType = 'final_destination_type',
  InspectionDate = 'inspection_date',
  InventoryCode = 'inventory_code',
  LocationType = 'location_type',
  Mark = 'mark',
  Name = 'name',
  NextDeliveryDatetime = 'next_delivery_datetime',
  NextDestinationName = 'next_destination_name',
  NextDestinationType = 'next_destination_type',
  Orchard = 'orchard',
  PackhouseCode = 'packhouse_code',
  PackingWeek = 'packing_week',
  PalletNumber = 'pallet_number',
  ProductCharacteristic = 'product_characteristic',
  ArrivalDate = 'arrival_date',
  State = 'state',
  StateInTransit = 'state_in_transit',
  TargetCountry = 'target_country',
  TargetMarket = 'target_market',
  TargetRegion = 'target_region',
  VarietyName = 'variety_name'
}

export type DashboardTrackingData = {
  __typename?: 'DashboardTrackingData';
  /** current active order carton_groupings */
  cartonGroupings?: Maybe<Array<DashboardCartonGrouping>>;
  /** current active order containers */
  containers?: Maybe<Array<DashboardContainer>>;
  /** current active order locations */
  locations?: Maybe<Array<DashboardLocation>>;
};

/** Contains information on data generation output */
export type DataOutput = {
  __typename?: 'DataOutput';
  /** Timestamp representing the date this document was last updated */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp representing the date this document was last downloaded */
  downloadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Data source type associated with this data output */
  fileType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']['output']>;
  /** The documents produced from template generation */
  outputFile?: Maybe<Document>;
};

/** Attributes for creating or updating a Data Output */
export type DataOutputAttributes = {
  /** Date and time the Data Output was downloaded */
  downloadedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** ID of the Data Output */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains information on data preparation */
export type DataPreparation = {
  __typename?: 'DataPreparation';
  /** The documents produced from template generation */
  dataOutputs?: Maybe<Array<DataOutput>>;
  /** Description of the output */
  description?: Maybe<Scalars['String']['output']>;
  /** Provides further detail if state is errored */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of the output */
  name?: Maybe<Scalars['String']['output']>;
  /** State of the template generation (Created, Processing, Errored, Completed) */
  status?: Maybe<Scalars['String']['output']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DefaultCost = {
  __typename?: 'DefaultCost';
  /** CGT associated with this default cost */
  cartonGroupingTransaction?: Maybe<CartonGroupingTransaction>;
  /** Finance rule associated with this default cost */
  financeRule?: Maybe<FinanceRule>;
  /** Unique default cost identifier */
  id?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for DefaultCost. */
export type DefaultCostConnection = {
  __typename?: 'DefaultCostConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DefaultCostEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DefaultCost>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DefaultCostEdge = {
  __typename?: 'DefaultCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DefaultCost>;
};

export type DefaultCostFilters = {
  /** Finance rule associated with the default cost */
  financeRuleId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the default costs are finalised or not */
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of pallet numbers to filter by. */
  palletNumbers?: InputMaybe<Scalars['String']['input']>;
  /** List of container numbers to filter by. */
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Defect = {
  __typename?: 'Defect';
  /** The category the defect belongs to */
  category?: Maybe<DefectCategoryEnum>;
  /** The ID of the defect */
  id: Scalars['Int']['output'];
  /** The name of the defect */
  name?: Maybe<Scalars['String']['output']>;
};

export enum DefectCategoryEnum {
  /** The defect categorisation: progressive */
  Progressive = 'progressive',
  /** The defect categorisation: cosmetic */
  Cosmetic = 'cosmetic',
  /** The defect categorisation: other */
  Other = 'other'
}

export type DefectInput = {
  /** Defect Category */
  category: DefectCategoryEnum;
  /** Defect ID */
  id: Scalars['ID']['input'];
  /** Defect Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DefectPercentageCaptureAttributes = {
  /** Claim Line Item Grouping ID */
  claimLineItemGroupingId: Scalars['ID']['input'];
  /** Progressive  Defects */
  progressiveDefects?: InputMaybe<Array<ClaimLineItemDefectInput>>;
  /** Cosmetic  Defects */
  cosmeticDefects?: InputMaybe<Array<ClaimLineItemDefectInput>>;
  /** Other Defects */
  otherDefects?: InputMaybe<Array<ClaimLineItemDefectInput>>;
  /** Progressive Defects Group Total Percentage */
  progressiveDefectsGroupTotalPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Cosmetic Defects Group Total Percentage */
  cosmeticDefectsGroupTotalPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Other Defects Group Total Percentage */
  otherDefectsGroupTotalPercentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of DeleteAddendumLineItem. */
export type DeleteAddendumLineItemPayload = {
  __typename?: 'DeleteAddendumLineItemPayload';
  addendumLineItems?: Maybe<Array<AddendumLineItem>>;
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteAdditionalField. */
export type DeleteAdditionalFieldPayload = {
  __typename?: 'DeleteAdditionalFieldPayload';
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteCartonConversion. */
export type DeleteCartonConversionPayload = {
  __typename?: 'DeleteCartonConversionPayload';
  /** The deleted Carton Conversion */
  cartonConversion?: Maybe<CartonConversion>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteComment. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  comment?: Maybe<Comment>;
};

/** Autogenerated return type of DeleteCompanyCertificate. */
export type DeleteCompanyCertificatePayload = {
  __typename?: 'DeleteCompanyCertificatePayload';
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteContact. */
export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The contact was deleted */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of DeleteCurrencyExchangeRate. */
export type DeleteCurrencyExchangeRatePayload = {
  __typename?: 'DeleteCurrencyExchangeRatePayload';
  /** The unique identifier of the currency exchange rate that was deleted */
  currencyExchangeRateId?: Maybe<Scalars['ID']['output']>;
  /** Errors that occurred while deleting the currency exchange rate */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of DeleteCustomField. */
export type DeleteCustomFieldPayload = {
  __typename?: 'DeleteCustomFieldPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The custom field was deleted */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of DeleteEmployee. */
export type DeleteEmployeePayload = {
  __typename?: 'DeleteEmployeePayload';
  employeeId?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteEphytoDocument. */
export type DeleteEphytoDocumentPayload = {
  __typename?: 'DeleteEphytoDocumentPayload';
  /** The ID of the Ephyto Document */
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteEphyto. */
export type DeleteEphytoPayload = {
  __typename?: 'DeleteEphytoPayload';
  /** Response message when attempting to delete */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteExportDocument. */
export type DeleteExportDocumentPayload = {
  __typename?: 'DeleteExportDocumentPayload';
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteFarmVarietyImage. */
export type DeleteFarmVarietyImagePayload = {
  __typename?: 'DeleteFarmVarietyImagePayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of DeleteFarmVariety. */
export type DeleteFarmVarietyPayload = {
  __typename?: 'DeleteFarmVarietyPayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of DeleteFinanceRule. */
export type DeleteFinanceRulePayload = {
  __typename?: 'DeleteFinanceRulePayload';
  errors?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteInvoiceDocument. */
export type DeleteInvoiceDocumentPayload = {
  __typename?: 'DeleteInvoiceDocumentPayload';
  /** Errors that occurred during deletion */
  errors: Array<Scalars['String']['output']>;
  /** The updated invoice after document deletion */
  invoice?: Maybe<Invoice>;
};

/** Autogenerated return type of DeleteInvoice. */
export type DeleteInvoicePayload = {
  __typename?: 'DeleteInvoicePayload';
  /** What went wrong when deleting the invoice */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteLoadOutInstruction. */
export type DeleteLoadOutInstructionPayload = {
  __typename?: 'DeleteLoadOutInstructionPayload';
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteNetReturnProgram. */
export type DeleteNetReturnProgramPayload = {
  __typename?: 'DeleteNetReturnProgramPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  netReturnProgram?: Maybe<NetReturnProgram>;
};

/** Autogenerated return type of DeleteOrderProgram. */
export type DeleteOrderProgramPayload = {
  __typename?: 'DeleteOrderProgramPayload';
  /** What went wrong when deleting an order program */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The order program that was deleted */
  orderProgram?: Maybe<OrderProgram>;
};

/** Autogenerated return type of DeletePayment. */
export type DeletePaymentPayload = {
  __typename?: 'DeletePaymentPayload';
  /** What went wrong when deleting the payment */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The payment that was deleted */
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of DeleteReportGroup. */
export type DeleteReportGroupPayload = {
  __typename?: 'DeleteReportGroupPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The report group was deleted */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of DeleteShipmentDocument. */
export type DeleteShipmentDocumentPayload = {
  __typename?: 'DeleteShipmentDocumentPayload';
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteShipmentLineItem. */
export type DeleteShipmentLineItemPayload = {
  __typename?: 'DeleteShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DeleteTaskDocument. */
export type DeleteTaskDocumentPayload = {
  __typename?: 'DeleteTaskDocumentPayload';
  /** Errors that occurred during the delete */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Tasks for the given Shipment Line Item (after update) */
  tasks?: Maybe<Array<TaskableTask>>;
};

/** Autogenerated return type of DeleteUiConfig. */
export type DeleteUiConfigPayload = {
  __typename?: 'DeleteUiConfigPayload';
  id?: Maybe<Scalars['Int']['output']>;
};

export type Document = {
  __typename?: 'Document';
  contentType?: Maybe<Scalars['String']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the file was uploaded */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  v2Url?: Maybe<Scalars['String']['output']>;
};

export type DocumentProcessingProgress = {
  __typename?: 'DocumentProcessingProgress';
  /** The ID of the document */
  documentId?: Maybe<Scalars['ID']['output']>;
  /** The name of the file */
  filename?: Maybe<Scalars['String']['output']>;
  /** The size of the file */
  filesize?: Maybe<Scalars['String']['output']>;
  /** The file extension */
  filetype?: Maybe<Scalars['String']['output']>;
  /** The status of the document processing */
  status?: Maybe<Scalars['String']['output']>;
  /** The updated_at timestamp */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Attributes for a document, including ID and source. */
export type DocumentSource = {
  /** The ID of the document/activestorageattachment. */
  id: Scalars['ID']['input'];
  /** The source of the document/activestorageattachment. */
  source: Scalars['String']['input'];
};

/** Attributes for the document being downloaded */
export type DownloadDocumentAttributes = {
  /** The ID of the document uploaded by user */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the document generated */
  platformDocumentId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the file */
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of DownloadDocuments. */
export type DownloadDocumentsPayload = {
  __typename?: 'DownloadDocumentsPayload';
  /** Errors that occurred during download */
  errors: Array<Scalars['String']['output']>;
  /** Temporary URL to download the zip file */
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DraftEphyto. */
export type DraftEphytoPayload = {
  __typename?: 'DraftEphytoPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to submit draft */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DuplicateAddendumLineItem. */
export type DuplicateAddendumLineItemPayload = {
  __typename?: 'DuplicateAddendumLineItemPayload';
  addendumLineItems?: Maybe<Array<AddendumLineItem>>;
};

/** Autogenerated return type of DuplicateEphyto. */
export type DuplicateEphytoPayload = {
  __typename?: 'DuplicateEphytoPayload';
  /** The ID of the Ephyto to duplicate */
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of DuplicateInvoice. */
export type DuplicateInvoicePayload = {
  __typename?: 'DuplicateInvoicePayload';
  /** Any errors from duplicating */
  errors?: Maybe<Scalars['String']['output']>;
  /** id of the duplicated invoice */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of DuplicateShipmentLineItem. */
export type DuplicateShipmentLineItemPayload = {
  __typename?: 'DuplicateShipmentLineItemPayload';
  /** All SLIs on the shipment */
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
};

export type ElasticHit = {
  __typename?: 'ElasticHit';
  highlight?: Maybe<Scalars['Json']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<ElasticHitSourceUnion>;
};

export type ElasticHitSourceUnion = DashboardCartonGrouping | DashboardContainer | DashboardLocation;

export type ElasticSearchResult = {
  __typename?: 'ElasticSearchResult';
  /** Array of results from elasticsearch */
  hits?: Maybe<Array<ElasticHit>>;
  /** The raw response from Elasticsearch. Use only for debugging. */
  raw?: Maybe<Scalars['Json']['output']>;
  /** Info on how many matching items were found in total. hits may only be a subset */
  total?: Maybe<ElasticTotal>;
};

export type ElasticTotal = {
  __typename?: 'ElasticTotal';
  relation?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** Attributes related to the emailing of a set of documents */
export type EmailDocumentsAttributes = {
  /** Body of the email */
  body: Scalars['String']['input'];
  /** The documents to send */
  documents: Array<DocumentSource>;
  /** Comma-seperated list of recipient email address */
  recipients: Array<Scalars['String']['input']>;
  /** Comma-seperated list of carbon copy email address */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Subject of the email */
  subject: Scalars['String']['input'];
};

/** Autogenerated return type of EmailDocuments. */
export type EmailDocumentsPayload = {
  __typename?: 'EmailDocumentsPayload';
  /** Any errors that occured during processing */
  errors?: Maybe<Scalars['String']['output']>;
  /** Return Message */
  message: Scalars['String']['output'];
};

export type EmailTaskDocumentsAttributes = {
  /** Body of the email */
  body: Scalars['String']['input'];
  /** IDs of the tasks to send documents from */
  ids: Array<Scalars['Int']['input']>;
  /** Comma-seperated list of recipient email address */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email */
  subject: Scalars['String']['input'];
};

/** Autogenerated return type of EmailTaskDocuments. */
export type EmailTaskDocumentsPayload = {
  __typename?: 'EmailTaskDocumentsPayload';
  /** Any errors that occured during processing */
  errors?: Maybe<Scalars['String']['output']>;
  /** Return Message */
  message: Scalars['String']['output'];
};

/** Returns all attributes needed to embed a PowerBI report. */
export type EmbeddedChart = {
  __typename?: 'EmbeddedChart';
  /** Report embed access token */
  embedToken?: Maybe<Scalars['String']['output']>;
  /** Report embed URL */
  embedUrl?: Maybe<Scalars['String']['output']>;
  /** Report Id in powerbi */
  reportId?: Maybe<Scalars['String']['output']>;
  /** Report embed config variables */
  settings?: Maybe<Scalars['String']['output']>;
};

export type Employee = {
  __typename?: 'Employee';
  /** The ID of the Employee */
  id?: Maybe<Scalars['Int']['output']>;
  /** The first name of the User the Employee belongs to */
  userFirstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the User the Employee belongs to */
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type Ephyto = {
  __typename?: 'Ephyto';
  /** Any additional treatment information */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  /** Is additional inspection required */
  additionalInspection?: Maybe<Scalars['Boolean']['output']>;
  /** Agreement Code related the commodity and target country */
  agreementCode?: Maybe<Scalars['String']['output']>;
  /** Reference returned by Ecert when Phyto has been submitted */
  applicationReferenceNo?: Maybe<Scalars['String']['output']>;
  /** The status for the Phyto returned from Ecert */
  applicationStatus?: Maybe<Scalars['String']['output']>;
  /** Type of Ephyto being applied for */
  applicationType?: Maybe<Scalars['Int']['output']>;
  /** Is Phyto based on the original */
  basedOnOriginalPhyto?: Maybe<Scalars['Boolean']['output']>;
  /** Booking Reference */
  bookingRef?: Maybe<Scalars['String']['output']>;
  /** The scientific name of the plant */
  botanicalName?: Maybe<Scalars['String']['output']>;
  /** Ecert Business Registered ID to be billed for the Phyto */
  cbrBillingId?: Maybe<Scalars['Int']['output']>;
  /** Ecert Business Registered ID applying for the Phyto */
  cbrId?: Maybe<Scalars['Int']['output']>;
  /** Flexi Field for CBS Free Area on the ephyto */
  cbsFreeArea?: Maybe<Scalars['String']['output']>;
  /** Type of chemical applied */
  chemical?: Maybe<Scalars['String']['output']>;
  /** Company that this ephyto belongs to */
  companyId?: Maybe<Scalars['Int']['output']>;
  /** The concentration of chemical application */
  concentration?: Maybe<Scalars['String']['output']>;
  /** Consignees Address */
  consigneeAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Consignees Address */
  consigneeAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Consignees Address */
  consigneeAddressLine3?: Maybe<Scalars['String']['output']>;
  /** Consignees Country Code */
  consigneeCountryId?: Maybe<Scalars['String']['output']>;
  /** Consignees registered ID on Ecert */
  consigneeId?: Maybe<Scalars['String']['output']>;
  /** Consignees name */
  consigneeName?: Maybe<Scalars['String']['output']>;
  /** Consignors address */
  consignorAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Consignors address */
  consignorAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Consignors address */
  consignorAddressLine3?: Maybe<Scalars['String']['output']>;
  /** Consignors registered Id on Ecert */
  consignorId?: Maybe<Scalars['String']['output']>;
  /** Consignors name */
  consignorName?: Maybe<Scalars['String']['output']>;
  /** Reference No */
  customReferenceNo?: Maybe<Scalars['String']['output']>;
  /** DALRRD registered Account number to handle payments */
  dalrrdAccNum?: Maybe<Scalars['String']['output']>;
  /** Means of conveyance */
  declaredMeansOfConveyance?: Maybe<Scalars['String']['output']>;
  /** First Point of Entry */
  declaredPointOfEntry?: Maybe<Scalars['String']['output']>;
  /** Date of Departure for Vessel */
  departureDate?: Maybe<Scalars['String']['output']>;
  /** The location where the EPhyto is issued */
  desiredIssueLocation?: Maybe<Scalars['String']['output']>;
  /** The scientific name of the plant */
  distinguishingMarks?: Maybe<Scalars['String']['output']>;
  /** Length of treatment and temperature applied */
  durationAndTemperature?: Maybe<Scalars['String']['output']>;
  /** Consignment items declared for the ephyto */
  ephytoConsignmentItems?: Maybe<Array<EphytoConsignmentItem>>;
  /** Supporting documents uploaded for the ephyto */
  ephytoDocuments?: Maybe<Array<EphytoDocument>>;
  /** Trade Units declared for the Ephyto */
  ephytoTradeUnits?: Maybe<Array<EphytoTradeUnit>>;
  /** Error tracking for the Ephyto */
  errorReason?: Maybe<Scalars['String']['output']>;
  /** Ephyto ID */
  id: Scalars['ID']['output'];
  /** Import Country Code */
  importCountryId?: Maybe<Scalars['String']['output']>;
  /** Flexi Field for import permit date on the ephyto */
  importPermitDate?: Maybe<Scalars['String']['output']>;
  /** Flexi Field for import permit no on the ephyto */
  importPermitNo?: Maybe<Scalars['String']['output']>;
  /** PPECB Activity Point Code that represents the load point */
  loadSeaPoint?: Maybe<Scalars['String']['output']>;
  /** Name of the product and declared quantity */
  nameOfProductAndDeclaredQuantity?: Maybe<Scalars['String']['output']>;
  /** Email where updates will be sent via Ecert */
  notificationEmail?: Maybe<Scalars['String']['output']>;
  /** Number and description of Package */
  numberAndDescriptionOfPackage?: Maybe<Scalars['String']['output']>;
  /** Is the consignment in the same or packed in a new container */
  originalContainer?: Maybe<Scalars['Boolean']['output']>;
  /** The original phyto or a certified copy if false */
  originalPhyto?: Maybe<Scalars['Boolean']['output']>;
  /** Date of issuance for original phyto */
  originalPhytoDate?: Maybe<Scalars['String']['output']>;
  /** The original phyto no being reexported */
  originalPhytoNo?: Maybe<Scalars['String']['output']>;
  /** Type of Payment such as Cash or Account */
  paymentType?: Maybe<Scalars['String']['output']>;
  /** Place of origin */
  placeOfOrigin?: Maybe<Scalars['String']['output']>;
  /** Location Code for port of entry */
  portOfEntry?: Maybe<Scalars['String']['output']>;
  /** Is the original Phyto repacked */
  rePacked?: Maybe<Scalars['Boolean']['output']>;
  /** The reexport phyto place of origin */
  reexportPlaceOfOrigin?: Maybe<Scalars['String']['output']>;
  /** Flexi Field for regime code on the ephyto */
  regimeCode?: Maybe<Scalars['String']['output']>;
  /** Internal State of the Ephyto */
  state?: Maybe<Scalars['String']['output']>;
  /** Stuff Date related to the Ephyto */
  stuffDate?: Maybe<Scalars['String']['output']>;
  /** Target Country Code */
  targetCountry?: Maybe<Scalars['String']['output']>;
  /** Target Country Code */
  targetCountryId?: Maybe<Scalars['String']['output']>;
  /** Target Region Code */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** Temperature Regime */
  temperatureRegime?: Maybe<Scalars['String']['output']>;
  /** Further describing transport eg. Container Vessel if Marine */
  transportMeans?: Maybe<Scalars['String']['output']>;
  /** Transport Type code to represent Air or Marine */
  transportModeCode?: Maybe<Scalars['Int']['output']>;
  /** Type of treatment */
  treatment?: Maybe<Scalars['String']['output']>;
  /** Date of treatment */
  treatmentDate?: Maybe<Scalars['String']['output']>;
  /** Location Code */
  unloadingBaseportLocation?: Maybe<Scalars['String']['output']>;
  /** When the ephyto was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Flexi Field for VAT no on the ephyto */
  vatNo?: Maybe<Scalars['String']['output']>;
  /** Vessel or Carrier Name */
  vessel?: Maybe<Scalars['String']['output']>;
  /** Voyage Number or Flight Number */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

/** Agreement Attributes related to exporting */
export type EphytoAgreementCode = {
  __typename?: 'EphytoAgreementCode';
  /** Agreement Code for exporting goods to a country */
  agreementCode?: Maybe<Scalars['String']['output']>;
  /** Agreement Name for exporting goods to a country */
  agreementName?: Maybe<Scalars['String']['output']>;
};

export type EphytoAttributes = {
  /** Ephyto ID */
  id: Scalars['ID']['input'];
  /** Reference returned by Ecert when Phyto has been submitted */
  applicationReferenceNo?: InputMaybe<Scalars['String']['input']>;
  /** Type of Ephyto being applied for */
  applicationType?: InputMaybe<Scalars['Int']['input']>;
  /** The status for the Phyto returned from Ecert */
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  /** Ecert Business Registered ID applying for the Phyto */
  cbrId?: InputMaybe<Scalars['Int']['input']>;
  /** Ecert Business Registered ID to be billed for the Phyto */
  cbrBillingId?: InputMaybe<Scalars['Int']['input']>;
  /** Reference No */
  customReferenceNo?: InputMaybe<Scalars['String']['input']>;
  /** Agreement Code related the commodity and target country */
  agreementCode?: InputMaybe<Scalars['String']['input']>;
  /** The location where the EPhyto is issued */
  desiredIssueLocation?: InputMaybe<Scalars['String']['input']>;
  /** Email where updates will be sent via Ecert */
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Consignors registered Id on Ecert */
  consignorId?: InputMaybe<Scalars['String']['input']>;
  /** Consignors name */
  consignorName?: InputMaybe<Scalars['String']['input']>;
  /** Consignors address */
  consignorAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Consignors address */
  consignorAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Consignors address */
  consignorAddressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Consignees registered ID on Ecert */
  consigneeId?: InputMaybe<Scalars['String']['input']>;
  /** Consignees name */
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** Consignees Address */
  consigneeAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Consignees Address */
  consigneeAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Consignees Address */
  consigneeAddressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Consignees Country Code */
  consigneeCountryId?: InputMaybe<Scalars['String']['input']>;
  /** Import Country Code */
  importCountryId?: InputMaybe<Scalars['String']['input']>;
  /** Target Country Code */
  targetCountryId?: InputMaybe<Scalars['String']['input']>;
  /** Location Code */
  unloadingBaseportLocation?: InputMaybe<Scalars['String']['input']>;
  /** Transport Type code to represent Air or Marine */
  transportModeCode?: InputMaybe<Scalars['Int']['input']>;
  /** Further describing transport eg. Container Vessel if Marine */
  transportMeans?: InputMaybe<Scalars['String']['input']>;
  /** Type of Payment such as Cash or Account */
  paymentType?: InputMaybe<Scalars['String']['input']>;
  /** DALRRD registered Account number to handle payments */
  dalrrdAccNum?: InputMaybe<Scalars['String']['input']>;
  /** PPECB Activity Point Code that represents the load point */
  loadSeaPoint?: InputMaybe<Scalars['String']['input']>;
  /** Target Country Code */
  targetCountry?: InputMaybe<Scalars['String']['input']>;
  /** Target Region Code */
  targetRegion?: InputMaybe<Scalars['String']['input']>;
  /** Location Code for port of entry */
  portOfEntry?: InputMaybe<Scalars['String']['input']>;
  /** Booking Reference */
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  /** Vessel or Carrier Name */
  vessel?: InputMaybe<Scalars['String']['input']>;
  /** Voyage Number or Flight Number */
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date of Departure for Vessel */
  departureDate?: InputMaybe<Scalars['String']['input']>;
  /** Stuff Date related to the Ephyto */
  stuffDate?: InputMaybe<Scalars['String']['input']>;
  /** Temperature Regime */
  temperatureRegime?: InputMaybe<Scalars['String']['input']>;
  /** Number and description of Package */
  numberAndDescriptionOfPackage?: InputMaybe<Scalars['String']['input']>;
  /** The scientific name of the plant */
  botanicalName?: InputMaybe<Scalars['String']['input']>;
  /** The scientific name of the plant */
  distinguishingMarks?: InputMaybe<Scalars['String']['input']>;
  /** Place of origin */
  placeOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** Means of conveyance */
  declaredMeansOfConveyance?: InputMaybe<Scalars['String']['input']>;
  /** First Point of Entry */
  declaredPointOfEntry?: InputMaybe<Scalars['String']['input']>;
  /** Name of the product and declared quantity */
  nameOfProductAndDeclaredQuantity?: InputMaybe<Scalars['String']['input']>;
  /** Date of treatment */
  treatmentDate?: InputMaybe<Scalars['String']['input']>;
  /** Type of treatment */
  treatment?: InputMaybe<Scalars['String']['input']>;
  /** Type of chemical applied */
  chemical?: InputMaybe<Scalars['String']['input']>;
  /** Length of treatment and temperature applied */
  durationAndTemperature?: InputMaybe<Scalars['String']['input']>;
  /** The concentration of chemical application */
  concentration?: InputMaybe<Scalars['String']['input']>;
  /** Any additional treatment information */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Company that this ephyto belongs to */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** Internal State of the Ephyto */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Date of issuance for original phyto */
  originalPhytoDate?: InputMaybe<Scalars['String']['input']>;
  /** The original phyto no being reexported */
  originalPhytoNo?: InputMaybe<Scalars['String']['input']>;
  /** The reexport phyto place of origin */
  reexportPlaceOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The original phyto or a certified copy if false */
  originalPhyto?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the original Phyto repacked */
  rePacked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the consignment in the same or packed in a new container */
  originalContainer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Phyto based on the original */
  basedOnOriginalPhyto?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is additional inspection required */
  additionalInspection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flexi Field for CBS Free Area on the ephyto */
  cbsFreeArea?: InputMaybe<Scalars['String']['input']>;
  /** Flexi Field for VAT no on the ephyto */
  vatNo?: InputMaybe<Scalars['String']['input']>;
  /** Flexi Field for regime code on the ephyto */
  regimeCode?: InputMaybe<Scalars['String']['input']>;
  /** Flexi Field for import permit no on the ephyto */
  importPermitNo?: InputMaybe<Scalars['String']['input']>;
  /** Flexi Field for import permit date on the ephyto */
  importPermitDate?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Ephyto. */
export type EphytoConnection = {
  __typename?: 'EphytoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EphytoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Ephyto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EphytoConsignmentItem = {
  __typename?: 'EphytoConsignmentItem';
  /** Additional notes or declarations for consignment */
  additionalConsignmentNotes?: Maybe<Scalars['String']['output']>;
  /** Additional notes for treatments */
  appliedProcessAdditionalNote?: Maybe<Scalars['String']['output']>;
  /** Chemical Ingredient */
  appliedProcessChemicalCode?: Maybe<Scalars['String']['output']>;
  /** Concentration Level */
  appliedProcessConcentration?: Maybe<Scalars['String']['output']>;
  /** Unit of measure for concentration */
  appliedProcessConcentrationUnitCode?: Maybe<Scalars['String']['output']>;
  /** Treatment End Date */
  appliedProcessEndDate?: Maybe<Scalars['String']['output']>;
  /** Treatment Start Date */
  appliedProcessStartDate?: Maybe<Scalars['String']['output']>;
  /** Temperature applied */
  appliedProcessTemperature?: Maybe<Scalars['String']['output']>;
  /** Unit of measure for temperature */
  appliedProcessTemperatureUnitCode?: Maybe<Scalars['String']['output']>;
  /** Treatment Type Level 1 */
  appliedProcessTreatmentTypeLevel1?: Maybe<Scalars['String']['output']>;
  /** Treatment Type Level 2 */
  appliedProcessTreatmentTypeLevel2?: Maybe<Scalars['String']['output']>;
  /** Condition of commodity */
  commodityConditionClass?: Maybe<Scalars['String']['output']>;
  /** Commoditys intent of use */
  commodityIntentOfUseClass?: Maybe<Scalars['String']['output']>;
  /** Type of commodity class */
  commodityVegetablePart?: Maybe<Scalars['String']['output']>;
  /** General product name */
  commonName?: Maybe<Scalars['String']['output']>;
  /** Harmonized system code */
  customsHarmonizedSystemClass?: Maybe<Scalars['String']['output']>;
  /** Product Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of treatment */
  durationMeasure?: Maybe<Scalars['String']['output']>;
  /** Unit code for the duration of treatment */
  durationMeasureCode?: Maybe<Scalars['String']['output']>;
  /** Ephyto ID this item belongs to */
  ephytoId?: Maybe<Scalars['Int']['output']>;
  /** Summary of the full treatment as would appear on the Phyto. */
  fullTreatmentInformation?: Maybe<Scalars['String']['output']>;
  /** Gross weight */
  grossWeightMeasure?: Maybe<Scalars['String']['output']>;
  /** Unit of measure for the gross weight */
  grossWeightMeasureCode?: Maybe<Scalars['String']['output']>;
  /** Internal Unique Consignment Item ID */
  id: Scalars['ID']['output'];
  /** Net weight */
  netWeightMeasure?: Maybe<Scalars['String']['output']>;
  /** Unit of measure for net weight */
  netWeightMeasureCode?: Maybe<Scalars['String']['output']>;
  /** Quantity of packaged items */
  packageItemQuantity?: Maybe<Scalars['String']['output']>;
  /** Unit of code to quantify the packaged item */
  packageItemUnitCode?: Maybe<Scalars['String']['output']>;
  /** Package Level */
  packageLevelCode?: Maybe<Scalars['String']['output']>;
  /** Visible Shipping Marks */
  packageShippingMarks?: Maybe<Scalars['String']['output']>;
  /** Package Type */
  packageTypeCode?: Maybe<Scalars['String']['output']>;
  /** The scientific name of the product */
  scientificName?: Maybe<Scalars['String']['output']>;
  /** A number used to uniquely identify a consignment for updates on eCert */
  sequenceNumeric?: Maybe<Scalars['String']['output']>;
};

export type EphytoConsignmentItemAttributes = {
  /** Consignment Item ID in our DB */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Product Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** General product name */
  commonName?: InputMaybe<Scalars['String']['input']>;
  /** The scientific name of the product */
  scientificName?: InputMaybe<Scalars['String']['input']>;
  /** Unit of measure for net weight */
  netWeightMeasureCode?: InputMaybe<Scalars['String']['input']>;
  /** Net weight */
  netWeightMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Unit of measure for the gross weight */
  grossWeightMeasureCode?: InputMaybe<Scalars['String']['input']>;
  /** Gross weight */
  grossWeightMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Harmonized system code */
  customsHarmonizedSystemClass?: InputMaybe<Scalars['String']['input']>;
  /** Type of commodity class */
  commodityVegetablePart?: InputMaybe<Scalars['String']['input']>;
  /** Condition of commodity */
  commodityConditionClass?: InputMaybe<Scalars['String']['input']>;
  /** Commoditys intent of use */
  commodityIntentOfUseClass?: InputMaybe<Scalars['String']['input']>;
  /** Treatment Start Date */
  appliedProcessStartDate?: InputMaybe<Scalars['String']['input']>;
  /** Treatment End Date */
  appliedProcessEndDate?: InputMaybe<Scalars['String']['input']>;
  /** Unit code for the duration of treatment */
  durationMeasureCode?: InputMaybe<Scalars['String']['input']>;
  /** Duration of treatment */
  durationMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Treatment Type Level 1 */
  appliedProcessTreatmentTypeLevel1?: InputMaybe<Scalars['String']['input']>;
  /** Treatment Type Level 2 */
  appliedProcessTreatmentTypeLevel2?: InputMaybe<Scalars['String']['input']>;
  /** Chemical Ingredient */
  appliedProcessChemicalCode?: InputMaybe<Scalars['String']['input']>;
  /** Unit of measure for temperature */
  appliedProcessTemperatureUnitCode?: InputMaybe<Scalars['String']['input']>;
  /** Temperature applied */
  appliedProcessTemperature?: InputMaybe<Scalars['String']['input']>;
  /** Unit of measure for concentration */
  appliedProcessConcentrationUnitCode?: InputMaybe<Scalars['String']['input']>;
  /** Concentration Level */
  appliedProcessConcentration?: InputMaybe<Scalars['String']['input']>;
  /** Additional notes for treatments */
  appliedProcessAdditionalNote?: InputMaybe<Scalars['String']['input']>;
  /** Summary of the full treatment as would appear on the Phyto. */
  fullTreatmentInformation?: InputMaybe<Scalars['String']['input']>;
  /** Package Level */
  packageLevelCode?: InputMaybe<Scalars['String']['input']>;
  /** Package Type */
  packageTypeCode?: InputMaybe<Scalars['String']['input']>;
  /** Unit of code to quantify the packaged item */
  packageItemUnitCode?: InputMaybe<Scalars['String']['input']>;
  /** Quantity of packaged items */
  packageItemQuantity?: InputMaybe<Scalars['String']['input']>;
  /** Visible Shipping Marks */
  packageShippingMarks?: InputMaybe<Scalars['String']['input']>;
  /** Additional notes or declarations for consignment */
  additionalConsignmentNotes?: InputMaybe<Scalars['String']['input']>;
  /** A number used to uniquely identify a consignment for updates on eCert */
  sequenceNumeric?: InputMaybe<Scalars['String']['input']>;
  /** Ephyto ID this item belongs to */
  ephytoId?: InputMaybe<Scalars['Int']['input']>;
};

export type EphytoCountry = {
  __typename?: 'EphytoCountry';
  /** Country ISO alpha code */
  isoCode?: Maybe<Scalars['String']['output']>;
  /** Name of country */
  name?: Maybe<Scalars['String']['output']>;
};

export type EphytoDocument = {
  __typename?: 'EphytoDocument';
  /** The Ecert Ephyto specified document type */
  documentType?: Maybe<Scalars['String']['output']>;
  /** The document associated with the EphytoDocument */
  file?: Maybe<Document>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']['output']>;
};

/** An edge in a connection. */
export type EphytoEdge = {
  __typename?: 'EphytoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Ephyto>;
};

export type EphytoFilterAttribute = {
  __typename?: 'EphytoFilterAttribute';
  /** ephyto consignees */
  consignees?: Maybe<Array<Scalars['String']['output']>>;
  /** ephyto consignors */
  consignors?: Maybe<Array<Scalars['String']['output']>>;
  /** ephyto customer references */
  customerReferences?: Maybe<Array<Scalars['String']['output']>>;
  /** ephyto ports of entry */
  entryPorts?: Maybe<Array<Scalars['String']['output']>>;
  /** ephyto statuses */
  statuses?: Maybe<Array<Scalars['String']['output']>>;
  /** ephyto vessels */
  vessels?: Maybe<Array<Scalars['String']['output']>>;
};

export type EphytoFilterAttributes = {
  /** ephyto statuses */
  applicationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ephyto customer references */
  customerReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ephyto ports of entry */
  entryPorts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ephyto consignees */
  consignees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ephyto consignors */
  consignors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ephyto vessels */
  vessels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EphytoLocation = {
  __typename?: 'EphytoLocation';
  /** Location code value */
  code?: Maybe<Scalars['String']['output']>;
  /** Display name of location */
  name?: Maybe<Scalars['String']['output']>;
};

export type EphytoPackage = {
  __typename?: 'EphytoPackage';
  /** Code of the package type */
  code?: Maybe<Scalars['String']['output']>;
  /** Display name of the package type */
  name?: Maybe<Scalars['String']['output']>;
};

export type EphytoPortOfEntry = {
  __typename?: 'EphytoPortOfEntry';
  /** Location code value */
  code?: Maybe<Scalars['String']['output']>;
  /** Display name of port of entry */
  name?: Maybe<Scalars['String']['output']>;
};

export type EphytoTradeUnit = {
  __typename?: 'EphytoTradeUnit';
  /** Clients Reference for this trade unit */
  clientRef?: Maybe<Scalars['String']['output']>;
  /** Commodity Code */
  commodity?: Maybe<Scalars['String']['output']>;
  /** Container Number if applicable for trade unit */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** Ephyto ID this trade unit belongs to */
  ephytoId?: Maybe<Scalars['Int']['output']>;
  /** Flesh color for trade unit if applicable */
  fleshColour?: Maybe<Scalars['String']['output']>;
  /** Trade Unit Id in our DB */
  id: Scalars['ID']['output'];
  /** PPECB manifest no for the trade unit */
  inspectionManifestNo?: Maybe<Scalars['String']['output']>;
  /** PPECB Actvitiy Point Code for inspection */
  inspectionPointLocationCode?: Maybe<Scalars['String']['output']>;
  /** Marketing Indication for trade unit */
  marketingIndication?: Maybe<Scalars['String']['output']>;
  /** Nett Weight */
  netTradeUnitWeight?: Maybe<Scalars['String']['output']>;
  /** Pallet Nett Weight */
  nettPalletWeight?: Maybe<Scalars['String']['output']>;
  /** Packaged Quantity for trade unit */
  numberOfPackagedItems?: Maybe<Scalars['String']['output']>;
  /** Orchard Code */
  orchard?: Maybe<Scalars['String']['output']>;
  /** Phyto Stats for Orchard */
  orchardPhytoStatus?: Maybe<Scalars['String']['output']>;
  /** Packhouse code for trade unit */
  phc?: Maybe<Scalars['String']['output']>;
  /** Date of inspection as on PO */
  ppecbInspectionDate?: Maybe<Scalars['String']['output']>;
  /** Production Area */
  productionArea?: Maybe<Scalars['String']['output']>;
  /** DALRRD PUC Code */
  puc?: Maybe<Scalars['String']['output']>;
  /** Loading Date for trade unit */
  stuffDate?: Maybe<Scalars['String']['output']>;
  /** Trade Units ID such as pallet or container number */
  tradeUnitId?: Maybe<Scalars['String']['output']>;
  /** product class code for the trade unit */
  tuClass?: Maybe<Scalars['String']['output']>;
};

export type EphytoTreatment = {
  __typename?: 'EphytoTreatment';
  /** First level of chemical treatment */
  firstLevel?: Maybe<Scalars['String']['output']>;
  /** Unique code for first level */
  firstLevelCode?: Maybe<Scalars['String']['output']>;
  /** Second level of chemical treatment */
  secondLevel?: Maybe<Scalars['String']['output']>;
  /** Unique code for second level */
  secondLevelCode?: Maybe<Scalars['String']['output']>;
};

export type Estimate = {
  __typename?: 'Estimate';
  cartonType: CartonType;
  commodity: Commodity;
  company: Company;
  estimateValues?: Maybe<Array<EstimateValue>>;
  fboOrchard?: Maybe<FboOrchard>;
  id: Scalars['Int']['output'];
  packHouse?: Maybe<FoodBusinessOperator>;
  productionUnit?: Maybe<FoodBusinessOperator>;
  provider?: Maybe<Company>;
  season: Scalars['Int']['output'];
  variety?: Maybe<Variety>;
  visibleCompanies?: Maybe<Array<Company>>;
  week?: Maybe<Scalars['String']['output']>;
};

/** Basic attributes for creating & updating an estimate */
export type EstimateAttributes = {
  cartonTypeId: Scalars['Int']['input'];
  commodityId: Scalars['Int']['input'];
  fboOrchardId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  packHouseId?: InputMaybe<Scalars['Int']['input']>;
  productionUnitId?: InputMaybe<Scalars['Int']['input']>;
  providerId: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
  values: Array<EstimateValueAttributes>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
  visibleCompanyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  week?: InputMaybe<Scalars['String']['input']>;
};

/** Determines how estimates and line items are matched. */
export enum EstimateMatchModeEnum {
  Provider = 'provider',
  ProviderProducer = 'provider_producer',
  Phc = 'phc',
  Puc = 'puc',
  Variety = 'variety',
  SubCommodity = 'sub_commodity',
  Commodity = 'commodity'
}

export type EstimateValue = {
  __typename?: 'EstimateValue';
  acceptedValue: Scalars['Float']['output'];
  conversionWeight?: Maybe<Scalars['Float']['output']>;
  estType: EstimateValueTypeEnum;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inSeasonValue?: Maybe<Scalars['Float']['output']>;
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['Float']['output'];
};


export type EstimateValueAcceptedValueArgs = {
  matchCols?: InputMaybe<Array<EstimateMatchModeEnum>>;
};

/** Basic attributes for creating & updating an estimate value */
export type EstimateValueAttributes = {
  conversionWeight?: InputMaybe<Scalars['Float']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  estType: EstimateValueTypeEnum;
  grade?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inSeasonValue?: InputMaybe<Scalars['Float']['input']>;
  sizeCounts?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['Float']['input'];
};

/** The type of estimate value. Either picked (kg) or packed (cartons) */
export enum EstimateValueTypeEnum {
  Picked = 'picked',
  Packed = 'packed'
}

export type EtlDocument = {
  __typename?: 'EtlDocument';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Document type from document mapping, or "unknown" if no mapping */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Email from address if source is an email */
  emailFrom?: Maybe<Scalars['String']['output']>;
  /** Email to address if source is an email */
  emailTo?: Maybe<Scalars['String']['output']>;
  errorReason?: Maybe<Scalars['String']['output']>;
  erroredRows?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** ETL states per linked invoice (derived from document rows) */
  invoiceEtlStates?: Maybe<Array<EtlInvoiceState>>;
  /** Invoices created by this document (vendor invoices only) */
  invoices?: Maybe<Array<Invoice>>;
  processedRows?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  /** Source of the document (user name, email to, or source type/id) */
  source?: Maybe<Scalars['String']['output']>;
  state: EtlDocumentStateEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for EtlDocument. */
export type EtlDocumentConnection = {
  __typename?: 'EtlDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EtlDocumentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EtlDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EtlDocumentEdge = {
  __typename?: 'EtlDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EtlDocument>;
};

export type EtlDocumentRow = {
  __typename?: 'EtlDocumentRow';
  createdAt: Scalars['ISO8601DateTime']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  processOutput?: Maybe<Scalars['String']['output']>;
  state: EtlDocumentRowStateEnum;
  value: Scalars['Json']['output'];
};

/** The connection type for EtlDocumentRow. */
export type EtlDocumentRowConnection = {
  __typename?: 'EtlDocumentRowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EtlDocumentRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EtlDocumentRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EtlDocumentRowEdge = {
  __typename?: 'EtlDocumentRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EtlDocumentRow>;
};

export enum EtlDocumentRowStateEnum {
  Unprocessed = 'unprocessed',
  Mapped = 'mapped',
  Processed = 'processed',
  Skipped = 'skipped',
  Errored = 'errored'
}

export enum EtlDocumentStateEnum {
  Created = 'created',
  Unmapped = 'unmapped',
  Processed = 'processed',
  Processing = 'processing',
  Ignored = 'ignored',
  Duplicate = 'duplicate',
  Errored = 'errored'
}

export type EtlInvoiceState = {
  __typename?: 'EtlInvoiceState';
  invoiceId: Scalars['Int']['output'];
  processOutput?: Maybe<Scalars['String']['output']>;
  state?: Maybe<EtlDocumentRowStateEnum>;
};

/** The type of exchange rate eg. "custom", "fixed", "spot" */
export enum ExchangeRateTypeEnum {
  /** The exchange rate type is custom */
  Custom = 'CUSTOM',
  /** The exchange rate type is fixed */
  Fixed = 'FIXED',
  /** The exchange rate type is spot */
  Spot = 'SPOT'
}

/** The type of exchangeable object eg. "Invoice", "Payment" */
export enum ExchangeableTypeEnum {
  /** The exchangeable type is Invoice */
  Invoice = 'INVOICE',
  /** The exchangeable type is Payment */
  Payment = 'PAYMENT'
}

export enum ExpectedClaimEnum {
  /** The expected claim: quality */
  Quality = 'quality',
  /** The expected claim: market */
  Market = 'market',
  /** The expected claim: insurance */
  Insurance = 'insurance'
}

export type ExpectedReturnSummary = {
  __typename?: 'ExpectedReturnSummary';
  equivalentPrice?: Maybe<IncotermPrice>;
  error?: Maybe<Scalars['String']['output']>;
  pricePoints?: Maybe<Array<IncotermPrice>>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ExportDocument = {
  __typename?: 'ExportDocument';
  documentType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Document>;
  id?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type ExporterCode = {
  __typename?: 'ExporterCode';
  /** The buyer company */
  buyerCompany?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The actual exporter code */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** The exporter company */
  exporterCompany?: Maybe<Company>;
  /** Unique identifier for the exporter code */
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A client change request for requested exporter cold store records */
export type ExporterColdStoreClientChangeRequest = {
  __typename?: 'ExporterColdStoreClientChangeRequest';
  /** The cold store to be added (pending approval) */
  coldStore?: Maybe<FoodBusinessOperator>;
  /** The supplier-exporter company association */
  companyAssociation?: Maybe<CompanyAssociation>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']['output']>;
  /** The status of the client change request */
  status?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ExtendedField = {
  __typename?: 'ExtendedField';
  /** company the extended fields are for */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** polymorphic parent ID */
  resourceId: Scalars['ID']['output'];
  /** polymorphic parent e.g. CartonGrouping */
  resourceType: Scalars['String']['output'];
  /** extended fields key-value pairs */
  value?: Maybe<Scalars['Json']['output']>;
};

export type FarmVariety = {
  __typename?: 'FarmVariety';
  /** The commodity record associated with the farm variety */
  commodity?: Maybe<Commodity>;
  /** The commodity name associated with the farm variety */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** The id of the company associated with the farm variety. */
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The area of this farm variety in hectares */
  hectares?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the farm variety */
  id?: Maybe<Scalars['Int']['output']>;
  /** Image objects related to the farm variety */
  images?: Maybe<Array<Image>>;
  /** The full name of the variety, including sub-commodity and variety code */
  name?: Maybe<Scalars['String']['output']>;
  /** The last week for packing, formatted as a string */
  packingEnd?: Maybe<Scalars['String']['output']>;
  /** The starting week for packing, formatted as a string */
  packingStart?: Maybe<Scalars['String']['output']>;
  /** A string representing the size count with the highest volume */
  peakCount?: Maybe<Scalars['String']['output']>;
  /** The status of the farm variety */
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The variety record associated with the farm variety */
  variety?: Maybe<Variety>;
  /** The variety codes associated with the farm variety */
  varietyCode?: Maybe<Scalars['String']['output']>;
  /** The variety id associated with the farm variety */
  varietyId?: Maybe<Scalars['Int']['output']>;
  /** The name of the farm variety */
  varietyName?: Maybe<Scalars['String']['output']>;
};

export type FarmVarietyFilterAttribute = {
  __typename?: 'FarmVarietyFilterAttribute';
  /** List of commodity names */
  commodityName?: Maybe<Array<Scalars['String']['output']>>;
  /** List of available states */
  status?: Maybe<Array<Scalars['String']['output']>>;
};

export type FarmVarietyFilters = {
  /** The commodities to filter on */
  commodityName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The statuses to filter on */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FarmVarietyRequest = {
  __typename?: 'FarmVarietyRequest';
  /** The commodity name associated with the farm variety */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the client change request */
  id?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the farm variety after the request is approved */
  modelId?: Maybe<Scalars['ID']['output']>;
  /** The name of the requested farm variety */
  name?: Maybe<Scalars['String']['output']>;
  /** Status of the change request */
  status?: Maybe<Scalars['String']['output']>;
  /** The variety codes associated with the requested farm variety */
  varietyCode?: Maybe<Scalars['String']['output']>;
};

export type FboOrchard = {
  __typename?: 'FboOrchard';
  block?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  foodBusinessOperator: FoodBusinessOperator;
  hectares?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  orchard: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  variety: Variety;
};


export type FboOrchardHectaresArgs = {
  season?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of FetchEphytoStatus. */
export type FetchEphytoStatusPayload = {
  __typename?: 'FetchEphytoStatusPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to fetch ephyto status */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of FetchTransnetContainerOperators. */
export type FetchTransnetContainerOperatorsPayload = {
  __typename?: 'FetchTransnetContainerOperatorsPayload';
  /** The container operators */
  containerOperators?: Maybe<Array<Scalars['Json']['output']>>;
  /** List of error messages */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of FetchTransnetVisitsByShipment. */
export type FetchTransnetVisitsByShipmentPayload = {
  __typename?: 'FetchTransnetVisitsByShipmentPayload';
  /** Error message if the fetch fails */
  error?: Maybe<Scalars['String']['output']>;
  /** The visit list */
  visitList?: Maybe<Array<Visit>>;
};

/** Fields defining a generic filter model */
export type Filter = {
  /** Field to filter on */
  field?: InputMaybe<Scalars['String']['input']>;
  /** can be a value of 'text' or 'number' */
  fieldType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter type in report group:
   * - 'input': Custom text entry.
   * - 'idSelection': Dropdown 'id', for backend identifiers.
   * - 'labelSelection': Dropdown 'label', for display text.
   * Select based on backend requirements.
   *
   */
  filterType?: InputMaybe<Scalars['String']['input']>;
  /** Filtering condition: 'equals', 'notEqual', 'contains','notContains', 'startsWith', 'endsWith','lessThan', 'lessThanOrEqual', 'greaterThan','greaterThanOrEqual', 'inRange' */
  condition?: InputMaybe<Scalars['String']['input']>;
  /** The value you want to filter on. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** The value you want to filter on. */
  filterTo?: InputMaybe<Scalars['String']['input']>;
  /** The values you want to filter on. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Attributes for finalising default costs */
export type FinaliseDefaultCostAttributes = {
  /** The ID of the Finance Rule being used to update the default costs */
  financeRuleId: Scalars['ID']['input'];
  /** Container Ids to update */
  containerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Pallet numbers to update */
  palletNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The amount to override the default cost with */
  overrideAmountMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The percentage to override the default cost with */
  overridePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Autogenerated return type of FinaliseDefaultCosts. */
export type FinaliseDefaultCostsPayload = {
  __typename?: 'FinaliseDefaultCostsPayload';
  /** Finalised CGT IDs associated with this finance rule */
  cgtIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Error information when attempting to finalise default costs */
  errors?: Maybe<Scalars['String']['output']>;
};

export type FinanceReport = {
  __typename?: 'FinanceReport';
  items?: Maybe<Array<FinanceReportItem>>;
};

export type FinanceReportFilterAttributes = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  endWeek?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startWeek?: InputMaybe<Scalars['String']['input']>;
  transactions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FinanceReportItem = {
  __typename?: 'FinanceReportItem';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPerCarton?: Maybe<Scalars['Float']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Scalars['String']['output']>;
  cartons?: Maybe<Scalars['Int']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  containerNumber?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  exporterCode?: Maybe<Scalars['String']['output']>;
  farmCode?: Maybe<Scalars['String']['output']>;
  generalLedgerName?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  incoterm?: Maybe<Scalars['String']['output']>;
  isActual?: Maybe<Scalars['Boolean']['output']>;
  liReferenceNumber?: Maybe<Scalars['String']['output']>;
  packType?: Maybe<Scalars['String']['output']>;
  packingWeek?: Maybe<Scalars['String']['output']>;
  palletNumber?: Maybe<Scalars['String']['output']>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  secondaryCategory?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<Scalars['String']['output']>;
  shippingWeek?: Maybe<Scalars['String']['output']>;
  sizeCount?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stdCartons?: Maybe<Scalars['Int']['output']>;
  targetMarket?: Maybe<Scalars['String']['output']>;
  targetRegion?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  transactionWeek?: Maybe<Scalars['String']['output']>;
  txReferenceNumber?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<Scalars['String']['output']>;
  zarAmount?: Maybe<Scalars['Float']['output']>;
  zarPerCarton?: Maybe<Scalars['Float']['output']>;
};

export type FinanceRule = {
  __typename?: 'FinanceRule';
  /** The amount in cents related to the finance rule. */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** The company associated with the finance rule. */
  company?: Maybe<Company>;
  /** The cost code associated with the finance rule. */
  costCode?: Maybe<CostCode>;
  /** Date and time when the finance rule created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The currency in which the finance rule is denominated. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The amount of CGTs this rule has been finalised on */
  defaultCgtsFinalised?: Maybe<Scalars['Int']['output']>;
  /** The amount of CGTs this rule has created but are still  estimates */
  defaultCgtsPendingReview?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the finance rule is enabled or active. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The date when the finance rule will end or expire. */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Formatted cost string including currency, amount, and unit */
  formattedCost?: Maybe<Scalars['String']['output']>;
  /** The cost codes associated with the grouped finance rule, including their effective dates */
  groupedCostCodes?: Maybe<Array<GroupedCostCode>>;
  /** Returns the match condition in a human-readable format */
  humanReadableExpression?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the finance rule. */
  id: Scalars['ID']['output'];
  /** The incoterm used for calculating percentages */
  incotermForPercentageCalculation?: Maybe<Scalars['String']['output']>;
  /** Whether this finance rule creates default costs or not */
  isDefaultCost: Scalars['Boolean']['output'];
  /** The match condition associated with this finance rule */
  matchCondition?: Maybe<MatchCondition>;
  /** The name or label of the finance rule. */
  name: Scalars['String']['output'];
  /** The percentage value applied within the finance rule, if applicable. */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Description of this finance rule */
  ruleDescription?: Maybe<Scalars['String']['output']>;
  /** Returns the simple expression if the rule is simple. */
  simpleExpression?: Maybe<Scalars['String']['output']>;
  /** The extracted fields from the simple expression. */
  simpleExpressionFields?: Maybe<Array<Scalars['String']['output']>>;
  /** The match types from the simple expression. */
  simpleExpressionMatchTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The extracted values from the simple expression. */
  simpleExpressionValues?: Maybe<Array<Scalars['String']['output']>>;
  /** The date when the finance rule starts. */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The unit of measurement for the finance rule. */
  unit?: Maybe<FinanceRuleUnitEnum>;
  /** Date and time when the finance rule was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FinanceRuleAttributes = {
  /**
   * The amount in minor units (e.g.,
   *               cents) for this finance rule
   */
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the company associated with this finance rule (optional) */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the cost code associated with this finance rule */
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The currency in which the amount is specified */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the finance rule is currently enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The end date after which the finance rule is no longer applicable */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The ID of the finance rule */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The Incoterm used for percentage calculation,
   *               if applicable
   */
  incotermForPercentageCalculation?: InputMaybe<Scalars['String']['input']>;
  /** Attributes for the match condition associated with this finance rule */
  matchConditionAttributes?: InputMaybe<MatchConditionAttributes>;
  /** The name of the finance rule */
  name: Scalars['String']['input'];
  /**
   * The percentage value for this finance rule,
   *               if applicable
   */
  percentage?: InputMaybe<Scalars['Float']['input']>;
  /** The start date from which the finance rule is applicable */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The unit of measure for this finance rule e.g. KG, PALLET */
  unit: Scalars['String']['input'];
  /** Indicates whether this finance rule is a default cost */
  isDefaultCost: Scalars['Boolean']['input'];
};

/** The connection type for FinanceRule. */
export type FinanceRuleConnection = {
  __typename?: 'FinanceRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FinanceRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FinanceRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FinanceRuleEdge = {
  __typename?: 'FinanceRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FinanceRule>;
};

/** A user-readable error for FinanceRule */
export type FinanceRuleError = {
  __typename?: 'FinanceRuleError';
  /** A description of the error */
  message: Scalars['String']['output'];
};

export type FinanceRuleFilterAttribute = {
  __typename?: 'FinanceRuleFilterAttribute';
  /** Cost codes associated with the finance rules */
  costCodes?: Maybe<Array<CostCode>>;
  /** Currencies used in the finance rules */
  currencies?: Maybe<Array<Scalars['String']['output']>>;
  /** Is finance rules enabled? */
  enabled?: Maybe<Array<Scalars['Boolean']['output']>>;
  /** End dates for the finance rules */
  endDates?: Maybe<Array<Scalars['String']['output']>>;
  /** Is a default cost finance rule? */
  isDefaultCost?: Maybe<Scalars['Boolean']['output']>;
  /** Names of the finance rules */
  ruleNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Start dates for the finance rules */
  startDates?: Maybe<Array<Scalars['String']['output']>>;
  /** Units of measurement used in the finance rules */
  units?: Maybe<Array<Scalars['String']['output']>>;
};

export type FinanceRuleFilters = {
  /** List of finance rule IDs to filter by. */
  financeRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of cost code IDs to filter by. */
  costCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Currency to filter by. */
  currency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name to filter by. */
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by enabled status. */
  enabled?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by default cost status. */
  isDefaultCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Incoterm for percentage calculation to filter by. */
  incotermForPercentageCalculation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Unit to filter by. */
  unit?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Start date to filter by. */
  startDate?: InputMaybe<Array<Scalars['ISO8601Date']['input']>>;
  /** End date to filter by. */
  endDate?: InputMaybe<Array<Scalars['ISO8601Date']['input']>>;
  /** Whether the screen should display active or historic costs */
  pageType?: InputMaybe<Scalars['String']['input']>;
};

/** The unit of measurement for the finance rule. */
export enum FinanceRuleUnitEnum {
  Kg = 'KG',
  RawCarton = 'RAW_CARTON',
  StdCarton = 'STD_CARTON',
  Pallet = 'PALLET',
  Container = 'CONTAINER',
  Percentage = 'PERCENTAGE',
  PercentageOfIncoterm = 'PERCENTAGE_OF_INCOTERM'
}

/** A financial year option for filtering */
export type FinancialYearOption = {
  __typename?: 'FinancialYearOption';
  /** FY end date */
  endDate: Scalars['ISO8601Date']['output'];
  /** Human-readable short label (e.g. "FY27 (Mar 2026 - Feb 2027)") */
  label: Scalars['String']['output'];
  /** FY start date */
  startDate: Scalars['ISO8601Date']['output'];
  /** The calendar year the FY ends in (end-year convention, e.g. 2027 for Mar 2026 - Feb 2027 on a Mar-Feb company) */
  year: Scalars['Int']['output'];
};

/** Autogenerated return type of FindOrCreateVessel. */
export type FindOrCreateVesselPayload = {
  __typename?: 'FindOrCreateVesselPayload';
  /** Any errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The vessel */
  vessel?: Maybe<Vessel>;
};

export type FoodBusinessOperator = {
  __typename?: 'FoodBusinessOperator';
  /** The address of the food business operator */
  address?: Maybe<Address>;
  /** The company associated with the food business operator */
  company?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The unique DALRAD code for the food business operator */
  fboCode?: Maybe<Scalars['String']['output']>;
  /** The GlobalGAP certification number */
  globalGapNumber?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this food business operator */
  id?: Maybe<Scalars['Int']['output']>;
  /** The latitude coordinate of the food business operator */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The location mappings for this food business operator */
  locationMappings?: Maybe<Array<LocationMapping>>;
  /** The longitude coordinate of the food business operator */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The name of the food business operator */
  name?: Maybe<Scalars['String']['output']>;
  /** The packhouse connections for this food business operator */
  packhouseConnections?: Maybe<Array<PackhouseConnection>>;
  /** The producer name of this food business operator */
  producerName?: Maybe<Scalars['String']['output']>;
  /** The production region of this food business operator */
  productionRegion?: Maybe<Scalars['String']['output']>;
  /** The status of the food business operator */
  status?: Maybe<Scalars['String']['output']>;
  /** The type of business for this food business operator */
  typeOfBusiness?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FoodBusinessOperatorFilterAttribute = {
  __typename?: 'FoodBusinessOperatorFilterAttribute';
  /** The list of statuses */
  status?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of type of businesses */
  typeOfBusiness?: Maybe<Array<Scalars['String']['output']>>;
};

export type FoodBusinessOperatorFilters = {
  /** The status to filter on */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The type of business to filter on */
  typeOfBusiness?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FoodBusinessOperatorRequest = {
  __typename?: 'FoodBusinessOperatorRequest';
  /** The unique DALRAD code for the food business operator */
  fboCode?: Maybe<Scalars['String']['output']>;
  /** The GlobalGAP certification number */
  globalGapNumber?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the food business operator request */
  id: Scalars['ID']['output'];
  /** The latitude coordinate of the food business operator */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the food business operator */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the farm variety after the request is approved */
  modelId?: Maybe<Scalars['Int']['output']>;
  /** The name of the requested food business operator */
  name?: Maybe<Scalars['String']['output']>;
  /** The producer name of this requested food business operator */
  producerName?: Maybe<Scalars['String']['output']>;
  /** The production region of this requested food business operator */
  productionRegion?: Maybe<Scalars['String']['output']>;
  /** Status of the change request */
  status?: Maybe<Scalars['String']['output']>;
  /** The type of business for this requested food business operator */
  typeOfBusiness?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateAccountStatementOutputFiles. */
export type GenerateAccountStatementOutputFilesPayload = {
  __typename?: 'GenerateAccountStatementOutputFilesPayload';
  /** The account statement containing state of the file generation */
  accountStatement?: Maybe<AccountStatement>;
};

/** Autogenerated return type of GenerateAccountingExport. */
export type GenerateAccountingExportPayload = {
  __typename?: 'GenerateAccountingExportPayload';
  /** The accounting export containing state of the file generation */
  accountingExport?: Maybe<AccountingExport>;
  /** Errors that occurred during the export */
  exportErrors?: Maybe<Array<AccountingExportError>>;
};

/** Autogenerated return type of GenerateAddendumHeaderOutputFiles. */
export type GenerateAddendumHeaderOutputFilesPayload = {
  __typename?: 'GenerateAddendumHeaderOutputFilesPayload';
  /** The template output object containing state of the file generation */
  templateOutput?: Maybe<Array<TemplateOutput>>;
};

/** Autogenerated return type of GenerateAddendum. */
export type GenerateAddendumPayload = {
  __typename?: 'GenerateAddendumPayload';
  /** The Addendum Header */
  addendumHeader?: Maybe<AddendumHeader>;
  /** Errors */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateAg1TableOutputFile. */
export type GenerateAg1TableOutputFilePayload = {
  __typename?: 'GenerateAg1TableOutputFilePayload';
  /** UUID of the file generation request */
  requestId: Scalars['String']['output'];
};

/** Autogenerated return type of GenerateAirAddendum. */
export type GenerateAirAddendumPayload = {
  __typename?: 'GenerateAirAddendumPayload';
  /** The generated addendum header */
  addendumHeader?: Maybe<AddendumHeader>;
  /** Errors */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateArrivalQcs. */
export type GenerateArrivalQcsPayload = {
  __typename?: 'GenerateArrivalQcsPayload';
  /** Errors that occurred during the generation of the arrival qcs */
  errors: Array<Scalars['String']['output']>;
  /** Whether triggering the generation of the arrival qcs was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GenerateCommoditySeasons. */
export type GenerateCommoditySeasonsPayload = {
  __typename?: 'GenerateCommoditySeasonsPayload';
  error?: Maybe<Scalars['String']['output']>;
  failures?: Maybe<Scalars['Int']['output']>;
  successes?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of GenerateDataOutputFiles. */
export type GenerateDataOutputFilesPayload = {
  __typename?: 'GenerateDataOutputFilesPayload';
  /** The template output object containing state of the file generation */
  dataPreparation?: Maybe<DataPreparation>;
};

/** Autogenerated return type of GenerateEphyto. */
export type GenerateEphytoPayload = {
  __typename?: 'GenerateEphytoPayload';
  /** The Resulting Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Errors */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateEphytoTradeUnit. */
export type GenerateEphytoTradeUnitPayload = {
  __typename?: 'GenerateEphytoTradeUnitPayload';
  /** The Resulting EphytoTradeUnits */
  ephytoTradeUnits?: Maybe<Array<EphytoTradeUnit>>;
  /** Errors */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateInvoiceOutputFiles. */
export type GenerateInvoiceOutputFilesPayload = {
  __typename?: 'GenerateInvoiceOutputFilesPayload';
  /** The template output object containing state of the file generation */
  templateOutput?: Maybe<Array<TemplateOutput>>;
};

/** Autogenerated return type of GenerateLoadOutInstructionOutputFiles. */
export type GenerateLoadOutInstructionOutputFilesPayload = {
  __typename?: 'GenerateLoadOutInstructionOutputFilesPayload';
  /** The template output object containing state of the file generation */
  templateOutput?: Maybe<Array<TemplateOutput>>;
};

/** Autogenerated return type of GeneratePalletInOutputFiles. */
export type GeneratePalletInOutputFilesPayload = {
  __typename?: 'GeneratePalletInOutputFilesPayload';
  /** Unique identifier of the created or updated pallet in */
  palletInId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of GeneratePalletOutOutputFiles. */
export type GeneratePalletOutOutputFilesPayload = {
  __typename?: 'GeneratePalletOutOutputFilesPayload';
  /** Unique identifier of the created or updated pallet out */
  palletOutId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of GenerateProducerStatement. */
export type GenerateProducerStatementPayload = {
  __typename?: 'GenerateProducerStatementPayload';
  /** URL for the generated statement file (from persisted TemplateOutput) */
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The generated statement number (e.g. PS-00001) */
  statementNumber: Scalars['String']['output'];
};

/** Autogenerated return type of GenerateShipmentExportNotificationOutputFiles. */
export type GenerateShipmentExportNotificationOutputFilesPayload = {
  __typename?: 'GenerateShipmentExportNotificationOutputFilesPayload';
  /** The shipment containing state of the file generation */
  shipment?: Maybe<Shipment>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  /** Latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  lon?: Maybe<Scalars['Float']['output']>;
};

export type GridColumn = {
  aggFunc?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** This defines a request for a SSR AG Grid */
export type GridRequest = {
  /** First row requested or undefined for all rows. */
  startRow: Scalars['Int']['input'];
  /** Last row requested or undefined for all rows. */
  endRow: Scalars['Int']['input'];
  /** Columns that are currently row grouped. */
  rowGroupCols?: InputMaybe<Array<GridColumn>>;
  /** Columns that have aggregations on them. */
  valueCols?: InputMaybe<Array<GridColumn>>;
  /** Columns that have pivot on them. */
  pivotCols?: InputMaybe<Array<GridColumn>>;
  /** Defines if pivot mode is on or off. */
  pivotMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** What groups the user is viewing. */
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If filtering, what the filter model is. */
  filterModel?: InputMaybe<Array<Filter>>;
  /** If sorting, what the sort model is. */
  sortModel?: InputMaybe<Array<GridSortModel>>;
};

/** Fields defining the sorting model for AG Grid */
export type GridSortModel = {
  /** Column Id to apply the sort to. */
  colId: Scalars['String']['input'];
  /** Sort direction. 'asc' or 'desc' */
  sort: Scalars['String']['input'];
};

export type GroupedCostCode = {
  __typename?: 'GroupedCostCode';
  /** The cost code */
  costCode: CostCode;
  /** End date for this cost code in the finance rule */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the finance rule that is used to group this cost code */
  financeRuleId?: Maybe<Scalars['ID']['output']>;
  /** Start date for this cost code in the finance rule */
  startDate: Scalars['ISO8601DateTime']['output'];
};

/** Historical market volume data showing percentage share by company, region, commodity and grade */
export type HistoricalMarketVolume = {
  __typename?: 'HistoricalMarketVolume';
  /** Name of the commodity */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** Company of the historical market volume */
  company?: Maybe<Company>;
  /** ID of the company */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Name of the company */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Grade classification of the fruit */
  grade?: Maybe<Scalars['String']['output']>;
  /** Percentage of total market volume for this region-commodity combination */
  percentageOfMarketVolume?: Maybe<Scalars['Float']['output']>;
  /** Target region code for the market */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** Total volume in cartons for this combination */
  volumeInCartons?: Maybe<Scalars['Float']['output']>;
};

/** A valid ISO 4217 currency code string. */
export enum Iso4217 {
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bitcoin Cash */
  Bch = 'BCH',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bitcoin */
  Btc = 'BTC',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Botswana Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** Swiss Franc */
  Chf = 'CHF',
  /** Unidad de Fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan Offshore */
  Cnh = 'CNH',
  /** Chinese Renminbi Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Pound */
  Fkp = 'FKP',
  /** British Pound */
  Gbp = 'GBP',
  /** British Penny */
  Gbx = 'GBX',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Guernsey Pound */
  Ggp = 'GGP',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Guyanese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Israeli New Sheqel */
  Ils = 'ILS',
  /** Isle of Man Pound */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Jersey Pound */
  Jep = 'JEP',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgyzstani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Lao Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tögrög */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya */
  Mro = 'MRO',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Złoty */
  Pln = 'PLN',
  /** Paraguayan Guaraní */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helenian Pound */
  Shp = 'SHP',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe Dobra */
  Std = 'STD',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** United States Dollar */
  Usd = 'USD',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uzbekistan Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar */
  Vef = 'VEF',
  /** Venezuelan Bolívar Soberano */
  Ves = 'VES',
  /** Vietnamese Đồng */
  Vnd = 'VND',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African Cfa Franc */
  Xaf = 'XAF',
  /** Silver (Troy Ounce) */
  Xag = 'XAG',
  /** Gold (Troy Ounce) */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account 9 */
  Xbc = 'XBC',
  /** European Unit of Account 17 */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** UIC Franc */
  Xfu = 'XFU',
  /** West African Cfa Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** Cfp Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** Codes specifically reserved for testing purposes */
  Xts = 'XTS',
  /** Yemeni Rial */
  Yer = 'YER',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmk = 'ZMK',
  /** Zimbabwean Dollar */
  Zwd = 'ZWD'
}

export type IdName = {
  __typename?: 'IdName';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  /** The image as a base 64 encoded string formatted for usage in an img html tag */
  base64ImgSrc?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the image (e.g., image/png, image/jpeg) */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The original name of the file */
  filename?: Maybe<Scalars['String']['output']>;
  /** The ID of the image */
  id?: Maybe<Scalars['Int']['output']>;
  /** A smaller version of the image */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The direct URL to the image */
  url?: Maybe<Scalars['String']['output']>;
  /** The upgraded version of the thumbnail URL */
  v2ThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The direct URL to the image that includes the host */
  v2Url?: Maybe<Scalars['String']['output']>;
};

/** An in-app notification for the current user */
export type InAppNotification = {
  __typename?: 'InAppNotification';
  /** When the user archived the notification, null means not archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Notification body */
  body?: Maybe<Scalars['String']['output']>;
  /** When the notification was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the notification was delivered in-app */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Channel notification ID */
  id: Scalars['ID']['output'];
  /** Structured metadata (entity_type, entity_ids, severity, etc.). */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Severity for UI: update - informative or alert - needs attention. */
  notificationType?: Maybe<NotificationTypeEnum>;
  /** When the user read the notification null means unread */
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the notification was sent */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Notification title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum IncotermEnum {
  /** The incoterm is EXW */
  Exw = 'EXW',
  /** The incoterm is DIP */
  Dip = 'DIP',
  /** The incoterm is FCA */
  Fca = 'FCA',
  /** The incoterm is FAS */
  Fas = 'FAS',
  /** The incoterm is FOB */
  Fob = 'FOB',
  /** The incoterm is CFR */
  Cfr = 'CFR',
  /** The incoterm is CIF */
  Cif = 'CIF',
  /** The incoterm is FOT */
  Fot = 'FOT',
  /** The incoterm is DAP */
  Dap = 'DAP',
  /** The incoterm is DDP */
  Ddp = 'DDP'
}

export type IncotermPrice = {
  __typename?: 'IncotermPrice';
  chargesApplied?: Maybe<Array<ChargeApplied>>;
  incoterm: IncotermWithNscEnum;
  moneyAmount: Money;
};

export enum IncotermWithNscEnum {
  /** The incoterm is NSC */
  Nsc = 'NSC',
  /** The incoterm is EXW */
  Exw = 'EXW',
  /** The incoterm is DIP */
  Dip = 'DIP',
  /** The incoterm is FCA */
  Fca = 'FCA',
  /** The incoterm is FAS */
  Fas = 'FAS',
  /** The incoterm is FOB */
  Fob = 'FOB',
  /** The incoterm is CFR */
  Cfr = 'CFR',
  /** The incoterm is CIF */
  Cif = 'CIF',
  /** The incoterm is FOT */
  Fot = 'FOT',
  /** The incoterm is DAP */
  Dap = 'DAP',
  /** The incoterm is DDP */
  Ddp = 'DDP'
}

/** A client change request for adding an internal packhouse */
export type InternalPackhouseClientChangeRequest = {
  __typename?: 'InternalPackhouseClientChangeRequest';
  /** The company that requested the packhouse addition */
  company?: Maybe<Company>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']['output']>;
  /** The packhouse (FBO) being added */
  packhouse?: Maybe<FoodBusinessOperator>;
  /** The packhouse connection being added */
  packhouseConnection?: Maybe<PackhouseConnection>;
  /** The status of the client change request */
  status?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


/** A client change request for adding an internal packhouse */
export type InternalPackhouseClientChangeRequestPackhouseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Invite = {
  __typename?: 'Invite';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initiator?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of InviteUser. */
export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  invite?: Maybe<Invite>;
};

/** Fields available on an invoice */
export type Invoice = {
  __typename?: 'Invoice';
  /** Accounting Exports attached to the invoice */
  accountingExports?: Maybe<Array<AccountingExport>>;
  /** The number of days within which advance payment is needed from agreed upon event */
  advanceCreditTerm?: Maybe<Scalars['Int']['output']>;
  /** The total advance payment for this invoice */
  advancePayment?: Maybe<Scalars['BigDecimal']['output']>;
  /** The air waybill no associated with this Invoice */
  airWaybillNo?: Maybe<Scalars['String']['output']>;
  /** Amount remitted against this invoice */
  allocatedAmountMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** The allocated weight of the goods for the Invoice */
  allocatedWeight?: Maybe<Scalars['Float']['output']>;
  /** Attached documents (PDF and Excel files) for this invoice */
  attachedDocuments?: Maybe<Array<Document>>;
  /** The number of cartons in the invoice */
  cartonCount?: Maybe<Scalars['Int']['output']>;
  /** The carton groupings that are associated with this invoice */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** All connected children invoices to this invoice */
  childInvoices?: Maybe<Array<Invoice>>;
  /** Commercial term associated with this invoice */
  commercialTerm?: Maybe<CommercialTerm>;
  /** The company that owns this invoice */
  company?: Maybe<Company>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The contacts for the invoice */
  contacts?: Maybe<Array<Contact>>;
  /** The container numbers associated with this invoice */
  containerNumbers?: Maybe<Scalars['String']['output']>;
  /** The containers on the invoice */
  containers?: Maybe<Array<Container>>;
  /** Whether or not to convert tons to kilograms */
  convertTonToKg?: Maybe<Scalars['Boolean']['output']>;
  /** Costs associated with the invoice */
  costs?: Maybe<Scalars['String']['output']>;
  /** The country of origin for the invoice */
  countryOfOrigin?: Maybe<TradeCountry>;
  /** The date and time at which the invoice was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Currency of the invoice */
  currency?: Maybe<CurrencyEnum>;
  /** Currency exchange rate for the payment */
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** The destination associated with the Invoice */
  destination?: Maybe<Scalars['String']['output']>;
  /** The kind of document e.g. invoice, tax invoice, ... */
  documentType?: Maybe<InvoiceDocumentTypeEnum>;
  /** The due date of the invoice, either final or advance */
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The advance due date of the invoice */
  dueDateAdvance?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The final due date of the invoice */
  dueDateFinal?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Exchange rate for the payment */
  exchangeRate?: Maybe<Scalars['String']['output']>;
  /** The number of days within which final payment is needed from agreed upon event */
  finalCreditTerm?: Maybe<Scalars['Int']['output']>;
  /** The total final payment for this invoice */
  finalPayment?: Maybe<Scalars['BigDecimal']['output']>;
  /** The flights date */
  flightDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Freight cost of the CI */
  freightCost?: Maybe<Scalars['Float']['output']>;
  /** Unique CI identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** Incoterm applicable */
  incoterm?: Maybe<IncotermEnum>;
  /** Insurance cost of the CI */
  insuranceCost?: Maybe<Scalars['Float']['output']>;
  /** Custom fields associated with this invoice */
  invoiceCustomFields?: Maybe<Array<InvoiceCustomField>>;
  /** The user-selected date that the invoice was issued */
  invoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The pallets that are associated with this invoice's carton groupings */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** A reference assigned to the CI */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The payments associated with this invoice */
  invoicePayments?: Maybe<Array<InvoicePayment>>;
  /** The advance invoice that is linked to this invoice */
  linkedAdvanceInvoice?: Maybe<Invoice>;
  /** All linked invoices to this invoice */
  linkedRecords?: Maybe<Array<Invoice>>;
  /** The FBO where the goods are loaded */
  loadingPoint?: Maybe<FoodBusinessOperator>;
  /** Local costs of the CI */
  localCosts?: Maybe<Scalars['Float']['output']>;
  /** Net amount calculation for the account sale */
  netAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** The FBO where the goods are unloaded */
  offloadingPoint?: Maybe<FoodBusinessOperator>;
  /** The credit note created for an over-recovery on this invoice */
  overRecoveryCreditNote?: Maybe<Invoice>;
  /** The number of pallets in the invoice */
  palletCount?: Maybe<Scalars['Int']['output']>;
  /** Parent invoice to this invoice */
  parentInvoice?: Maybe<Invoice>;
  /** The ID this invoice is linked to */
  parentInvoiceId?: Maybe<Scalars['Int']['output']>;
  /** Purchase order number */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** Where vessel is delivering the shipment */
  portOfDestination?: Maybe<SeaPort>;
  /** Where shipment was loaded onto a vessel */
  portOfLoading?: Maybe<SeaPort>;
  /** The remaining amount in major unit */
  remainingAmountMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** The invoice total with debit and credits applied */
  remittableAmountMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** The flights routing */
  routing?: Maybe<Scalars['String']['output']>;
  /** The sale type of this CI */
  saleType?: Maybe<Scalars['String']['output']>;
  /** Emails in which this document was included */
  sentEmailList?: Maybe<Array<SentEmail>>;
  /** The Shippers name */
  shipper?: Maybe<Scalars['String']['output']>;
  /** The state of the invoice */
  state?: Maybe<InvoiceStateEnum>;
  /** FBO Associated with this CI */
  stuffLocation?: Maybe<FoodBusinessOperator>;
  /** The sub total on the invoice */
  subTotal?: Maybe<Scalars['Float']['output']>;
  /** Object containing information on the document generated for this invoice */
  templateOutput?: Maybe<Array<TemplateOutput>>;
  /** Total costs calculation for the account sale */
  totalCostsMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** The total FOB value of the invoice */
  totalFob?: Maybe<Scalars['Float']['output']>;
  /** Total incoterm value of the CI */
  totalIncoterm?: Maybe<Scalars['BigDecimal']['output']>;
  /** Transport Type seleccted for this document */
  transportType?: Maybe<Scalars['String']['output']>;
  /** UCR number */
  ucrNumber?: Maybe<Scalars['String']['output']>;
  /** The time at which the invoice was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Total VAT payable on the invoice */
  vat?: Maybe<Scalars['Float']['output']>;
  /** The VAT Type associated with the invoice */
  vatType?: Maybe<VatType>;
  /** The vehicle number that is associated with this CI */
  vehicleNumber?: Maybe<Scalars['String']['output']>;
  /** Vessel associated with CI */
  vessel?: Maybe<Vessel>;
  /** Estimated Time of Arrival based on Vessel Tracking Events */
  vesselEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated Time of Departure based on Vessel Tracking Events */
  vesselEtd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Voyage that the associated vessel is taking */
  voyage?: Maybe<Scalars['String']['output']>;
};


/** Fields available on an invoice */
export type InvoiceSentEmailListArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

/** Whether an invoice has been included in an accounting export (invoice list filter). */
export enum InvoiceAccountingExportFilterEnum {
  /** Invoices that have been exported to accounting */
  Exported = 'EXPORTED',
  /** Invoices not yet exported to accounting */
  NotExported = 'NOT_EXPORTED'
}

export type InvoiceAttributes = {
  /** The number of days within which advance payment is needed from agreed upon event */
  advanceCreditTerm: Scalars['Int']['input'];
  /** The advance to be paid on the invoice */
  advancePayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The air waybill number associated with this Invoice */
  airWaybillNo?: InputMaybe<Scalars['String']['input']>;
  /** The allocated weight of the goods for the Invoice */
  allocatedWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The IDs of the carton groupings associated with the invoice */
  cartonGroupingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The IDs of the contacts associated with the invoice */
  contactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The IDs of the containers associated with the invoice */
  containerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether the weight should be converted from tons to kilograms */
  convertTonToKg?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Cost line Items on the invoice */
  costLineItems?: InputMaybe<Array<InvoiceLineItemAttributes>>;
  /** The ID of the country of origin for the shipment */
  countryOfOriginId?: InputMaybe<Scalars['Int']['input']>;
  /** The currency of the invoice line item. */
  currency?: InputMaybe<CurrencyEnum>;
  /** The destination associated with the Invoice */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** The type of document (e.g., invoice, credit note) */
  documentType: Scalars['String']['input'];
  /** The number of days within which final payment is needed from agreed upon event */
  finalCreditTerm: Scalars['Int']['input'];
  /** The final amount to be payed on the invoice */
  finalPayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The flight's date */
  flightDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The ID of the invoice */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The Incoterm associated with the shipment */
  incoterm?: InputMaybe<IncotermEnum>;
  /** The custom fields associated with the invoice */
  invoiceCustomFields?: InputMaybe<Array<InvoiceCustomFieldAttributes>>;
  /** The date associated to the invoice */
  invoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The pallets associated with the invoice */
  invoiceLineItems?: InputMaybe<Array<InvoiceLineItemAttributes>>;
  /** The invoice number */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** The loading point */
  loadingPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The offloading point */
  offloadingPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The parent invoice that this invoice is linked to */
  parentInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  /** The purchase order number associated with the shipment */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the port of destination for the shipment */
  portOfDestinationId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the port of loading for the shipment */
  portOfLoadingId?: InputMaybe<Scalars['Int']['input']>;
  /** The flights routing */
  routing?: InputMaybe<Scalars['String']['input']>;
  /** The sale type */
  saleType?: InputMaybe<Scalars['String']['input']>;
  /** The Shipper's name */
  shipper?: InputMaybe<Scalars['String']['input']>;
  /** The state of the invoice */
  state?: InputMaybe<InvoiceStateEnum>;
  /** Where the container was loaded */
  stuffLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** The sub total on the invoice */
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  /** The Total Incoterm of the invoice */
  totalIncoterm?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The type of transportation for the shipment (e.g., container, break bulk) */
  transportType?: InputMaybe<Scalars['String']['input']>;
  /** The Unique Consignment Reference (UCR) number associated with the shipment */
  ucrNumber?: InputMaybe<Scalars['String']['input']>;
  /** The Total VAT payable on the invoice */
  vat?: InputMaybe<Scalars['Float']['input']>;
  /** The associated VAT Type on the invoice */
  vatTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** The vehicle number */
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  /** The vessel details associated with the shipment */
  vessel?: InputMaybe<VesselAttributes>;
  /** The voyage or trip number associated with the shipment */
  voyage?: InputMaybe<Scalars['String']['input']>;
  /** The commercial term associated with the invoice */
  commercialTermId?: InputMaybe<Scalars['Int']['input']>;
  /** The final due date of the invoice */
  dueDateFinal?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Invoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceCustomField = {
  __typename?: 'InvoiceCustomField';
  /** whether the underlying custom field is soft-deleted */
  customFieldDeleted: Scalars['Boolean']['output'];
  /** Unique custom field identifier */
  customFieldId?: Maybe<Scalars['Int']['output']>;
  /** The default value of the custom field */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Unique invoice identifier */
  invoiceId?: Maybe<Scalars['Int']['output']>;
  /** Whether the custom field should appear by default */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the custom field */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the custom field is required */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The value of the custom field */
  value?: Maybe<Scalars['String']['output']>;
};

export type InvoiceCustomFieldAttributes = {
  /** The id of the invoice */
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the custom field */
  customFieldId?: InputMaybe<Scalars['Int']['input']>;
  /** The custom field value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** The different types of invoice documents available. */
export enum InvoiceDocumentTypeEnum {
  CommercialInvoice = 'commercial_invoice',
  TaxInvoice = 'tax_invoice',
  AdvanceInvoice = 'advance_invoice',
  CreditNote = 'credit_note',
  DebitNote = 'debit_note',
  VendorInvoice = 'vendor_invoice',
  AccountStatement = 'AccountStatement',
  AccountSale = 'account_sale'
}

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>;
};

export type InvoiceFilterAttribute = {
  __typename?: 'InvoiceFilterAttribute';
  /** commodities found on this user's CIs */
  commodities?: Maybe<Array<Commodity>>;
  /** Contacts for this invoice */
  contacts?: Maybe<Array<Contact>>;
  /** Containers of this user's Invoices */
  containers?: Maybe<Array<Scalars['String']['output']>>;
  /** Cost codes of this user's Invoices */
  costCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Types of invoices - commercial / tax / credit_note / debit_note */
  documentTypes: Array<InvoiceDocument>;
  /** Export status options for filtering invoices */
  exportStatuses?: Maybe<Array<InvoiceAccountingExportFilterEnum>>;
  /** Available financial year options for the FY filter dropdown */
  financialYearOptions?: Maybe<Array<FinancialYearOption>>;
  /** Incoterms associated with this user's CIs */
  incoterms?: Maybe<Array<IncotermEnum>>;
  /** Invoice number for the invoice */
  invoiceNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Pallet numbers of this user's Invoices */
  palletNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** The states of a document e.g. draft, finalised, ... */
  states?: Maybe<Array<Scalars['String']['output']>>;
  /** Target countries associated with this user's CIs */
  targetCountries: Array<Scalars['String']['output']>;
  /** Transport Types of this user's CIs */
  transportTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** varieties found on this user's CIs */
  varieties?: Maybe<Array<Variety>>;
  /** Vessels associated with this user's CIs */
  vessels?: Maybe<Array<Vessel>>;
};

export type InvoiceIncotermAttributes = {
  /** The id of the invoice */
  invoiceId: Scalars['Int']['input'];
  /** The currency to calculate the incoterm for */
  currency: CurrencyEnum;
  /** The incoterm to calculate for */
  incoterm: IncotermEnum;
  /** The freight cost to use */
  freightCost?: InputMaybe<Scalars['Float']['input']>;
  /** The insurance cost to use */
  insuranceCost?: InputMaybe<Scalars['Float']['input']>;
  /** The local costs to use */
  localCosts?: InputMaybe<Scalars['Float']['input']>;
  /** The total advance payment for this invoice */
  advancePayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The total final payment for this invoice */
  finalPayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The number of days within which advance payment is needed from agreed upon event */
  advanceCreditTerm?: InputMaybe<Scalars['Int']['input']>;
  /** The number of days within which final payment is needed from agreed upon event */
  finalCreditTerm?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  /** Total Amount on the Invoice Line Item */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The carton grouping associated with this invoice line item */
  cartonGrouping?: Maybe<CartonGrouping>;
  /** Carton Grouping Transactions associated with the Invoice LI */
  cartonGroupingTransactions?: Maybe<Array<CartonGroupingTransaction>>;
  /** The updated number of cartons in the carton grouping */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** Cost Code Associated with the InvoiceLineItem */
  costCode?: Maybe<CostCode>;
  /** The updated currency of the carton grouping */
  currency?: Maybe<CurrencyEnum>;
  /** The kind of document e.g. invoice, tax invoice, ... */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Grouped Grade Field */
  grade?: Maybe<Scalars['String']['output']>;
  /** ID of the invoice line item */
  id?: Maybe<Scalars['ID']['output']>;
  /** Parent CI identifier */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  /** Grouped Mark Field */
  mark?: Maybe<Scalars['String']['output']>;
  /** The updated net mass of the carton grouping */
  netMass?: Maybe<Scalars['Float']['output']>;
  /** Grouped Pack Field */
  pack?: Maybe<Scalars['String']['output']>;
  /** The number of pallets in this invoice line item */
  palletCount?: Maybe<Scalars['Float']['output']>;
  /** The updated gross mass of the carton grouping */
  palletGrossMass?: Maybe<Scalars['Float']['output']>;
  /** The updated price of the carton grouping */
  price?: Maybe<Scalars['String']['output']>;
  /** Total Amount on the Invoice Line Item */
  priceMinorUnit?: Maybe<Scalars['Float']['output']>;
  /** The updated price unit of the carton grouping (carton/ton) */
  priceUnit?: Maybe<Scalars['String']['output']>;
  /** Amount of the Price Unit on the Invoice Line Item */
  quantityAmount?: Maybe<Scalars['Float']['output']>;
  /** Grouped Size Count Field */
  sizeCount?: Maybe<Scalars['String']['output']>;
  /** The target market of the invoice line item */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** The total price minor unit of the invoice line item. */
  totalPriceMinorUnit?: Maybe<Scalars['String']['output']>;
  /** Grouped Variety Field */
  variety?: Maybe<Variety>;
  /** The VAT Type associated with the invoice line item */
  vatType?: Maybe<VatType>;
};

export type InvoiceLineItemAttributes = {
  /** Total Amount on the Invoice Line Item. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** The ID of the associated carton grouping. */
  cartonGroupingId?: InputMaybe<Scalars['Int']['input']>;
  /** Carton Grouping Transactions associated with this invoice line item */
  cartonGroupingTransactions?: InputMaybe<Array<CartonGroupingTransactionAttributes>>;
  /** The number of cartons in the invoice line item. */
  cartons?: InputMaybe<Scalars['Int']['input']>;
  /** The currency of the invoice line item. */
  currency?: InputMaybe<CurrencyEnum>;
  /** The document type of the invoice line item. */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /** Grade of the item on this invoice line item. */
  grade?: InputMaybe<Scalars['String']['input']>;
  /** ID of the invoice line item */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Mark of the item on this invoice line item. */
  mark?: InputMaybe<Scalars['String']['input']>;
  /** The net mass of the invoice line item. */
  netMass?: InputMaybe<Scalars['Float']['input']>;
  /** Pack type of the item on this invoice line item. */
  pack?: InputMaybe<Scalars['String']['input']>;
  /** The gross mass of the pallet in the invoice line item. */
  palletGrossMass?: InputMaybe<Scalars['Float']['input']>;
  /** The price of the invoice line item in minor units. */
  priceMinorUnit?: InputMaybe<Scalars['String']['input']>;
  /** The unit of the price (e.g., carton or ton). */
  priceUnit?: InputMaybe<PriceUnitEnum>;
  /** Amount of the Price Unit on the Invoice Line Item. */
  quantityAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Size count of the item on this invoice line item . */
  sizeCount?: InputMaybe<Scalars['String']['input']>;
  /** Target market of the item on this invoice line item . */
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  /** The Variety associated with the invoice line item . */
  variety?: InputMaybe<VarietyAttributes>;
  /** The Vat Type associated with the invoice line item . */
  vatType?: InputMaybe<VatTypeAttributes>;
  /** The Cost Code associated with the invoice line item . */
  costCodeId?: InputMaybe<Scalars['Int']['input']>;
};

/** Fields available on an invoice payment */
export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  /** Amount of money allocated to the invoice in major unit */
  amountMajorUnit: Scalars['Float']['output'];
  /** Date and time the payment allocation was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique invoice payment identifier */
  id: Scalars['ID']['output'];
  /** The invoice linked to the payment */
  invoice: Invoice;
  /** The invoice linked to the payment */
  invoiceId: Scalars['String']['output'];
  /** The payment linked to the invoice */
  payment: Payment;
  /** The payment linked to the invoice */
  paymentId: Scalars['String']['output'];
  /** Date and time the payment allocation was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Fields available on an invoice payment allocation */
export type InvoicePaymentAllocation = {
  __typename?: 'InvoicePaymentAllocation';
  /** The invoice linked to the payment */
  invoiceId: Scalars['ID']['output'];
  /** Total amount of money allocated to the invoice in major unit */
  totalAmountMajorUnit: Scalars['Float']['output'];
};

/** The different states available for invoices. */
export enum InvoiceStateEnum {
  /** The invoice state type draft */
  Draft = 'draft',
  /** The invoice state type finalised */
  Finalised = 'finalised',
  /** The invoice state type awaiting_payment */
  AwaitingPayment = 'awaiting_payment',
  /** The invoice state type partially_paid */
  PartiallyPaid = 'partially_paid',
  /** The invoice state type paid */
  Paid = 'paid',
  /** The invoice state type overpaid */
  Overpaid = 'overpaid',
  /** The invoice state type closed */
  Closed = 'closed',
  /** The invoice state type overdue */
  Overdue = 'overdue',
  /** The invoice state type voided */
  Voided = 'voided',
  /** The invoice state type to_be_invoiced */
  ToBeInvoiced = 'to_be_invoiced',
  /** The invoice state type invoiced */
  Invoiced = 'invoiced',
  /** The invoice state type archived */
  Archived = 'archived',
  /** The invoice state type building */
  Building = 'building'
}

export type InvoicesFilters = {
  /** List of commodity IDs to filter by. */
  commodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of contact IDs to filter by. */
  contactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of currencies to filter by. */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of document types to filter by. */
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter invoices with invoice_date on or after this date (inclusive). */
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Filter invoices with invoice_date on or before this date (inclusive). */
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** List of Incoterms to filter by. */
  incoterms?: InputMaybe<Array<IncotermEnum>>;
  /** List of invoice numbers to filter by. */
  invoiceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of states to filter by. */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of target countries to filter by. */
  targetCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of transport types to filter by. */
  transportTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of variety IDs to filter by. */
  varietyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of vessel IDs to filter by. */
  vesselIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by accounting export presence; omit for all invoices. */
  accountingExportFilter?: InputMaybe<InvoiceAccountingExportFilterEnum>;
  /** only fetch unallocated or partially allocated invoices */
  unallocatedOrPartiallyAllocated?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by incoming or outgoing payment type */
  paymentTypes?: InputMaybe<Scalars['String']['input']>;
  /** List of container numbers to filter by. */
  containers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of pallet numbers to filter by. */
  palletNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of cost codes to filter by. */
  costCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** only show invoices created after this date (inclusive) */
  createdAtDateStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** only show invoices created before this date (inclusive) */
  createdAtDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Financial year to filter by. The year the FY ends in (end-year convention, e.g. 2025 = Mar 2024 - Feb 2025 on a Mar-Feb company). Uses company FY config to resolve the date range. */
  financialYear?: InputMaybe<Scalars['Int']['input']>;
};

/** A line item contains the fruit specification, quantity and payment details of the product being ordered */
export type LineItem = {
  __typename?: 'LineItem';
  /** A list of extra fields that are not part of the standard fields, set by the user */
  additionalFields?: Maybe<Scalars['Json']['output']>;
  /** The audit trail of the line item showing changes made to the line item */
  audits?: Maybe<Array<Audit>>;
  /** Unique number for a collection of line items with similar/ same specifications, user set */
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** The buyer of the line item */
  buyer?: Maybe<Company>;
  /** The carton groupings of the line item */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** Comments on the line item provided by the user */
  comments?: Maybe<Array<Comment>>;
  /** The commodity of the fruit being ordered */
  commodity?: Maybe<Commodity>;
  /** The commodity of the fruit being ordered */
  commodityId?: Maybe<Scalars['Int']['output']>;
  /** The container that the line item is in */
  containerId?: Maybe<Scalars['Int']['output']>;
  /** When the line item was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The cumulative quantity of the line item grouping */
  cumulativeQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * The currency of the line item
   * @deprecated use MoneyType `price` instead
   */
  currency?: Maybe<Scalars['String']['output']>;
  /** Deal sheet fields when this line item is part of a deal sheet */
  dealSheetLineItemDetail?: Maybe<YieldDealSheetLineItemDetail>;
  /** Whether the line item has been soft deleted */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** The departure port of the line item */
  departurePort?: Maybe<SeaPort>;
  /** The departure port of the line item */
  departurePortId?: Maybe<Scalars['Int']['output']>;
  /** The name of the departure port of the line item */
  departurePortName?: Maybe<Scalars['String']['output']>;
  /** The destination port of the line item */
  destinationPort?: Maybe<SeaPort>;
  /** The destination port of the line item */
  destinationPortId?: Maybe<Scalars['Int']['output']>;
  /** The name of the destination port of the line item */
  destinationPortName?: Maybe<Scalars['String']['output']>;
  /** Indicates the final week of a packhouse run, a system where all available fruit is packed for a given week range */
  endWeek?: Maybe<Scalars['String']['output']>;
  /** Net return summary using input args OR defaults 'ZAR', 'RAW CARTON', 'EXW' */
  expectedReturnSummary?: Maybe<ExpectedReturnSummary>;
  /** The classification of the fruit, eg. A, B inidicating quality */
  grade?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the line item */
  id?: Maybe<Scalars['Int']['output']>;
  /** An international commercial term, used to define ownership and responsibility for the goods */
  incoterm?: Maybe<Scalars['String']['output']>;
  /** The inventory code of the fruit, eg. 1234567890 */
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the line item grouping that contains the line item */
  lineItemGroupingId?: Maybe<Scalars['Int']['output']>;
  /** food and safety indicator to indicate compliance with safety standards */
  mark?: Maybe<Scalars['String']['output']>;
  /** The new seller of the line item */
  newSellerId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the order that the line item belongs to */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** The box that the fruit is packed in, eg. A15C. This denotes size and type of box */
  pack?: Maybe<Scalars['String']['output']>;
  /** The actual quantity of cartons that have been packed thus far for this line item */
  packedCartons?: Maybe<Scalars['Int']['output']>;
  /** The actual quantity of pallets that have been packed thus far for this line item */
  packedPallets?: Maybe<Scalars['Float']['output']>;
  /** When not doing a packhouse run, this is the week that the fruit is packed */
  packingWeek?: Maybe<Scalars['String']['output']>;
  /** The number of boxes that can be stacked on a pallet eg. 80 */
  palletStack?: Maybe<Scalars['Int']['output']>;
  /** The quantity of the fruit that is planned to be packed by the producer. This quantity can takes precedence over the quantity field */
  plannedQuantity?: Maybe<Scalars['Int']['output']>;
  /** The unit of the planned quantity, eg. cartons */
  plannedQuantityUnit?: Maybe<Scalars['String']['output']>;
  /** The price of the fruit per unit */
  price?: Maybe<Money>;
  /**
   * The price of the fruit per unit in minor units i.e cents to avoid floating point precision issues
   * @deprecated use MoneyType `price` instead
   */
  priceMinorUnit?: Maybe<Scalars['Int']['output']>;
  /** A financial agreement between parties, eg. Fixed, MPG or Consignment */
  priceTerm?: Maybe<Scalars['String']['output']>;
  /** The unit of the price, eg. cartons */
  priceUnit?: Maybe<Scalars['String']['output']>;
  /** An indicator of urgency/ preference of the line item */
  priority?: Maybe<Scalars['Int']['output']>;
  /** The amound of fruit per unit requested by the buyer, can be overridden by the planned quantity */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The unit of the quantity, eg. cartons */
  quantityUnit?: Maybe<Scalars['String']['output']>;
  /** The order in which the line item appears in the order */
  rank?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the line item, set by the user */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the line item has been selected */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** The seller of the line item */
  seller?: Maybe<Company>;
  /** The seller of the line item */
  sellerId?: Maybe<Scalars['Int']['output']>;
  /** The size of the fruit, determined by the number of items that can fit in the box, eg. 32 implies 32 items per box. Lower number implies bigger items */
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  /** The first week of a packhouse run, a system where all available fruit is packed for a given week range */
  startWeek?: Maybe<Scalars['String']['output']>;
  /** The current state of the line item, eg. new, packed, accepted, etc. */
  state?: Maybe<Scalars['String']['output']>;
  /** The state of the line item */
  stateUpdate?: Maybe<Array<Scalars['String']['output']>>;
  /** The distribution of the line item states and quantities */
  statesDistribution?: Maybe<Array<LineItemState>>;
  /** The country code of the country that the fruit is being shipped to */
  targetCountry?: Maybe<Scalars['String']['output']>;
  /** The market that the fruit is being shipped to */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** The region code that the fruit is being shipped to eg. AFR (Africa), ASA (Asia), etc. linked to countries */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** During a packhouse run, the quantity is not specified. Producers want to move all available fruit */
  unlimited?: Maybe<Scalars['Boolean']['output']>;
  /** When the line item was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The variety of the fruit being ordered */
  variety?: Maybe<Variety>;
  /** The variety of the fruit being ordered */
  varietyId?: Maybe<Scalars['Int']['output']>;
};


/** A line item contains the fruit specification, quantity and payment details of the product being ordered */
export type LineItemExpectedReturnSummaryArgs = {
  currency?: InputMaybe<CurrencyEnum>;
  incoterm?: InputMaybe<IncotermWithNscEnum>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for LineItem. */
export type LineItemConnection = {
  __typename?: 'LineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LineItemEdge = {
  __typename?: 'LineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LineItem>;
};

/** Attributes to filter line items by */
export type LineItemFilterAttribute = {
  __typename?: 'LineItemFilterAttribute';
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** sellers you want to filter by */
  sellers?: Maybe<Array<Company>>;
  /** varieties you want to filter by */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes to filter line items by */
export type LineItemFilterAttributes = {
  /** currencies you want to filter by */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** incoterms you want to filter by */
  incoterms?: InputMaybe<Array<IncotermEnum>>;
  /** buyers you want to filter by */
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sellers you want to filter by */
  sellerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** states you want to filter by */
  states?: InputMaybe<Array<OrderStateEnum>>;
  /** commodities you want to filter by */
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** varieties you want to filter by */
  varietyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start of packing week you want to filter by */
  packingWeekStart?: InputMaybe<Scalars['String']['input']>;
  /** end of packing week you want to filter by */
  packingWeekEnd?: InputMaybe<Scalars['String']['input']>;
  /** additional fields to filter by, keyed by field name with array of values */
  additionalFields?: InputMaybe<Scalars['Json']['input']>;
};

export type LineItemGrouping = {
  __typename?: 'LineItemGrouping';
  /** List of fields that line items in this group have the same value for. */
  commonFields?: Maybe<Array<Scalars['String']['output']>>;
  /** The date and time when the line item grouping was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The total cumulative number of units requested on this line item group (optional). */
  cumulativeQuantity?: Maybe<Scalars['Int']['output']>;
  /** Descriptive information about the cumulative quantity for this line item. */
  cumulativeTooltip?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the line item grouping is marked as deleted. */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the line item grouping. */
  id?: Maybe<Scalars['Int']['output']>;
  /** List of line items belonging to this grouping. */
  lineItems?: Maybe<Array<LineItem>>;
  /** Total number of line items within the same grouping. */
  numberCumulativeSiblings?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the order associated with this line item grouping. */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** The unit of measurement for the cumulative quantity, such as cartons, pallets, or containers. */
  quantityType?: Maybe<Scalars['String']['output']>;
  /** The rank or order of this line item grouping among others. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The date and time when the line item grouping was last updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type LineItemGroupingLineItemsArgs = {
  commodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lineItemStates?: InputMaybe<Array<Scalars['String']['input']>>;
  packingWeekEnd?: InputMaybe<Scalars['String']['input']>;
  packingWeekStart?: InputMaybe<Scalars['String']['input']>;
  subCommodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  varietyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  states?: InputMaybe<Array<StateFilter>>;
};

export type LineItemState = {
  __typename?: 'LineItemState';
  /** The number of items in this state */
  palletQuantity?: Maybe<Scalars['Int']['output']>;
  /** Total number of items expected */
  palletQuantityTotal?: Maybe<Scalars['Int']['output']>;
  /** The number of items in this state */
  quanity?: Maybe<Scalars['Int']['output']>;
  /** Total number of items expected */
  quanityTotal?: Maybe<Scalars['Int']['output']>;
  quanityType?: Maybe<Quantity>;
  /** The number of items in this state */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Total number of items expected */
  quantityTotal?: Maybe<Scalars['Int']['output']>;
  /** The name of this state type */
  state?: Maybe<Scalars['String']['output']>;
  /** The index of its order in the supply chain, 0 = first */
  supplyChainOrder?: Maybe<Scalars['Int']['output']>;
};

/** Represents a linked entity (either ReportGroup or Report) with its ID */
export type LinkedItem = {
  __typename?: 'LinkedItem';
  /** The ID of the linked entity (either ReportGroup or Report) */
  linkedId?: Maybe<Scalars['Int']['output']>;
  /** Specifies the type of the linked entity (either ReportGroup or Report) */
  linkedType?: Maybe<LinkedTypeEnum>;
};

/** Specifies the linked_type, either ReportGroup or Report */
export enum LinkedTypeEnum {
  /** Represents a ReportGroup */
  ReportGroup = 'REPORT_GROUP',
  /** Represents a Report */
  Report = 'REPORT'
}

export type LoadOutAttributes = {
  /** Reference of booked container */
  bookingReference?: InputMaybe<Scalars['String']['input']>;
  /** CGs associated with the LOI */
  cartonGroupingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** LOI Pallet attributes to override CG values */
  loadOutInstructionPalletsAttributes?: InputMaybe<Array<LoadOutInstructionPalletAttributes>>;
  /** Contacts associated with the LOI */
  contactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Container unique identification number */
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  /** When the shipment is expected to be delivered */
  estimatedTimeOfDelivery?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Company exporting the goods */
  exporterId?: InputMaybe<Scalars['Int']['input']>;
  /** Unique reference for exporting company */
  exportersReference?: InputMaybe<Scalars['String']['input']>;
  /** Unique idetification number associated with the LOI */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unique LOI reference number */
  loadOutReference?: InputMaybe<Scalars['String']['input']>;
  /** Additional information or special instructions for the LOI */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Where the shipment is going */
  portOfDestinationId?: InputMaybe<Scalars['Int']['input']>;
  /** Where the ship was loaded */
  portOfLoadingId?: InputMaybe<Scalars['Int']['input']>;
  /** When the LOI was created */
  printedDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Storage configuration requirements */
  q67Reference?: InputMaybe<Scalars['String']['input']>;
  /** Shipping company transporting the goods */
  shippingLine?: InputMaybe<Scalars['String']['input']>;
  /** When the container was loaded */
  stuffDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Where the container was loaded */
  stuffLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Temperature configuration */
  temperatureSetting?: InputMaybe<Scalars['String']['input']>;
  /** The id of the vessel shipping the goods */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the vessel shipping the goods */
  vesselName?: InputMaybe<Scalars['String']['input']>;
  /** The vessel voyage */
  voyage?: InputMaybe<Scalars['String']['input']>;
  /** The type of transport */
  transportType?: InputMaybe<TransportTypeEnum>;
  /** The trucking reference number */
  truckReference?: InputMaybe<Scalars['String']['input']>;
  /** The loading point */
  loadingPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The offloading point */
  offloadingPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The file number associated with the LOI */
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  /** The air waybill no associated with this LOI */
  airWaybillNo?: InputMaybe<Scalars['String']['input']>;
  /** The Shippers name */
  shipper?: InputMaybe<Scalars['String']['input']>;
  /** The destination associated with the LOI */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** The allocated weight of the goods for the LOI */
  allocatedWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The flights routing */
  routing?: InputMaybe<Scalars['String']['input']>;
  /** The flights date */
  flightDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Defined equipment used */
  equipment?: InputMaybe<Scalars['String']['input']>;
  /** The Phyto Certificate identifier */
  phytoCertificate?: InputMaybe<Scalars['String']['input']>;
  /** Name of who prepared the order */
  orderPreparedBy?: InputMaybe<Scalars['String']['input']>;
  /** Name of who picked up the order */
  orderPickedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checked at warehouse information */
  checked?: InputMaybe<Scalars['String']['input']>;
  /** Air Freight SLI associated with the LOI */
  airFreightShipmentLineItemId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the LOI is for transferring stock between FBOs */
  stockTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company responsible for transportation */
  transporterCompany?: InputMaybe<Scalars['String']['input']>;
  /** The date the goods were loaded onto the truck */
  loadDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Estimated date for dispatching the goods */
  estimatedDispatchDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Estimated date for delivery of the goods */
  estimatedDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Unique Reference used to determine the SLI group */
  consignmentReference?: InputMaybe<Scalars['String']['input']>;
  /** Purchase Order reference number */
  orderReference?: InputMaybe<Scalars['String']['input']>;
};

export type LoadOutInstruction = {
  __typename?: 'LoadOutInstruction';
  /** Actual time of arrival of the vessel */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Air Freight SLI that is associated with this load out information */
  airFreightShipmentLineItem?: Maybe<AirFreightShipmentLineItem>;
  /** The air waybill no associated with this LOI */
  airWaybillNo?: Maybe<Scalars['String']['output']>;
  /** The allocated weight of the goods for the LOI */
  allocatedWeight?: Maybe<Scalars['Float']['output']>;
  /** Numerical value assigned to the reservation of a ship */
  bookingReference?: Maybe<Scalars['String']['output']>;
  /** Whether the LOI is for break bulk (left in for backwards compatibility) */
  breakBulk?: Maybe<Scalars['Boolean']['output']>;
  /** The carton groupings that are associated with this load out information */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** Checked at warehouse information */
  checked?: Maybe<Scalars['String']['output']>;
  /** Client reference associated with LOI */
  clientReference?: Maybe<Scalars['String']['output']>;
  /** Company associated with LOI */
  company?: Maybe<Company>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Unique Reference used to determine the SLI group */
  consignmentReference?: Maybe<Scalars['String']['output']>;
  /** Contacts associated with LOI */
  contacts?: Maybe<Array<Contact>>;
  /** Unique identifier of a container */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** The date and time at which the LOI was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The destination associated with the LOI */
  destination?: Maybe<Scalars['String']['output']>;
  /** Additional dispatch details for trucking */
  dispatchDetails?: Maybe<Scalars['JSON']['output']>;
  /** Defined equipment used */
  equipment?: Maybe<Scalars['String']['output']>;
  /** Estimated date for delivery of the goods */
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated date for dispatching the goods */
  estimatedDispatchDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimate of when goods are to be delivered */
  estimatedTimeOfDelivery?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Exporter associated with LOI */
  exporter?: Maybe<Company>;
  /** Name of the exporter associated with LOI */
  exporterName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for exporters */
  exportersReference?: Maybe<Scalars['String']['output']>;
  /** The file number associated with the LOI */
  fileNumber?: Maybe<Scalars['String']['output']>;
  /** The flights date */
  flightDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Unique LOI identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** The date the goods were loaded onto the truck */
  loadDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A reference assigned to the LOI */
  loadOutReference?: Maybe<Scalars['String']['output']>;
  /** The FBO where the goods are loaded */
  loadingPoint?: Maybe<FoodBusinessOperator>;
  /** The flattend carton groupings that are associated with this load out information */
  loiCartonGroupings?: Maybe<Array<LoiCartonGrouping>>;
  /** Additional information about a LOI */
  notes?: Maybe<Scalars['String']['output']>;
  /** The FBO where the goods are unloaded */
  offloadingPoint?: Maybe<FoodBusinessOperator>;
  /** Name of who picked up the order */
  orderPickedBy?: Maybe<Scalars['String']['output']>;
  /** Name of who prepared the order */
  orderPreparedBy?: Maybe<Scalars['String']['output']>;
  /** Purchase Order reference number */
  orderReference?: Maybe<Scalars['String']['output']>;
  /** The number of pallets assigned to the LOI */
  palletCount?: Maybe<Scalars['String']['output']>;
  /** Pallet in linked to load out instruction */
  palletIn?: Maybe<PalletIn>;
  /** Whether user has PhytClean enabled */
  phytcleanEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Phytclean result for loi */
  phytcleanResult?: Maybe<Result>;
  /** The Phyto Certificate identifier */
  phytoCertificate?: Maybe<Scalars['String']['output']>;
  /** Where shipment is going */
  portOfDestination?: Maybe<SeaPort>;
  /** Name of the destination port */
  portOfDestinationName?: Maybe<Scalars['String']['output']>;
  /** Where shipment was loaded onto a vessel */
  portOfLoading?: Maybe<SeaPort>;
  /** Name of the loading port */
  portOfLoadingName?: Maybe<Scalars['String']['output']>;
  /** Date of LOI sticker */
  printedDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Q67 stipulates the temperature settings and other protocols that must be followed */
  q67Reference?: Maybe<Scalars['String']['output']>;
  /** The flights routing */
  routing?: Maybe<Scalars['String']['output']>;
  /** Emails in which this document was included */
  sentEmailList?: Maybe<Array<SentEmail>>;
  /** Shipment Line Item associated with the LOI */
  shipmentLineItem?: Maybe<ShipmentLineItem>;
  /** The Shippers name */
  shipper?: Maybe<Scalars['String']['output']>;
  /** Company that operates the ships that transport the goods */
  shippingLine?: Maybe<Scalars['String']['output']>;
  /** Source system that created the LOI (e.g. yield) */
  source?: Maybe<Scalars['String']['output']>;
  /** The stack dates of the shipment associated with the associated shipment line item */
  stackDates?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The stack dates close of the shipment associated with the associated shipment line item */
  stackDatesClose?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the LOI is for transferring stock between FBOs */
  stockTransfer?: Maybe<Scalars['Boolean']['output']>;
  /** Date when shipment was loaded */
  stuffDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** FBO Associated with this LOI */
  stuffLocation?: Maybe<FoodBusinessOperator>;
  /** Temperature instructions */
  temperatureSetting?: Maybe<Scalars['String']['output']>;
  /** Object containing information on the document generated for this load out information */
  templateOutput?: Maybe<TemplateOutput>;
  /** The type of transport used to transport the goods */
  transportType?: Maybe<TransportTypeEnum>;
  /** Company responsible for transportation */
  transporterCompany?: Maybe<Scalars['String']['output']>;
  /** The truck reference that is associated with this LOI */
  truckReference?: Maybe<Scalars['String']['output']>;
  /** The time at which the LOI was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Vessel associated with LOI */
  vessel?: Maybe<Vessel>;
  /** Vessel name associated with LOI */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** Vessel name directly from the record */
  vesselNameDirect?: Maybe<Scalars['String']['output']>;
  /** Voyage that the associated vessel is taking */
  voyage?: Maybe<Scalars['String']['output']>;
};


export type LoadOutInstructionSentEmailListArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for LoadOutInstruction. */
export type LoadOutInstructionConnection = {
  __typename?: 'LoadOutInstructionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoadOutInstructionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LoadOutInstruction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LoadOutInstructionEdge = {
  __typename?: 'LoadOutInstructionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LoadOutInstruction>;
};

export type LoadOutInstructionError = {
  __typename?: 'LoadOutInstructionError';
  /** Attribute with error on */
  attribute: Scalars['String']['output'];
  /** List of carton grouping ids that have failed phytclean inspection */
  cartonGroupingIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Unique LOI identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** List of orchard results */
  orchardResults?: Maybe<Array<OrchardResult>>;
  /** List of orchard names with errors */
  orchards?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of error present on attribute */
  type: Scalars['String']['output'];
};

export type LoadOutInstructionFilterAttribute = {
  __typename?: 'LoadOutInstructionFilterAttribute';
  /** commodities found on this user's LOIs */
  commodities?: Maybe<Array<Commodity>>;
  /** Contacts for this user's LOI */
  contacts?: Maybe<Array<Contact>>;
  /** exporters found on this user's LOIs */
  exporters?: Maybe<Array<Company>>;
  /** List of unique FBOs used as loading points */
  loadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** List of unique FBOs used as offloading points */
  offloadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** varieties found on this user's LOIs */
  varieties?: Maybe<Array<Variety>>;
  /** Vessels associated with this this user's LOIs */
  vessels?: Maybe<Array<Vessel>>;
};

export type LoadOutInstructionPalletAttributes = {
  /** Carton Grouping ID for this pallet */
  cartonGroupingId: Scalars['ID']['input'];
  /** LOI Net mass override for this pallet */
  netMass?: InputMaybe<Scalars['Float']['input']>;
  /** LOI Gross mass override for this pallet */
  grossMass?: InputMaybe<Scalars['Float']['input']>;
};

/** Filtering options for load out instructions */
export type LoadOutInstructionsFilters = {
  /** filter by the commodity ids */
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by the contact ids */
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by the exporter ids */
  exporterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by the date the container started being stuffed */
  stuffDateStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by the date the container finished being stuffed */
  stuffDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by the variety ids */
  varietyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by the vessel ids */
  vesselIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only show load out instructions that were loaded at one of the FBOs in this list */
  loadingPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only show load out instructions that were offloaded at one of the FBOs in this list */
  offloadingPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only show load out instructions printed after this date (inclusive) */
  printedDateStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** only show load out instructions printed before this date (inclusive) */
  printedDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** only show load out instructions of a certain transport type */
  transportTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** only show load out instructions created after this date (inclusive) */
  createdAtDateStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** only show load out instructions created before this date (inclusive) */
  createdAtDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type LoadingPoint = {
  __typename?: 'LoadingPoint';
  /** Code representing the specific activity point for the loading process */
  activityPointCode?: Maybe<Scalars['String']['output']>;
  /** Name of the activity point, fetched by the activity point code */
  activityPointName?: Maybe<Scalars['String']['output']>;
  /** Type of container used for the shipment (e.g. 12M HC INTEGRAL REGULAR) */
  containerType?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the loading point record was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique ID associated with the loading point */
  id: Scalars['Int']['output'];
  /** Flag indicating whether the items at this loading point have been loaded */
  isLoaded?: Maybe<Scalars['Boolean']['output']>;
  /** The quantity of goods that have been loaded at this loading point */
  loadedQuantity?: Maybe<Scalars['Int']['output']>;
  /** Date and time of loading */
  loadingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the PPECB activity point related to the loading point */
  ppecbActivityPointId?: Maybe<Scalars['Int']['output']>;
  /** Total quantity of goods to be loaded at this point */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** ID of the related shipment line item being loaded */
  shipmentLineItemId?: Maybe<Scalars['Int']['output']>;
  /** Unit of measurement for the loaded quantity (e.g. CONTAINER, CARTON, PALLET) */
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  /** Timestamp for when the loading point record was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LoadingPointAttributes = {
  /** Code representing the specific activity point for the loading process */
  activityPointCode?: InputMaybe<Scalars['String']['input']>;
  /** Type of container used for the shipment (e.g. 12M HC INTEGRAL REGULAR) */
  containerType?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when the loading point record was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Unique ID associated with the loading point */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Flag indicating if the items at this loading point have been loaded */
  isLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** The quantity of goods that have been loaded at this loading point */
  loadedQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Date and time of loading */
  loadingDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** ID of the PPECB activity point related to the loading point */
  ppecbActivityPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total quantity of goods to be loaded at this point */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the related shipment line item being loaded */
  shipmentLineItemId?: InputMaybe<Scalars['Int']['input']>;
  /** Unit of measurement for the loaded quantity (e.g. CONTAINER, CARTON, PALLET) */
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp for when the loading point record was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type Location = {
  __typename?: 'Location';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voyage?: Maybe<Voyage>;
};

export type LocationMapping = {
  __typename?: 'LocationMapping';
  /** The ID of the facility */
  facilityId?: Maybe<Scalars['ID']['output']>;
  /** The type of the facility */
  facilityType?: Maybe<Scalars['String']['output']>;
  /** The ID of the location mapping */
  id?: Maybe<Scalars['ID']['output']>;
  /** The location code of the location mapping */
  locationCode?: Maybe<Scalars['String']['output']>;
};

/** Returns the location information of pallets at that location. */
export type LocationMillerFilter = {
  __typename?: 'LocationMillerFilter';
  /** ID of the Location */
  id?: Maybe<Scalars['ID']['output']>;
  /** The location name class as a string */
  locationType?: Maybe<Scalars['String']['output']>;
  /** Location name */
  name?: Maybe<Scalars['String']['output']>;
  /** The total number of pallets at that location */
  totalPallets?: Maybe<Scalars['Int']['output']>;
};

export type LoiCartonGrouping = {
  __typename?: 'LoiCartonGrouping';
  /** The batch number of the carton grouping */
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** Who the carton grouping was sold to */
  buyerName?: Maybe<Scalars['String']['output']>;
  /** The number of cartons in the carton grouping */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** The name of the commodity */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** The consignment number of the carton grouping */
  consignmentNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated. Previously listed existing load out instructions for reassignment.
   * @deprecated Reassignment UI was removed; allocation uses loadOutInstructionsUnallocated
   */
  existingLoadOut?: Maybe<Scalars['String']['output']>;
  /** The exporter code of the carton grouping */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** The farm code of the carton grouping */
  farmCode?: Maybe<Scalars['String']['output']>;
  /** The grade of the carton grouping */
  grade?: Maybe<Scalars['String']['output']>;
  /** The ID of the carton grouping */
  id: Scalars['ID']['output'];
  /** The inventory code of the carton grouping */
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated. Previously indicated the carton grouping could be reassigned.
   * @deprecated Reassignment UI was removed; allocation uses loadOutInstructionsUnallocated
   */
  isReassignable?: Maybe<Scalars['Boolean']['output']>;
  /** The mark of the carton grouping */
  mark?: Maybe<Scalars['String']['output']>;
  /** The net mass of the carton grouping */
  netMass?: Maybe<Scalars['Float']['output']>;
  /** The orchard of the carton grouping */
  orchard?: Maybe<Scalars['String']['output']>;
  /** The pack of the carton grouping */
  pack?: Maybe<Scalars['String']['output']>;
  /** The packing week of the carton grouping */
  packingWeek?: Maybe<Scalars['String']['output']>;
  /** How old the pallet is */
  palletAge?: Maybe<Scalars['Int']['output']>;
  /** The pallet gross mass of the carton grouping */
  palletGrossMass?: Maybe<Scalars['Float']['output']>;
  /** The pallet number of the carton grouping */
  palletNumber?: Maybe<Scalars['String']['output']>;
  /** Who the carton grouping was sold by */
  sellerName?: Maybe<Scalars['String']['output']>;
  /** Indicator of whether the carton grouping is part of a sequence appearing on the same pallet */
  sequenceNumber?: Maybe<Scalars['String']['output']>;
  /** The size count of the carton grouping */
  sizeCount?: Maybe<Scalars['String']['output']>;
  /** The state of the carton grouping */
  state?: Maybe<Scalars['String']['output']>;
  /** The name of the sub commodity */
  subCommodityName?: Maybe<Scalars['String']['output']>;
  /** The target market of the carton grouping */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** The target region of the carton grouping */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** The name of the variety */
  varietyName?: Maybe<Scalars['String']['output']>;
};

export type MapPoint = {
  __typename?: 'MapPoint';
  containers?: Maybe<Array<MapPointContainer>>;
  location?: Maybe<MapPointLocatableUnion>;
  orders?: Maybe<Array<MapPointOrder>>;
  totalCartons?: Maybe<Scalars['Int']['output']>;
};

export type MapPointContainer = {
  __typename?: 'MapPointContainer';
  containerNumber?: Maybe<Scalars['String']['output']>;
  eta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  otherPartyName?: Maybe<Scalars['String']['output']>;
  portOfDestination?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
};

export type MapPointLocatableUnion = FoodBusinessOperator | SeaPort | Vessel;

export type MapPointOrder = {
  __typename?: 'MapPointOrder';
  orderId?: Maybe<Scalars['Int']['output']>;
  otherPartyName?: Maybe<Scalars['String']['output']>;
  totalCartons?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of MarkAuditsAsViewedMutation. */
export type MarkAuditsAsViewedMutationPayload = {
  __typename?: 'MarkAuditsAsViewedMutationPayload';
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of MarkContainerClaimAsCompleted. */
export type MarkContainerClaimAsCompletedPayload = {
  __typename?: 'MarkContainerClaimAsCompletedPayload';
  /** The ID of the container claim that was marked as completed */
  containerClaimId?: Maybe<Scalars['ID']['output']>;
  /** Errors that occurred during the mutation */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of MarkNotificationsAsRead. */
export type MarkNotificationsAsReadPayload = {
  __typename?: 'MarkNotificationsAsReadPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** The IDs of the notifications that were marked as read */
  ids?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated return type of MarkNotificationsAsUnread. */
export type MarkNotificationsAsUnreadPayload = {
  __typename?: 'MarkNotificationsAsUnreadPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** The IDs of the notifications that were marked as unread */
  ids?: Maybe<Array<Scalars['ID']['output']>>;
};

export type MasterfileConfig = {
  __typename?: 'MasterfileConfig';
  /** The id of the company */
  companyId?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of the creation of the masterfile config */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The id of the masterfile config */
  id?: Maybe<Scalars['ID']['output']>;
  /** The masterfile entity */
  masterfileEntity?: Maybe<MasterfileEntityUnion>;
  /** The id of the masterfile entity */
  masterfileEntityId?: Maybe<Scalars['Int']['output']>;
  /** The type of the masterfile entity */
  masterfileEntityType?: Maybe<MasterfileEntityTypeEnum>;
  /** The state of the masterfile config */
  state?: Maybe<MasterfileConfigStateEnum>;
  /** The timestamp of the last update to the masterfile config */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Input type for masterfile config company associations creation or update */
export type MasterfileConfigCompanyAssociationInput = {
  /** Unique identifier for the masterfile config company association */
  id: Scalars['ID']['input'];
  /** The state of the masterfile config company association */
  state: MasterfileConfigStateEnum;
};

/** Attributes for masterfile config farm variety creation or update */
export type MasterfileConfigFarmVarietyAttributes = {
  /** The ID of the variety to create/ edit */
  varietyId: Scalars['Int']['input'];
  /** ISO week format for packing start (e.g., "2025-W05") */
  packingStartWeek?: InputMaybe<Scalars['String']['input']>;
  /** ISO week format for packing end (e.g., "2025-W24") */
  packingEndWeek?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for masterfile config farm variety creation or update */
export type MasterfileConfigFarmVarietyInput = {
  /** Unique identifier for the masterfile config farm variety */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The farm variety attributes for creation or update */
  farmVariety?: InputMaybe<MasterfileConfigFarmVarietyAttributes>;
  /** The state of the masterfile config farm variety */
  state: MasterfileConfigStateEnum;
  /** The commodity ID for creating/updating commodity season */
  commodityId: Scalars['Int']['input'];
  /** ISO week format for commodity season start (e.g., "2025-W05") */
  commoditySeasonStartWeek?: InputMaybe<Scalars['String']['input']>;
  /** ISO week format for commodity season end (e.g., "2025-W24") */
  commoditySeasonEndWeek?: InputMaybe<Scalars['String']['input']>;
};

export type MasterfileConfigFboInput = {
  /** The id of the masterfile config fbo */
  id: Scalars['ID']['input'];
  /** The state of the masterfile config fbo */
  state: MasterfileConfigStateEnum;
  /** The latitude of the fbo */
  fboLatitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude of the fbo */
  fboLongitude?: InputMaybe<Scalars['Float']['input']>;
  /** The address of the fbo */
  address?: InputMaybe<AddressInput>;
};

/** Attributes to filter masterfile configs by */
export type MasterfileConfigFilterAttributes = {
  /** states you want to filter by (needs_confirmation, confirmed, ignored, missing) */
  states?: InputMaybe<Array<MasterfileConfigStateEnum>>;
  /** masterfile entity types you want to filter by (FarmVariety, FoodBusinessOperator) */
  masterfileEntityTypes?: InputMaybe<Array<MasterfileEntityTypeEnum>>;
};

/** Attributes for confirming a masterfile config packhouse connection */
export type MasterfileConfigPackhouseConnectionAttributes = {
  /** The id of the masterfile config packhouse connection */
  id: Scalars['ID']['input'];
  /** The state of the masterfile config packhouse connection */
  state: MasterfileConfigStateEnum;
};

/** The state of a masterfile config */
export enum MasterfileConfigStateEnum {
  /** Masterfile config is needs confirmation */
  NeedsConfirmation = 'needs_confirmation',
  /** Masterfile config is confirmed */
  Confirmed = 'confirmed',
  /** Masterfile config is ignored */
  Ignored = 'ignored',
  /** Masterfile config is missing */
  Missing = 'missing',
  /** Masterfile config is pending review */
  PendingReview = 'pending_review'
}

/** The type of masterfile entity */
export enum MasterfileEntityTypeEnum {
  /** Masterfile config is farm variety */
  FarmVariety = 'farm_variety',
  /** Masterfile config is food business operator */
  FoodBusinessOperator = 'food_business_operator',
  /** Masterfile config is packhouse connection */
  PackhouseConnection = 'packhouse_connection',
  /** Masterfile config is company association */
  CompanyAssociation = 'company_association'
}

/** Union of entities that can be masterfile entities */
export type MasterfileEntityUnion = CompanyAssociation | FarmVariety | FoodBusinessOperator | PackhouseConnection;

/** Union of FarmVariety and ClientChangeRequest */
export type MasterfileFarmVariety = FarmVariety | FarmVarietyRequest;

/** Union of FarmVariety and ClientChangeRequest */
export type MasterfileFoodBusinessOperator = FoodBusinessOperator | FoodBusinessOperatorRequest;

export type MatchCondition = {
  __typename?: 'MatchCondition';
  createdAt: Scalars['ISO8601DateTime']['output'];
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matchTypes?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
  variables?: Maybe<Array<Scalars['String']['output']>>;
};

export type MatchConditionAttributes = {
  /** The ID of the match condition */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The expression to evaluate */
  expression?: InputMaybe<Scalars['String']['input']>;
};

/** The domain of the report in the value chain (e.g. production, logistics etc.) */
export enum MetabaseDomainEnum {
  GlobalMarket = 'global_market',
  Production = 'production',
  MarketingAndSales = 'marketing_and_sales',
  Logistics = 'logistics',
  Claims = 'claims'
}

export type MetabaseReport = {
  __typename?: 'MetabaseReport';
  /** The badges associated with the report */
  badges?: Maybe<Array<Badge>>;
  /** The chart source of the report */
  chartSource?: Maybe<Scalars['String']['output']>;
  /** The chart type of the report */
  chartType?: Maybe<Scalars['String']['output']>;
  /** The description of the report */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the report to display in the UI */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The domain of the report in the value chain (e.g. production, logistics etc.) */
  domain?: Maybe<MetabaseDomainEnum>;
  /** The unique identifier of the report */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of the report */
  name?: Maybe<Scalars['String']['output']>;
  /** Fetches the PowerBI report and returns embedding attributes. */
  powerbiEmbedAttributes?: Maybe<EmbeddedChart>;
  /** The production identifier of the report */
  productionId?: Maybe<Scalars['Int']['output']>;
  /** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
  scope?: Maybe<MetabaseScopeEnum>;
  /** The metabase URL of the report */
  url?: Maybe<Scalars['String']['output']>;
};

export type MetabaseReportFilters = {
  /** The badges to filter on */
  badgeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The domains to filter on */
  domains?: InputMaybe<Array<MetabaseDomainEnum>>;
  /** The scopes to filter on */
  scopes?: InputMaybe<Array<MetabaseScopeEnum>>;
};

export type MetabaseReportsFilterAttribute = {
  __typename?: 'MetabaseReportsFilterAttribute';
  /** The badges associated with the reports */
  badges?: Maybe<Array<Badge>>;
};

/** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
export enum MetabaseScopeEnum {
  Predictive = 'predictive',
  Operational = 'operational',
  Retrospective = 'retrospective'
}

/** Returns the miller column second level field values. */
export type MillerCollapsibleInLocation = {
  __typename?: 'MillerCollapsibleInLocation';
  /** The custom field to aggregate pallets in location by. */
  field?: Maybe<Scalars['String']['output']>;
  /** Total pallets with value of the custom field. */
  totalPallets?: Maybe<Scalars['Int']['output']>;
  /** The value of the custom field. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Attributes for the miller column to filter data */
export type MillerCollapsibleInLocationInput = {
  /** The ID of the location */
  locationId: Scalars['ID']['input'];
  /** The class of the location object */
  locationType: Scalars['String']['input'];
  /** The column field name to filter by */
  filterField: Scalars['String']['input'];
  /** The column field value used to filter */
  filterValue?: InputMaybe<Scalars['String']['input']>;
};

/** An object representing money, with an amount and currency. */
export type Money = {
  __typename?: 'Money';
  /** Numerical amount of the money (i.e. 3.50). */
  amount: Scalars['Float']['output'];
  /** Currency of the money */
  currency: Currency;
  /** Displayable string (i.e. "$3.50"). */
  displayString: Scalars['String']['output'];
  /** Fractional unit value of a given currency (i.e. 350). */
  fractional: Scalars['Int']['output'];
};

/** Autogenerated return type of MoveSlisToNewShipment. */
export type MoveSlisToNewShipmentPayload = {
  __typename?: 'MoveSlisToNewShipmentPayload';
  shipment?: Maybe<Shipment>;
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
};

/** root mutation */
export type Mutation = {
  __typename?: 'Mutation';
  acceptLineItems?: Maybe<AcceptLineItemsPayload>;
  /** Accept a counter-offer as a supplier and allocates the inventory. */
  acceptOfferAsSupplier?: Maybe<AcceptOfferAsSupplierPayload>;
  /** Create a client change request for adding an internal packhouse */
  addInternalPackhouse?: Maybe<AddInternalPackhousePayload>;
  allocatePayments?: Maybe<AllocatePaymentsPayload>;
  allocateShipmentController?: Maybe<AllocateShipmentControllerPayload>;
  allocateSliContainer?: Maybe<AllocateSliContainerPayload>;
  /** Archive notifications */
  archiveNotifications?: Maybe<ArchiveNotificationsPayload>;
  calculateCommercials?: Maybe<CalculateCommercialsPayload>;
  calculateInvoiceIncoterm?: Maybe<CalculateInvoiceIncotermPayload>;
  /** Get the total estimated amount for the cost code for all passed CGs */
  calculatePalletCosts?: Maybe<CalculatePalletCostsPayload>;
  cancelAddendum?: Maybe<CancelAddendumPayload>;
  cancelAirAddendum?: Maybe<CancelAirAddendumPayload>;
  captureAccountSale?: Maybe<CaptureAccountSalePayload>;
  /** Capture Defect Percentages */
  captureDefectPercentages?: Maybe<CaptureDefectPercentagesPayload>;
  /** Close an offer as a supplier */
  closeOfferAsSupplier?: Maybe<CloseOfferAsSupplierPayload>;
  completeAirFreightShipment?: Maybe<CompleteAirFreightShipmentPayload>;
  completeShipment?: Maybe<CompleteShipmentPayload>;
  completeShipmentLineItem?: Maybe<CompleteShipmentLineItemPayload>;
  /** Send confirmation to PPECB for an already submitted ShipmentLineItem */
  confirmExportNotificationLineItem?: Maybe<ConfirmExportNotificationLineItemPayload>;
  /** Confirms the cold stores associated with a supplier-exporter association */
  confirmExporterColdStores?: Maybe<ConfirmExporterColdStoresPayload>;
  /** Confirm company association masterfile configs */
  confirmMasterfileConfigCompanyAssociations?: Maybe<ConfirmMasterfileConfigCompanyAssociationsPayload>;
  /** Confirm farm variety masterfile configs (updates existing or creates new farm varieties as needed) */
  confirmMasterfileConfigFarmVarieties?: Maybe<ConfirmMasterfileConfigFarmVarietiesPayload>;
  /** Confirm FBO masterfile configs */
  confirmMasterfileConfigFbo?: Maybe<ConfirmMasterfileConfigFboPayload>;
  /** Confirm packhouse connection masterfile configs */
  confirmMasterfileConfigPackhouseConnections?: Maybe<ConfirmMasterfileConfigPackhouseConnectionsPayload>;
  createAdditionalField?: Maybe<CreateAdditionalFieldPayload>;
  /** Creates a new cargo dues record and generates COPRAR EDI file */
  createCargoDue?: Maybe<CreateCargoDuePayload>;
  createCartonConversion?: Maybe<CreateCartonConversionPayload>;
  createClientChangeRequest?: Maybe<CreateClientChangeRequestPayload>;
  createComment?: Maybe<CreateCommentPayload>;
  createCommercialTermChangeRequest?: Maybe<CreateCommercialTermChangeRequestPayload>;
  createContact?: Maybe<CreateContactPayload>;
  /** Counter a buyer counter-offer as a supplier and notify the buyer via WhatsApp. */
  createCounterOfferAsSupplier?: Maybe<CreateCounterOfferAsSupplierPayload>;
  createCustomField?: Maybe<CreateCustomFieldPayload>;
  createExportNotificationBooking?: Maybe<CreateExportNotificationBookingPayload>;
  createExportNotificationLineItem?: Maybe<CreateExportNotificationLineItemPayload>;
  /** Create a single client change request for one exporter FBO with cold store IDs */
  createExporterAndColdStoreClientRequest?: Maybe<CreateExporterAndColdStoreClientRequestPayload>;
  /** Create client change requests for requested exporter cold store records */
  createExporterColdStoreRequest?: Maybe<CreateExporterColdStoreRequestPayload>;
  /** Create a new farm FBO */
  createFarmFbo?: Maybe<CreateFarmFboPayload>;
  createFarmVariety?: Maybe<CreateFarmVarietyPayload>;
  createFarmVarietyClientChangeRequest?: Maybe<CreateFarmVarietyRequestPayload>;
  /** Create a finance rule */
  createFinanceRule?: Maybe<CreateFinanceRulePayload>;
  createFoodBusinessOperatorClientChangeRequest?: Maybe<CreateFoodBusinessOperatorRequestPayload>;
  createIgnoreErrorRequest?: Maybe<CreateIgnoreErrorRequestPayload>;
  createIncotermLineItem?: Maybe<CreateIncotermLineItemPayload>;
  /** Creates multiple line items for a given incoterm, this is used to return the expected return summary for a given incoterm */
  createIncotermLineItems?: Maybe<CreateIncotermLineItemsPayload>;
  /** Mutation to create an invoice with a currency exchange rate */
  createInvoice?: Maybe<CreateInvoicePayload>;
  /** Create a new invoice from a batch of existing account system invoices */
  createInvoiceFromBatch?: Maybe<CreateInvoiceFromBatchPayload>;
  createLoadOutInstruction?: Maybe<CreateLoadOutInstructionPayload>;
  createNetReturnProgram?: Maybe<CreateNetReturnProgramPayload>;
  /** Create a broadcast offer as a supplier and dispatch it to the given buyers via WhatsApp */
  createOfferAsSupplier?: Maybe<CreateOfferAsSupplierPayload>;
  /** Mutation to create an order */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Mutation to create an order program and associated program */
  createOrderProgram?: Maybe<CreateOrderProgramPayload>;
  /** Create a packhouse connection request */
  createPackhouseConnectionsRequest?: Maybe<CreatePackhouseConnectionsRequestPayload>;
  /** Mutation to create a payment with a currency exchange rate */
  createPayment?: Maybe<CreatePaymentPayload>;
  createQuickCost?: Maybe<CreateQuickCostPayload>;
  createReportGroup?: Maybe<CreateReportGroupPayload>;
  createShipment?: Maybe<CreateShipmentPayload>;
  createShipmentLineItem?: Maybe<CreateShipmentLineItemPayload>;
  /** Create a software update report */
  createSoftwareUpdateReport?: Maybe<CreateSoftwareUpdateReportPayload>;
  /** Create client change requests for a supplier-exporter relationship (to be CompanyAssociation when approved) */
  createSupplierExporterRequest?: Maybe<CreateSupplierExporterRequestPayload>;
  createUiConfig?: Maybe<CreateUiConfigPayload>;
  deleteAddendumLineItem?: Maybe<DeleteAddendumLineItemPayload>;
  deleteAdditionalField?: Maybe<DeleteAdditionalFieldPayload>;
  deleteCartonConversion?: Maybe<DeleteCartonConversionPayload>;
  deleteComment?: Maybe<DeleteCommentPayload>;
  deleteCompanyCertificate?: Maybe<DeleteCompanyCertificatePayload>;
  deleteContact?: Maybe<DeleteContactPayload>;
  /** Delete the exchange rate for an invoice or payment */
  deleteCurrencyExchangeRate?: Maybe<DeleteCurrencyExchangeRatePayload>;
  deleteCustomField?: Maybe<DeleteCustomFieldPayload>;
  deleteEmployee?: Maybe<DeleteEmployeePayload>;
  /** Delete an existing Ephyto and send a delete request to ecert */
  deleteEphyto?: Maybe<DeleteEphytoPayload>;
  deleteEphytoDocument?: Maybe<DeleteEphytoDocumentPayload>;
  deleteExportDocument?: Maybe<DeleteExportDocumentPayload>;
  deleteFarmVariety?: Maybe<DeleteFarmVarietyPayload>;
  deleteFarmVarietyImage?: Maybe<DeleteFarmVarietyImagePayload>;
  deleteFinanceRule?: Maybe<DeleteFinanceRulePayload>;
  deleteInvoice?: Maybe<DeleteInvoicePayload>;
  /** Delete a document from an invoice */
  deleteInvoiceDocument?: Maybe<DeleteInvoiceDocumentPayload>;
  deleteLoadOutInstruction?: Maybe<DeleteLoadOutInstructionPayload>;
  deleteNetReturnProgram?: Maybe<DeleteNetReturnProgramPayload>;
  /** Mutation to delete an order program and associated program */
  deleteOrderProgram?: Maybe<DeleteOrderProgramPayload>;
  deletePayment?: Maybe<DeletePaymentPayload>;
  deleteReportGroup?: Maybe<DeleteReportGroupPayload>;
  deleteShipmentDocument?: Maybe<DeleteShipmentDocumentPayload>;
  deleteShipmentLineItem?: Maybe<DeleteShipmentLineItemPayload>;
  /** Delete the document related to a task */
  deleteTaskDocument?: Maybe<DeleteTaskDocumentPayload>;
  deleteUiConfig?: Maybe<DeleteUiConfigPayload>;
  /** Downloads multiple documents as a zip file */
  downloadDocuments?: Maybe<DownloadDocumentsPayload>;
  /** Send an ephyto to ecert in a DRAFT state */
  draftEphyto?: Maybe<DraftEphytoPayload>;
  duplicateAddendumLineItem?: Maybe<DuplicateAddendumLineItemPayload>;
  /** Duplicate an existing Ephyto */
  duplicateEphyto?: Maybe<DuplicateEphytoPayload>;
  duplicateInvoice?: Maybe<DuplicateInvoicePayload>;
  /** Duplicate an existing ShipmentLineItem */
  duplicateShipmentLineItem?: Maybe<DuplicateShipmentLineItemPayload>;
  /** Mutation that sends an email to a list of recipients with a list of documents */
  emailDocuments?: Maybe<EmailDocumentsPayload>;
  /** sends an email to a list of recipients with a list of tasks documents */
  emailTaskDocuments?: Maybe<EmailTaskDocumentsPayload>;
  /** Fetch the status of a submitted Ephyto on eCert */
  fetchEphytoStatus?: Maybe<FetchEphytoStatusPayload>;
  /** Fetches transnet container operators */
  fetchTransnetContainerOperators?: Maybe<FetchTransnetContainerOperatorsPayload>;
  /** Fetches the visit list for a given port and date range */
  fetchTransnetVisitsByShipment?: Maybe<FetchTransnetVisitsByShipmentPayload>;
  /** Mutation used to finalise default costs */
  finaliseDefaultCosts?: Maybe<FinaliseDefaultCostsPayload>;
  /** Find or create a vessel */
  findOrCreateVessel?: Maybe<FindOrCreateVesselPayload>;
  /** Requests the generation of PDF & XLS for a specific account statement.Generation is done asyncronously */
  generateAccountStatementOutputFiles?: Maybe<GenerateAccountStatementOutputFilesPayload>;
  /** Requests the generation of a specific accounting export file.Generation is done asyncronously */
  generateAccountingExport?: Maybe<GenerateAccountingExportPayload>;
  generateAddendum?: Maybe<GenerateAddendumPayload>;
  /** Requests the generation of PDF & XLS for a specific addendum header.Generation is done asyncronously */
  generateAddendumHeaderOutputFiles?: Maybe<GenerateAddendumHeaderOutputFilesPayload>;
  /** Requests the generation of PDF & XLS for a specific UI screen that has an AG1 table component */
  generateAg1TableOutputFile?: Maybe<GenerateAg1TableOutputFilePayload>;
  /** Generate an addendum for the selected load out instructions */
  generateAirAddendum?: Maybe<GenerateAirAddendumPayload>;
  /** Generate arrival qcs for containerables */
  generateArrivalQcs?: Maybe<GenerateArrivalQcsPayload>;
  generateCommoditySeasons?: Maybe<GenerateCommoditySeasonsPayload>;
  /**
   *
   *       Generates Output files for specified Data Preparation
   *
   */
  generateDataOutputFiles?: Maybe<GenerateDataOutputFilesPayload>;
  /** Generate an Ephyto from existing AFSLI or SLIs */
  generateEphyto?: Maybe<GenerateEphytoPayload>;
  /** Generate Ephyto Trade Units for the Ephyto */
  generateEphytoTradeUnit?: Maybe<GenerateEphytoTradeUnitPayload>;
  /** Requests the generation of PDF & XLS for a specific invoice. Generation is done asyncronously */
  generateInvoiceOutputFiles?: Maybe<GenerateInvoiceOutputFilesPayload>;
  /** Requests the generation of PDF & XLS for a specific load out instruction. Generation is done asyncronously */
  generateLoadOutInstructionOutputFiles?: Maybe<GenerateLoadOutInstructionOutputFilesPayload>;
  /** Requests the generation of a pallet in EDI for a specific load out instruction. Generation is done asyncronously */
  generatePalletInOutputFiles?: Maybe<GeneratePalletInOutputFilesPayload>;
  /** Requests the generation of a pallet out EDI for a specific addendum header. Generation is done asyncronously */
  generatePalletOutOutputFiles?: Maybe<GeneratePalletOutOutputFilesPayload>;
  /** Generates a persisted producer statement (PDF or XLS) from selected P&L row CG IDs. Creates a ProducerStatement record, links CGs, and generates the document via Templatable. */
  generateProducerStatement?: Maybe<GenerateProducerStatementPayload>;
  /** Requests the generation of PDF & XLS for a specific shipment export notification.Generation is done asyncronously */
  generateShipmentExportNotificationOutputFiles?: Maybe<GenerateShipmentExportNotificationOutputFilesPayload>;
  inviteUser?: Maybe<InviteUserPayload>;
  lookupAndTranslate: Scalars['JSON']['output'];
  /** Mark a carton grouping audit as viewed */
  markAuditsAsViewed?: Maybe<MarkAuditsAsViewedMutationPayload>;
  /** Marks a container claim as completed, removing it from active claims */
  markContainerClaimAsCompleted?: Maybe<MarkContainerClaimAsCompletedPayload>;
  /** Mark notifications as read */
  markNotificationsAsRead?: Maybe<MarkNotificationsAsReadPayload>;
  /** Mark notifications as unread */
  markNotificationsAsUnread?: Maybe<MarkNotificationsAsUnreadPayload>;
  /** Moves a set of SLIs to an existing shipment or creates a new shipment and reassigns the SLIs. */
  moveSlisToNewShipment?: Maybe<MoveSlisToNewShipmentPayload>;
  processEtlDocument?: Maybe<ProcessEtlDocumentPayload>;
  /** Push pack instructions to OnePack via NSOffice */
  pushPackInstructionsToOnepack?: Maybe<PushPackInstructionsToOnepackPayload>;
  queryAddendum?: Maybe<QueryAddendumPayload>;
  /** Queue async P&L report generation */
  queueProfitAndLossReport: ProfitAndLossReportPending;
  /** Queue a report group for PDF generation */
  queueReportGroupOutputFile?: Maybe<QueueReportGroupOutputFilePayload>;
  /** Reassign an SLIs Shipment Line Grouping. */
  reassignShipmentLineItemGrouping?: Maybe<ReassignShipmentLineItemGroupingPayload>;
  /** Reject a counter offer as a supplier and notify the buyer via WhatsApp */
  rejectOfferAsSupplier?: Maybe<RejectOfferAsSupplierPayload>;
  /** Removes a defect from all claim line items that belong to a given claim line item grouping */
  removeClaimLineItemGroupingDefect?: Maybe<RemoveClaimLineItemGroupingDefectPayload>;
  /** Removes expected claim from a claim line item grouping */
  removeClaimLineItemGroupingExpectedClaim?: Maybe<RemoveClaimLineItemGroupingExpectedClaimPayload>;
  /** Removes a defect from a claim line item */
  removeClaimLineItemPalletDefect?: Maybe<RemoveClaimLineItemPalletDefectPayload>;
  /** Remove an expected claim from a claim line item pallet */
  removeClaimLineItemPalletExpectedClaim?: Maybe<RemoveClaimLineItemPalletExpectedClaimPayload>;
  /** Mutation used to remove default costs */
  removeDefaultCosts?: Maybe<RemoveDefaultCostsPayload>;
  resendInvite?: Maybe<ResendInvitePayload>;
  /** Mutation used to resolve a CG error */
  resolveCgError?: Maybe<ResolveCgErrorPayload>;
  revertLineItemsToCreated?: Maybe<RevertLineItemsToCreatedPayload>;
  revertOrderChange?: Maybe<RevertOrderChangePayload>;
  revokeInvite?: Maybe<RevokeInvitePayload>;
  /**
   * Requests the emailing of (templatable, for now) documents, for a list of document IDs, a list of recipients, and a specific document type (Invoice/LOI/etc). Generation is done asyncronously
   * @deprecated This mutation is deprecated. TODO: remove
   */
  sendEmail?: Maybe<SendEmailPayload>;
  /** Soft deletes a container claim */
  softDeleteContainerClaim?: Maybe<SoftDeleteContainerClaimPayload>;
  /** Submit an Addendum to PPECB */
  submitAddendum?: Maybe<SubmitAddendumPayload>;
  /** Mark an existing Ephyto on ECERT as Submit for processing */
  submitEphyto?: Maybe<SubmitEphytoPayload>;
  /** Starts the job of submitting the shipment header and each ShipmentLineItem to PPEB */
  submitShipmentExportNotification?: Maybe<SubmitShipmentExportNotificationPayload>;
  /** Allows user to configure which of their notification rules they want to receive notifications for */
  subscribeToNotificationRules?: Maybe<SubscribeToNotificationRulesPayload>;
  /** Update an Addendum Header and its Line Items in our system */
  updateAddendum?: Maybe<UpdateAddendumPayload>;
  updateAdditionalField?: Maybe<UpdateAdditionalFieldPayload>;
  /** Update an Air Addendum Header and its Line Items in our system */
  updateAirAddendum?: Maybe<UpdateAirAddendumPayload>;
  /** Update an Air Freight Shipment controller in our system */
  updateAirFreightShipmentController?: Maybe<UpdateAirFreightShipmentControllerPayload>;
  /** Update the arrival qc capture datetime on the container claim */
  updateArrivalQcCaptureDatetime?: Maybe<UpdateArrivalQcCaptureDatetimePayload>;
  /** Updates the arrival qc grade of all claim line items in a claim line item grouping */
  updateArrivalQcClaimLineItemGroupingGrade?: Maybe<UpdateArrivalQcClaimLineItemGroupingGradePayload>;
  /** Mutations that updates the arrival qc grade of a claim line item pallet */
  updateArrivalQcClaimLineItemPalletGrade?: Maybe<UpdateArrivalQcClaimLineItemPalletGradePayload>;
  updateCartonConversion?: Maybe<UpdateCartonConversionPayload>;
  updateCartonGroupingTransactions?: Maybe<UpdateCartonGroupingTransactionsPayload>;
  /** Updates the comment on a claim line item grouping */
  updateClaimLineItemGroupingComment?: Maybe<UpdateClaimLineItemGroupingCommentPayload>;
  /** Updates the commodity defect on all claim line itemsin a claim line item grouping */
  updateClaimLineItemGroupingDefect?: Maybe<UpdateClaimLineItemGroupingDefectPayload>;
  /** Updates the expected claim of all claim line items in a claim line item grouping */
  updateClaimLineItemGroupingExpectedClaim?: Maybe<UpdateClaimLineItemGroupingExpectedClaimPayload>;
  /** Updates the arrival qc defect all claim line items in a claim line item pallet */
  updateClaimLineItemPalletDefect?: Maybe<UpdateClaimLineItemPalletDefectPayload>;
  /** Update the expected claim for a set of claim line items that belong to a claim line item pallet */
  updateClaimLineItemPalletExpectedClaim?: Maybe<UpdateClaimLineItemPalletExpectedClaimPayload>;
  /** Updates an on premises command with a result */
  updateCommandResult?: Maybe<UpdateCommandResultPayload>;
  updateCompanyDetails?: Maybe<UpdateCompanyDetailsPayload>;
  /** Mutation to update the onboarding step of a company */
  updateCompanyOnboardingStep?: Maybe<UpdateCompanyOnboardingStepPayload>;
  updateCompanyTradeRegions?: Maybe<UpdateCompanyTradeRegionsPayload>;
  updateContact?: Maybe<UpdateContactPayload>;
  /** Updates the grade of a container claim */
  updateContainerClaimGrade?: Maybe<UpdateContainerClaimGradePayload>;
  /** Updates the the container claim's note */
  updateContainerClaimNote?: Maybe<UpdateContainerClaimNotePayload>;
  updateCustomField?: Maybe<UpdateCustomFieldPayload>;
  /** Mutation that updates the custom date for a task. */
  updateCustomTaskDate?: Maybe<UpdateCustomTaskDatePayload>;
  /** Updates a Data Output */
  updateDataOutput?: Maybe<UpdateDataOutputPayload>;
  /** Update an Ephyto on eCert */
  updateDraftEphyto?: Maybe<UpdateDraftEphytoPayload>;
  /** Update an Ephyto and its related models in our system */
  updateEphyto?: Maybe<UpdateEphytoPayload>;
  updateEphytoDocument?: Maybe<UpdateEphytoDocumentPayload>;
  updateEstimates?: Maybe<UpdateEstimatesPayload>;
  updateExportDocument?: Maybe<UpdateExportDocumentPayload>;
  updateFarmVariety?: Maybe<UpdateFarmVarietyPayload>;
  /** Update a finance rule */
  updateFinanceRule?: Maybe<UpdateFinanceRulePayload>;
  /** Update the enabled state of a finance rule */
  updateFinanceRuleEnabledState?: Maybe<UpdateFinanceRuleEnabledStatePayload>;
  /** Mutation to update an invoice and its currency exchange rate */
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  updateInvoiceState?: Maybe<UpdateInvoiceStatePayload>;
  updateLineItems?: Maybe<UpdateLineItemsPayload>;
  updateLoadOutInstruction?: Maybe<UpdateLoadOutInstructionPayload>;
  updateLoadOutInstructionsFromSlis?: Maybe<UpdateLoadOutInstructionsFromSlisPayload>;
  updateNetReturnProgram?: Maybe<UpdateNetReturnProgramPayload>;
  updateOrchardSeasons?: Maybe<UpdateOrchardSeasonsPayload>;
  updateOrchardYields?: Maybe<UpdateOrchardYieldsPayload>;
  updateOrder?: Maybe<UpdateOrderPayload>;
  /** Mutation to update an order program and associated program */
  updateOrderProgram?: Maybe<UpdateOrderProgramPayload>;
  /**
   * Mutation that updates the priority on a pack
   *                                                        instruction line item
   */
  updatePackInstructionLineItemPriority?: Maybe<UpdatePackInstructionLineItemPriorityPayload>;
  /** Mutation to update a payment and its currency exchange rate */
  updatePayment?: Maybe<UpdatePaymentPayload>;
  updateReportGroup?: Maybe<UpdateReportGroupPayload>;
  updateShipment?: Maybe<UpdateShipmentPayload>;
  updateShipmentDocument?: Maybe<UpdateShipmentDocumentPayload>;
  updateShipmentLineItem?: Maybe<UpdateShipmentLineItemPayload>;
  /** Mutation that updates tasks dates */
  updateTasksDates?: Maybe<UpdateTasksDatesPayload>;
  updateUiConfig?: Maybe<UpdateUiConfigPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserFeedItem?: Maybe<UpdateUserFeedItemPayload>;
  updateUserFeedItems?: Maybe<UpdateUserFeedItemsPayload>;
  updateUserNotifications?: Maybe<UpdateUserNotificationsPayload>;
  /** Uploads files on a container claim */
  uploadClaimFiles?: Maybe<UploadClaimFilesPayload>;
  uploadCompanyCertificate?: Maybe<UploadCompanyCertificatePayload>;
  uploadCompanyLogo?: Maybe<UploadCompanyLogoPayload>;
  /** Upload of support ephyto documents on the UI, Ephyto tab specifically */
  uploadEphytoDocument?: Maybe<UploadEphytoDocumentPayload>;
  uploadEtlDocument?: Maybe<UploadEtlDocumentPayload>;
  uploadExportDocument?: Maybe<UploadExportDocumentPayload>;
  uploadFarmVarietyImage?: Maybe<UploadFarmVarietyImagePayload>;
  /** Upload documents (PDF and Excel files) to an invoice */
  uploadInvoiceDocuments?: Maybe<UploadInvoiceDocumentsPayload>;
  uploadOrderShipmentDocument?: Maybe<UploadOrderShipmentDocumentPayload>;
  /** Upload stock files from the stock screen */
  uploadStockFile?: Maybe<UploadStockFileMutationPayload>;
  /** Mutation that uploads a document to a task */
  uploadTaskDocument?: Maybe<UploadTaskDocumentPayload>;
  /** Upload a single document for a Task and associate it with multiple SLI Tasks */
  uploadTaskDocumentPerSli?: Maybe<UploadTaskDocumentPerSliPayload>;
  uploadUserAvatar?: Maybe<UploadUserAvatarPayload>;
  /** Creates or updates a CTI from the SLI and generates a PDF and XL documentGeneration is done asynchronously */
  upsertCertificateTransportInstruction?: Maybe<UpsertCertificateTransportInstructionPayload>;
  /** Upsert a commercial term */
  upsertCommercialTerm?: Maybe<UpsertCommercialTermPayload>;
  /** Upsert the exchange rate for an invoice or payment */
  upsertCurrencyExchangeRate?: Maybe<UpsertCurrencyExchangeRatePayload>;
  /** Upsert multiple finance rules */
  upsertFinanceRule?: Maybe<UpsertFinanceRulePayload>;
  wontPackLineItems?: Maybe<WontPackLineItemsPayload>;
};


/** root mutation */
export type MutationAcceptLineItemsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** root mutation */
export type MutationAcceptOfferAsSupplierArgs = {
  counterOfferId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationAddInternalPackhouseArgs = {
  attributes: AddInternalPackhouseAttributes;
};


/** root mutation */
export type MutationAllocatePaymentsArgs = {
  paymentAllocations: Array<PaymentAllocationAttributes>;
};


/** root mutation */
export type MutationAllocateShipmentControllerArgs = {
  shipmentId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


/** root mutation */
export type MutationAllocateSliContainerArgs = {
  isBreakBulk: Scalars['Boolean']['input'];
  sliContainerId?: InputMaybe<Scalars['Int']['input']>;
  sliId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationArchiveNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** root mutation */
export type MutationCalculateCommercialsArgs = {
  attributes: InvoiceAttributes;
};


/** root mutation */
export type MutationCalculateInvoiceIncotermArgs = {
  attributes: InvoiceIncotermAttributes;
};


/** root mutation */
export type MutationCalculatePalletCostsArgs = {
  cgIds: Array<Scalars['Int']['input']>;
  costId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationCancelAddendumArgs = {
  deleteAddendum: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationCancelAirAddendumArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationCaptureAccountSaleArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationCaptureDefectPercentagesArgs = {
  attributes: DefectPercentageCaptureAttributes;
};


/** root mutation */
export type MutationCloseOfferAsSupplierArgs = {
  offerId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationCompleteAirFreightShipmentArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationCompleteShipmentArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationCompleteShipmentLineItemArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationConfirmExportNotificationLineItemArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationConfirmExporterColdStoresArgs = {
  companyAssociationExportColdStoreAttributes: Array<CompanyAssociationExportColdStoreAttributes>;
  clientChangeRequestExportColdStoreAttributes: Array<ClientChangeRequestExportColdStoreAttributes>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigCompanyAssociationsArgs = {
  masterfileConfigs: Array<MasterfileConfigCompanyAssociationInput>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigFarmVarietiesArgs = {
  masterfileConfigs: Array<MasterfileConfigFarmVarietyInput>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigFboArgs = {
  masterfileConfigs: Array<MasterfileConfigFboInput>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigPackhouseConnectionsArgs = {
  masterfileConfigs: Array<MasterfileConfigPackhouseConnectionAttributes>;
};


/** root mutation */
export type MutationCreateAdditionalFieldArgs = {
  attributes: CreateAdditionalFieldAttributes;
};


/** root mutation */
export type MutationCreateCargoDueArgs = {
  cargoDueData: Scalars['Json']['input'];
  sliIds: Array<Scalars['ID']['input']>;
  transnetVisit: Scalars['Json']['input'];
  cargoDueId?: InputMaybe<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationCreateCartonConversionArgs = {
  actualMass?: InputMaybe<Scalars['Float']['input']>;
  commodityId?: InputMaybe<Scalars['ID']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  conversionType?: InputMaybe<Scalars['String']['input']>;
  convertedSizeCount?: InputMaybe<Scalars['String']['input']>;
  massConversion?: InputMaybe<Scalars['Float']['input']>;
  pack?: InputMaybe<Scalars['String']['input']>;
  sizeCount?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationCreateClientChangeRequestArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  userContext?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationCreateCommentArgs = {
  attributes: CreateCommentAttributes;
};


/** root mutation */
export type MutationCreateCommercialTermChangeRequestArgs = {
  attributes: CreateCommercialTermChangeRequestAttributes;
};


/** root mutation */
export type MutationCreateContactArgs = {
  attributes: ContactAttributes;
};


/** root mutation */
export type MutationCreateCounterOfferAsSupplierArgs = {
  previousOfferId: Scalars['ID']['input'];
  attributes: CounterOfferAttributes;
};


/** root mutation */
export type MutationCreateCustomFieldArgs = {
  attributes: CustomFieldAttributes;
};


/** root mutation */
export type MutationCreateExportNotificationBookingArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationCreateExportNotificationLineItemArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationCreateExporterAndColdStoreClientRequestArgs = {
  exporterFboId: Scalars['ID']['input'];
  coldStoreIds: Array<Scalars['ID']['input']>;
  isPackhouseContainerised?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root mutation */
export type MutationCreateExporterColdStoreRequestArgs = {
  companyAssociationId: Scalars['ID']['input'];
  coldStoreIds: Array<Scalars['ID']['input']>;
  isPackhouseContainerisation: Scalars['Boolean']['input'];
};


/** root mutation */
export type MutationCreateFarmFboArgs = {
  attributes: CreateFarmAttribute;
};


/** root mutation */
export type MutationCreateFarmVarietyArgs = {
  attributes: CreateFarmVarietyAttributes;
};


/** root mutation */
export type MutationCreateFarmVarietyClientChangeRequestArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  commodityId?: InputMaybe<Scalars['Int']['input']>;
  commodityName?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  varietyCode?: InputMaybe<Scalars['String']['input']>;
  varietyId?: InputMaybe<Scalars['Int']['input']>;
};


/** root mutation */
export type MutationCreateFinanceRuleArgs = {
  attributes: Array<FinanceRuleAttributes>;
};


/** root mutation */
export type MutationCreateFoodBusinessOperatorClientChangeRequestArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  fboCode?: InputMaybe<Scalars['String']['input']>;
  globalGapNumber?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  producerName?: InputMaybe<Scalars['String']['input']>;
  productionRegion?: InputMaybe<Scalars['String']['input']>;
  typeOfBusiness?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationCreateIgnoreErrorRequestArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  errorToIgnore?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationCreateIncotermLineItemArgs = {
  attributes: CreateLineItemAttributes;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationCreateIncotermLineItemsArgs = {
  lineItemAttributes: Array<CreateLineItemAttributes>;
};


/** root mutation */
export type MutationCreateInvoiceArgs = {
  attributes: InvoiceAttributes;
  currencyExchangeRateAttributes?: InputMaybe<CurrencyExchangeRateAttributes>;
};


/** root mutation */
export type MutationCreateInvoiceFromBatchArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
  documentType: Scalars['String']['input'];
};


/** root mutation */
export type MutationCreateLoadOutInstructionArgs = {
  attributes: LoadOutAttributes;
};


/** root mutation */
export type MutationCreateNetReturnProgramArgs = {
  attributes: NetReturnProgramAttributes;
};


/** root mutation */
export type MutationCreateOfferAsSupplierArgs = {
  attributes: OfferAttributes;
};


/** root mutation */
export type MutationCreateOrderArgs = {
  attributes: CreateOrderAttributes;
};


/** root mutation */
export type MutationCreateOrderProgramArgs = {
  attributes: OrderProgramAttributes;
};


/** root mutation */
export type MutationCreatePackhouseConnectionsRequestArgs = {
  attributes: CreatePackhouseConnectionsAttribute;
};


/** root mutation */
export type MutationCreatePaymentArgs = {
  attributes: PaymentAttributes;
  currencyExchangeRateAttributes?: InputMaybe<CurrencyExchangeRateAttributes>;
};


/** root mutation */
export type MutationCreateQuickCostArgs = {
  attributes: QuickCostAttributes;
};


/** root mutation */
export type MutationCreateReportGroupArgs = {
  attributes: ReportGroupAttributes;
};


/** root mutation */
export type MutationCreateShipmentArgs = {
  attributes: ShipmentAttributes;
};


/** root mutation */
export type MutationCreateShipmentLineItemArgs = {
  attributes: ShipmentLineItemAttributes;
};


/** root mutation */
export type MutationCreateSoftwareUpdateReportArgs = {
  softwareUpdateReport: Array<Scalars['String']['input']>;
};


/** root mutation */
export type MutationCreateSupplierExporterRequestArgs = {
  attributes: CreateSupplierExporterRequestAttribute;
};


/** root mutation */
export type MutationCreateUiConfigArgs = {
  attributes: CreateUpdateUiConfigAttributes;
};


/** root mutation */
export type MutationDeleteAddendumLineItemArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteAdditionalFieldArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteCartonConversionArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeleteCommentArgs = {
  commentId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteCompanyCertificateArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteContactArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteCurrencyExchangeRateArgs = {
  currencyExchangeRateId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeleteCustomFieldArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteEmployeeArgs = {
  employeeId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteEphytoArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteEphytoDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteExportDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteFarmVarietyArgs = {
  companyId: Scalars['Int']['input'];
  varietyId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteFarmVarietyImageArgs = {
  varietyId: Scalars['Int']['input'];
  imageId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteFinanceRuleArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationDeleteInvoiceArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteInvoiceDocumentArgs = {
  invoiceId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeleteLoadOutInstructionArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteNetReturnProgramArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeleteOrderProgramArgs = {
  orderProgramId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeletePaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeleteReportGroupArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteShipmentDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteShipmentLineItemArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDeleteTaskDocumentArgs = {
  id: Scalars['ID']['input'];
  shipmentLineItemId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationDeleteUiConfigArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDownloadDocumentsArgs = {
  documentAttributes: Array<DownloadDocumentAttributes>;
  zippedFilename: Scalars['String']['input'];
};


/** root mutation */
export type MutationDraftEphytoArgs = {
  ephytoId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDuplicateAddendumLineItemArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDuplicateEphytoArgs = {
  applicationType: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationDuplicateInvoiceArgs = {
  documentType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  shouldDuplicateLineItems: Scalars['Boolean']['input'];
};


/** root mutation */
export type MutationDuplicateShipmentLineItemArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationEmailDocumentsArgs = {
  attributes: EmailDocumentsAttributes;
};


/** root mutation */
export type MutationEmailTaskDocumentsArgs = {
  attributes: EmailTaskDocumentsAttributes;
};


/** root mutation */
export type MutationFetchEphytoStatusArgs = {
  ephytoId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationFetchTransnetVisitsByShipmentArgs = {
  portId?: InputMaybe<Scalars['ID']['input']>;
  shipmentId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationFinaliseDefaultCostsArgs = {
  attributes: FinaliseDefaultCostAttributes;
};


/** root mutation */
export type MutationFindOrCreateVesselArgs = {
  vesselName: Scalars['String']['input'];
};


/** root mutation */
export type MutationGenerateAccountStatementOutputFilesArgs = {
  companyId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


/** root mutation */
export type MutationGenerateAccountingExportArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationGenerateAddendumArgs = {
  bookingReference?: InputMaybe<Scalars['String']['input']>;
  sliIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationGenerateAddendumHeaderOutputFilesArgs = {
  addendumHeaderId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationGenerateAg1TableOutputFileArgs = {
  data: Scalars['Json']['input'];
  fields: Array<Ag1TableFieldAttribute>;
  fileFormat: TemplateFileFormatEnum;
  tableName: Scalars['String']['input'];
  filterValues?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};


/** root mutation */
export type MutationGenerateAirAddendumArgs = {
  loiIds: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationGenerateArrivalQcsArgs = {
  containerableIds: Array<Scalars['ID']['input']>;
  containerableType: ContainerableTypeEnum;
};


/** root mutation */
export type MutationGenerateCommoditySeasonsArgs = {
  seasonYear: Scalars['Int']['input'];
};


/** root mutation */
export type MutationGenerateDataOutputFilesArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationGenerateEphytoArgs = {
  bookingReference?: InputMaybe<Scalars['String']['input']>;
  ephytoId?: InputMaybe<Scalars['Int']['input']>;
  isEntireBooking: Scalars['Boolean']['input'];
  shipmentType: Scalars['String']['input'];
  sliIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** root mutation */
export type MutationGenerateEphytoTradeUnitArgs = {
  shipmentType: Scalars['String']['input'];
  ephytoId?: InputMaybe<Scalars['Int']['input']>;
};


/** root mutation */
export type MutationGenerateInvoiceOutputFilesArgs = {
  invoiceId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationGenerateLoadOutInstructionOutputFilesArgs = {
  loadoutinstructionid: Scalars['ID']['input'];
};


/** root mutation */
export type MutationGeneratePalletInOutputFilesArgs = {
  loadOutInstructionId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationGeneratePalletOutOutputFilesArgs = {
  addendumHeaderId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationGenerateProducerStatementArgs = {
  cartonGroupingIds: Array<Scalars['Int']['input']>;
  fileFormat: TemplateFileFormatEnum;
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationGenerateShipmentExportNotificationOutputFilesArgs = {
  shipmentId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationInviteUserArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationLookupAndTranslateArgs = {
  englishTexts: Array<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** root mutation */
export type MutationMarkAuditsAsViewedArgs = {
  auditIds: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationMarkContainerClaimAsCompletedArgs = {
  containerClaimId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationMarkNotificationsAsReadArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationMarkNotificationsAsUnreadArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** root mutation */
export type MutationMoveSlisToNewShipmentArgs = {
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  sliIds: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationProcessEtlDocumentArgs = {
  documentId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationPushPackInstructionsToOnepackArgs = {
  clientCode: Scalars['String']['input'];
  packInstructionsAttributes: PackInstructionsAttributes;
};


/** root mutation */
export type MutationQueryAddendumArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationQueueProfitAndLossReportArgs = {
  requestId: Scalars['String']['input'];
  filters: ProfitAndLossFilters;
};


/** root mutation */
export type MutationQueueReportGroupOutputFileArgs = {
  reportGroupId: Scalars['ID']['input'];
  requestId: Scalars['String']['input'];
  queryParams?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationReassignShipmentLineItemGroupingArgs = {
  id: Scalars['ID']['input'];
  sligId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationRejectOfferAsSupplierArgs = {
  counterOfferId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationRemoveClaimLineItemGroupingDefectArgs = {
  claimLineItemGroupingId: Scalars['ID']['input'];
  defectId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationRemoveClaimLineItemGroupingExpectedClaimArgs = {
  claimLineItemGroupingId: Scalars['ID']['input'];
  expectedClaim: ExpectedClaimEnum;
};


/** root mutation */
export type MutationRemoveClaimLineItemPalletDefectArgs = {
  claimLineItemIds: Array<Scalars['ID']['input']>;
  defectId: Scalars['ID']['input'];
  claimLineItemGroupingId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationRemoveClaimLineItemPalletExpectedClaimArgs = {
  claimLineItemIds: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationRemoveDefaultCostsArgs = {
  attributes: RemoveDefaultCostAttributes;
};


/** root mutation */
export type MutationResendInviteArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationResolveCgErrorArgs = {
  id: Scalars['ID']['input'];
  resolution: CgErrorResolutionInput;
  userContext?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationRevertLineItemsToCreatedArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** root mutation */
export type MutationRevertOrderChangeArgs = {
  startId: Scalars['Int']['input'];
  endId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationRevokeInviteArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationSendEmailArgs = {
  attributes: SendEmailAttributes;
};


/** root mutation */
export type MutationSoftDeleteContainerClaimArgs = {
  containerClaimId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationSubmitAddendumArgs = {
  id: Scalars['Int']['input'];
};


/** root mutation */
export type MutationSubmitEphytoArgs = {
  ephytoId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationSubmitShipmentExportNotificationArgs = {
  id: Scalars['ID']['input'];
};


/** root mutation */
export type MutationSubscribeToNotificationRulesArgs = {
  notificationRuleSubscriptionAttributes: Array<NotificationRuleSubscriptionAttributes>;
};


/** root mutation */
export type MutationUpdateAddendumArgs = {
  addendumHeader: AddendumHeaderAttributes;
  addendumLineItems: Array<AddendumLineItemAttributes>;
};


/** root mutation */
export type MutationUpdateAdditionalFieldArgs = {
  id: Scalars['Int']['input'];
  attributes: UpdateAdditionalFieldAttributes;
};


/** root mutation */
export type MutationUpdateAirAddendumArgs = {
  addendumHeader: AddendumHeaderAttributes;
  addendumLineItems: Array<AddendumLineItemAttributes>;
};


/** root mutation */
export type MutationUpdateAirFreightShipmentControllerArgs = {
  airFreightShipmentId: Scalars['Int']['input'];
  controllerId?: InputMaybe<Scalars['Int']['input']>;
  controllerName?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationUpdateArrivalQcCaptureDatetimeArgs = {
  containerClaimId: Scalars['ID']['input'];
  arrivalQcCaptureDatetime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** root mutation */
export type MutationUpdateArrivalQcClaimLineItemGroupingGradeArgs = {
  claimLineItemGroupingId: Scalars['ID']['input'];
  arrivalQcGrade: ArrivalQcGradeEnum;
};


/** root mutation */
export type MutationUpdateArrivalQcClaimLineItemPalletGradeArgs = {
  claimLineItemIds: Array<Scalars['ID']['input']>;
  arrivalQcGrade: ArrivalQcGradeEnum;
};


/** root mutation */
export type MutationUpdateCartonConversionArgs = {
  actualMass?: InputMaybe<Scalars['Float']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  convertedSizeCount?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  massConversion?: InputMaybe<Scalars['Float']['input']>;
};


/** root mutation */
export type MutationUpdateCartonGroupingTransactionsArgs = {
  deleteData?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** root mutation */
export type MutationUpdateClaimLineItemGroupingCommentArgs = {
  claimLineItemGroupingId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationUpdateClaimLineItemGroupingDefectArgs = {
  claimLineItemGroupingId: Scalars['ID']['input'];
  defectId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationUpdateClaimLineItemGroupingExpectedClaimArgs = {
  claimLineItemGroupingId: Scalars['ID']['input'];
  expectedClaim: ExpectedClaimEnum;
};


/** root mutation */
export type MutationUpdateClaimLineItemPalletDefectArgs = {
  claimLineItemIds: Array<Scalars['ID']['input']>;
  defectId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationUpdateClaimLineItemPalletExpectedClaimArgs = {
  claimLineItemIds: Array<Scalars['ID']['input']>;
  expectedClaim: ExpectedClaimEnum;
};


/** root mutation */
export type MutationUpdateCommandResultArgs = {
  attributes: CommandResultAttributes;
};


/** root mutation */
export type MutationUpdateCompanyDetailsArgs = {
  attributes: UpdateCompanyAttributes;
};


/** root mutation */
export type MutationUpdateCompanyOnboardingStepArgs = {
  onboardingStep: CompanyOnboardingStepEnum;
};


/** root mutation */
export type MutationUpdateCompanyTradeRegionsArgs = {
  addTradeRegions: Array<TradeRegionAttributes>;
  removeTradeRegions: Array<TradeRegionAttributes>;
};


/** root mutation */
export type MutationUpdateContactArgs = {
  attributes: ContactAttributes;
};


/** root mutation */
export type MutationUpdateContainerClaimGradeArgs = {
  containerClaimId: Scalars['ID']['input'];
  arrivalQcState: ArrivalQcStateEnum;
  arrivalQcGrade: ArrivalQcGradeEnum;
};


/** root mutation */
export type MutationUpdateContainerClaimNoteArgs = {
  containerClaimId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


/** root mutation */
export type MutationUpdateCustomFieldArgs = {
  attributes: CustomFieldAttributes;
};


/** root mutation */
export type MutationUpdateCustomTaskDateArgs = {
  customDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shipmentLineItemId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationUpdateDataOutputArgs = {
  attributes: DataOutputAttributes;
};


/** root mutation */
export type MutationUpdateDraftEphytoArgs = {
  ephytoId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationUpdateEphytoArgs = {
  ephyto: EphytoAttributes;
  ephytoConsignmentItems?: InputMaybe<Array<EphytoConsignmentItemAttributes>>;
};


/** root mutation */
export type MutationUpdateEphytoDocumentArgs = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


/** root mutation */
export type MutationUpdateEstimatesArgs = {
  createData?: InputMaybe<Array<EstimateAttributes>>;
  deleteData?: InputMaybe<Array<Scalars['Int']['input']>>;
  updateData?: InputMaybe<Array<EstimateAttributes>>;
};


/** root mutation */
export type MutationUpdateExportDocumentArgs = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


/** root mutation */
export type MutationUpdateFarmVarietyArgs = {
  attributes: UpdateFarmVarietyAttributes;
};


/** root mutation */
export type MutationUpdateFinanceRuleArgs = {
  attributes: Array<FinanceRuleAttributes>;
  deleteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** root mutation */
export type MutationUpdateFinanceRuleEnabledStateArgs = {
  updateIds: Array<Scalars['ID']['input']>;
  state: Scalars['Boolean']['input'];
};


/** root mutation */
export type MutationUpdateInvoiceArgs = {
  attributes: InvoiceAttributes;
  currencyExchangeRateAttributes?: InputMaybe<CurrencyExchangeRateAttributes>;
};


/** root mutation */
export type MutationUpdateInvoiceStateArgs = {
  id: Scalars['Int']['input'];
  state: Scalars['String']['input'];
};


/** root mutation */
export type MutationUpdateLineItemsArgs = {
  attributes: Array<UpdateLineItemAttributes>;
};


/** root mutation */
export type MutationUpdateLoadOutInstructionArgs = {
  attributes: LoadOutAttributes;
};


/** root mutation */
export type MutationUpdateLoadOutInstructionsFromSlisArgs = {
  sliIds: Array<Scalars['ID']['input']>;
};


/** root mutation */
export type MutationUpdateNetReturnProgramArgs = {
  attributes: NetReturnProgramAttributes;
};


/** root mutation */
export type MutationUpdateOrchardSeasonsArgs = {
  deleteData?: InputMaybe<Array<Scalars['Int']['input']>>;
  updateData?: InputMaybe<Array<OrchardSeasonAttributes>>;
};


/** root mutation */
export type MutationUpdateOrchardYieldsArgs = {
  createData?: InputMaybe<Array<OrchardYieldAttributes>>;
  deleteData?: InputMaybe<Array<Scalars['Int']['input']>>;
  updateData?: InputMaybe<Array<OrchardYieldAttributes>>;
};


/** root mutation */
export type MutationUpdateOrderArgs = {
  attributes: UpdateOrderAttributes;
};


/** root mutation */
export type MutationUpdateOrderProgramArgs = {
  orderProgramId: Scalars['ID']['input'];
  attributes: OrderProgramAttributes;
};


/** root mutation */
export type MutationUpdatePackInstructionLineItemPriorityArgs = {
  packInstructionLineItemId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
};


/** root mutation */
export type MutationUpdatePaymentArgs = {
  attributes: PaymentAttributes;
  currencyExchangeRateAttributes?: InputMaybe<CurrencyExchangeRateAttributes>;
  paymentId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationUpdateReportGroupArgs = {
  attributes: ReportGroupAttributes;
};


/** root mutation */
export type MutationUpdateShipmentArgs = {
  attributes: ShipmentAttributes;
};


/** root mutation */
export type MutationUpdateShipmentDocumentArgs = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


/** root mutation */
export type MutationUpdateShipmentLineItemArgs = {
  attributes: ShipmentLineItemAttributes;
};


/** root mutation */
export type MutationUpdateTasksDatesArgs = {
  updateValues: Scalars['Json']['input'];
};


/** root mutation */
export type MutationUpdateUiConfigArgs = {
  attributes: CreateUpdateUiConfigAttributes;
};


/** root mutation */
export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  notifyEmail: Scalars['Boolean']['input'];
  notifyBrowserPush: Scalars['Boolean']['input'];
  useV2: Scalars['Boolean']['input'];
};


/** root mutation */
export type MutationUpdateUserFeedItemArgs = {
  attributes: UpdateUserFeedItemAttributes;
};


/** root mutation */
export type MutationUpdateUserFeedItemsArgs = {
  attributes: Array<UpdateUserFeedItemAttributes>;
};


/** root mutation */
export type MutationUpdateUserNotificationsArgs = {
  id: Scalars['Int']['input'];
  notifyEmail: Scalars['Boolean']['input'];
  notifyBrowserPush: Scalars['Boolean']['input'];
};


/** root mutation */
export type MutationUploadClaimFilesArgs = {
  containerClaimId: Scalars['ID']['input'];
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
};


/** root mutation */
export type MutationUploadCompanyCertificateArgs = {
  companyId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  expiryDate: Scalars['String']['input'];
  certificateTypeId: Scalars['Int']['input'];
};


/** root mutation */
export type MutationUploadCompanyLogoArgs = {
  companyId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadEphytoDocumentArgs = {
  ephytoId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadEtlDocumentArgs = {
  documentId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadExportDocumentArgs = {
  attributes: ShipmentLineItemAttributes;
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadFarmVarietyImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadInvoiceDocumentsArgs = {
  invoiceId: Scalars['ID']['input'];
  files: Array<Scalars['Upload']['input']>;
};


/** root mutation */
export type MutationUploadOrderShipmentDocumentArgs = {
  orderid: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadStockFileArgs = {
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUploadTaskDocumentArgs = {
  customDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  file: Scalars['Upload']['input'];
  taskId: Scalars['Int']['input'];
  uploadDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** root mutation */
export type MutationUploadTaskDocumentPerSliArgs = {
  file: Scalars['Upload']['input'];
  selectedSliIds: Array<Scalars['ID']['input']>;
  shipmentLineItemId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationUploadUserAvatarArgs = {
  file: Scalars['Upload']['input'];
};


/** root mutation */
export type MutationUpsertCertificateTransportInstructionArgs = {
  shipmentLineItemId: Scalars['ID']['input'];
};


/** root mutation */
export type MutationUpsertCommercialTermArgs = {
  attributes: CommercialTermAttributes;
};


/** root mutation */
export type MutationUpsertCurrencyExchangeRateArgs = {
  currencyExchangeRateAttributes: CurrencyExchangeRateAttributes;
};


/** root mutation */
export type MutationUpsertFinanceRuleArgs = {
  attributesList: Array<FinanceRuleAttributes>;
};


/** root mutation */
export type MutationWontPackLineItemsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type NetReturnProgram = {
  __typename?: 'NetReturnProgram';
  /** The additional fields associated with the net return program */
  additionalFields?: Maybe<Scalars['String']['output']>;
  /** The batch number associated with the net return program */
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** The buyer associated with the net return program */
  buyer?: Maybe<Company>;
  /** The ID of the buyer associated with the net return program */
  buyerId?: Maybe<Scalars['ID']['output']>;
  /** The name of the buyer associated with the net return program */
  buyerName?: Maybe<Scalars['String']['output']>;
  /** The carton type associated with the net return program */
  cartonType?: Maybe<CartonType>;
  /** The ID of the carton type associated with the net return program */
  cartonTypeId: Scalars['ID']['output'];
  /** The name of the carton type associated with the net return program */
  cartonTypeName: Scalars['String']['output'];
  /** The commodity associated with the net return program */
  commodity?: Maybe<Commodity>;
  /** The ID of the commodity associated with the net return program */
  commodityId: Scalars['ID']['output'];
  /** The name of the commodity associated with the net return program */
  commodityName: Scalars['String']['output'];
  /** The configured currency associated with the net return program */
  configuredCurrency?: Maybe<Scalars['String']['output']>;
  /** The configured unit associated with the net return program */
  configuredUnit?: Maybe<Scalars['String']['output']>;
  /** The created at date of the net return program */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The currency associated with the net return program */
  currency: Scalars['String']['output'];
  /** The departure port associated with the net return program */
  departurePort?: Maybe<SeaPort>;
  /** The destination port associated with the net return program */
  destinationPort?: Maybe<SeaPort>;
  /** The ID of the net return program */
  id: Scalars['ID']['output'];
  /** The incoterm associated with the net return program */
  incoterm: Scalars['String']['output'];
  /** The inventory code associated with the net return program */
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /** The packing week associated with the net return program */
  packingWeek: Scalars['String']['output'];
  /** The price minor unit associated with the net return program */
  priceMinorUnit: Scalars['Int']['output'];
  /** The price term associated with the net return program */
  priceTerm: Scalars['String']['output'];
  /** The price unit associated with the net return program */
  priceUnit: Scalars['String']['output'];
  /** The ID of the program */
  programId: Scalars['ID']['output'];
  /** The name of the program */
  programName: Scalars['String']['output'];
  /** The visibility of the program */
  programVisibility: Scalars['String']['output'];
  /** The quantity associated with the net return program */
  quantity: Scalars['Int']['output'];
  /** The quantity unit associated with the net return program */
  quantityUnit: Scalars['String']['output'];
  /** The reference number associated with the net return program */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** The seller associated with the net return program */
  seller?: Maybe<Company>;
  /** The ID of the seller associated with the net return program */
  sellerId?: Maybe<Scalars['ID']['output']>;
  /** The name of the seller associated with the net return program */
  sellerName?: Maybe<Scalars['String']['output']>;
  /** The size counts associated with the net return program */
  sizeCounts: Scalars['String']['output'];
  /** The stack size associated with the net return program */
  stackSize: Scalars['Int']['output'];
  /** The target market associated with the net return program */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** The trade country associated with the net return program */
  tradeCountry?: Maybe<TradeCountry>;
  /** The ID of the trade country associated with the net return program */
  tradeCountryId?: Maybe<Scalars['ID']['output']>;
  /** The name of the trade country associated with the net return program */
  tradeCountryName?: Maybe<Scalars['String']['output']>;
  /** The trade region associated with the net return program */
  tradeRegion?: Maybe<TradeRegion>;
  /** The ID of the trade region associated with the net return program */
  tradeRegionId: Scalars['ID']['output'];
  /** The name of the trade region associated with the net return program */
  tradeRegionName: Scalars['String']['output'];
  /** The updated at date of the net return program */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The variety associated with the net return program */
  variety?: Maybe<Variety>;
  /** The ID of the variety associated with the net return program */
  varietyId: Scalars['ID']['output'];
  /** The name of the variety associated with the net return program */
  varietyName: Scalars['String']['output'];
};

/** Attributes for creating a net return program and its associated program */
export type NetReturnProgramAttributes = {
  /** The ID of the net return program */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the program */
  programName: Scalars['String']['input'];
  /** The visibility of the program */
  programVisibility: Scalars['String']['input'];
  /** The ID of the commodity associated with the program */
  commodityId: Scalars['ID']['input'];
  /** The ID of the variety associated with the program */
  varietyId: Scalars['ID']['input'];
  /** The name of the carton type associated with the program */
  cartonTypeName: Scalars['String']['input'];
  /** The ID of the trade region associated with the program */
  tradeRegionId: Scalars['ID']['input'];
  /** The ID of the trade country associated with the program */
  tradeCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the seller associated with the program */
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the buyer associated with the program */
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  /** The additional fields associated with the program */
  additionalFields: Scalars['String']['input'];
  /** The batch number associated with the program */
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  /** The currency associated with the program */
  currency: Scalars['String']['input'];
  /** The Incoterm associated with the program */
  incoterm: Scalars['String']['input'];
  /** The inventory code associated with the program */
  inventoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The packing week associated with the program */
  packingWeek: Scalars['String']['input'];
  /** The stack size associated with the program */
  stackSize: Scalars['Int']['input'];
  /** The price minor unit associated with the program */
  priceMinorUnit: Scalars['Int']['input'];
  /** The price term associated with the program */
  priceTerm: Scalars['String']['input'];
  /** The price unit associated with the program */
  priceUnit: Scalars['String']['input'];
  /** The quantity associated with the program */
  quantity: Scalars['Int']['input'];
  /** The quantity unit associated with the program */
  quantityUnit: Scalars['String']['input'];
  /** The reference number associated with the program */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** The size counts associated with the program */
  sizeCounts: Array<Scalars['String']['input']>;
  /** The target market associated with the program */
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  /** The configured unit associated with the program */
  configuredUnit?: InputMaybe<Scalars['String']['input']>;
  /** The configured currency associated with the program */
  configuredCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the departure port associated with the program */
  departurePortId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the destination port associated with the program */
  destinationPortId?: InputMaybe<Scalars['ID']['input']>;
};

export type NonEphytoShipmentLineItem = {
  __typename?: 'NonEphytoShipmentLineItem';
  /** Unique identifier for the shipment line item */
  id: Scalars['Int']['output'];
  /** Label displayed to easily identify the SLI */
  labelDisplay?: Maybe<Scalars['String']['output']>;
  /** This could be Shipment or AirFreightShipment related */
  type?: Maybe<Scalars['String']['output']>;
};

export type NotifiableUnion = Comment;

/** returns details notification item model */
export type NotificationItem = {
  __typename?: 'NotificationItem';
  /** the unique identifier for the entity that the notification item is associated with */
  entityId?: Maybe<Scalars['ID']['output']>;
  /** the type of the entity that the notification item is associated with */
  entityType?: Maybe<Scalars['String']['output']>;
  /** the unique identifier for the notification item */
  id?: Maybe<Scalars['ID']['output']>;
};

/** returns details notification rule model */
export type NotificationRule = {
  __typename?: 'NotificationRule';
  /** Overridable time thresholds from rule conditions, as [{ field, operator, value }]. Each field can be overridden per-user via subscription config. */
  defaultThresholds: Scalars['JSON']['output'];
  /** the description of the notification rule */
  description?: Maybe<Scalars['String']['output']>;
  /** the unique identifier for the channel notification */
  id?: Maybe<Scalars['ID']['output']>;
  /** the name of the notification rule */
  name?: Maybe<Scalars['String']['output']>;
  /** the subscription for the notification rule */
  notificationRuleSubscription?: Maybe<NotificationRuleSubscription>;
  /** unique human readable identifier for the notification rule */
  notificationSlug?: Maybe<NotificationSlugEnum>;
  /** the severity of the notification rule */
  severity?: Maybe<NotificationRuleSeverityEnum>;
};

/** Severity level of a notification rule */
export enum NotificationRuleSeverityEnum {
  /** Notification rule severity is info */
  Info = 'info',
  /** Notification rule severity is warning */
  Warning = 'warning',
  /** Notification rule severity is critical */
  Critical = 'critical',
  /** Notification rule severity is alert */
  Alert = 'alert'
}

/** returns details of a notification rule subscription */
export type NotificationRuleSubscription = {
  __typename?: 'NotificationRuleSubscription';
  /** Per-user configuration for this subscription, e.g. { threshold: { field, value } } for time-based rules */
  config: Scalars['JSON']['output'];
  /** whether the subscription is enabled */
  enabled: Scalars['Boolean']['output'];
  /** the unique identifier for the notification rule subscription */
  id?: Maybe<Scalars['ID']['output']>;
  /** Last successful scheduled run time for this subscription */
  lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled run time for this subscription */
  nextRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the notification rule that the subscription is for */
  notificationRule?: Maybe<NotificationRule>;
  /** whether the user wants to receive email notifications for this rule */
  notifyEmail: Scalars['Boolean']['output'];
  /** whether the user wants to receive mobile notifications for this rule */
  notifyMobile: Scalars['Boolean']['output'];
  /** whether the user wants to receive web notifications for this rule */
  notifyWeb: Scalars['Boolean']['output'];
  /** whether the user wants to receive WhatsApp notifications for this rule */
  notifyWhatsapp: Scalars['Boolean']['output'];
  /** Optional per-user cron override for scheduled rules */
  scheduleCron?: Maybe<Scalars['String']['output']>;
};

/** Attributes for a notification rule subscription */
export type NotificationRuleSubscriptionAttributes = {
  /** The slug of the notification rule to subscribe to/update */
  notificationRuleSlug: Scalars['String']['input'];
  /** Whether the user wants to receive notifications for this rule */
  enabled: Scalars['Boolean']['input'];
  /** Whether the user wants to receive email notifications for this rule */
  notifyEmail: Scalars['Boolean']['input'];
  /** Whether the user wants to receive web notifications for this rule */
  notifyWeb: Scalars['Boolean']['input'];
  /** Whether the user wants to receive WhatsApp notifications for this rule */
  notifyWhatsapp: Scalars['Boolean']['input'];
  /** Whether the user wants to receive mobile notifications for this rule */
  notifyMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional per-user cron override for scheduled rules (uses rule default when blank) */
  scheduleCron?: InputMaybe<Scalars['String']['input']>;
  /** The configuration for the notification rule subscription eg. time duration */
  config?: InputMaybe<Scalars['JSON']['input']>;
};

export enum NotificationSlugEnum {
  /** The notification slug: example */
  Example = 'example',
  /** The notification slug: client_change_request */
  ClientChangeRequest = 'client_change_request',
  /** The notification slug: offer */
  Offer = 'offer',
  /** The notification slug: order_comment */
  OrderComment = 'order_comment',
  /** The notification slug: pallet_data_change */
  PalletDataChange = 'pallet_data_change'
}

export enum NotificationTypeEnum {
  Update = 'update',
  Alert = 'alert'
}

/** returns details about an offer between a buyer and a supplier */
export type Offer = {
  __typename?: 'Offer';
  /** the buyer of the offer */
  buyer?: Maybe<Company>;
  /** the ID of the buyer of the offer */
  buyerId?: Maybe<Scalars['ID']['output']>;
  /** the company that created the offer */
  company?: Maybe<Company>;
  /** the ID of the company that created the offer */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Offers that were created in response to this one */
  counterOffers?: Maybe<Array<Offer>>;
  /** when the offer was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the currency of the offer */
  currency?: Maybe<CurrencyEnum>;
  /** the description of the offer */
  description?: Maybe<Scalars['String']['output']>;
  /** when the offer expires */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the unique identifier for the offer */
  id: Scalars['ID']['output'];
  /** the incoterm of the offer */
  incoterm?: Maybe<IncotermEnum>;
  /** the initial quantity of the offer */
  initialQuantity?: Maybe<Scalars['Int']['output']>;
  /** whether the root offer was created with the pricing deferred to the buyer */
  isRootOfferOpenPrice?: Maybe<Scalars['Boolean']['output']>;
  /** whether the root offer was created with the quantity deferred to the buyer */
  isRootOfferOpenQuantity?: Maybe<Scalars['Boolean']['output']>;
  /** the items associated with the offer */
  offerItems?: Maybe<Array<OfferItem>>;
  /** the recipients of the offer */
  offerRecipients?: Maybe<Array<OfferRecipient>>;
  /** the order that was created from the offer */
  order?: Maybe<Order>;
  /** the ID of the order that was created from the offer */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** the pack type of the offer */
  packType?: Maybe<Scalars['String']['output']>;
  /** the packing week of the offer */
  packingWeek?: Maybe<Scalars['String']['output']>;
  /** the pallet stack of the offer */
  palletStack?: Maybe<Scalars['Int']['output']>;
  /** the previous offer in the negotiation chain */
  previousOffer?: Maybe<Offer>;
  /** the previous offer in the negotiation chain */
  previousOfferId?: Maybe<Scalars['ID']['output']>;
  /** the price term of the offer */
  priceTerm?: Maybe<OfferPriceTermEnum>;
  /** the quantity available/ requested for the offer */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** the quantity unit for the available/ requested/ initial quantity of the offer */
  quantityUnit?: Maybe<OfferQuantityUnitEnum>;
  /** the root offer that started this negotiation chain */
  rootOffer?: Maybe<Offer>;
  /** the root offer that started this negotiation chain */
  rootOfferId?: Maybe<Scalars['ID']['output']>;
  /** the seller of the offer */
  seller?: Maybe<Company>;
  /** the ID of the seller of the offer */
  sellerId?: Maybe<Scalars['ID']['output']>;
  /** the state of the offer eg. active or closed */
  state?: Maybe<OfferStateEnum>;
  /** the title of the offer */
  title?: Maybe<Scalars['String']['output']>;
  /** the trade region of the offer */
  tradeRegion?: Maybe<TradeRegion>;
  /** the ID of the trade region of the offer */
  tradeRegionId?: Maybe<Scalars['ID']['output']>;
  /** when the offer was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the user that created the offer */
  user?: Maybe<User>;
  /** the variety of the offer */
  variety?: Maybe<Variety>;
  /** the ID of the variety of the offer */
  varietyId?: Maybe<Scalars['ID']['output']>;
};

/** Attributes used by a supplier to create a new broadcast offer */
export type OfferAttributes = {
  /** The ID of the seller */
  sellerId: Scalars['ID']['input'];
  /** The title of the offer */
  title: Scalars['String']['input'];
  /** The description of the offer */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variety of the offer */
  varietyId: Scalars['ID']['input'];
  /** The ID of the trade region of the offer */
  tradeRegionId: Scalars['ID']['input'];
  /** The currency of the offer */
  currency: CurrencyEnum;
  /** The incoterm of the offer */
  incoterm: IncotermEnum;
  /** The packing week of the offer */
  packingWeek: Scalars['String']['input'];
  /** The pack type of the offer e.g. A15C */
  packType: Scalars['String']['input'];
  /** The pallet stack of the offer */
  palletStack: Scalars['Int']['input'];
  /** The price term of the offer */
  priceTerm: OfferPriceTermEnum;
  /** When the offer expires */
  expiresAt: Scalars['ISO8601DateTime']['input'];
  /** The initial quantity of the offer */
  initialQuantity: Scalars['Int']['input'];
  /** The quantity available/ requested for the offer */
  quantity: Scalars['Int']['input'];
  /** The quantity unit for the available/ requested/ initial quantity of the offer */
  quantityUnit: OfferQuantityUnitEnum;
  /** The items associated with the offer containing fruit spec and quantity; pricing lives in nested offer_item_prices */
  offerItems: Array<OfferItemAttributes>;
  /** The recipients of the offer */
  offerRecipients: Array<OfferRecipientAttributes>;
};

/** The connection type for Offer. */
export type OfferConnection = {
  __typename?: 'OfferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfferEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Offer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OfferEdge = {
  __typename?: 'OfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Offer>;
};

/** Attributes to filter offers by */
export type OfferFilterAttribute = {
  __typename?: 'OfferFilterAttribute';
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** ports of destination you want to filter by */
  portsOfDestination?: Maybe<Array<SeaPort>>;
  /** trade regions you want to filter by */
  tradeRegions?: Maybe<Array<TradeRegion>>;
  /** varieties you want to filter by */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes to filter offers by */
export type OfferFilterAttributes = {
  /** buyers you want to filter by (matches offers broadcast to these buyers via offer recipients) */
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** commodities you want to filter by (resolves through variety -> commodity) */
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** varieties you want to filter by */
  varietyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trade regions you want to filter by */
  tradeRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ports of destination you want to filter by (matches the recipient's pinned port — the buyer's port is set by the supplier at broadcast time) */
  portOfDestinationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** returns details about an offer item associated with an offer */
export type OfferItem = {
  __typename?: 'OfferItem';
  /** the date and time when the offer item was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the grade for the offer item (A, B, C, etc.) */
  grade?: Maybe<Scalars['String']['output']>;
  /** the unique identifier for the offer item */
  id: Scalars['ID']['output'];
  /** the initial quantity for the offer item */
  initialQuantity?: Maybe<Scalars['Int']['output']>;
  /** the offer that the offer item is associated with */
  offer?: Maybe<Offer>;
  /** the ID of the offer that the offer item is associated with */
  offerId?: Maybe<Scalars['ID']['output']>;
  /** pricing associated with the offer item; CIF and DIP prices are captured here based on port of destination */
  offerItemPrices?: Maybe<Array<OfferItemPrice>>;
  /** the quantity for the offer item */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** the quantity unit for the offer item */
  quantityUnit?: Maybe<OfferItemQuantityUnitEnum>;
  /** the size counts for the offer item */
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  /** the date and time when the offer item was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes used by a supplier to create an offer item */
export type OfferItemAttributes = {
  /** The size counts for the offer item */
  sizeCounts: Array<Scalars['String']['input']>;
  /** The grade for the offer item (A, B, C, etc.) */
  grade: Scalars['String']['input'];
  /** The quantity for the offer item */
  quantity: Scalars['Int']['input'];
  /** The quantity unit for the offer item */
  quantityUnit: OfferItemQuantityUnitEnum;
  /** pricing associated with the offer item; CIF and DIP prices are captured here based on port of destination */
  offerItemPrices: Array<OfferItemPriceAttributes>;
};

/** returns details about an offer item price associated with an offer item */
export type OfferItemPrice = {
  __typename?: 'OfferItemPrice';
  /** the CIF price amount for the offer item, can be blank if the buyer sets the price */
  cifPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** the DIP price amount for the offer item, what the seller needs to net from the trade after shipping costs */
  dipPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net return for the CIF price converted to a target incoterm/currency/unit */
  expectedReturnSummary?: Maybe<OfferItemPriceExpectedReturn>;
  /** the unique identifier for the offer item price */
  id: Scalars['ID']['output'];
  /** the offer item that the offer item price is associated with */
  offerItem?: Maybe<OfferItem>;
  /** the ID of the offer item that the offer item price is associated with */
  offerItemId?: Maybe<Scalars['ID']['output']>;
  /** port of destination this price applies to, used for incoterm calculations */
  portOfDestination?: Maybe<SeaPort>;
  /** the ID of the port of destination this price applies to */
  portOfDestinationId?: Maybe<Scalars['ID']['output']>;
  /** the price unit for the offer item price */
  priceUnit?: Maybe<OfferItemPricePriceUnitEnum>;
};


/** returns details about an offer item price associated with an offer item */
export type OfferItemPriceExpectedReturnSummaryArgs = {
  currency?: InputMaybe<CurrencyEnum>;
  incoterm?: InputMaybe<IncotermWithNscEnum>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes used by a supplier to create an offer item price */
export type OfferItemPriceAttributes = {
  /** port of destination this price applies to (required); used for incoterm calculations */
  portOfDestinationId: Scalars['ID']['input'];
  /** the DIP price amount for the offer item, what the seller needs to net from the trade after shipping costs */
  dipPriceAmountMajorUnit: Scalars['BigDecimal']['input'];
  /** the CIF price amount for the offer item, can be blank if the buyer sets the price */
  cifPriceAmountMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The price unit for the offer item price */
  priceUnit: OfferItemPricePriceUnitEnum;
};

/** Expected return for an offer item price converted to a target incoterm */
export type OfferItemPriceExpectedReturn = {
  __typename?: 'OfferItemPriceExpectedReturn';
  conversionPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  incoterm?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** The price unit available for offer item prices. */
export enum OfferItemPricePriceUnitEnum {
  /** The offer item price price unit is carton */
  Carton = 'carton'
}

/** The quantity unit available for offer items. */
export enum OfferItemQuantityUnitEnum {
  /** The offer item quantity unit is pallet */
  Pallet = 'pallet'
}

/** The different price terms available for offers. */
export enum OfferPriceTermEnum {
  /** The offer price term is mgp */
  Mgp = 'mgp',
  /** The offer price term is fixed */
  Fixed = 'fixed',
  /** The offer price term is consignment */
  Consignment = 'consignment'
}

/** The quantity unit available for offers. */
export enum OfferQuantityUnitEnum {
  /** The offer quantity unit is pallet */
  Pallet = 'pallet'
}

/** returns details about an offer recipient associated with an offer */
export type OfferRecipient = {
  __typename?: 'OfferRecipient';
  /** the buyer that the offer recipient is associated with */
  buyer?: Maybe<Company>;
  /** the ID of the buyer that the offer recipient is associated with */
  buyerId?: Maybe<Scalars['ID']['output']>;
  /** who should be notified about the offer */
  contactUser?: Maybe<User>;
  /** the ID of the user that should be notified about the offer */
  contactUserId?: Maybe<Scalars['ID']['output']>;
  /** when the offer recipient was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the unique identifier for the offer recipient */
  id: Scalars['ID']['output'];
  /** the offer that the offer recipient is associated with */
  offer?: Maybe<Offer>;
  /** the ID of the offer that the offer recipient is associated with */
  offerId?: Maybe<Scalars['ID']['output']>;
  /** port of destination associated with the offer recipient, used to link buyer to offer item prices */
  portOfDestination?: Maybe<SeaPort>;
  /** the ID of the port of destination associated with the offer recipient */
  portOfDestinationId?: Maybe<Scalars['ID']['output']>;
  /** the state of the negotiation between the buyer and the supplier eg. pending_buyer, pending_supplier, won, lost */
  state?: Maybe<OfferRecipientStateEnum>;
  /** when the offer recipient was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes used by a supplier to create a new offer recipient */
export type OfferRecipientAttributes = {
  /** The ID of the buyer */
  buyerId: Scalars['ID']['input'];
  /** port the supplier pins this buyer to (required); buyers cannot change their port — it carries forward through every counter in the chain */
  portOfDestinationId: Scalars['ID']['input'];
};

/** The different states available for offer recipients. */
export enum OfferRecipientStateEnum {
  /** The offer recipient state is pending_buyer */
  PendingBuyer = 'pending_buyer',
  /** The offer recipient state is pending_supplier */
  PendingSupplier = 'pending_supplier',
  /** The offer recipient state is won */
  Won = 'won',
  /** The offer recipient state is lost */
  Lost = 'lost',
  /** The offer recipient state is superseded */
  Superseded = 'superseded'
}

/** The different states available for offers. */
export enum OfferStateEnum {
  /** The offer state is active */
  Active = 'active',
  /** The offer state is closed */
  Closed = 'closed'
}

/** OnePack client code for pushing pack instructions to NSOffice */
export type OnepackClientCode = {
  __typename?: 'OnepackClientCode';
  /** Client code used when pushing pack instructions to OnePack */
  clientCode: Scalars['String']['output'];
  /** Unique identifier for the OnePack client code */
  id: Scalars['ID']['output'];
  /** Display label for the client code */
  label: Scalars['String']['output'];
};

/** A OnePack pack-instruction push to NSOffice;HTTP status, response message, and whether it succeeded */
export type OnepackPackInstructionSyncCall = {
  __typename?: 'OnepackPackInstructionSyncCall';
  /** Client code from request metadata */
  clientCode?: Maybe<Scalars['String']['output']>;
  /** When the request was made */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Platform API call id */
  id: Scalars['ID']['output'];
  /** Number of pack instruction line items in the request */
  itemsCount: Scalars['Int']['output'];
  /** Response message and validation detail when present */
  message?: Maybe<Scalars['String']['output']>;
  /** HTTP status code */
  statusCode?: Maybe<Scalars['String']['output']>;
  /** Whether the HTTP response indicates success */
  syncSucceeded: Scalars['Boolean']['output'];
  /** Request URL */
  url: Scalars['String']['output'];
};

export type OrchardResult = {
  __typename?: 'OrchardResult';
  /** Whether it has applied for eu status */
  applied: Scalars['String']['output'];
  /** Flag if it passed BD test */
  bd: Scalars['String']['output'];
  /** Flag if it passed CBS test */
  cbs: Scalars['String']['output'];
  /** Current status whether commodity can go to EU market */
  currentEuStatus: Scalars['String']['output'];
  /** Flag whether commodity is for EU */
  eu: Scalars['String']['output'];
  /** PUC identifier */
  farmCode: Scalars['String']['output'];
  /** Flag if it passed FMS test */
  fms: Scalars['String']['output'];
  /** Unique Orchard identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** Orchard name */
  orchardName: Scalars['String']['output'];
  /** Phyto data for orchard */
  phytoData: Scalars['String']['output'];
  /** Whether orchard has been verified */
  verified: Scalars['String']['output'];
};

export type OrchardSeason = {
  __typename?: 'OrchardSeason';
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fboOrchard: FboOrchard;
  foodBusinessOperator: FoodBusinessOperator;
  hectares: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  plantedDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Basic attributes for updating an Orchard Season */
export type OrchardSeasonAttributes = {
  endDate: Scalars['ISO8601DateTime']['input'];
  hectares: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  plantedDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};

export type OrchardYield = {
  __typename?: 'OrchardYield';
  captureDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  orchardSeasonId: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
  weightPerBin?: Maybe<Scalars['Float']['output']>;
};

/** Basic attributes for creating & updating an orchard yield */
export type OrchardYieldAttributes = {
  captureDate: Scalars['ISO8601DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  orchardSeasonId?: InputMaybe<Scalars['Int']['input']>;
  weight: Scalars['Float']['input'];
  weightPerBin?: InputMaybe<Scalars['Float']['input']>;
};

/** returns details about the order model */
export type Order = {
  __typename?: 'Order';
  /** the audit trail associated with the order */
  audits?: Maybe<Array<Audit>>;
  /** the buyer associated with the order */
  buyer?: Maybe<Company>;
  /** the comments associated with the order */
  comments?: Maybe<Array<Comment>>;
  /** when the order was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Deal sheet fields when this order is a deal sheet */
  dealSheetDetail?: Maybe<YieldDealSheetDetail>;
  /** child orders (deal sheets) when this order is a parent */
  dealSheets?: Maybe<Array<Order>>;
  /** the unique identifier for the order */
  id?: Maybe<Scalars['Int']['output']>;
  /** whether the order is a packhouse run, packhouse runs are ordersrequesting all the fruit from a specific packhouse */
  isPackhouseRun?: Maybe<Scalars['Boolean']['output']>;
  /** the line item groupings associated with the order */
  lineItemGroupings?: Maybe<Array<LineItemGrouping>>;
  /** the line items associated with the order */
  lineItems?: Maybe<Array<LineItem>>;
  /** the parent order when this order is a deal sheet */
  parentOrder?: Maybe<Order>;
  /** ID of the parent order when this order is a deal sheet */
  parentOrderId?: Maybe<Scalars['ID']['output']>;
  /** the seller associated with the order */
  seller?: Maybe<Company>;
  /** the shipment documents associated with the order */
  shipmentDocuments?: Maybe<Array<ShipmentDocument>>;
  /** the state of the order */
  state?: Maybe<Scalars['String']['output']>;
  /** when the order was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the user associated with the order */
  user?: Maybe<User>;
};

export type OrderBy = {
  column?: InputMaybe<OrderByColumn>;
  direction?: InputMaybe<OrderByDirection>;
};

export enum OrderByColumn {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at',
  ReferenceNumber = 'reference_number',
  SellerName = 'seller_name',
  BuyerName = 'buyer_name',
  Id = 'id',
  State = 'state'
}

export enum OrderByDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderFilter = {
  buyercontains?: InputMaybe<Scalars['String']['input']>;
  buyerids?: InputMaybe<Array<Scalars['Int']['input']>>;
  commoditycontains?: InputMaybe<Scalars['String']['input']>;
  commodityseasonids?: InputMaybe<Array<Scalars['Int']['input']>>;
  ordering?: InputMaybe<Array<OrderBy>>;
  packingweekcontains?: InputMaybe<Scalars['String']['input']>;
  packingweekends?: InputMaybe<Scalars['String']['input']>;
  packingweekstarts?: InputMaybe<Scalars['String']['input']>;
  referencestartswith?: InputMaybe<Scalars['String']['input']>;
  sellercontains?: InputMaybe<Scalars['String']['input']>;
  sellerids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** only return orders with this state */
  states?: InputMaybe<Array<StateFilter>>;
  /** only include orders that one of these companies participate in */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Attributes to filter orders by */
export type OrderFilterAttribute = {
  __typename?: 'OrderFilterAttribute';
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** sellers you want to filter by */
  sellers?: Maybe<Array<Company>>;
  /** varieties you want to filter by */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes to filter orders by */
export type OrderFilterAttributes = {
  /** buyers you want to filter by */
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sellers you want to filter by */
  sellerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** states you want to filter by */
  states?: InputMaybe<Array<OrderStateEnum>>;
  /** commodities you want to filter by */
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** varieties you want to filter by */
  varietyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start of packing week you want to filter by */
  packingWeekStart?: InputMaybe<Scalars['String']['input']>;
  /** end of packing week you want to filter by */
  packingWeekEnd?: InputMaybe<Scalars['String']['input']>;
};

/** returns details about the order program model */
export type OrderProgram = {
  __typename?: 'OrderProgram';
  /** A list of default values for extra fields that are not part of the standard fields, set by the user */
  additionalFields?: Maybe<Scalars['Json']['output']>;
  /** the batch number associated with the order program */
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** the id of the carton count associated with the order program */
  cartonCountId?: Maybe<Scalars['ID']['output']>;
  /** the carton type associated with the order program */
  cartonType?: Maybe<CartonType>;
  /** the id of the carton type associated with the order program */
  cartonTypeId?: Maybe<Scalars['ID']['output']>;
  /** the name of the carton type associated with the order program */
  cartonTypeName?: Maybe<Scalars['String']['output']>;
  /** the commodity associated with the order program */
  commodity?: Maybe<Commodity>;
  /** the id of the commodity associated with the order program */
  commodityId?: Maybe<Scalars['ID']['output']>;
  /** the name of the commodity associated with the order program */
  commodityName?: Maybe<Scalars['String']['output']>;
  /** the company associated with the order program */
  company?: Maybe<Company>;
  /** the id of the company associated with the order program */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** the url of the company associated with the order program logo */
  companyLogoImageUrl?: Maybe<Scalars['String']['output']>;
  /** the name of the company associated with the order program */
  companyName?: Maybe<Scalars['String']['output']>;
  /** when the order program was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the currency of the order program */
  currency?: Maybe<Scalars['String']['output']>;
  /** the grade associated with the order program */
  grade?: Maybe<Scalars['String']['output']>;
  /** the fields that are hidden from the user */
  hiddenFields?: Maybe<Array<Scalars['String']['output']>>;
  /** the unique identifier for the order program */
  id?: Maybe<Scalars['ID']['output']>;
  /** the incoterm associated with the order program */
  incoterm?: Maybe<Scalars['String']['output']>;
  /** the inventory code associated with the order program */
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /** the mark associated with the order program */
  mark?: Maybe<Scalars['String']['output']>;
  /** the port of destination associated with the order program */
  portOfDestination?: Maybe<SeaPort>;
  /** the id of the port of destination associated with the order program */
  portOfDestinationId?: Maybe<Scalars['ID']['output']>;
  /** the name of the port of destination associated with the order program */
  portOfDestinationName?: Maybe<Scalars['String']['output']>;
  /** the port of loading associated with the order program */
  portOfLoading?: Maybe<SeaPort>;
  /** the id of the port of loading associated with the order program */
  portOfLoadingId?: Maybe<Scalars['ID']['output']>;
  /** the name of the port of loading associated with the order program */
  portOfLoadingName?: Maybe<Scalars['String']['output']>;
  /** the price amount in the major unit of the currency for a given price unit */
  priceAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** the price term of the order program, e.g. "Fixed", "Consignment" or "MGP */
  priceTerm?: Maybe<Scalars['String']['output']>;
  /** the price unit of the order program, e.g. "carton" or "ton" */
  priceUnit?: Maybe<Scalars['String']['output']>;
  /** the priority associated with the order program */
  priority?: Maybe<Scalars['String']['output']>;
  /** the program associated with the order program */
  program?: Maybe<Program>;
  /** the id of the program associated with the order program */
  programId?: Maybe<Scalars['ID']['output']>;
  /** the name of the program associated with the order program */
  programName?: Maybe<Scalars['String']['output']>;
  /** the visibility of the program associated with the order program */
  programVisibility?: Maybe<ProgramVisibilityEnum>;
  /** the quantity of the goods being ordered per quantity unit */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** the quantity unit of the order program, e.g. "carton", "pallet" or "containers" */
  quantityUnit?: Maybe<Scalars['String']['output']>;
  /** the reference number associated with the order program */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** the size counts associated with the order program */
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  /** the stack size associated with the order program */
  stackSize?: Maybe<Scalars['Int']['output']>;
  /** the target market where the fruit will be shipped to in the order */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** the country where the fruit will be shipped to in the order */
  tradeCountry?: Maybe<TradeCountry>;
  /** the code of the trade country associated with the order program */
  tradeCountryCode?: Maybe<Scalars['String']['output']>;
  /** the id of the trade country associated with the order program */
  tradeCountryId?: Maybe<Scalars['ID']['output']>;
  /** the name of the trade country associated with the order program */
  tradeCountryName?: Maybe<Scalars['String']['output']>;
  /** where the fruit will be shipped to in the order */
  tradeRegion?: Maybe<TradeRegion>;
  /** the code of the trade region associated with the order program */
  tradeRegionCode?: Maybe<Scalars['String']['output']>;
  /** the id of the trade region associated with the order program */
  tradeRegionId?: Maybe<Scalars['ID']['output']>;
  /** the name of the trade region associated with the order program */
  tradeRegionName?: Maybe<Scalars['String']['output']>;
  /** when the order program was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the variety associated with the order program */
  variety?: Maybe<Variety>;
  /** the code of the variety associated with the order program */
  varietyCode?: Maybe<Scalars['String']['output']>;
  /** the id of the variety associated with the order program */
  varietyId?: Maybe<Scalars['ID']['output']>;
  /** the name of the variety associated with the order program */
  varietyName?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating an order program and associated program */
export type OrderProgramAttributes = {
  /** The name of the program */
  programName: Scalars['String']['input'];
  /** The id of the company associated with the order program */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the trade region associated with the order program */
  tradeRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** The visibility of the program */
  programVisibility: ProgramVisibilityEnum;
  /** the fields that are hidden from the user */
  hiddenFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The priority of the order program */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** The batch number of the order program */
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  /** The reference number of the order program */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** The inventory code of the order program */
  inventoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The id of the trade country associated with the order program */
  tradeCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** The target market of the order program */
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  /** The id of the port of loading associated with the order program */
  portOfLoadingId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the port of destination associated with the order program */
  portOfDestinationId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the commodity associated with the order program */
  commodityId: Scalars['ID']['input'];
  /** The id of the variety associated with the order program */
  varietyId: Scalars['ID']['input'];
  /** The id of the carton type associated with the order program */
  cartonTypeId: Scalars['ID']['input'];
  /** The size counts of the order program */
  sizeCounts: Array<Scalars['String']['input']>;
  /** The stack size of the order program */
  stackSize: Scalars['Int']['input'];
  /** The grade of the order program */
  grade: Scalars['String']['input'];
  /** The mark of the order program */
  mark?: InputMaybe<Scalars['String']['input']>;
  /** The incoterm of the order program */
  incoterm: IncotermEnum;
  /** The currency of the order program */
  currency: CurrencyEnum;
  /** the price term of the order program, e.g. "Fixed", "Consignment" or "MGP */
  priceTerm?: InputMaybe<Scalars['String']['input']>;
  /** the price unit of the order program, e.g. "carton" or "ton" */
  priceUnit?: InputMaybe<Scalars['String']['input']>;
  /** the price amount in the major unit of the currency for a given price unit */
  priceAmountMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** the quantity unit of the order program, e.g. "carton", "pallet" or "containers" */
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  /** the quantity of the goods being ordered per quantity unit */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** the additional field default values of the order program */
  additionalFields: Scalars['String']['input'];
};

/** Attributes to filter order programs by */
export type OrderProgramFilterAttributes = {
  /** companies you want to filter programs by */
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** target regions you want to filter by */
  targetRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** commodities you want to filter by */
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** varieties you want to filter by */
  varietyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** inventory codes you want to filter by */
  inventoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** target countries you want to filter by */
  targetCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** target markets you want to filter by */
  targetMarkets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** incoterms you want to filter by */
  incoterms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** currencies you want to filter by */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** grades you want to filter by */
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderSearch = {
  __typename?: 'OrderSearch';
  orders?: Maybe<Array<Order>>;
  totalFiltered?: Maybe<Scalars['Int']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
};


export type OrderSearchOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum OrderStateEnum {
  Accepted = 'ACCEPTED',
  AtColdStore = 'AT_COLD_STORE',
  AtOriginPort = 'AT_ORIGIN_PORT',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED',
  InTransit = 'IN_TRANSIT',
  Packed = 'PACKED',
  PartiallyAccepted = 'PARTIALLY_ACCEPTED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyPacked = 'PARTIALLY_PACKED',
  WontPack = 'WONT_PACK'
}

export type OrdersSearchFilterAttributes = {
  __typename?: 'OrdersSearchFilterAttributes';
  /** unique set of commodities used on line items */
  commodities?: Maybe<Array<Commodity>>;
  /** unique set of trade partners that appear on line items */
  companies?: Maybe<Array<Company>>;
  /** unique set of sub-commodities used on line items */
  subCommodities?: Maybe<Array<SubCommodity>>;
  /** unique set of varieties used on line items */
  varieties?: Maybe<Array<Variety>>;
};

export type OutputFile = {
  __typename?: 'OutputFile';
  /** Unique identifier for the blob */
  blobId: Scalars['ID']['output'];
  /** MIME type of the file */
  contentType: Scalars['String']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** Unique identifier for the file */
  id: Scalars['ID']['output'];
  /** Timestamp when the file was uploaded */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** URL for the file */
  v2Url: Scalars['String']['output'];
};

export type PackInstructionLineItem = {
  __typename?: 'PackInstructionLineItem';
  /** arbitrary fields saved onto a line item */
  additionalFields?: Maybe<Scalars['Json']['output']>;
  /** arbitrary grouping of line items */
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** purchasing company name */
  buyer?: Maybe<Scalars['String']['output']>;
  /** line item comments */
  comments?: Maybe<Array<Comment>>;
  /** commodity name */
  commodity?: Maybe<Scalars['String']['output']>;
  /** Currency of the price major unit field */
  currency?: Maybe<Scalars['String']['output']>;
  /** price in major unit, including currency symbol and price unit, e.g. $1 / carton */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** quality indicator */
  grade?: Maybe<Scalars['String']['output']>;
  /** unique identifier showing cumulative grouping */
  groupId?: Maybe<Scalars['Int']['output']>;
  /** unique identifier */
  id?: Maybe<Scalars['Int']['output']>;
  incoterm?: Maybe<Scalars['String']['output']>;
  /** inventory code */
  inventoryCode?: Maybe<Scalars['String']['output']>;
  /** identifying word or number on freight */
  mark?: Maybe<Scalars['String']['output']>;
  /** order identifier */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** code indicating which box to pack fruit into */
  pack?: Maybe<Scalars['String']['output']>;
  /** isoweek when fruit is going to be or was packed */
  packingWeek?: Maybe<Scalars['String']['output']>;
  /** number of cartons on a pallet */
  palletStack?: Maybe<Scalars['Int']['output']>;
  /** the price of a unit expressed in the major unit of the currency */
  priceMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** specifies the price term (fixed, mgp or consignment) */
  priceTerm?: Maybe<Scalars['String']['output']>;
  /** the unit being priced, can be per carton or per ton */
  priceUnit?: Maybe<Scalars['String']['output']>;
  /** priority of order */
  priority?: Maybe<Scalars['Int']['output']>;
  /** quantities packed per size count */
  quantitesPacked?: Maybe<Array<Scalars['Int']['output']>>;
  /** quantities requested */
  quantityRequested?: Maybe<Scalars['Int']['output']>;
  /** quantity unit */
  quantityUnit?: Maybe<Scalars['String']['output']>;
  /** reference number */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** selling company name */
  seller?: Maybe<Scalars['String']['output']>;
  /** indication of commodity size */
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  /** state */
  state?: Maybe<Scalars['String']['output']>;
  /** sub commodity name */
  subCommodity?: Maybe<Scalars['String']['output']>;
  /** target country */
  targetCountry?: Maybe<Scalars['String']['output']>;
  /** target market */
  targetMarket?: Maybe<Scalars['String']['output']>;
  /** target region */
  targetRegion?: Maybe<Scalars['String']['output']>;
  /** variety name */
  variety?: Maybe<Scalars['String']['output']>;
  /** main code associated with the seller farm variety */
  varietyCode?: Maybe<Scalars['String']['output']>;
};

export enum PackInstructionStateEnum {
  Overdue = 'OVERDUE',
  Packed = 'PACKED',
  PackhouseRun = 'PACKHOUSE_RUN',
  PartiallyPacked = 'PARTIALLY_PACKED',
  ToPack = 'TO_PACK',
  OverPacked = 'OVER_PACKED'
}

export type PackInstructionsAttributes = {
  /** Packing Week to filter on */
  endWeek: Scalars['String']['input'];
  /** Packing Week to filter on */
  startWeek: Scalars['String']['input'];
  /** States to filter on */
  states?: InputMaybe<Array<PackInstructionStateEnum>>;
  /** Varieties to filter on */
  varietyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Commmodities to filter on */
  commodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Buyers to filter on */
  buyerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Sellers to filter on */
  sellerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Sub Commodities to filter on */
  subCommodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Only return entries that contain these reference numbers (wild card, case insensitive) */
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PackInstructionsFilterAttribute = {
  __typename?: 'PackInstructionsFilterAttribute';
  /** this company's buyers */
  buyers?: Maybe<Array<Company>>;
  /** this company's commodityes */
  commodities?: Maybe<Array<Commodity>>;
  /** this company's sellers */
  sellers?: Maybe<Array<Company>>;
  /** this company's commodityes */
  subCommodities?: Maybe<Array<SubCommodity>>;
  /** this company's varieties */
  varieties?: Maybe<Array<Variety>>;
};

/** Represents a packhouse connection allowing a company to monitor/view packhouse data */
export type PackhouseConnection = {
  __typename?: 'PackhouseConnection';
  /** The ID of the on-prem server (electron app) for this connection */
  apiUserId: Scalars['Int']['output'];
  /** The company that has monitoring/visibility rights for this connection */
  company: Company;
  /** Whether the server is currently connected */
  connected: Scalars['Boolean']['output'];
  /** When this connection record was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The packhouse this connection serves */
  foodBusinessOperator: FoodBusinessOperator;
  /** Unique identifier for this connection */
  id: Scalars['ID']['output'];
  /** Most recent datetime processed from packhouse database */
  lastProcessedDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The masterfile config associated with this packhouse connection */
  masterfileConfig?: Maybe<MasterfileConfig>;
  /** User-friendly name for this connection (e.g., "Packhouse A - Main Server") */
  name: Scalars['String']['output'];
  /** The type of on-prem system this connection is connected to */
  onPremSystem?: Maybe<Scalars['String']['output']>;
  /** When the installation is scheduled for */
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Details of when installation was scheduled via Hubspot */
  scheduledFor?: Maybe<Scalars['String']['output']>;
  /** Connection state: pending_verification, scheduled, or installed */
  state: Scalars['String']['output'];
  /** When this connection record was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A client change request for a packhouse connection */
export type PackhouseConnectionClientChangeRequest = {
  __typename?: 'PackhouseConnectionClientChangeRequest';
  /** The company that has monitoring/visibility rights for this connection */
  company?: Maybe<Company>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The packhouse this connection serves */
  foodBusinessOperator?: Maybe<FoodBusinessOperator>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['ID']['output']>;
  /** The ID of the packhouse */
  packhouseId?: Maybe<Scalars['ID']['output']>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Contains information on pallet ins */
export type PalletIn = {
  __typename?: 'PalletIn';
  /** Unique identifier of the Pallet In */
  id?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the load out instruction associated with this pallet in */
  loadOutInstructionId?: Maybe<Scalars['ID']['output']>;
  /** The document produced for this pallet in */
  outputFile?: Maybe<Document>;
  /** State of the template generation (created, processing, completed) */
  state?: Maybe<Scalars['String']['output']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Contains information on pallet outs */
export type PalletOut = {
  __typename?: 'PalletOut';
  /** Unique identifier of the addendum header associated with this pallet out */
  addendumHeaderId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']['output']>;
  /** The document produced for this pallet out */
  outputFile?: Maybe<Document>;
  /** State of the template generation (created, processing, completed) */
  state?: Maybe<Scalars['String']['output']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Returns the Cg erros as errors from pallet rules validations. */
export type PalletRuleError = {
  __typename?: 'PalletRuleError';
  /** ID of the cg error */
  id?: Maybe<Scalars['ID']['output']>;
  /** The reason why the rule failed */
  reason?: Maybe<Scalars['Int']['output']>;
  /** The rule that failed as an error type */
  ruleError?: Maybe<Scalars['String']['output']>;
  /** The resolution status of this error */
  state?: Maybe<Scalars['String']['output']>;
};

/** Fields available on a payment */
export type Payment = {
  __typename?: 'Payment';
  /** Allocated amount of money paid in major unit */
  allocatedAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** Bank charges for the payment in major unit */
  bankChargesMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** Split of bank charges between the companies */
  bankChargesSplit?: Maybe<BankChargeSplitEnum>;
  /** Reference to the cashbook entry in client system */
  cashbookReference?: Maybe<Scalars['String']['output']>;
  /** The company that made/ received the payment */
  company?: Maybe<Company>;
  /** Identifier of the company that made/ received the payment */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Name of the company that made/ received the payment */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The contact involved in the transaction */
  contact?: Maybe<Contact>;
  /** Identifier of the contact involved in the transaction */
  contactId?: Maybe<Scalars['ID']['output']>;
  /** Name of the contact involved in the transaction */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Date and time the payment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Currency the payment was made in */
  currency?: Maybe<Scalars['String']['output']>;
  /** Currency exchange rate for the payment */
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** Description of the payment */
  description?: Maybe<Scalars['String']['output']>;
  /** Exchange rate for the payment */
  exchangeRate?: Maybe<Scalars['String']['output']>;
  /** Unique payment identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** Payment allocations per invoice */
  invoicePaymentAllocations?: Maybe<Array<InvoicePaymentAllocation>>;
  /** Invoices ascociated with the payment */
  invoices?: Maybe<Array<Invoice>>;
  /** Date the payment was made */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Type of payment, i.e. Receipt, Disbursement, etc. */
  paymentType?: Maybe<PaymentTypeEnum>;
  /** Remaining amount of money paid in major unit */
  remainingAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** State of the payment */
  state?: Maybe<PaymentStateEnum>;
  /** Total amount of money paid in major unit */
  totalAmountMajorUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** Date and time the payment was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes for creating or updating a payment allocation */
export type PaymentAllocationAttributes = {
  /** Amount to be allocated */
  amount: Scalars['BigDecimal']['input'];
  /** ID of the invoice to allocate the payment to */
  invoiceId: Scalars['ID']['input'];
  /** ID of the payment to be allocated */
  paymentId: Scalars['ID']['input'];
  /** Remove allocation if true */
  removeAllocation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attributes for creating a payment */
export type PaymentAttributes = {
  /** Paid amount in major unit */
  totalAmountMajorUnit: Scalars['BigDecimal']['input'];
  /** Allocated amount in major unit */
  allocatedAmountMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Remaining amount in major unit */
  remainingAmountMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Amount of bank charges */
  bankChargesMajorUnit?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Split of bank charges */
  bankChargesSplit?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the current company's cashbook */
  cashbookReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of the current company */
  companyId: Scalars['ID']['input'];
  /** Currency of the payment */
  currency: Scalars['String']['input'];
  /** Description of the payment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact involved in the transaction */
  contactId: Scalars['ID']['input'];
  /** Date of the payment */
  paymentDate: Scalars['ISO8601DateTime']['input'];
  /** Type of payment eg. 'credit', 'debit' */
  paymentType: Scalars['String']['input'];
};

/** The connection type for Payment. */
export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Payment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Payment>;
};

/** Payment filter attribute for populating frontend filters */
export type PaymentFilterAttribute = {
  __typename?: 'PaymentFilterAttribute';
  /** Contacts for this user's payments */
  contacts?: Maybe<Array<Contact>>;
};

export enum PaymentStateEnum {
  Unallocated = 'unallocated',
  PartiallyAllocated = 'partially_allocated',
  Allocated = 'allocated'
}

export enum PaymentTypeEnum {
  Incoming = 'incoming',
  Outgoing = 'outgoing'
}

/** Filtering options for payments */
export type PaymentsFilters = {
  /** filter by the contact id */
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by the currency */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by the payment type */
  paymentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by the payment state */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** only fetch unallocated or partially allocated payments */
  unallocatedOrPartiallyAllocated?: InputMaybe<Scalars['Boolean']['input']>;
  /** only fetch payments with payment_date on or after this date (inclusive) */
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** only fetch payments with payment_date on or before this date (inclusive) */
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type Permission = {
  __typename?: 'Permission';
  key?: Maybe<PermissionEnum>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export enum PermissionEnum {
  /** Whether the Demo page is available */
  PagesDemo = 'pages_demo',
  /** Whether the Dashboard page is available */
  PagesDashboard = 'pages_dashboard',
  /** Whether the Settings page is available */
  PagesSettings = 'pages_settings',
  /** Whether the Company page is available */
  PagesCompany = 'pages_company',
  /** Whether the Orders page is available */
  PagesOrders = 'pages_orders',
  /** Whether the Vieworder page is available */
  PagesViewOrder = 'pages_viewOrder',
  /** Whether the Neworder page is available */
  PagesNewOrder = 'pages_newOrder',
  /** Whether the Partners page is available */
  PagesPartners = 'pages_partners',
  /** Whether the Planning page is available */
  PagesPlanning = 'pages_planning',
  /** Whether the Packinstructions page is available */
  PagesPackInstructions = 'pages_packInstructions',
  /** Whether the Cashflow page is available */
  PagesCashFlow = 'pages_cashFlow',
  /** Whether the Commercialterms page is available */
  PagesCommercialTerms = 'pages_commercialTerms',
  /** Whether the Insights page is available */
  PagesInsights = 'pages_insights',
  /** Whether the Loadoutinstructions page is available */
  PagesLoadOutInstructions = 'pages_loadOutInstructions',
  /** Whether the Commercialinvoices page is available */
  PagesCommercialInvoices = 'pages_commercialInvoices',
  /** Whether the Estimations page is available */
  PagesEstimations = 'pages_estimations',
  /** Whether the Shipments page is available */
  PagesShipments = 'pages_shipments',
  /** Whether the Airfreightshipments page is available */
  PagesAirFreightShipments = 'pages_airFreightShipments',
  /** Whether the Dataexports page is available */
  PagesDataExports = 'pages_dataExports',
  /** Whether the Financepipeline page is available */
  PagesFinancePipeline = 'pages_financePipeline',
  /** Whether the Customerinvoices page is available */
  PagesCustomerInvoices = 'pages_customerInvoices',
  /** Whether the Defaultcosts page is available */
  PagesDefaultCosts = 'pages_defaultCosts',
  /** Whether the Payments page is available */
  PagesPayments = 'pages_payments',
  /** Whether the Stock page is available */
  PagesStock = 'pages_stock',
  /** Whether the Financeindex page is available */
  PagesFinanceIndex = 'pages_financeIndex',
  /** Whether the Profitandloss page is available */
  PagesProfitAndLoss = 'pages_profitAndLoss',
  /** Whether the Masterfiles page is available */
  PagesMasterfiles = 'pages_masterfiles',
  /** Whether the Financerulemanagement page is available */
  PagesFinanceRuleManagement = 'pages_financeRuleManagement',
  /** Whether the Vendorinvoices page is available */
  PagesVendorInvoices = 'pages_vendorInvoices',
  /** Whether the Claims page is available */
  PagesClaims = 'pages_claims',
  /** Whether the Incotermcalculator page is available */
  PagesIncotermCalculator = 'pages_incotermCalculator',
  /** Whether the Knowledgebase page is available */
  PagesKnowledgeBase = 'pages_knowledgeBase',
  /** Whether the Inspections page is available */
  PagesInspections = 'pages_inspections',
  /**
   *
   *                     Whether the Orders
   *                     page should allow the Viewprice
   *                     action for this user
   *
   */
  OrdersViewPrice = 'orders_viewPrice',
  /**
   *
   *                     Whether the Orders
   *                     page should allow the Duplicateorder
   *                     action for this user
   *
   */
  OrdersDuplicateOrder = 'orders_duplicateOrder',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Acceptandwontpacktoggle
   *                     action for this user
   *
   */
  ViewOrderAcceptAndWontPackToggle = 'viewOrder_acceptAndWontPackToggle',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Addorremovelineitem
   *                     action for this user
   *
   */
  ViewOrderAddOrRemoveLineItem = 'viewOrder_addOrRemoveLineItem',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Addorremovelineitemgroup
   *                     action for this user
   *
   */
  ViewOrderAddOrRemoveLineItemGroup = 'viewOrder_addOrRemoveLineItemGroup',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Duplicateorder
   *                     action for this user
   *
   */
  ViewOrderDuplicateOrder = 'viewOrder_duplicateOrder',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editbatchnumber
   *                     action for this user
   *
   */
  ViewOrderEditBatchNumber = 'viewOrder_editBatchNumber',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editcommodity
   *                     action for this user
   *
   */
  ViewOrderEditCommodity = 'viewOrder_editCommodity',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editgrade
   *                     action for this user
   *
   */
  ViewOrderEditGrade = 'viewOrder_editGrade',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editincoterm
   *                     action for this user
   *
   */
  ViewOrderEditIncoterm = 'viewOrder_editIncoterm',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editinventorycode
   *                     action for this user
   *
   */
  ViewOrderEditInventoryCode = 'viewOrder_editInventoryCode',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editmark
   *                     action for this user
   *
   */
  ViewOrderEditMark = 'viewOrder_editMark',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editorder
   *                     action for this user
   *
   */
  ViewOrderEditOrder = 'viewOrder_editOrder',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editpackingweek
   *                     action for this user
   *
   */
  ViewOrderEditPackingWeek = 'viewOrder_editPackingWeek',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editpacktype
   *                     action for this user
   *
   */
  ViewOrderEditPackType = 'viewOrder_editPackType',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editplannedquantity
   *                     action for this user
   *
   */
  ViewOrderEditPlannedQuantity = 'viewOrder_editPlannedQuantity',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editpriority
   *                     action for this user
   *
   */
  ViewOrderEditPriority = 'viewOrder_editPriority',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editreferencenumber
   *                     action for this user
   *
   */
  ViewOrderEditReferenceNumber = 'viewOrder_editReferenceNumber',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editrequestedquantity
   *                     action for this user
   *
   */
  ViewOrderEditRequestedQuantity = 'viewOrder_editRequestedQuantity',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editsizecounts
   *                     action for this user
   *
   */
  ViewOrderEditSizeCounts = 'viewOrder_editSizeCounts',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editstacksize
   *                     action for this user
   *
   */
  ViewOrderEditStackSize = 'viewOrder_editStackSize',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Edittargetcountry
   *                     action for this user
   *
   */
  ViewOrderEditTargetCountry = 'viewOrder_editTargetCountry',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Edittargetmarket
   *                     action for this user
   *
   */
  ViewOrderEditTargetMarket = 'viewOrder_editTargetMarket',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Edittargetregion
   *                     action for this user
   *
   */
  ViewOrderEditTargetRegion = 'viewOrder_editTargetRegion',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Editvariety
   *                     action for this user
   *
   */
  ViewOrderEditVariety = 'viewOrder_editVariety',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Grouplineitemtoggle
   *                     action for this user
   *
   */
  ViewOrderGroupLineItemToggle = 'viewOrder_groupLineItemToggle',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Viewcomments
   *                     action for this user
   *
   */
  ViewOrderViewComments = 'viewOrder_viewComments',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Viewpallets
   *                     action for this user
   *
   */
  ViewOrderViewPallets = 'viewOrder_viewPallets',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Viewprice
   *                     action for this user
   *
   */
  ViewOrderViewPrice = 'viewOrder_viewPrice',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Viewtimeline
   *                     action for this user
   *
   */
  ViewOrderViewTimeline = 'viewOrder_viewTimeline',
  /**
   *
   *                     Whether the Vieworder
   *                     page should allow the Staticorderlineitemtable additionalfield
   *                     action for this user
   *
   */
  ViewOrderStaticOrderLineItemTableAdditionalField = 'viewOrder_staticOrderLineItemTable_additionalField',
  /**
   *
   *                     Whether the Planning
   *                     page should allow the Allocatable
   *                     action for this user
   *
   */
  PlanningAllocatable = 'planning_allocatable',
  /**
   *
   *                     Whether the Packinstructions
   *                     page should allow the Onepackpush
   *                     action for this user
   *
   */
  PackInstructionsOnepackPush = 'packInstructions_onepackPush',
  /**
   *
   *                     Whether the Estimations
   *                     page should allow the Edit
   *                     action for this user
   *
   */
  EstimationsEdit = 'estimations_edit',
  /**
   *
   *                     Whether the General
   *                     page should allow the Netreturnscalc
   *                     action for this user
   *
   */
  GeneralNetReturnsCalc = 'general_netReturnsCalc',
  /**
   *
   *                     Whether the General
   *                     page should allow the Exportactions
   *                     action for this user
   *
   */
  GeneralExportActions = 'general_exportActions',
  /**
   *
   *                     Whether the General
   *                     page should allow the Accountingexportpermission
   *                     action for this user
   *
   */
  GeneralAccountingExportPermission = 'general_accountingExportPermission',
  /**
   *
   *                     Whether the General
   *                     page should allow the Accountingsupplierexportpermission
   *                     action for this user
   *
   */
  GeneralAccountingSupplierExportPermission = 'general_accountingSupplierExportPermission',
  /**
   *
   *                     Whether the General
   *                     page should allow the Accountsalepermission
   *                     action for this user
   *
   */
  GeneralAccountSalePermission = 'general_accountSalePermission',
  /**
   *
   *                     Whether the Loadoutinstructions
   *                     page should allow the Viewloioceantab
   *                     action for this user
   *
   */
  LoadOutInstructionsViewLoiOceanTab = 'loadOutInstructions_viewLoiOceanTab',
  /**
   *
   *                     Whether the Loadoutinstructions
   *                     page should allow the Viewloiroadtab
   *                     action for this user
   *
   */
  LoadOutInstructionsViewLoiRoadTab = 'loadOutInstructions_viewLoiRoadTab',
  /**
   *
   *                     Whether the Loadoutinstructions
   *                     page should allow the Viewloiairtab
   *                     action for this user
   *
   */
  LoadOutInstructionsViewLoiAirTab = 'loadOutInstructions_viewLoiAirTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Exporttoppecb
   *                     action for this user
   *
   */
  OceanShipmentsExportToPpecb = 'oceanShipments_exportToPPECB',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Exportnotificationtab
   *                     action for this user
   *
   */
  OceanShipmentsExportNotificationTab = 'oceanShipments_exportNotificationTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Addendumtab
   *                     action for this user
   *
   */
  OceanShipmentsAddendumTab = 'oceanShipments_addendumTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Ephytotab
   *                     action for this user
   *
   */
  OceanShipmentsEphytoTab = 'oceanShipments_ephytoTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Rmsvoyages
   *                     action for this user
   *
   */
  OceanShipmentsRmsVoyages = 'oceanShipments_rmsVoyages',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Phytcleanvalidation
   *                     action for this user
   *
   */
  OceanShipmentsPhytcleanValidation = 'oceanShipments_phytcleanValidation',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Cargoduestab
   *                     action for this user
   *
   */
  OceanShipmentsCargoDuesTab = 'oceanShipments_cargoDuesTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Roadshipmentstab
   *                     action for this user
   *
   */
  OceanShipmentsRoadShipmentsTab = 'oceanShipments_roadShipmentsTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Oceanshipmentstab
   *                     action for this user
   *
   */
  OceanShipmentsOceanShipmentsTab = 'oceanShipments_oceanShipmentsTab',
  /**
   *
   *                     Whether the Oceanshipments
   *                     page should allow the Airshipmentstab
   *                     action for this user
   *
   */
  OceanShipmentsAirShipmentsTab = 'oceanShipments_airShipmentsTab',
  /**
   *
   *                     Whether the Masterfiles
   *                     page should allow the Farmvarieties
   *                     action for this user
   *
   */
  MasterfilesFarmVarieties = 'masterfiles_farmVarieties',
  /**
   *
   *                     Whether the Masterfiles
   *                     page should allow the Orchards
   *                     action for this user
   *
   */
  MasterfilesOrchards = 'masterfiles_orchards',
  /**
   *
   *                     Whether the Masterfiles
   *                     page should allow the Foodbusinessoperators
   *                     action for this user
   *
   */
  MasterfilesFoodBusinessOperators = 'masterfiles_foodBusinessOperators',
  /**
   *
   *                     Whether the Masterfiles
   *                     page should allow the Cartonconversions
   *                     action for this user
   *
   */
  MasterfilesCartonConversions = 'masterfiles_cartonConversions',
  /**
   *
   *                     Whether the Masterfiles
   *                     page should allow the Errors
   *                     action for this user
   *
   */
  MasterfilesErrors = 'masterfiles_errors',
  /**
   *
   *                     Whether the Masterfiles
   *                     page should allow the Packhouses
   *                     action for this user
   *
   */
  MasterfilesPackhouses = 'masterfiles_packhouses',
  /**
   *
   *                     Whether the Inspections
   *                     page should allow the Manager
   *                     action for this user
   *
   */
  InspectionsManager = 'inspections_manager',
  /**
   *
   *                     Whether the Offers
   *                     page should allow the Whatsapprecipient
   *                     action for this user
   *
   */
  OffersWhatsappRecipient = 'offers_whatsappRecipient'
}

export type Permissions = {
  __typename?: 'Permissions';
  landingPage?: Maybe<PermissionEnum>;
  permissions?: Maybe<Array<Permission>>;
};

export type PnlLinkedRecord = {
  __typename?: 'PnlLinkedRecord';
  amountMajorUnit?: Maybe<Scalars['Float']['output']>;
  /** Total cartons (producer statements only) */
  cartons?: Maybe<Scalars['Int']['output']>;
  /** Number of CGs on this record */
  cgCount?: Maybe<Scalars['Int']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  /** URL to download the document (producer statements only) */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** FX rate used to convert amount to reporting currency (same logic as P&L report) */
  exchangeRateToReporting?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isPayment: Scalars['Boolean']['output'];
  rawDocumentType?: Maybe<Scalars['String']['output']>;
  /** invoice or payment */
  recordType: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PopulateContainer = {
  __typename?: 'PopulateContainer';
  /** Commercial term related to the CGs in container */
  commercialTerm?: Maybe<CommercialTerm>;
  /** Invoice Line Item built from container data */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** POD associated to the container */
  portOfDestination?: Maybe<SeaPort>;
  /** POL associated to the container */
  portOfLoading?: Maybe<SeaPort>;
  /** Vessel that the container is loaded on */
  vessel?: Maybe<Vessel>;
  /** Voyage related to the vessel */
  voyage?: Maybe<Scalars['String']['output']>;
};

export type PortArrival = {
  __typename?: 'PortArrival';
  /** The date that the vessel will be arriving */
  arrivalDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date that this information was received */
  observedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The port that the vessel will be arriving at */
  seaPort?: Maybe<SeaPort>;
  /** The vessel that is going to be arriving */
  vessel?: Maybe<Vessel>;
  /** The outgoing voyage number for the incoming vessel */
  voyage?: Maybe<Scalars['String']['output']>;
};

export type PpecbActivityPoint = {
  __typename?: 'PpecbActivityPoint';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbContainerType = {
  __typename?: 'PpecbContainerType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbCountry = {
  __typename?: 'PpecbCountry';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbExporter = {
  __typename?: 'PpecbExporter';
  /** Company associated with the PPECB exporter */
  company?: Maybe<Company>;
  /** Code representing the exporter FBO */
  exporterFboCode?: Maybe<Scalars['String']['output']>;
  /** Unique ID associated with the PPECB exporter */
  id: Scalars['ID']['output'];
  /** Code representing the registered exporter in PPECB */
  ppecbRegisteredExporterCode?: Maybe<Scalars['String']['output']>;
};

export type PpecbPort = {
  __typename?: 'PpecbPort';
  /** Timestamp when this record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The unique identifier for this PpecbPort record. */
  id: Scalars['ID']['output'];
  /** The code assigned to the port, used to match against SeaPort's unlocode. */
  portCode?: Maybe<Scalars['String']['output']>;
  /** The name of the port according to PPECB. */
  portName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbProduct = {
  __typename?: 'PpecbProduct';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbRegimeCode = {
  __typename?: 'PpecbRegimeCode';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  loadSpecification?: Maybe<Scalars['String']['output']>;
  maxProductTemp?: Maybe<Scalars['Float']['output']>;
  minProductTemp?: Maybe<Scalars['Float']['output']>;
  recipeDescription?: Maybe<Scalars['String']['output']>;
  regimeCode?: Maybe<Scalars['String']['output']>;
  regimeDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbUser = {
  __typename?: 'PpecbUser';
  /** Code representing the agent FBO */
  agentFboCode?: Maybe<Scalars['String']['output']>;
  /** Unique ID associated with the PPECB user */
  id: Scalars['ID']['output'];
  /** List of exporters associated with the PPECB user */
  ppecbExporters?: Maybe<Array<PpecbExporter>>;
  /** Code representing the registered agent in PPECB */
  ppecbRegisteredAgentCode?: Maybe<Scalars['String']['output']>;
  /** User associated with the PPECB user */
  user?: Maybe<User>;
};

export type PpecbVent = {
  __typename?: 'PpecbVent';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PpecbVoyageNumber = {
  __typename?: 'PpecbVoyageNumber';
  /** Unique ID associated with the PPECB voyage */
  id: Scalars['ID']['output'];
  /** PPECB registered voyage number */
  ppecbVoyageNumber?: Maybe<Scalars['String']['output']>;
  /** Name of the vessel */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** Identifier for the voyage */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export type PpecbWorldPort = {
  __typename?: 'PpecbWorldPort';
  /** Timestamp when this record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The unique identifier for this PpecbWorldPort record. */
  id: Scalars['ID']['output'];
  /** The code assigned to the port, used to match against SeaPort's unlocode. */
  portCode?: Maybe<Scalars['String']['output']>;
  /** The name of the port according to PPECB. */
  portName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum PriceUnitEnum {
  /** The line item is priced per ton */
  Ton = 'ton',
  /** The line item is priced per carton */
  Carton = 'carton',
  /** The line item is priced per pallet */
  Pallet = 'pallet',
  /** Cost line only: amount is allocated to revenue line items proportionally by their gross revenue contribution. Only valid on account sales. */
  Revenue = 'revenue'
}

/** Autogenerated return type of ProcessEtlDocument. */
export type ProcessEtlDocumentPayload = {
  __typename?: 'ProcessEtlDocumentPayload';
  document?: Maybe<EtlDocument>;
};

export type ProductionRegion = {
  __typename?: 'ProductionRegion';
  /** The country code of the production region */
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for this production region */
  id: Scalars['ID']['output'];
  /** The name of the production region */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProfitAndLossCostCategory = {
  __typename?: 'ProfitAndLossCostCategory';
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
};

export type ProfitAndLossExtendedFieldKey = {
  __typename?: 'ProfitAndLossExtendedFieldKey';
  /** Internal field name (e.g. pallet_base) */
  key: Scalars['String']['output'];
  /** Human-readable label from external_field_name */
  label?: Maybe<Scalars['String']['output']>;
  /** Distinct values for filter dropdown */
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProfitAndLossFilterAttributes = {
  __typename?: 'ProfitAndLossFilterAttributes';
  buyers?: Maybe<Array<IdName>>;
  commodities?: Maybe<Array<IdName>>;
  containers?: Maybe<Array<IdName>>;
  exporterCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Extended field keys with distinct values for filter dropdowns */
  extendedFieldKeys?: Maybe<Array<ProfitAndLossExtendedFieldKey>>;
  farmCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Available financial year options for the FY filter dropdown */
  financialYearOptions?: Maybe<Array<FinancialYearOption>>;
  grades?: Maybe<Array<Scalars['String']['output']>>;
  inventoryCodes?: Maybe<Array<Scalars['String']['output']>>;
  marks?: Maybe<Array<Scalars['String']['output']>>;
  packTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Distinct PO Numbers across non-voided invoices for the company. Returned verbatim (no whitespace normalisation, no case folding). */
  poNumbers?: Maybe<Array<Scalars['String']['output']>>;
  sellers?: Maybe<Array<IdName>>;
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  targetCountries?: Maybe<Array<Scalars['String']['output']>>;
  targetMarkets?: Maybe<Array<Scalars['String']['output']>>;
  targetRegions?: Maybe<Array<Scalars['String']['output']>>;
  varieties?: Maybe<Array<IdName>>;
  vessels?: Maybe<Array<IdName>>;
};

export type ProfitAndLossFilters = {
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Financial year identified by the calendar year the FY ends in (end-year convention, e.g. 2025 = Mar 2024 - Feb 2025 on a Mar-Feb company). Used as default when no start/end date. */
  financialYear?: InputMaybe<Scalars['Int']['input']>;
  /** Columns to GROUP BY in the SQL aggregation */
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter to specific carton grouping IDs. Used for producer statement generation from selected P&L rows. */
  cartonGroupingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  farmCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  containerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Text search fallback — prefer container_ids for dropdown filters */
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  commodityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  varietyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** AR counterparty (invoice party) company IDs. Filter to CGs with income CGTs from these buyers. */
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Producer (farm) company IDs from CGO. Filter to CGs where a CGO has company_id IN list and type farm. */
  sellerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  batchNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  palletNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  exporterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  targetMarkets?: InputMaybe<Array<Scalars['String']['input']>>;
  targetCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Packing week range start (ISO format: YYYY-WNN) */
  packingWeekStart?: InputMaybe<Scalars['String']['input']>;
  /** Packing week range end (ISO format: YYYY-WNN) */
  packingWeekEnd?: InputMaybe<Scalars['String']['input']>;
  marks?: InputMaybe<Array<Scalars['String']['input']>>;
  packTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeCounts?: InputMaybe<Array<Scalars['String']['input']>>;
  inventoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by vessel IDs (from sea_journeys pol_vessel_id/pod_vessel_id) */
  vesselIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free text filter on vessel name (ILIKE match via sea_journeys) */
  vesselName?: InputMaybe<Scalars['String']['input']>;
  /** Free text filter on voyage number (ILIKE match via sea_journeys) */
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Shipping week range start (ISO format: YYYY-WNN) */
  shippingWeekStart?: InputMaybe<Scalars['String']['input']>;
  /** Shipping week range end (ISO format: YYYY-WNN) */
  shippingWeekEnd?: InputMaybe<Scalars['String']['input']>;
  /** Filter to CGs on specific producer statement numbers */
  paymentAdviceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter to rows where at least one CG has a non-voided invoice with po_number in this list (exact string match) */
  poNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Per-CG filter: when true, only CGs with a statement. When false, only unstamped CGs. */
  hasPaymentAdvice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Row-level filter: when false, hides rows where ALL CGs have a statement (shows only rows with at least one unstamped CG). */
  hasProducerStatement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target currency for FX conversion (default: company reporting_currency or ZAR) */
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Enable/disable FX conversion */
  fxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Page number (1-based) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Rows per page (max 500 per page when paging). Use 0 to return all rows (e.g. Excel export). */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Sort fields and directions */
  orderByFields?: InputMaybe<Array<ProfitAndLossOrderBy>>;
  /** When true, include revenue_advance, revenue_final, revenue_credit_note, revenue_debit_note on each row */
  includeRevenueBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by extended field values. Key = internal_field_name, value = array of allowed values. */
  extendedFieldFilters?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProfitAndLossMeta = {
  __typename?: 'ProfitAndLossMeta';
  companyId?: Maybe<Scalars['Int']['output']>;
  costCategories?: Maybe<Array<ProfitAndLossCostCategory>>;
  extendedFieldKeys?: Maybe<Array<Scalars['String']['output']>>;
  fxEnabled?: Maybe<Scalars['Boolean']['output']>;
  groupBy?: Maybe<Array<Scalars['String']['output']>>;
  materializeMs?: Maybe<Scalars['Float']['output']>;
  reportingCurrency?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  sqlBuildMs?: Maybe<Scalars['Float']['output']>;
  sqlMs?: Maybe<Scalars['Float']['output']>;
  totalMs?: Maybe<Scalars['Float']['output']>;
};

export type ProfitAndLossOrderBy = {
  /** Column name to sort by */
  field: Scalars['String']['input'];
  /** asc or desc */
  direction?: InputMaybe<Scalars['String']['input']>;
};

export type ProfitAndLossPageInfo = {
  __typename?: 'ProfitAndLossPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ProfitAndLossReport = {
  __typename?: 'ProfitAndLossReport';
  meta?: Maybe<ProfitAndLossMeta>;
  nodes?: Maybe<Array<ProfitAndLossRow>>;
  pageInfo?: Maybe<ProfitAndLossPageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProfitAndLossReportCompleted = {
  __typename?: 'ProfitAndLossReportCompleted';
  report: ProfitAndLossReport;
  requestId: Scalars['String']['output'];
};

export type ProfitAndLossReportError = {
  __typename?: 'ProfitAndLossReportError';
  error: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
};

export type ProfitAndLossReportNotFound = {
  __typename?: 'ProfitAndLossReportNotFound';
  requestId: Scalars['String']['output'];
};

/** Async P&L report generation outcome */
export type ProfitAndLossReportOutcomeUnion = ProfitAndLossReportCompleted | ProfitAndLossReportError | ProfitAndLossReportNotFound | ProfitAndLossReportPending;

export type ProfitAndLossReportPending = {
  __typename?: 'ProfitAndLossReportPending';
  requestId: Scalars['String']['output'];
};

export type ProfitAndLossRow = {
  __typename?: 'ProfitAndLossRow';
  accountsReceivable?: Maybe<Scalars['Float']['output']>;
  /** True if all CGs in this row have at least one producer statement */
  allOnStatement?: Maybe<Scalars['Boolean']['output']>;
  arrivalWeek?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  cashReceived?: Maybe<Scalars['Float']['output']>;
  cashReceivedPerCarton?: Maybe<Scalars['Float']['output']>;
  cashReceivedPerStdCarton?: Maybe<Scalars['Float']['output']>;
  cgCount?: Maybe<Scalars['Int']['output']>;
  /** Total CIF Cost (Freight + Marine Insurance + Receiver Commission + Receiver Cost ex Commission + Repacking) */
  cifCosts?: Maybe<Scalars['Float']['output']>;
  cifCostsInclVat?: Maybe<Scalars['Float']['output']>;
  commodity?: Maybe<Scalars['String']['output']>;
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** Original invoice currency (distinct from reporting currency used for amounts) */
  contractCurrency?: Maybe<Scalars['String']['output']>;
  costBreakdown?: Maybe<Scalars['JSON']['output']>;
  /** Total DIP Costs (Certificate Fees + Documentation Fee + Coldstore Cost + Handling Cost + Local Transport + Admin Costs) */
  dipCosts?: Maybe<Scalars['Float']['output']>;
  dipCostsInclVat?: Maybe<Scalars['Float']['output']>;
  dischargePort?: Maybe<Scalars['String']['output']>;
  exporterCode?: Maybe<Scalars['String']['output']>;
  extendedFields?: Maybe<Scalars['JSON']['output']>;
  /** Total EXW Costs (Royalties Pack + Royalties EXW + Royalties FOB) */
  exwCosts?: Maybe<Scalars['Float']['output']>;
  exwCostsInclVat?: Maybe<Scalars['Float']['output']>;
  farmCode?: Maybe<Scalars['String']['output']>;
  /** Total FOB Cost (Temperature Monitoring + Freight Shipment Cost) */
  fobCosts?: Maybe<Scalars['Float']['output']>;
  fobCostsInclVat?: Maybe<Scalars['Float']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  /** Equal to Net EXW */
  growerFinalPayment?: Maybe<Scalars['Float']['output']>;
  /** Incoterm from highest-priority invoice (tax > advance > account sale > commercial > line item) */
  incoterm?: Maybe<Scalars['String']['output']>;
  inventoryCode?: Maybe<Scalars['String']['output']>;
  linkedBbcIds?: Maybe<Array<Scalars['Int']['output']>>;
  linkedCgIds?: Maybe<Array<Scalars['Int']['output']>>;
  linkedContainerIds?: Maybe<Array<Scalars['Int']['output']>>;
  linkedRecordsCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use fobCosts + dipCosts instead */
  localCosts?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use fobCostsInclVat + dipCostsInclVat instead */
  localCostsInclVat?: Maybe<Scalars['Float']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  /** Revenue - Total CIF Cost */
  netCif?: Maybe<Scalars['Float']['output']>;
  netCifInclVat?: Maybe<Scalars['Float']['output']>;
  netCifInclVatPerCarton?: Maybe<Scalars['Float']['output']>;
  netCifInclVatPerStdCarton?: Maybe<Scalars['Float']['output']>;
  netCifPerCarton?: Maybe<Scalars['Float']['output']>;
  netCifPerStdCarton?: Maybe<Scalars['Float']['output']>;
  /** Net FOB - Total DIP Costs */
  netDip?: Maybe<Scalars['Float']['output']>;
  netDipInclVat?: Maybe<Scalars['Float']['output']>;
  netDipInclVatPerCarton?: Maybe<Scalars['Float']['output']>;
  netDipInclVatPerStdCarton?: Maybe<Scalars['Float']['output']>;
  netDipPerCarton?: Maybe<Scalars['Float']['output']>;
  netDipPerStdCarton?: Maybe<Scalars['Float']['output']>;
  /** Net DIP - Total EXW Costs */
  netExw?: Maybe<Scalars['Float']['output']>;
  netExwInclVat?: Maybe<Scalars['Float']['output']>;
  netExwInclVatPerCarton?: Maybe<Scalars['Float']['output']>;
  netExwInclVatPerStdCarton?: Maybe<Scalars['Float']['output']>;
  /** EXW / Raw Carton */
  netExwPerCarton?: Maybe<Scalars['Float']['output']>;
  /** EXW / Standard Carton */
  netExwPerStdCarton?: Maybe<Scalars['Float']['output']>;
  /** Net CIF - Total FOB Cost */
  netFob?: Maybe<Scalars['Float']['output']>;
  netFobInclVat?: Maybe<Scalars['Float']['output']>;
  netFobInclVatPerCarton?: Maybe<Scalars['Float']['output']>;
  netFobInclVatPerStdCarton?: Maybe<Scalars['Float']['output']>;
  netFobPerCarton?: Maybe<Scalars['Float']['output']>;
  netFobPerStdCarton?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use cifCosts instead */
  overseasCosts?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use cifCostsInclVat instead */
  overseasCostsInclVat?: Maybe<Scalars['Float']['output']>;
  packType?: Maybe<Scalars['String']['output']>;
  packingWeek?: Maybe<Scalars['String']['output']>;
  palletCount?: Maybe<Scalars['Int']['output']>;
  palletNumber?: Maybe<Scalars['String']['output']>;
  /** Download URL for the latest producer statement on this row */
  paymentAdviceDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Latest producer statement number for these CGs */
  paymentAdviceNumber?: Maybe<Scalars['String']['output']>;
  /** Highest-priority non-voided invoice PO Number for the row's CG (tax > advance > account_sale > commercial) */
  poNumber?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueAdvance?: Maybe<Scalars['Float']['output']>;
  revenueCreditNote?: Maybe<Scalars['Float']['output']>;
  revenueDebitNote?: Maybe<Scalars['Float']['output']>;
  revenueFinal?: Maybe<Scalars['Float']['output']>;
  revenueInclVat?: Maybe<Scalars['Float']['output']>;
  revenueInclVatPerCarton?: Maybe<Scalars['Float']['output']>;
  revenueInclVatPerKg?: Maybe<Scalars['Float']['output']>;
  revenueInclVatPerStdCarton?: Maybe<Scalars['Float']['output']>;
  revenuePerCarton?: Maybe<Scalars['Float']['output']>;
  revenuePerKg?: Maybe<Scalars['Float']['output']>;
  revenuePerStdCarton?: Maybe<Scalars['Float']['output']>;
  sellerName?: Maybe<Scalars['String']['output']>;
  shippingWeek?: Maybe<Scalars['String']['output']>;
  sizeCount?: Maybe<Scalars['String']['output']>;
  targetCountry?: Maybe<Scalars['String']['output']>;
  targetMarket?: Maybe<Scalars['String']['output']>;
  targetRegion?: Maybe<Scalars['String']['output']>;
  totalCartons?: Maybe<Scalars['Int']['output']>;
  totalKilograms?: Maybe<Scalars['Float']['output']>;
  totalStdCartons?: Maybe<Scalars['Float']['output']>;
  variety?: Maybe<Scalars['String']['output']>;
  vatTotalCosts?: Maybe<Scalars['Float']['output']>;
  vatTotalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Vessel name when grouped by vessel */
  vesselId?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

/** returns details about the program model */
export type Program = {
  __typename?: 'Program';
  /** the company that created the program */
  company?: Maybe<Company>;
  /** the id of the company that created the program */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** when the program was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the unique identifier for the program */
  id?: Maybe<Scalars['ID']['output']>;
  /** the unique user identifiable name of the program */
  name?: Maybe<Scalars['String']['output']>;
  /** the id of the object that the program is associated with */
  programmableId?: Maybe<Scalars['ID']['output']>;
  /** the type of the program eg. OrderProgram */
  programmableType?: Maybe<Scalars['String']['output']>;
  /** when the program was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the user that created the program */
  user?: Maybe<User>;
  /** the id of the user that created the program */
  userId?: Maybe<Scalars['ID']['output']>;
  /** the visibility of the program eg. 'Public', 'Company' or 'Private' */
  visibility?: Maybe<ProgramVisibilityEnum>;
};

export enum ProgramVisibilityEnum {
  Private = 'PRIVATE',
  Company = 'COMPANY',
  Public = 'PUBLIC'
}

/** Autogenerated return type of PushPackInstructionsToOnepack. */
export type PushPackInstructionsToOnepackPayload = {
  __typename?: 'PushPackInstructionsToOnepackPayload';
  /** Whether the push resulted in a platform (from our system) error. If true, then the export did not occur. */
  isPlatformError: Scalars['Boolean']['output'];
  /** Human-readable message when the push did not succeed or for partial failures. */
  message?: Maybe<Scalars['String']['output']>;
  /** Pack instruction reference sent to OnePack (header.pack_instruction_ref). */
  packInstructionRef?: Maybe<Scalars['String']['output']>;
  /** Whether the push to OnePack succeeded. */
  success: Scalars['Boolean']['output'];
};

export enum Quantity {
  Carton = 'CARTON',
  Pallet = 'PALLET',
  Container = 'CONTAINER'
}

/** root query */
export type Query = {
  __typename?: 'Query';
  /** Fetches the specific account statement */
  accountStatement?: Maybe<AccountStatement>;
  /** Fetches a specific accounting export */
  accountingExport?: Maybe<AccountingExport>;
  /** Fetches Addendum */
  addendumHeaderById?: Maybe<AddendumHeader>;
  /** Fetches Addendum Line Items for specific addendum */
  addendumLineItemsByHeaderId?: Maybe<Array<AddendumLineItem>>;
  /** Fetches Addendums on a air freight shipment */
  addendumsOnAirFreightShipment?: Maybe<Array<AddendumHeader>>;
  /** Fetches Addendums on a shipment */
  addendumsOnShipment?: Maybe<Array<AddendumHeader>>;
  /** Gets additional fields configured for companies */
  additionalFields?: Maybe<Array<AdditionalField>>;
  /** Poll async AG1 table file generation result by request ID (correlates with generateAg1TableOutputFile) */
  ag1TableOutputFileResult?: Maybe<Ag1TableOutputFileResult>;
  /** Fetches Air Freight Shipment by Id */
  airFreightShipmentById?: Maybe<AirFreightShipment>;
  /** Fetches attributes for air freight shipments filters */
  airFreightShipmentLineItemsByShipment?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Fetches all air freight SLIs with no LOI and `In progress` state */
  airFreightShipmentLineItemsWithNoLoi?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Gets all load out instructions associated with a shipment */
  airFreightShipmentLois?: Maybe<Array<LoadOutInstruction>>;
  /** fetches air freight shipments based on filters or search term */
  airFreightShipments?: Maybe<AirFreightShipmentConnection>;
  /** Fetches attributes for air freight shipments filters */
  airFreightShipmentsFilterAttributes?: Maybe<AirFreightShipmentsFilterAttribute>;
  /** List of allowed currencies */
  allowedCurrencies: Array<Scalars['String']['output']>;
  /** List of allowed incoterms */
  allowedIncoterms: Array<Scalars['String']['output']>;
  /** List of allowed match types */
  allowedMatchTypes: Array<Scalars['String']['output']>;
  /** List of allowed units */
  allowedUnits: Array<Scalars['String']['output']>;
  /** Fetches break bulk containers eligible for arrival QC */
  breakBulkContainersForArrivalQc?: Maybe<Array<BreakBulkContainer>>;
  /** fetches all valid shipment line items that can have Cargo Dues */
  cargoDues?: Maybe<ShipmentLineItemConnection>;
  /** Fetches attributes for Carton Conversion filters */
  cartonConversionFilterAttributes?: Maybe<Array<CartonConversionFilterAttribute>>;
  /** All Carton Conversions for the seller */
  cartonConversions: Array<CartonConversion>;
  /** get all carton counts */
  cartonCounts?: Maybe<Array<CartonCount>>;
  /** All the audits for the specified carton grouping */
  cartonGroupingAudits?: Maybe<Array<CartonGroupingAudit>>;
  cartonGroupingsForLineItem?: Maybe<Array<CartonGrouping>>;
  /** get cartons groupings for a specific week */
  cartonGroupingsForWeek?: Maybe<Array<CartonGrouping>>;
  /**
   *
   *         fetchs a list of carton groupings based on the defined search requirements,
   *         also returns the total amount of cartons found and
   *         the distinct values of certain columns to be used for filters
   *
   */
  cartonGroupingsSearch?: Maybe<CartonGroupingSearch>;
  /** Gets all carton types for a given commodity */
  cartonTypesByCommodity?: Maybe<Array<CartonType>>;
  /** get the iframe url for the cartons per buyer chart for the current user */
  cartonsPerBuyerChartUrl?: Maybe<Scalars['String']['output']>;
  /** get the iframe url for the cartons per seller chart for the current user */
  cartonsPerSellerChartUrl?: Maybe<Scalars['String']['output']>;
  /** Fetches the specific certificate transport instruction */
  certificateTransportInstruction?: Maybe<CertificateTransportInstruction>;
  /** get a list of all known certificate types */
  certificateTypes?: Maybe<Array<CertificateType>>;
  /** Fetches attributes for Cg Error filters */
  cgErrorFilterAttributes?: Maybe<Array<CgErrorFilterAttribute>>;
  /** All Carton Conversions for the seller */
  cgErrors: Array<CgError>;
  /** Gets a channel notification by ID */
  channelNotificationById?: Maybe<ChannelNotification>;
  /** Gets all channel notifications for the current user */
  channelNotifications?: Maybe<ChannelNotificationConnection>;
  /** Gets the count of all channel notifications for the current user */
  channelNotificationsCount?: Maybe<Scalars['Int']['output']>;
  checkTranslationUpdates: Scalars['JSON']['output'];
  /** Fetches all of a company's claims */
  claims?: Maybe<Claims>;
  /** Fetches attributes for commercial term filters */
  commercialTermFilterAttributes?: Maybe<CommercialTermFilterAttribute>;
  /** get all commercial terms */
  commercialTerms?: Maybe<CommercialTermConnection>;
  /** Get all commodities */
  commodities?: Maybe<Array<Commodity>>;
  /** Get all commodity default seasons */
  commodityDefaultSeasons?: Maybe<Array<CommodityDefaultSeason>>;
  /** get the iframe url for the commodity split chart for the current user */
  commoditySplitChartUrl?: Maybe<Scalars['String']['output']>;
  /** Gets a single company */
  company?: Maybe<Company>;
  /** Fetches all Cost Codes configured for the company */
  companyCostCodes?: Maybe<Array<CostCode>>;
  /** Fetches all company payments for the current company */
  companyPayments?: Maybe<Array<CompanyPayment>>;
  /** Fetches attributes for company payment filters */
  companyPaymentsFilterAttributes?: Maybe<CompanyPaymentFilterAttribute>;
  /** Company contacts */
  contacts?: Maybe<Array<Contact>>;
  /** Container */
  containers?: Maybe<Array<Container>>;
  /** Fetches containers eligible for arrival QC */
  containersForArrivalQc?: Maybe<Array<ContainersForArrivalQc>>;
  /** Fetches all containers for a given finance rule */
  containersForFinanceRule?: Maybe<Array<Container>>;
  /** Fetches attributes for cost code filters */
  costCodesFilterAttributes?: Maybe<CostCodeFilterAttribute>;
  /** Fetches the cost line items for the specific invoice */
  costInvoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** Gets counter offers based on search and filter criteria */
  counterOffers?: Maybe<OfferConnection>;
  /** Fetches a currency conversion based on the provided attributes */
  currencyConversion?: Maybe<CurrencyConversion>;
  /** Fetches a currency conversion using the id */
  currencyConversionById?: Maybe<CurrencyConversion>;
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** Get all active map locations for a specific Order */
  currentMapPointsForOrder?: Maybe<Array<MapPoint>>;
  /** Fetches all existing shipment clients for the current company */
  currentShipmentClients?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches all existing shipment controllers for the current company */
  currentShipmentControllers?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches all transport companies for the current company */
  currentTransportCompanies?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches all truck references for the current company */
  currentTruckReferences?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches all custom fields for the selected company */
  customFields?: Maybe<Array<CustomField>>;
  /** get filtering data for the dashboard */
  dashboardFilters?: Maybe<DashboardFilters>;
  /** Search all active carton groupings */
  dashboardSearch?: Maybe<ElasticSearchResult>;
  /** Get all active carton groupings */
  dashboardTrackingData?: Maybe<DashboardTrackingData>;
  /** Fetches the data preparation for the user */
  dataPreparation?: Maybe<DataPreparation>;
  /** Fetches the data preparations for the user */
  dataPreparations?: Maybe<Array<DataPreparation>>;
  /** Fetches specific default cost */
  defaultCost?: Maybe<DefaultCost>;
  /** Fetch default costs based on filter criteria */
  defaultCosts?: Maybe<DefaultCostConnection>;
  /** Gets a specific document */
  document: EtlDocument;
  /** Gets document rows for a specific document. Only returns rows for documents the user has access to (via DocumentOwner) and only for vendor_invoice, account_sale, or unmapped documents. */
  documentRows: EtlDocumentRowConnection;
  /** Gets documents for a company */
  documents: EtlDocumentConnection;
  /** Gets all company employees information */
  employees?: Maybe<Array<Employee>>;
  /** Fetches the Agreemet Codes from ecert */
  ephytoAgreementCodes?: Maybe<Array<EphytoAgreementCode>>;
  /** Fetches the applied chemicals from ecert */
  ephytoAppliedChemicals?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches Ephyto by ID */
  ephytoById?: Maybe<Ephyto>;
  /** Fetches the ephyto certificate */
  ephytoCertificateUrl?: Maybe<Scalars['String']['output']>;
  /** Fetches the country ISOs from ecert */
  ephytoCountries?: Maybe<Array<EphytoCountry>>;
  /** Fetches the Ephyto Document Types */
  ephytoDocumentTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches attributes for Ephyto Filters */
  ephytoFilterAttributes?: Maybe<EphytoFilterAttribute>;
  /** Fetches the Ephyto Locations from eCert */
  ephytoLocations?: Maybe<Array<EphytoLocation>>;
  /** Fetches the package types from eCert */
  ephytoPackageTypes?: Maybe<Array<EphytoPackage>>;
  /** Fetches the Ephyto Port of Entries from eCert */
  ephytoPortOfEntries?: Maybe<Array<EphytoPortOfEntry>>;
  /** Fetches the transport means from ecert */
  ephytoTransportMeans?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches the treatment levels from ecert */
  ephytoTreatments?: Maybe<Array<EphytoTreatment>>;
  /** Fetches the unit of measure codes from ecert */
  ephytoUnitOfMeasureCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches all Ephytos for the user */
  ephytos?: Maybe<EphytoConnection>;
  /** Gets all estimates for a company for a given season */
  estimates?: Maybe<Array<Estimate>>;
  /** Evaluates whether updating the SLI will affect its shipment and whether a new shipment is needed. */
  evaluateShipmentImpact: ShipmentImpact;
  /** Fetches the Export Document Types */
  exportDocumentTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Gets available FBOs that are of type exporter for the current company */
  exporterFbos?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches exporters */
  exporters?: Maybe<Array<Company>>;
  /** All Farm Varieties */
  farmVarieties: Array<FarmVariety>;
  /** Farm Variety Change requests from clients */
  farmVarietyClientChangeRequests: Array<FarmVarietyRequest>;
  /** Fetches attributes for farm variety and farm variety client change request filters */
  farmVarietyFilterAttributes?: Maybe<FarmVarietyFilterAttribute>;
  /** Returns the active orchards for the current user's company */
  fboOrchards?: Maybe<Array<FboOrchard>>;
  fetchCgCommercialTerm?: Maybe<CommercialTerm>;
  fetchReportResult?: Maybe<Scalars['Json']['output']>;
  /** Fetches cg based financial items for report purposes */
  financeReport?: Maybe<FinanceReport>;
  /** Fetches a single finance rule */
  financeRule?: Maybe<FinanceRule>;
  /** Fetch finance rules with optional filters, search, and sorting */
  financeRules?: Maybe<FinanceRuleConnection>;
  /** Fetches attributes for finance rule filters */
  financeRulesFilterAttributes?: Maybe<FinanceRuleFilterAttribute>;
  /** Food Business Operator Change requests from clients */
  foodBusinessOperatorClientChangeRequests?: Maybe<Array<FoodBusinessOperatorRequest>>;
  /** Fetches attributes for food business operators and client change request filters */
  foodBusinessOperatorFilterAttributes?: Maybe<FoodBusinessOperatorFilterAttribute>;
  /** Returns food business operators for the current user's company */
  foodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches all business specific FBOs for the user */
  foodBusinessOperatorsByType?: Maybe<Array<FoodBusinessOperator>>;
  /** Calculate historical market volume percentages for delivered orders in the last year */
  historicalMarketVolumes?: Maybe<Array<HistoricalMarketVolume>>;
  /** Fetches the revenue line items for the specific invoice */
  incomeInvoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** Gets pending client change requests for internal packhouses for a given company */
  internalPackhouseClientChangeRequests?: Maybe<Array<InternalPackhouseClientChangeRequest>>;
  /** Fetches the specific invoice */
  invoice?: Maybe<Invoice>;
  /** Fetches the CGTs for the Invoice */
  invoiceCartonGroupingTransactions?: Maybe<Array<CartonGroupingTransaction>>;
  /** A default reference to be used */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Fetches all invoice payments for the current company */
  invoicePayments?: Maybe<Array<InvoicePayment>>;
  /** gets all trade countries */
  invoiceScrollTradeCountries?: Maybe<TradeCountryConnection>;
  /** Fetches all invoices for the selected company */
  invoices?: Maybe<InvoiceConnection>;
  /** Fetches attributes for invoice filters */
  invoicesFilterAttributes?: Maybe<InvoiceFilterAttribute>;
  /** Gets the latest currency conversion */
  latestCurrencyConversion?: Maybe<CurrencyConversion>;
  /** Retrieve an Order Line Item by line item ID */
  lineItem?: Maybe<LineItem>;
  /** Gets line items based on search and filter criteria */
  lineItems?: Maybe<LineItemConnection>;
  /** Fetches attributes for line item filters */
  lineItemsFilterAttributes?: Maybe<LineItemFilterAttribute>;
  /** Get all food business operators */
  listFoodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** Get all varieties */
  listVarieties?: Maybe<Array<Variety>>;
  /** Fetches the specific load out instruction */
  loadOutInstruction?: Maybe<LoadOutInstruction>;
  /** Load Out Instruction carton groupings for allocation */
  loadOutInstructionCgs: Array<LoiCartonGrouping>;
  /** A default reference to be used */
  loadOutInstructionReference?: Maybe<Scalars['String']['output']>;
  /** Gets load out instructions based on search and filter criteria */
  loadOutInstructions?: Maybe<LoadOutInstructionConnection>;
  /** Fetches attributes for load out instruction filters */
  loadOutInstructionsFilterAttributes?: Maybe<LoadOutInstructionFilterAttribute>;
  /** Fetch masterfile configurations with filtering and search capabilities */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
  /** Fetch a combination of farm varieties and client change requests */
  masterfileFarmVarieties?: Maybe<Array<MasterfileFarmVariety>>;
  /** Fetch a combination of food business operators and client change requests */
  masterfileFoodBusinessOperators?: Maybe<Array<MasterfileFoodBusinessOperator>>;
  /** get metabase report */
  metabaseReport?: Maybe<MetabaseReport>;
  /** Fetches attributes for metabase report filters */
  metabaseReportFilterAttributes?: Maybe<MetabaseReportsFilterAttribute>;
  /** get metabase reports */
  metabaseReports?: Maybe<Array<MetabaseReport>>;
  /** get the signed in users company */
  myCompany?: Maybe<Company>;
  /** get the signed in user */
  myUser?: Maybe<User>;
  /** Fetches air freight shipment line items for parent */
  nestedAirFreightShipmentLineItems?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Gets applicable additional field filters for applicable finance rules for a given date */
  netReturnAdditionalFields?: Maybe<Array<AdditionalField>>;
  /** Gets all net return programs for a given company */
  netReturnPrograms?: Maybe<Array<NetReturnProgram>>;
  /** Gets applicable standard field filters for applicable finance rules for a given date */
  netReturnStandardFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches SLIs without an addendum on a shipment */
  nonAddendumShipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
  /** Fetches SLIs without an addendum on a shipment */
  nonEphytoShipmentLineItems?: Maybe<Array<NonEphytoShipmentLineItem>>;
  /** Gets all notification rules, filtered by notification slugs if provided */
  notificationRules?: Maybe<Array<NotificationRule>>;
  /** Gets an offer by its ID */
  offerById?: Maybe<Offer>;
  /** Fetches attributes for offer filters */
  offerFilterAttributes?: Maybe<OfferFilterAttribute>;
  /** Gets the linear history of an offer chain ending at the specified offer ID */
  offerHistoryById?: Maybe<Array<Offer>>;
  /** Gets offers based on search and filter criteria */
  offers?: Maybe<OfferConnection>;
  /** OnePack client codes for the current user company */
  onepackClientCodes: Array<OnepackClientCode>;
  /** Recent company-scoped outgoing OnePack pack-instruction API calls to NS Office (platform_api_calls), newest first */
  onepackPackInstructionSyncCalls: Array<OnepackPackInstructionSyncCall>;
  /** Gets all OneSwitch facilitated company associations where the parent company is the seller. */
  oneswitchBuyers?: Maybe<Array<Company>>;
  /** Gets all orchard seasons for given company and season */
  orchardSeasons?: Maybe<Array<OrchardSeason>>;
  /** Gets all orchard yields in a given range */
  orchardYields?: Maybe<Array<OrchardYield>>;
  /** Find an order by its ID */
  order?: Maybe<Order>;
  /** Gets order programs based on search and filter criteria */
  orderPrograms?: Maybe<Array<OrderProgram>>;
  /** Gets all orders */
  orders?: Maybe<Array<Order>>;
  /** Fetches attributes for order filters */
  ordersFilterAttributes?: Maybe<OrderFilterAttribute>;
  /** Gets orders based on search criteria */
  ordersSearch?: Maybe<OrderSearch>;
  /** Fetches attributes that orders can be filtered on */
  ordersSearchFilterAttributes?: Maybe<OrdersSearchFilterAttributes>;
  /** Gets orders based on search and filter criteria */
  ordersV3?: Maybe<OrderConnection>;
  /** creates pack instructions based on applied filters */
  packInstructions?: Maybe<Array<PackInstructionLineItem>>;
  /** Fetches attributes for pack instruction filters */
  packInstructionsFilterAttributes?: Maybe<PackInstructionsFilterAttribute>;
  /** Gets packhouse connections for the current company */
  packhouseConnections?: Maybe<Array<PackhouseConnection>>;
  /** Gets packhouse connections client change requests for the current company */
  packhouseConnectionsClientChangeRequests?: Maybe<Array<PackhouseConnectionClientChangeRequest>>;
  /** Fetches all packhouse software update reports */
  packhouseSoftwareUpdateReports?: Maybe<Array<SoftwareUpdateReportRequest>>;
  /** Fetches the specific payment */
  payment?: Maybe<Payment>;
  /** Fetches all payments for the company based on search and filter criteria */
  payments?: Maybe<PaymentConnection>;
  /** Fetches attributes for payment filters */
  paymentsFilterAttributes?: Maybe<PaymentFilterAttribute>;
  /** Linked records (invoices, payments) from CGT sources for given identifiers */
  pnlLinkedRecords: Array<PnlLinkedRecord>;
  populateInvoiceContainerData?: Maybe<PopulateContainer>;
  /** Populate and return a new invoice from a parent invoice */
  populateInvoiceFromParent?: Maybe<ChildInvoice>;
  /** Fetches port arrivals */
  portArrivals?: Maybe<PortArrival>;
  /** Fetches all ppecb_activity_points for the user */
  ppecbActivityPoints?: Maybe<Array<PpecbActivityPoint>>;
  /** Fetches all ppecb_container_types for the user */
  ppecbContainerTypes?: Maybe<Array<PpecbContainerType>>;
  /** Fetches all ppecb_countries for the user */
  ppecbCountries?: Maybe<Array<PpecbCountry>>;
  /** Fetches ppecb_exporter belonging to the shipment */
  ppecbExporterByShipment?: Maybe<PpecbExporter>;
  /** Fetches all ppecb_ports for the user */
  ppecbPorts?: Maybe<Array<PpecbPort>>;
  /** Fetches all ppecb_products for the user */
  ppecbProducts?: Maybe<Array<PpecbProduct>>;
  /** Fetches all ppecb_regime_codes for the user */
  ppecbRegimeCodes?: Maybe<Array<PpecbRegimeCode>>;
  /** Fetches ppecb_user belonging to the shipment */
  ppecbUserByShipment?: Maybe<PpecbUser>;
  /** Fetches ppecb_user data for a specific User */
  ppecbUserByUserId?: Maybe<PpecbUser>;
  /** Fetches all ppecb_users for the user */
  ppecbUsers?: Maybe<Array<PpecbUser>>;
  /** Fetches all ppecb_vents for the user */
  ppecbVents?: Maybe<Array<PpecbVent>>;
  /** Fetches all ppecb_voyage_numbers for the user */
  ppecbVoyageNumbers?: Maybe<Array<PpecbVoyageNumber>>;
  /** Fetches all ppecb_world_ports for the user */
  ppecbWorldPorts?: Maybe<Array<PpecbWorldPort>>;
  /** Gets all prodcution regions */
  productionRegions?: Maybe<Array<ProductionRegion>>;
  /** Filter options for P&L report dropdowns */
  profitAndLossFilterAttributes?: Maybe<ProfitAndLossFilterAttributes>;
  /** P&L report with dynamic FX conversion to reporting currency */
  profitAndLossReport?: Maybe<ProfitAndLossReport>;
  /** Poll async P&L report generation outcome by request id (correlates with queueProfitAndLossReport) */
  profitAndLossReportOutcome: ProfitAndLossReportOutcomeUnion;
  /** Quantity types for line items */
  quantityType?: Maybe<Quantity>;
  /** Gets recent root offers for the current user */
  recentRootOffers?: Maybe<Array<Offer>>;
  /** Fetches the report configuration */
  report?: Maybe<Report>;
  /** Fetches the report group for the user */
  reportGroup?: Maybe<ReportGroup>;
  /** Fetches a single report group cycle by ID */
  reportGroupCycle?: Maybe<ReportGroupCycle>;
  /** Gets report groups based on search and filter criteria */
  reportGroups?: Maybe<Array<ReportGroup>>;
  /** Runs the report for the user for a given report */
  runReport?: Maybe<Scalars['Json']['output']>;
  /** Runs the report for the user for a given report */
  runReportAsync?: Maybe<Scalars['Json']['output']>;
  /** Fetches a particular sea port based on its id */
  seaPort?: Maybe<SeaPort>;
  /** Fetches sea ports */
  seaPorts?: Maybe<Array<SeaPort>>;
  /** Fetches sea ports based on search and filter criteria */
  seaPortsV2?: Maybe<Array<SeaPort>>;
  /** Fetches all company users that have ppecb user credentials */
  seaShipmentControllers?: Maybe<Array<User>>;
  /** Fetches the specific shipment */
  shipment?: Maybe<Shipment>;
  /** Fetches Addendums on a shipment */
  shipmentBookingReferences?: Maybe<Array<Scalars['String']['output']>>;
  /** Fetches the specific shipment */
  shipmentLineItemById?: Maybe<ShipmentLineItem>;
  /** Fetches attributes for Shipment Line Item Filters */
  shipmentLineItemFilterAttributes?: Maybe<ShipmentLineItemFilterAttribute>;
  /** Fetches shipment_line_item_groupings for a specific shipment */
  shipmentLineItemGroupingsByShipment?: Maybe<Array<ShipmentLineItemGrouping>>;
  /** Fetches shipment_line_items based on applied filters */
  shipmentLineItems?: Maybe<ShipmentLineItemConnection>;
  /** Fetches shipment_line_items for a specific shipment */
  shipmentLineItemsByShipment?: Maybe<Array<ShipmentLineItem>>;
  /** Fetches shipment_line_items for a specific shipment_line_item_grouping */
  shipmentLineItemsBySlig?: Maybe<Array<ShipmentLineItem>>;
  /** Fetches shipments and shipment line items */
  shipmentsAndShipmentLineItems?: Maybe<ShipmentsAndShipmentLineItems>;
  /** Fetches shipments a set of shipment line items can be moved to */
  shipmentsToChooseFrom?: Maybe<Array<Shipment>>;
  /** Fetches attributes shipped stock can be filtered on */
  shippedStockFilterAttributes?: Maybe<StockFilterAttributes>;
  /** Fetches all Shipment Line Item Break Bulks */
  sliBreakBulks?: Maybe<Array<SliBreakBulk>>;
  /** Fetches all Shipment Line Item Containers */
  sliContainers?: Maybe<Array<SliContainer>>;
  /** Fetches SLI Container based on booking ref */
  sliContainersByBookingReference?: Maybe<Array<SliContainer>>;
  /** Fetches the carton groupings for the company. */
  stockAtLocation?: Maybe<StockModuleData>;
  /** Returns the stock errors for the company. */
  stockErrors?: Maybe<Array<StockDiscrepancies>>;
  /** Fetches attributes that stock can be filtered on */
  stockFilterAttributes?: Maybe<StockFilterAttributes>;
  /** Fetches carton groupings on a particular vessel */
  stockOnVessel?: Maybe<ShippedStockModuleData>;
  /** Fetches stuff locations */
  stuffLocations?: Maybe<Array<FoodBusinessOperator>>;
  /** Gets supplier-exporter associations and pending client change requests for the current company */
  supplierExporters?: Maybe<SupplierExporters>;
  /** get the iframe url for the target market split chart for the current user */
  targetMarketSplitChartUrl?: Maybe<Scalars['String']['output']>;
  /** Fetch all tasks for a given ShipmentLineItem */
  tasksByShipmentLineItem: Array<TaskableTask>;
  /** Fetches template output files by template_output id */
  templateOutputFiles?: Maybe<TemplateOutput>;
  /** Fetch template output files based on the data source type and data source id */
  templateOutputFilesBySource?: Maybe<Array<TemplateOutput>>;
  /** Fetches all Terminals */
  terminals?: Maybe<Array<Terminal>>;
  /** gets all trade countries */
  tradeCountries?: Maybe<Array<TradeCountry>>;
  /** Gets all company associations */
  tradePartners?: Maybe<Array<Company>>;
  /** gets all trade regions */
  tradeRegions?: Maybe<Array<TradeRegion>>;
  /** Fetches all transnet accounts for the current user */
  transnetAccounts?: Maybe<Array<TransnetAccount>>;
  /** Fetches all Transnet Terminals */
  transnetTerminals?: Maybe<Array<TransnetTerminal>>;
  /** Fetches trucking onload points */
  truckingLoadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches trucking offload points */
  truckingOffloadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches a UI config data available to the user */
  uiConfig?: Maybe<UiConfig>;
  /** Fetches all remote UI config data available to the user */
  uiConfigs?: Maybe<Array<UiConfig>>;
  /** Fetches all unallocated air freight shipment line items */
  unallocatedAirFreightShipmentLineItems?: Maybe<AirFreightShipmentLineItemConnection>;
  /** Gets the count of unread channel notifications for the current user */
  unreadChannelNotificationsCount?: Maybe<Scalars['Int']['output']>;
  /** All the stock files uploaded by the user */
  uploadedStockFiles?: Maybe<Array<DocumentProcessingProgress>>;
  /** get a list of all signed in user UserFeedItem paging */
  userFeedConnection: UserFeedItemConnection;
  /** get the amount of unseen user feed items */
  userFeedUnseenCount: Scalars['Int']['output'];
  /** Get all varieties */
  varieties?: Maybe<Array<Variety>>;
  /** All configured VAT Types */
  vatTypes?: Maybe<Array<VatType>>;
  /** Fetches vessels */
  vessels?: Maybe<Array<Vessel>>;
  /** Returns voyages for a certain vessel and potentially a port of departure */
  voyages?: Maybe<Array<Scalars['String']['output']>>;
};


/** root query */
export type QueryAccountStatementArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryAccountingExportArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryAddendumHeaderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryAddendumLineItemsByHeaderIdArgs = {
  addendumHeaderId: Scalars['Int']['input'];
};


/** root query */
export type QueryAddendumsOnAirFreightShipmentArgs = {
  airFreightShipmentId: Scalars['Int']['input'];
};


/** root query */
export type QueryAddendumsOnShipmentArgs = {
  shipmentId: Scalars['Int']['input'];
};


/** root query */
export type QueryAdditionalFieldsArgs = {
  companyIds: Array<Scalars['Int']['input']>;
};


/** root query */
export type QueryAg1TableOutputFileResultArgs = {
  requestId: Scalars['String']['input'];
};


/** root query */
export type QueryAirFreightShipmentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryAirFreightShipmentLineItemsByShipmentArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryAirFreightShipmentLoisArgs = {
  airFreightShipmentId: Scalars['ID']['input'];
};


/** root query */
export type QueryAirFreightShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: AirFreightShipmentsFilter;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryBreakBulkContainersForArrivalQcArgs = {
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCargoDuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<CargoDuesFilterAttributes>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCartonConversionsArgs = {
  filterAttributes?: InputMaybe<CartonConversionFilters>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCartonGroupingAuditsArgs = {
  cartonGroupingId: Scalars['ID']['input'];
};


/** root query */
export type QueryCartonGroupingsForLineItemArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryCartonGroupingsForWeekArgs = {
  week: Scalars['String']['input'];
};


/** root query */
export type QueryCartonGroupingsSearchArgs = {
  attributes: CartonGroupingSearchAttributes;
};


/** root query */
export type QueryCartonTypesByCommodityArgs = {
  commodityId: Scalars['ID']['input'];
};


/** root query */
export type QueryCertificateTransportInstructionArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryCgErrorsArgs = {
  filterAttributes?: InputMaybe<CgErrorFilters>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryChannelNotificationByIdArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryChannelNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<ChannelNotificationFilterAttributes>;
};


/** root query */
export type QueryChannelNotificationsCountArgs = {
  severity?: InputMaybe<NotificationRuleSeverityEnum>;
};


/** root query */
export type QueryCheckTranslationUpdatesArgs = {
  locale: Scalars['String']['input'];
  updatedAt: Scalars['String']['input'];
};


/** root query */
export type QueryClaimsArgs = {
  claimLineItemGroupingId?: InputMaybe<Scalars['ID']['input']>;
  containerClaimId?: InputMaybe<Scalars['ID']['input']>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
  tab: ArrivalQcTabEnum;
};


/** root query */
export type QueryCommercialTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<CommercialTermFilterAttributes>;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCommoditiesArgs = {
  onlyOperational?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryCompanyPaymentsArgs = {
  filterAttributes?: InputMaybe<CompanyPaymentFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryContainersArgs = {
  containernumber?: InputMaybe<Scalars['String']['input']>;
  eventsafter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  excludesassignedinvlis?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlytrackingenabled?: InputMaybe<Scalars['Boolean']['input']>;
  originportid?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QueryContainersForArrivalQcArgs = {
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryContainersForFinanceRuleArgs = {
  financeRuleId: Scalars['ID']['input'];
};


/** root query */
export type QueryCostInvoiceLineItemsArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryCounterOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: OfferFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCurrencyConversionArgs = {
  currencyConversionAttributes: CurrencyConversionAttributes;
};


/** root query */
export type QueryCurrencyConversionByIdArgs = {
  currencyConversionId: Scalars['ID']['input'];
};


/** root query */
export type QueryCurrencyExchangeRateArgs = {
  exchangeableId: Scalars['ID']['input'];
  exchangeableType: Scalars['String']['input'];
};


/** root query */
export type QueryCurrentMapPointsForOrderArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryCustomFieldsArgs = {
  excludedCustomFieldIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** root query */
export type QueryDashboardSearchArgs = {
  commodityGroups?: InputMaybe<Array<CommodityGroupEnum>>;
  fields?: InputMaybe<Array<DashboardSearchFieldsEnum>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** root query */
export type QueryDashboardTrackingDataArgs = {
  commoditygroups?: InputMaybe<Array<CommodityGroupEnum>>;
  containerId?: InputMaybe<Scalars['Int']['input']>;
  forExport?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QueryDataPreparationArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryDefaultCostArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryDefaultCostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<DefaultCostFilters>;
};


/** root query */
export type QueryDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryDocumentRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  documentId: Scalars['Int']['input'];
  states?: InputMaybe<Array<EtlDocumentRowStateEnum>>;
};


/** root query */
export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  dateAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dateBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  states?: InputMaybe<Array<EtlDocumentStateEnum>>;
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryEphytoByIdArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryEphytoCertificateUrlArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryEphytoLocationsArgs = {
  countryCodes: Array<Scalars['String']['input']>;
};


/** root query */
export type QueryEphytoPortOfEntriesArgs = {
  countryCodes: Array<Scalars['String']['input']>;
};


/** root query */
export type QueryEphytosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: EphytoFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryEstimatesArgs = {
  endWeek?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Scalars['Boolean']['input']>;
  commodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subCommodityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  varietyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  onlyEditableEstimates?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryEvaluateShipmentImpactArgs = {
  loiAttributes: LoadOutAttributes;
  sliId: Scalars['ID']['input'];
};


/** root query */
export type QueryExportersArgs = {
  companyname?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderbyloi?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryFboOrchardsArgs = {
  includeSellers?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryFetchCgCommercialTermArgs = {
  cgId: Scalars['ID']['input'];
};


/** root query */
export type QueryFetchReportResultArgs = {
  requestUuid: Scalars['String']['input'];
};


/** root query */
export type QueryFinanceReportArgs = {
  attributes: FinanceReportFilterAttributes;
};


/** root query */
export type QueryFinanceRuleArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryFinanceRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<FinanceRuleFilters>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
};


/** root query */
export type QueryFoodBusinessOperatorsArgs = {
  businessTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeSellers?: InputMaybe<Scalars['Boolean']['input']>;
  includeThirdPartyPackhouses?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryFoodBusinessOperatorsByTypeArgs = {
  typeOfBusiness: Scalars['Int']['input'];
};


/** root query */
export type QueryHistoricalMarketVolumesArgs = {
  companyId: Scalars['ID']['input'];
  commodityId: Scalars['ID']['input'];
  regionCode: Scalars['String']['input'];
};


/** root query */
export type QueryIncomeInvoiceLineItemsArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryInvoiceArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryInvoiceCartonGroupingTransactionsArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryInvoiceNumberArgs = {
  documenttype?: InputMaybe<Scalars['String']['input']>;
};


/** root query */
export type QueryInvoiceScrollTradeCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** root query */
export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: InvoicesFilters;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
  page: Scalars['String']['input'];
};


/** root query */
export type QueryInvoicesFilterAttributesArgs = {
  page: Scalars['String']['input'];
};


/** root query */
export type QueryLineItemArgs = {
  lineItemId: Scalars['ID']['input'];
};


/** root query */
export type QueryLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: LineItemFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryLoadOutInstructionArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryLoadOutInstructionCgsArgs = {
  attributes: CartonGroupingSearchAttributes;
};


/** root query */
export type QueryLoadOutInstructionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<LoadOutInstructionsFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryMasterfileConfigsArgs = {
  filterAttributes?: InputMaybe<MasterfileConfigFilterAttributes>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryMasterfileFarmVarietiesArgs = {
  filterAttributes?: InputMaybe<FarmVarietyFilters>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: InputMaybe<SearchAttributes>;
};


/** root query */
export type QueryMasterfileFoodBusinessOperatorsArgs = {
  filterAttributes?: InputMaybe<FoodBusinessOperatorFilters>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: InputMaybe<SearchAttributes>;
};


/** root query */
export type QueryMetabaseReportArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryMetabaseReportsArgs = {
  filters: MetabaseReportFilters;
  searchField: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
};


/** root query */
export type QueryNestedAirFreightShipmentLineItemsArgs = {
  airFreightShipmentId: Scalars['ID']['input'];
};


/** root query */
export type QueryNetReturnAdditionalFieldsArgs = {
  packingWeek: Scalars['String']['input'];
};


/** root query */
export type QueryNetReturnStandardFieldsArgs = {
  packingWeek: Scalars['String']['input'];
};


/** root query */
export type QueryNonAddendumShipmentLineItemsArgs = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['Int']['input'];
};


/** root query */
export type QueryNonEphytoShipmentLineItemsArgs = {
  shipmentId: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


/** root query */
export type QueryNotificationRulesArgs = {
  notificationSlugs?: InputMaybe<Array<NotificationSlugEnum>>;
};


/** root query */
export type QueryOfferByIdArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryOfferHistoryByIdArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: OfferFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryOnepackPackInstructionSyncCallsArgs = {
  clientCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QueryOrchardSeasonsArgs = {
  season: Scalars['Int']['input'];
};


/** root query */
export type QueryOrchardYieldsArgs = {
  capturedAfter: Scalars['ISO8601DateTime']['input'];
  capturedBefore: Scalars['ISO8601DateTime']['input'];
  orchardSeasonId?: InputMaybe<Scalars['ID']['input']>;
};


/** root query */
export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryOrderProgramsArgs = {
  orderProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAttributes: OrderProgramFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryOrdersSearchArgs = {
  filter?: InputMaybe<OrderFilter>;
};


/** root query */
export type QueryOrdersV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: OrderFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryPackInstructionsArgs = {
  attributes: PackInstructionsAttributes;
};


/** root query */
export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<PaymentsFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryPnlLinkedRecordsArgs = {
  cartonGroupingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  containerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  breakBulkContainerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
  fxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryPopulateInvoiceContainerDataArgs = {
  cgIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  commercialTermId?: InputMaybe<Scalars['Int']['input']>;
  containerId: Scalars['Int']['input'];
  invoiceType: Scalars['String']['input'];
  selectedCurrency: Scalars['String']['input'];
};


/** root query */
export type QueryPopulateInvoiceFromParentArgs = {
  documentType: Scalars['String']['input'];
  parentInvoiceId: Scalars['Int']['input'];
};


/** root query */
export type QueryPpecbExporterByShipmentArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryPpecbUserByShipmentArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryPpecbUserByUserIdArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryProfitAndLossReportArgs = {
  filters: ProfitAndLossFilters;
};


/** root query */
export type QueryProfitAndLossReportOutcomeArgs = {
  requestId: Scalars['String']['input'];
};


/** root query */
export type QueryReportArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryReportGroupArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryReportGroupCycleArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryReportGroupsArgs = {
  filterAttributes: ReportGroupFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryRunReportArgs = {
  gridRequest?: InputMaybe<GridRequest>;
  id: Scalars['Int']['input'];
  outputType?: InputMaybe<RunReportOutputTypeEnum>;
  reportFilters?: InputMaybe<Array<Filter>>;
};


/** root query */
export type QueryRunReportAsyncArgs = {
  id: Scalars['Int']['input'];
  requestUuid: Scalars['String']['input'];
  gridRequest?: InputMaybe<GridRequest>;
  reportFilters?: InputMaybe<Array<Filter>>;
};


/** root query */
export type QuerySeaPortArgs = {
  seaPortId: Scalars['ID']['input'];
};


/** root query */
export type QuerySeaPortsArgs = {
  isportofloading?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderbyinv?: InputMaybe<Scalars['Boolean']['input']>;
  orderbyloi?: InputMaybe<Scalars['Boolean']['input']>;
  seaportname?: InputMaybe<Scalars['String']['input']>;
  stufflocationid?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QuerySeaPortsV2Args = {
  filterAttributes: SeaPortFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryShipmentArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryShipmentBookingReferencesArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryShipmentLineItemByIdArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryShipmentLineItemGroupingsByShipmentArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryShipmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes: ShipmentLineItemFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryShipmentLineItemsByShipmentArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryShipmentLineItemsBySligArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryShipmentsAndShipmentLineItemsArgs = {
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  filterAttributes?: InputMaybe<ShipmentLineItemFilterAttributes>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryShipmentsToChooseFromArgs = {
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QuerySliContainersByBookingReferenceArgs = {
  bookingReference: Scalars['String']['input'];
};


/** root query */
export type QueryStockAtLocationArgs = {
  filterAttributes?: InputMaybe<StockFilterInputAttributes>;
  millerAttributes?: InputMaybe<MillerCollapsibleInLocationInput>;
  orderAttributes?: InputMaybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: InputMaybe<SearchAttributes>;
};


/** root query */
export type QueryStockOnVesselArgs = {
  filterAttributes?: InputMaybe<StockFilterInputAttributes>;
  orderAttributes?: InputMaybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QueryStuffLocationsArgs = {
  fboname?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderbyloi?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QuerySupplierExportersArgs = {
  filterAttributes?: InputMaybe<SupplierExporterFilterAttributes>;
  searchAttributes?: InputMaybe<SearchAttributes>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryTasksByShipmentLineItemArgs = {
  sliId: Scalars['Int']['input'];
};


/** root query */
export type QueryTemplateOutputFilesArgs = {
  id: Scalars['Int']['input'];
};


/** root query */
export type QueryTemplateOutputFilesBySourceArgs = {
  dataSourceId: Scalars['Int']['input'];
  dataSourceType: Scalars['String']['input'];
};


/** root query */
export type QueryTradeCountriesArgs = {
  tradeRegionId?: InputMaybe<Scalars['ID']['input']>;
};


/** root query */
export type QueryTradePartnersArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryTruckingLoadingPointsArgs = {
  fboName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderByLoi?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryTruckingOffloadingPointsArgs = {
  fboName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderByLoi?: InputMaybe<Scalars['Boolean']['input']>;
};


/** root query */
export type QueryUiConfigArgs = {
  id: Scalars['ID']['input'];
};


/** root query */
export type QueryUiConfigsArgs = {
  configType?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<UiConfigVisibilityEnum>;
};


/** root query */
export type QueryUnallocatedAirFreightShipmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderByFields?: InputMaybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryUnreadChannelNotificationsCountArgs = {
  severity?: InputMaybe<NotificationRuleSeverityEnum>;
};


/** root query */
export type QueryUserFeedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** root query */
export type QueryVarietiesArgs = {
  onlyOperational?: InputMaybe<Scalars['Boolean']['input']>;
  skipMixedVarieties?: InputMaybe<Scalars['Boolean']['input']>;
  commodityId?: InputMaybe<Scalars['ID']['input']>;
};


/** root query */
export type QueryVesselsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  seaportid?: InputMaybe<Scalars['Int']['input']>;
  vesselname?: InputMaybe<Scalars['String']['input']>;
};


/** root query */
export type QueryVoyagesArgs = {
  seaportid?: InputMaybe<Scalars['Int']['input']>;
  vesselid: Scalars['Int']['input'];
};

/** Autogenerated return type of QueryAddendum. */
export type QueryAddendumPayload = {
  __typename?: 'QueryAddendumPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of QueueReportGroupOutputFile. */
export type QueueReportGroupOutputFilePayload = {
  __typename?: 'QueueReportGroupOutputFilePayload';
  errors: Array<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type QuickCostAttributes = {
  /** Carton Groupings Linked to the Cost Captured */
  cartonGroupingIds: Array<Scalars['ID']['input']>;
  /** Cost Type associated with the quick cost capture */
  costCodeId: Scalars['ID']['input'];
  /** Invoice Reference related to the quick cost captured */
  reference: Scalars['String']['input'];
  /** Currency related to the quick cost captured */
  currency: Scalars['String']['input'];
  /** Exchange Currency related to the quick cost captured */
  exchangeCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Exchange Rate related to the quick cost captured */
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  /** The date associated to the invoice */
  invoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Amount related to the quick cost captured */
  amount: Scalars['Float']['input'];
  /** Quantity Unit related to the quick cost captured */
  priceUnit: Scalars['String']['input'];
  /** The associated VAT Type on the cost */
  vatTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** The IDs of the contacts associated with the invoice */
  invoicePartyId: Scalars['Int']['input'];
};

/** Autogenerated return type of ReassignShipmentLineItemGrouping. */
export type ReassignShipmentLineItemGroupingPayload = {
  __typename?: 'ReassignShipmentLineItemGroupingPayload';
  errors?: Maybe<Scalars['String']['output']>;
};

/** A credit or debit note created during account sale reconciliation */
export type ReconciliationDocument = {
  __typename?: 'ReconciliationDocument';
  /** The document type (credit_note or debit_note) */
  documentType: Scalars['String']['output'];
  /** The document ID */
  id: Scalars['ID']['output'];
  /** The document invoice number */
  invoiceNumber: Scalars['String']['output'];
};

/** Autogenerated return type of RejectOfferAsSupplier. */
export type RejectOfferAsSupplierPayload = {
  __typename?: 'RejectOfferAsSupplierPayload';
  /** The counter offer that was rejected */
  counterOffer?: Maybe<Offer>;
  /** What went wrong when rejecting the counter offer */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of RemoveClaimLineItemGroupingDefect. */
export type RemoveClaimLineItemGroupingDefectPayload = {
  __typename?: 'RemoveClaimLineItemGroupingDefectPayload';
  /** Errors that occurred while updating the arrival QC grade of the claim line items */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveClaimLineItemGroupingExpectedClaim. */
export type RemoveClaimLineItemGroupingExpectedClaimPayload = {
  __typename?: 'RemoveClaimLineItemGroupingExpectedClaimPayload';
  /** Errors that occurred while removing the expected claim on a claim line item grouping */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveClaimLineItemPalletDefect. */
export type RemoveClaimLineItemPalletDefectPayload = {
  __typename?: 'RemoveClaimLineItemPalletDefectPayload';
  /** Errors that occurred while removing the defect from the claim line item */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveClaimLineItemPalletExpectedClaim. */
export type RemoveClaimLineItemPalletExpectedClaimPayload = {
  __typename?: 'RemoveClaimLineItemPalletExpectedClaimPayload';
  /** Errors that occurred while removing the expected claim from the claim line item */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Attributes for removing default costs */
export type RemoveDefaultCostAttributes = {
  /** The ID of the Finance Rule being used to remove the default costs */
  financeRuleId: Scalars['ID']['input'];
  /** Container Ids to remove */
  containerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Pallet numbers to remove */
  palletNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether we want to remove finalised costs or unfinalised costs */
  finalisedCosts: Scalars['Boolean']['input'];
};

/** Autogenerated return type of RemoveDefaultCosts. */
export type RemoveDefaultCostsPayload = {
  __typename?: 'RemoveDefaultCostsPayload';
  /** Removed CGT IDs associated with this finance rule */
  cgtIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Error information when attempting to remove default costs */
  errors?: Maybe<Scalars['String']['output']>;
};

/** A report */
export type Report = {
  __typename?: 'Report';
  /** configs associated with the report */
  configs?: Maybe<Array<Config>>;
  /** The date and time the report was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the data preparation used to generate the report */
  dataPreparationId?: Maybe<Scalars['Int']['output']>;
  /** A longer description of the report */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the report */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the report */
  name?: Maybe<Scalars['String']['output']>;
  /** How the report should be displayed: 'grid' or 'chart' */
  reportType?: Maybe<Scalars['String']['output']>;
  /** The date and time the report was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ReportGroup = {
  __typename?: 'ReportGroup';
  /** The badges associated with the report */
  badges?: Maybe<Array<Badge>>;
  /** configs associated with the report group */
  configs?: Maybe<Array<Config>>;
  /** report group created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** report group description */
  description?: Maybe<Scalars['String']['output']>;
  /** The domain of the report in the value chain (e.g. production, logistics etc.) */
  domain?: Maybe<ReportGroupDomainEnum>;
  /** report group unique identifier */
  id?: Maybe<Scalars['Int']['output']>;
  /** layout represents the structure of the reports appearing on the report group. If there is only one report in your report group, you would most likely just want the layout to be [[your_report_id]] */
  layout?: Maybe<Scalars['String']['output']>;
  /** report group name */
  name?: Maybe<Scalars['String']['output']>;
  /** report group cycle items associated with this report group, used for automated cycling between different report groups */
  reportGroupCycleItems?: Maybe<Array<ReportGroupCycleItem>>;
  /** reports associated with the report group */
  reports?: Maybe<Array<Report>>;
  /** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
  scope?: Maybe<ReportGroupScopeEnum>;
  /** switch_units associated with the report group */
  switchUnit?: Maybe<SwitchUnit>;
  /** report group updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ReportGroupAttributes = {
  /** The default filters of the new report group */
  defaultFilters?: InputMaybe<Scalars['String']['input']>;
  /** The description of the new report group */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The id of the reportGroup */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the new report group */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportGroupCycle = {
  __typename?: 'ReportGroupCycle';
  /** When the report group cycle was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The description of the report group cycle */
  description?: Maybe<Scalars['String']['output']>;
  /** How long to display each report group(in seconds) */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the report group cycle */
  id?: Maybe<Scalars['Int']['output']>;
  /** The items in this report group cycle */
  items?: Maybe<Array<ReportGroupCycleItem>>;
  /** The name of the report group cycle */
  name?: Maybe<Scalars['String']['output']>;
  /** When the report group cycle was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ReportGroupCycleItem = {
  __typename?: 'ReportGroupCycleItem';
  /** When the report group cycle item was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique identifier for the report group cycle item */
  id?: Maybe<Scalars['Int']['output']>;
  /** The order of this item in the cycle */
  order?: Maybe<Scalars['Int']['output']>;
  /** URL parameters for this report group in JSON format */
  params?: Maybe<Scalars['String']['output']>;
  /** The report group for this item */
  reportGroup?: Maybe<ReportGroup>;
  /** The report group cycle this item belongs to */
  reportGroupCycleId?: Maybe<Scalars['Int']['output']>;
  /** The report group ID for this item */
  reportGroupId?: Maybe<Scalars['Int']['output']>;
  /** When the report group cycle item was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The domain of the report in the value chain (e.g. production, logistics etc.) */
export enum ReportGroupDomainEnum {
  GlobalMarket = 'global_market',
  Production = 'production',
  MarketingAndSales = 'marketing_and_sales',
  Logistics = 'logistics',
  Claims = 'claims'
}

/** Attributes to filter report groups by */
export type ReportGroupFilterAttributes = {
  /** The badges to filter on */
  badgeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The domains to filter on */
  domains?: InputMaybe<Array<ReportGroupDomainEnum>>;
  /** The scopes to filter on */
  scopes?: InputMaybe<Array<ReportGroupScopeEnum>>;
};

/** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
export enum ReportGroupScopeEnum {
  Predictive = 'predictive',
  Operational = 'operational',
  Retrospective = 'retrospective'
}

export type ReportOutputFileStatus = {
  __typename?: 'ReportOutputFileStatus';
  error?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Autogenerated return type of ResendInvite. */
export type ResendInvitePayload = {
  __typename?: 'ResendInvitePayload';
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of ResolveCgError. */
export type ResolveCgErrorPayload = {
  __typename?: 'ResolveCgErrorPayload';
  /** The Cg Error being resolved */
  cgError: CgError;
  /** Errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type Result = {
  __typename?: 'Result';
  /** DateTime when phytclean result will expire */
  dataExpirationDatetime: Scalars['ISO8601DateTime']['output'];
  /** Port of load unlocode */
  port?: Maybe<Scalars['String']['output']>;
  /** Temperature setting for loi */
  regimeCode?: Maybe<Scalars['String']['output']>;
  /** DateTime when loi was submitted to phytclean */
  reportDatetime: Scalars['ISO8601DateTime']['output'];
  /** Verification key for result */
  verificationKey: Scalars['String']['output'];
};

/** Autogenerated return type of RevertLineItemsToCreated. */
export type RevertLineItemsToCreatedPayload = {
  __typename?: 'RevertLineItemsToCreatedPayload';
  orders?: Maybe<Array<Order>>;
};

/** Autogenerated return type of RevertOrderChange. */
export type RevertOrderChangePayload = {
  __typename?: 'RevertOrderChangePayload';
  errors?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of RevokeInvite. */
export type RevokeInvitePayload = {
  __typename?: 'RevokeInvitePayload';
  id?: Maybe<Scalars['Int']['output']>;
};

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['Int']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum RunReportOutputTypeEnum {
  /** report output will be JSON */
  Json = 'json',
  /** report output will be a string to a URL for a PDF */
  Pdf = 'pdf',
  /** report output will be a string to a URL for a xls */
  Xls = 'xls'
}

export type SeaPort = {
  __typename?: 'SeaPort';
  /** The country code where the sea port is located */
  country?: Maybe<Scalars['String']['output']>;
  /** The date and time when the sea port record was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The display name of the sea port */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the sea port */
  id?: Maybe<Scalars['Int']['output']>;
  /** The latitude coordinate of the sea port's location */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the sea port's location */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The name of the sea port */
  name?: Maybe<Scalars['String']['output']>;
  /** The UN/LOCODE identifier for the sea port */
  unLocode?: Maybe<Scalars['String']['output']>;
  /** The date and time when the sea port record was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Attributes to search on sea ports */
export type SeaPortFilterAttributes = {
  /** The ids of the sea ports to filter on */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the sea port eg. "Durban" */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the sea port eg. "ZA" */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The region code of the sea port eg. "ASA" */
  regionCode?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes to search on */
export type SearchAttributes = {
  /** term you want to search for */
  searchTerm: Scalars['String']['input'];
  /** field you want to search on */
  searchField: Scalars['String']['input'];
};

export type SendEmailAttributes = {
  /** Body of the email */
  body: Scalars['String']['input'];
  /** IDs of the records within abovementioned model */
  docIds: Array<Scalars['Int']['input']>;
  /** Comma-seperated list of types of documents to send e.g. "PDF","Excel" */
  docTypes: Array<Scalars['String']['input']>;
  /** The templatable model from which documents should be retrieved and sent */
  model: Scalars['String']['input'];
  /** Comma-seperated list of recipient email address */
  recipientEmailAddresses: Array<Scalars['String']['input']>;
  /** Subject of the email */
  subject: Scalars['String']['input'];
};

/** Autogenerated return type of SendEmail. */
export type SendEmailPayload = {
  __typename?: 'SendEmailPayload';
  /** Any errors that occured during processing */
  errors?: Maybe<Scalars['String']['output']>;
  /** Return Message */
  message: Scalars['String']['output'];
};

export type SentEmail = {
  __typename?: 'SentEmail';
  attachments?: Maybe<Scalars['JSON']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  /** DateTime when the email was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Record ID */
  id: Scalars['ID']['output'];
  /** Email address of the receiver */
  recipient?: Maybe<Scalars['String']['output']>;
  /** Email address of the sender */
  sender?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Subject of the email */
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Shipment = {
  __typename?: 'Shipment';
  /** The actual time of arrival for the shipment */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The actual time of departure for the shipment */
  actualTimeOfDeparture?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The party responsible for paying the bill */
  billToParty?: Maybe<Scalars['String']['output']>;
  /** The CF code for the shipment */
  cfCode?: Maybe<Scalars['String']['output']>;
  /** The client for the shipment */
  client?: Maybe<Scalars['String']['output']>;
  /** Any additional comments related to the shipment */
  comments?: Maybe<Scalars['String']['output']>;
  /** Company associated with this Shipment */
  company?: Maybe<Company>;
  /** Controller (PPECB Registered User/Company User) of the shipment */
  controller?: Maybe<Scalars['String']['output']>;
  /** The date and time when the shipment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date when the shipment was created */
  dateCreated?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601Date']['output']>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: Maybe<Scalars['String']['output']>;
  /** The code for the exporter */
  exporterCode?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the shipment */
  id: Scalars['ID']['output'];
  /** The port where the shipment is loaded */
  loadPort?: Maybe<Scalars['String']['output']>;
  /** The phone number associated with the shipment */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The port where the shipment is loaded */
  portOfLoading?: Maybe<SeaPort>;
  /** The PPECB booking reference number */
  ppecbBookingReference?: Maybe<Scalars['Int']['output']>;
  /** The PPECB registered code for the agent */
  ppecbRegisteredAgentCode?: Maybe<Scalars['String']['output']>;
  /** The PPECB registered code for the exporter */
  ppecbRegisteredExporterCode?: Maybe<Scalars['String']['output']>;
  /** The voyage number provided by PPECB */
  ppecbVoyageNumber?: Maybe<Scalars['String']['output']>;
  /** List of line items for the shipment */
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
  /** Type of the shipment (e.g., OCEAN, ROAD, AIR) */
  shipmentType?: Maybe<ShipmentTypeEnum>;
  /** The party who is shipping the goods */
  shipper?: Maybe<Scalars['String']['output']>;
  /** The shipping line for the shipment */
  shippingLine?: Maybe<Scalars['String']['output']>;
  /** The voyage number provided by the shipping line */
  shippingLineVoyageNumber?: Maybe<Scalars['String']['output']>;
  /** The dates when the shipments stacks open */
  stackDates?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The dates when the shipments stacks close */
  stackDatesClose?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The status of the shipments stacks close */
  stackDatesCloseStatus?: Maybe<Scalars['String']['output']>;
  /** The status of the shipments stacks open */
  stackDatesOpenStatus?: Maybe<Scalars['String']['output']>;
  /** The current state of the shipment */
  state?: Maybe<Scalars['String']['output']>;
  /** The current status of the shipment */
  status?: Maybe<Scalars['String']['output']>;
  /** Object containing information on the document generated for this shipment */
  templateOutput?: Maybe<TemplateOutput>;
  /** The terminal associated with the shipment */
  terminal?: Maybe<Terminal>;
  /** The trucks unique identifier */
  truckReference?: Maybe<Scalars['String']['output']>;
  /** The date and time when the shipment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The username of the person who created the shipment */
  userName?: Maybe<Scalars['String']['output']>;
  /** The code of the vessel carrying the shipment */
  vesselCode?: Maybe<Scalars['String']['output']>;
  /** The name of the vessel carrying the shipment */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** The original estimated date of departure for the vessel */
  vesselOriginalEstimatedDateOfDeparture?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The voyage number for the shipment */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export type ShipmentAttributes = {
  /** Unique ID associated with Shipment */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Booking Reference provided by PPECB */
  ppecbBookingReference?: InputMaybe<Scalars['String']['input']>;
  /** Shipping line transporting goods */
  shippingLine?: InputMaybe<Scalars['String']['input']>;
  /** Indentifier for the voyage */
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Combination of Shipping line and voyage nr */
  shippingLineVoyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Port where goods are loaded */
  loadPort?: InputMaybe<Scalars['String']['input']>;
  /** Registered code of the party that will be billed */
  billToParty?: InputMaybe<Scalars['String']['input']>;
  /** Registered Exporter Code */
  exporterCode?: InputMaybe<Scalars['String']['input']>;
  /** Agent FBO Code */
  cfCode?: InputMaybe<Scalars['String']['input']>;
  /** PPECB registered Exporter Code */
  ppecbRegisteredExporterCode?: InputMaybe<Scalars['String']['input']>;
  /** PPECB registered Agent Code */
  ppecbRegisteredAgentCode?: InputMaybe<Scalars['String']['input']>;
  /** Contact details for agent */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** PPECB registered user name */
  userName?: InputMaybe<Scalars['String']['input']>;
  /** Date of booking creation */
  dateCreated?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Vessel planned departure date */
  vesselOriginalEstimatedDateOfDeparture?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Planned opening stack dates */
  stackDates?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Planned closing stack dates */
  stackDatesClose?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Name of the shipper */
  shipper?: InputMaybe<Scalars['String']['input']>;
  /** Status of the booking */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Name of the vessel */
  vesselName?: InputMaybe<Scalars['String']['input']>;
  /** Code to identify the vessel */
  vesselCode?: InputMaybe<Scalars['String']['input']>;
  /** PPECB registered voyage number */
  ppecbVoyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Controller (PPECB Registered User/Company User) of the shipment */
  controller?: InputMaybe<Scalars['String']['input']>;
  /** Client of the shipment */
  client?: InputMaybe<Scalars['String']['input']>;
  /** Port of loading ID (PPECB registered Port) of the shipment */
  portOfLoadingId?: InputMaybe<Scalars['Int']['input']>;
  /** Comments made on the shipment */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Terminal ID of the shipment */
  terminalId?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Actual time of departure for the shipment */
  actualTimeOfDeparture?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Actual time of arrival for the shipment */
  actualTimeOfArrival?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: InputMaybe<Scalars['String']['input']>;
  /** ID of the PPECB Exporter */
  ppecbExporterId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the PPECB User */
  ppecbUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Type of the shipment (e.g., OCEAN, ROAD, AIR) */
  shipmentType?: InputMaybe<Scalars['String']['input']>;
  /** Truck reference for road shipments */
  truckReference?: InputMaybe<Scalars['String']['input']>;
};

export type ShipmentDocument = {
  __typename?: 'ShipmentDocument';
  documentType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Document>;
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Represents the result of evaluating whether a shipment will be affected by updated LOI attributes. */
export type ShipmentImpact = {
  __typename?: 'ShipmentImpact';
  /** Client name for the new or affected shipment. */
  client?: Maybe<Scalars['String']['output']>;
  /** Name of the new or affected shipment’s port of loading. */
  portOfLoading?: Maybe<Scalars['String']['output']>;
  /** ID of the shipment that the SLI will be moved to, if applicable. */
  shipmentId?: Maybe<Scalars['ID']['output']>;
  /** Shipping line name for the new or affected shipment. */
  shippingLine?: Maybe<Scalars['String']['output']>;
  /** Name of the vessel for the new or affected shipment. */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** Voyage number of the new or affected shipment. */
  voyage?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the current SLI changes will affect the existing shipment. */
  willAffectShipment: Scalars['Boolean']['output'];
  /** True if the SLI must be moved to a new shipment instead of an existing one. */
  willCreateNewShipment: Scalars['Boolean']['output'];
};

export type ShipmentLineItem = {
  __typename?: 'ShipmentLineItem';
  /** Actual time of arrival for the shipment */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Actual time of departure for the shipment */
  actualTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Booking reference for the shipment */
  bookingReference?: Maybe<Scalars['String']['output']>;
  /** Break Bulk container name */
  breakBulkContainerNamesIn?: Maybe<Scalars['String']['output']>;
  /** The Cargo Due submitted for this SLI */
  cargoDue?: Maybe<CargoDue>;
  /** The Verified Gross Mass (VGM) of the cargo */
  cargoVgm?: Maybe<Scalars['String']['output']>;
  /** The certificate transport instruction generated for this shipment line item */
  certificateTransportInstruction?: Maybe<CertificateTransportInstruction>;
  /** The Checklist associated with this SLI */
  checklist?: Maybe<TaskableChecklist>;
  /** The reference number provided by the client */
  clientReference?: Maybe<Scalars['String']['output']>;
  /** The date when the shipment was collected */
  collectionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Any additional comments or details about the shipment */
  comments?: Maybe<Scalars['String']['output']>;
  /** The party to whom the shipment is consigned */
  consignee?: Maybe<Scalars['String']['output']>;
  /** The name of the group the SLI belongs to */
  consignmentGroupName?: Maybe<Scalars['String']['output']>;
  /** Unique indentifier for the goods being shipped */
  consignmentReference?: Maybe<Scalars['String']['output']>;
  /** The combined number of the container and its corresponding seal */
  containerAndSealNumber?: Maybe<Scalars['String']['output']>;
  /** The container number specific to the shipment line item */
  containerNumber?: Maybe<Scalars['String']['output']>;
  /** When the shipment line item was first created in the system */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Customer reference number or code */
  customerReference?: Maybe<Scalars['String']['output']>;
  /** When the shipment line item was created */
  dateCreated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The depot where the shipment is stored or prepared */
  depot?: Maybe<Scalars['String']['output']>;
  /** The number of documents belonging to the SLI */
  documentCount?: Maybe<Scalars['Int']['output']>;
  /** The depot where the empty containers are located */
  emptyDepot?: Maybe<FoodBusinessOperator>;
  /** Estimated date and time of delivery */
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated date and time of dispatch */
  estimatedDispatchDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The documents required for export */
  exportDocuments?: Maybe<Array<ExportDocument>>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: Maybe<Scalars['String']['output']>;
  /** Exporter as named on the certificate */
  exporterOnCertificate?: Maybe<Scalars['String']['output']>;
  /** Final country of destination for the shipment */
  finalCountryOfDestination?: Maybe<Scalars['String']['output']>;
  /**
   * Final port where the shipment will be discharged
   * @deprecated Use port_of_discharge instead
   */
  finalPortOfDischarge?: Maybe<Scalars['String']['output']>;
  /** PPECB fruit origin code (maps to FruitOriginCode in export notification) */
  fruitOriginCode?: Maybe<Scalars['String']['output']>;
  /** PPECB fruit origin name (maps to FruitOriginName in export notification) */
  fruitOriginName?: Maybe<Scalars['String']['output']>;
  /** Fumigation treatment indicator for export notification */
  fumigation?: Maybe<Scalars['String']['output']>;
  /** The gross weight of the shipment line item */
  grossWeight?: Maybe<Scalars['Float']['output']>;
  /** Whether this shipment line item has an associated load out instruction */
  hasLoadOutInstruction?: Maybe<Scalars['Boolean']['output']>;
  /** The type of haulage used for the shipment */
  haulageType?: Maybe<Scalars['String']['output']>;
  /** Humidity conditions within the shipping environment */
  humidity?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the shipment line item */
  id: Scalars['ID']['output'];
  /** Import permit number for the shipment */
  importPermitNumber?: Maybe<Scalars['String']['output']>;
  /** Boolean value indicating if the shipment requires cold treatment */
  isColdTreatment?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean value indicating if the shipment uses conventional shipping methods */
  isConventionalShipping?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean value indicating if a generator set is required */
  isGensetRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean value indicating if the shipment is a transhipment */
  isTranshipment?: Maybe<Scalars['Boolean']['output']>;
  /** Date and time the goods were loaded */
  loadDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The loading instruction number associated with the shipment */
  loadingInstructionNumber?: Maybe<Scalars['String']['output']>;
  /** The FBO where the goods are loaded */
  loadingPoint?: Maybe<FoodBusinessOperator>;
  /** The points at which the shipment will be loaded */
  loadingPoints?: Maybe<Array<LoadingPoint>>;
  /** Derived market section mapping from linked load out instruction */
  marketSectionAssignments?: Maybe<Scalars['JSON']['output']>;
  /** The net weight of the shipment line item */
  nettWeight?: Maybe<Scalars['Float']['output']>;
  /** The number of containers with the same shipping line reference */
  numberOfContainers?: Maybe<Scalars['Int']['output']>;
  /** The FBO where the goods are unloaded */
  offloadingPoint?: Maybe<FoodBusinessOperator>;
  /** Purchase order reference */
  orderReference?: Maybe<Scalars['String']['output']>;
  /** The number of pallets belonging to the SLI */
  palletCount?: Maybe<Scalars['Int']['output']>;
  /** The terms of payment agreed upon for the shipment */
  paymentTerms?: Maybe<Scalars['String']['output']>;
  /** The final destination port of the shipment */
  portOfDestination?: Maybe<SeaPort>;
  /** The name of the final destination port of the shipment */
  portOfDestinationName?: Maybe<Scalars['String']['output']>;
  /** The final discharge port of the shipment */
  portOfDischarge?: Maybe<SeaPort>;
  /** The name of the final discharge port of the shipment */
  portOfDischargeName?: Maybe<Scalars['String']['output']>;
  /** Name of the port of loading */
  portOfLoadingName?: Maybe<Scalars['String']['output']>;
  /** PPECB booking item reference number */
  ppecbBookingItemReference?: Maybe<Scalars['Int']['output']>;
  /** PPECB booking reference number */
  ppecbBookingReference?: Maybe<Scalars['Int']['output']>;
  /** The product codes associated with the shipment line item */
  productCodes?: Maybe<Scalars['String']['output']>;
  /** The agreed number of days as per the protocol for the shipment */
  protocolDays?: Maybe<Scalars['Int']['output']>;
  /** The agreed temperature as per the protocol for the shipment */
  protocolTemperature?: Maybe<Scalars['Float']['output']>;
  /** Whether radiation treatment applies for export notification */
  radiation?: Maybe<Scalars['Boolean']['output']>;
  /** The individual or company designated to receive the shipment */
  receiver?: Maybe<Scalars['String']['output']>;
  /** Regime code for the shipment */
  regimeCode?: Maybe<Scalars['String']['output']>;
  /** The seal number specific to the shipment line item */
  sealNumber?: Maybe<Scalars['String']['output']>;
  /** The number of the service contract for the shipment */
  serviceContractNumber?: Maybe<Scalars['String']['output']>;
  /** The overall shipment to which this line item belongs */
  shipment?: Maybe<Shipment>;
  /** The unique identifier of the overall shipment */
  shipmentId?: Maybe<Scalars['Int']['output']>;
  /** ID of the Shipment Line Item Grouping it belongs to */
  shipmentLineItemGroupingId?: Maybe<Scalars['ID']['output']>;
  /** The type of shipment (e.g., ocean, road, air) */
  shipmentType?: Maybe<ShipmentTypeEnum>;
  /** Contact number for the shipping line */
  shippingLineContactNumber?: Maybe<Scalars['String']['output']>;
  /** Shipping line reference number or code */
  shippingLineReference?: Maybe<Scalars['String']['output']>;
  /** The Break Bulk linked to the SLI */
  sliBreakBulk?: Maybe<SliBreakBulk>;
  /** The Container linked to the SLI */
  sliContainer?: Maybe<SliContainer>;
  /** Compliance status with the Safety of Life at Sea (SOLAS) convention */
  solas?: Maybe<Scalars['String']['output']>;
  /** Special instructions given for the shipment */
  specialInstruction?: Maybe<Scalars['String']['output']>;
  /** Stack dates */
  stackDates?: Maybe<Scalars['String']['output']>;
  /** Stack dates close for this shipment line item */
  stackDatesClose?: Maybe<Scalars['String']['output']>;
  /** The status of the shipments stacks close */
  stackDatesCloseStatus?: Maybe<Scalars['String']['output']>;
  /** The status of the shipments stacks open */
  stackDatesOpenStatus?: Maybe<Scalars['String']['output']>;
  /** The current state of the shipment line item */
  state?: Maybe<Scalars['String']['output']>;
  /** The current status of the shipment line item */
  status?: Maybe<Scalars['String']['output']>;
  /** Tare weight of the goods */
  tareWeight?: Maybe<Scalars['Float']['output']>;
  /** The state of task completion */
  taskCompletion?: Maybe<TaskCompletion>;
  /** The tasks related to this SLI */
  tasks?: Maybe<Array<TaskableTask>>;
  /** The device used to measure and control the temperature during the shipment */
  tempDevice?: Maybe<Scalars['String']['output']>;
  /** Temperature sensor used in the shipment */
  tempSensor?: Maybe<Scalars['String']['output']>;
  /** Total Cartons on this SLI */
  totalCartons?: Maybe<Scalars['Int']['output']>;
  /** Port used for transhipment */
  transhipmentPort?: Maybe<Scalars['String']['output']>;
  /** Name of the vessel used for transhipment */
  transhipmentVesselName?: Maybe<Scalars['String']['output']>;
  /** Voyage number for the transhipment */
  transhipmentVoyageNumber?: Maybe<Scalars['String']['output']>;
  /** The company or individual responsible for transporting the shipment */
  transporter?: Maybe<Scalars['String']['output']>;
  /** Treatment type code for export notification (maps to treatmentType) */
  treatmentType?: Maybe<Scalars['String']['output']>;
  /** The trucks unique identifier */
  truckReference?: Maybe<Scalars['String']['output']>;
  /** When the shipment line item was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the user who created or last modified the shipment */
  userName?: Maybe<Scalars['String']['output']>;
  /** The settings of the ventilation system within the shipment */
  ventSetting?: Maybe<Scalars['String']['output']>;
  /** The name of the vessel for this shipment */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** Information about the void plugs used in the shipment */
  voidPlugs?: Maybe<Scalars['String']['output']>;
  /** Voyage number associated with this shipment line item */
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export type ShipmentLineItemAttributes = {
  /** Unique identifier for the data entry */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference number for the PPECB booking */
  ppecbBookingReference?: InputMaybe<Scalars['Int']['input']>;
  /** Reference number for the PPECB booking item */
  ppecbBookingItemReference?: InputMaybe<Scalars['Int']['input']>;
  /** Reference string for the shipping line */
  shippingLineReference?: InputMaybe<Scalars['String']['input']>;
  /** Reference string for the customer */
  customerReference?: InputMaybe<Scalars['String']['input']>;
  /** Code that represents the trade regime */
  regimeCode?: InputMaybe<Scalars['String']['input']>;
  /** Country where the shipment is destined */
  finalCountryOfDestination?: InputMaybe<Scalars['String']['input']>;
  /** Number for the import permit */
  importPermitNumber?: InputMaybe<Scalars['String']['input']>;
  /** Exporter's name on the certificate */
  exporterOnCertificate?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if a generator set is required */
  isGensetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if shipment is a transhipment */
  isTranshipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if cold treatment is needed for shipment */
  isColdTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the vessel used for transhipment */
  transhipmentVesselName?: InputMaybe<Scalars['String']['input']>;
  /** Number of the voyage used for transhipment */
  transhipmentVoyageNumber?: InputMaybe<Scalars['String']['input']>;
  /** Port used for transhipment */
  transhipmentPort?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the port of discharge */
  portOfDischargeId?: InputMaybe<Scalars['Int']['input']>;
  /** Type of temperature sensor used */
  tempSensor?: InputMaybe<Scalars['String']['input']>;
  /** Name of the user creating the shipment record */
  userName?: InputMaybe<Scalars['String']['input']>;
  /** When the shipment was created */
  dateCreated?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Indicates if the shipping is conventional */
  isConventionalShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Depot where shipment is stored */
  depot?: InputMaybe<Scalars['String']['input']>;
  /** Date when the shipment was collected */
  collectionDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Loading instruction number for shipment */
  loadingInstructionNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of haulage used for transportation */
  haulageType?: InputMaybe<Scalars['String']['input']>;
  /** Transporter involved in shipment */
  transporter?: InputMaybe<Scalars['String']['input']>;
  /** Receiver of the shipment */
  receiver?: InputMaybe<Scalars['String']['input']>;
  /** Verified Gross Mass (VGM) of the cargo */
  cargoVgm?: InputMaybe<Scalars['String']['input']>;
  /** Safety of Life at Sea (SOLAS) requirement for shipment */
  solas?: InputMaybe<Scalars['String']['input']>;
  /** Temperature device used in shipment */
  tempDevice?: InputMaybe<Scalars['String']['input']>;
  /** Estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Actual time of departure for the shipment */
  actualTimeOfDeparture?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Actual time of arrival for the shipment */
  actualTimeOfArrival?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Container and seal number for the shipment */
  containerAndSealNumber?: InputMaybe<Scalars['String']['input']>;
  /** Payment terms for the shipment */
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  /** Contact number of the shipping line */
  shippingLineContactNumber?: InputMaybe<Scalars['String']['input']>;
  /** Humidity condition for shipment */
  humidity?: InputMaybe<Scalars['String']['input']>;
  /** Information about void plugs used in shipment */
  voidPlugs?: InputMaybe<Scalars['String']['input']>;
  /** Ventilation setting for the shipment */
  ventSetting?: InputMaybe<Scalars['String']['input']>;
  /** Protocol temperature for the shipment */
  protocolTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Protocol days for the shipment */
  protocolDays?: InputMaybe<Scalars['Int']['input']>;
  /** Special instructions for the shipment */
  specialInstruction?: InputMaybe<Scalars['String']['input']>;
  /** Current status of the shipment */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Product codes included in the shipment */
  productCodes?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when the shipment record was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timestamp when the shipment record was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Unique identifier for the shipment */
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Loading points for the shipment */
  loadingPoints?: InputMaybe<Array<LoadingPointAttributes>>;
  /** Number of the container used for shipment */
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Number of the seal used for shipment */
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  /** Gross weight of the shipment */
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Nett weight of the shipment */
  nettWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Current state of the shipment */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Comments regarding the shipment */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Party to whom the shipment will be delivered */
  consignee?: InputMaybe<Scalars['String']['input']>;
  /** PPECB fruit origin code (maps to FruitOriginCode in export notification) */
  fruitOriginCode?: InputMaybe<Scalars['String']['input']>;
  /** PPECB fruit origin name (maps to FruitOriginName in export notification) */
  fruitOriginName?: InputMaybe<Scalars['String']['input']>;
  /** Whether radiation treatment applies for export notification */
  radiation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fumigation treatment indicator for export notification */
  fumigation?: InputMaybe<Scalars['String']['input']>;
  /** Treatment type code for export notification (maps to treatmentType) */
  treatmentType?: InputMaybe<Scalars['String']['input']>;
  /** Service contract number for the shipment */
  serviceContractNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the port of destination */
  portOfDestinationId?: InputMaybe<Scalars['Int']['input']>;
  /** Reference number or string from the client */
  clientReference?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the depot where the container is stored when empty */
  emptyDepotId?: InputMaybe<Scalars['Int']['input']>;
  /** Total Cartons on this SLI */
  totalCartons?: InputMaybe<Scalars['Int']['input']>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: InputMaybe<Scalars['String']['input']>;
  /** Tare weight of the goods */
  tareWeight?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the Shipment Line Item Grouping it belongs to */
  shipmentLineItemGroupingId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of the shipment (e.g., ocean, road, air) */
  shipmentType?: InputMaybe<Scalars['String']['input']>;
  /** con */
  consignmentReference?: InputMaybe<Scalars['String']['input']>;
  /** Date and time the goods were loaded */
  loadDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Purchase order reference */
  orderReference?: InputMaybe<Scalars['String']['input']>;
  /** The trucks unique identifier */
  truckReference?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for ShipmentLineItem. */
export type ShipmentLineItemConnection = {
  __typename?: 'ShipmentLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShipmentLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShipmentLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ShipmentLineItemEdge = {
  __typename?: 'ShipmentLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ShipmentLineItem>;
};

export type ShipmentLineItemFilterAttribute = {
  __typename?: 'ShipmentLineItemFilterAttribute';
  /** this shipments clients */
  clients?: Maybe<Array<Scalars['String']['output']>>;
  /** this shipments controllers */
  controllers?: Maybe<Array<Scalars['String']['output']>>;
  /** this shipments type */
  shipmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** this shipments booking_references */
  shippingLineReferences?: Maybe<Array<Scalars['String']['output']>>;
  /** the status of the stack dates */
  stackDatesStatus?: Maybe<Array<Scalars['String']['output']>>;
  /** this shipments state */
  states?: Maybe<Array<Scalars['String']['output']>>;
  /** this shipments vessels */
  vessels?: Maybe<Array<Scalars['String']['output']>>;
};

export type ShipmentLineItemFilterAttributes = {
  /** this shipments clients */
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this shipments controllers */
  controllers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this shipments booking references */
  shippingLineReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this shipments state */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** the status of the stack dates */
  stackDatesStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this shipments vessels */
  vessels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this shipments type */
  shipmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ShipmentLineItemGrouping = {
  __typename?: 'ShipmentLineItemGrouping';
  /** Unique identifier for the Company associated with this SLIG */
  companyId: Scalars['ID']['output'];
  /** When the shipment line item grouping was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the shipment line item grouping */
  id: Scalars['ID']['output'];
  /** Unique identifier for the Shipment associated with this SLIG */
  shipmentId: Scalars['ID']['output'];
  /** The fields the SLIG is grouped on */
  sligFields?: Maybe<Scalars['JSON']['output']>;
  /** Summation of all the SLIs cartons belonging to this SLIG */
  totalCartons?: Maybe<Scalars['Int']['output']>;
  /** Summation of all the SLIs gross weight belonging to this SLIG */
  totalGrossWeight?: Maybe<Scalars['Float']['output']>;
  /** Summation of all the SLIs nett weight belonging to this SLIG */
  totalNettWeight?: Maybe<Scalars['Float']['output']>;
  /** When the shipment line item grouping was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ShipmentTypeEnum {
  /** Ocean shipment */
  Ocean = 'OCEAN',
  /** Air shipment */
  Air = 'AIR',
  /** Road shipment */
  Road = 'ROAD'
}

export type ShipmentsAndShipmentLineItems = {
  __typename?: 'ShipmentsAndShipmentLineItems';
  /** The shipment line items returned by the resolver */
  shipmentLineItems: ShipmentLineItemConnection;
  /** The shipments returned by the resolver */
  shipments: Array<Shipment>;
};


export type ShipmentsAndShipmentLineItemsShipmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Returns the name of the vessel and CG states at that vessel. */
export type ShippedStockModuleData = {
  __typename?: 'ShippedStockModuleData';
  /** Vessels that appear in the miller column */
  allVessels?: Maybe<Array<VesselMillerFilter>>;
  /** Cartons groupings with location and vessel */
  results?: Maybe<CartonGroupingWithLocationConnection>;
};


/** Returns the name of the vessel and CG states at that vessel. */
export type ShippedStockModuleDataResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SliBreakBulk = {
  __typename?: 'SliBreakBulk';
  /** Break Bulk Container joined on the SliBreakBulk record */
  breakBulkContainer?: Maybe<BreakBulkContainer>;
  /** Internal Id of the SliBreakBulk join */
  id: Scalars['ID']['output'];
};

export type SliContainer = {
  __typename?: 'SliContainer';
  container?: Maybe<Container>;
  id: Scalars['ID']['output'];
};

/** Autogenerated return type of SoftDeleteContainerClaim. */
export type SoftDeleteContainerClaimPayload = {
  __typename?: 'SoftDeleteContainerClaimPayload';
  /** The ID of the container claim that was soft deleted */
  containerClaimId?: Maybe<Scalars['ID']['output']>;
  /** Error message that occurred during the mutation */
  error?: Maybe<Scalars['String']['output']>;
};

/** A software update report request */
export type SoftwareUpdateReportRequest = {
  __typename?: 'SoftwareUpdateReportRequest';
  /** The company that requested the software update report */
  company?: Maybe<Company>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']['output']>;
  /** The software update report */
  softwareUpdateReport?: Maybe<Array<Scalars['String']['output']>>;
};

export enum StateFilter {
  Expired = 'expired',
  WontPack = 'wont_pack',
  Created = 'created',
  Accepted = 'accepted',
  PartiallyPacked = 'partially_packed',
  Packed = 'packed',
  AtColdStore = 'at_cold_store',
  AtRailDepot = 'at_rail_depot',
  AtOriginPort = 'at_origin_port',
  InTransit = 'in_transit',
  AtDestinationPort = 'at_destination_port',
  Delivered = 'delivered',
  PartiallyDelivered = 'partially_delivered',
  PartiallyAccepted = 'partially_accepted',
  Allocated = 'allocated',
  ToPack = 'to_pack'
}

export type Status = {
  __typename?: 'Status';
  requestUuid: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** Returns the Cg errors as errors. */
export type StockDiscrepancies = {
  __typename?: 'StockDiscrepancies';
  /** The number of errors of this type */
  errorCount?: Maybe<Scalars['Int']['output']>;
  /** The error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The resolution status of this error */
  status?: Maybe<Scalars['String']['output']>;
};

/** Attributes for filtering stock */
export type StockFilterAttributes = {
  __typename?: 'StockFilterAttributes';
  /** batch numbers to filter on */
  batchNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** buyers to filter on */
  buyers?: Maybe<Array<Company>>;
  /** commodities to filter on */
  commodities?: Maybe<Array<Commodity>>;
  /** On the FE -> Allocation statuses but these are document statuses */
  documentStatuses?: Maybe<Array<Scalars['String']['output']>>;
  /** exporter codes to filter on */
  exporterCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** grades to filter on */
  grades?: Maybe<Array<Scalars['String']['output']>>;
  /** inventory codes to filter on */
  inventoryCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** marks to filter on */
  marks?: Maybe<Array<Scalars['String']['output']>>;
  /** pack types to filter on */
  packTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** sellers to filter on */
  sellers?: Maybe<Array<Company>>;
  /** size counts to filter on */
  sizeCounts?: Maybe<Array<Scalars['String']['output']>>;
  /** states to filter on */
  states?: Maybe<Array<Scalars['String']['output']>>;
  /** sub-commodities to filter on */
  subCommodities?: Maybe<Array<SubCommodity>>;
  /** target markets to filter on */
  targetMarkets?: Maybe<Array<Scalars['String']['output']>>;
  /** varieties to filter on */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes for filtering stock */
export type StockFilterInputAttributes = {
  /** Batch numbers to filter on */
  batchNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buyer IDs to filter on */
  buyerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Commodity IDs to filter on */
  commodityId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Exporter codes to filter on */
  exporterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Document status to filter on */
  allocationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Grades to filter on */
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Inspection date end */
  inspectionDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Inspection date start */
  inspectionDateStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Inventory codes to filter on */
  inventoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Marks to filter on */
  marks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pack types to filter on */
  packs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sellers to filter on */
  sellerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Size counts to filter on */
  sizeCounts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** States to filter on */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sub-commodities to filter on */
  subCommodityId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Target markets to filter on */
  targetMarkets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Variety IDs to filter on */
  varietyId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Returns the name of the location and CG states at that location. */
export type StockModuleData = {
  __typename?: 'StockModuleData';
  /** Locations miller column. */
  allLocations?: Maybe<Array<LocationMillerFilter>>;
  /** Vessels miller column. */
  allVessels?: Maybe<Array<VesselMillerFilter>>;
  /** The Miller column second level which further aggregates the carton groupings/stock. */
  millerCollapsibleForLocation?: Maybe<Array<MillerCollapsibleInLocation>>;
  /** Cartons groupings with location */
  results?: Maybe<Array<CartonGroupingWithLocation>>;
};


/** Returns the name of the location and CG states at that location. */
export type StockModuleDataMillerCollapsibleForLocationArgs = {
  millerColumnAttributes?: InputMaybe<MillerCollapsibleInLocationInput>;
};

export type SubCommodity = {
  __typename?: 'SubCommodity';
  commodity?: Maybe<Commodity>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of SubmitAddendum. */
export type SubmitAddendumPayload = {
  __typename?: 'SubmitAddendumPayload';
  /** The Addendum Header */
  addendumHeader?: Maybe<AddendumHeader>;
  /**
   * Errors
   * @deprecated no longer used
   */
  errors?: Maybe<Scalars['String']['output']>;
  /** Validation information */
  validation?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of SubmitEphyto. */
export type SubmitEphytoPayload = {
  __typename?: 'SubmitEphytoPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to submit */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of SubmitShipmentExportNotification. */
export type SubmitShipmentExportNotificationPayload = {
  __typename?: 'SubmitShipmentExportNotificationPayload';
  /** The errors that occured */
  errors?: Maybe<Scalars['String']['output']>;
  /** The current shipment */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of SubscribeToNotificationRules. */
export type SubscribeToNotificationRulesPayload = {
  __typename?: 'SubscribeToNotificationRulesPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** The notification rule subscriptions that were updated */
  notificationRuleSubscriptions: Array<NotificationRuleSubscription>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a new in-app (web) notification is delivered for the current user */
  newInAppNotification: InAppNotification;
  newOrder: Order;
  newUserFeedItem: UserFeedItem;
  onAcceptLineItems: Order;
  /** Triggered on state change for Account Statement file generation */
  onAccountStatementStateChange: AccountStatement;
  /** Triggered when an accounting export state changes */
  onAccountingExportStateChange: AccountingExport;
  /** Triggered on state change for Addendum generation */
  onAddendumHeaderStateChange: AddendumHeader;
  /** Triggered when async AG1 table file generation completes or fails */
  onAg1TableOutputFileComplete: Ag1TableOutputFileResult;
  /** Triggered during the generation of an Arrival QC */
  onArrivalQcGenerationStateChange: ArrivalQcGeneration;
  /** Triggered on state change for Pallet In file generation */
  onPalletInOutputStateChange: PalletIn;
  /** Triggered on state change for Pallet Out file generation */
  onPalletOutOutputStateChange: PalletOut;
  onPremCommands: Array<Command>;
  /** Terminal async P&L report outcome (completed or error) for a request id */
  onProfitAndLossReportComplete: ProfitAndLossReportOutcomeUnion;
  /** Triggered when data for a given report is a powerbi report and API tokens are refreshed. */
  onRefreshReport: MetabaseReport;
  /** Triggered when data for a given report is ready */
  onReportComplete: Status;
  /** A subscription for report output file generation completion */
  onReportOutputFileComplete: ReportOutputFileStatus;
  onRevertLineItemsToCreated: Order;
  /** Triggered on state change for Export Notification */
  onShipmentStateChange: Shipment;
  /** Triggered on state change for template output */
  onTemplateOutputStateChange: TemplateOutput;
  /** Triggered when a WhatsApp message fails to deliver */
  onWhatsappInteractionFailedToDeliver: WhatsappInteractionStatus;
  onWontPackLineItems: Order;
};


export type SubscriptionOnAg1TableOutputFileCompleteArgs = {
  requestId: Scalars['String']['input'];
};


export type SubscriptionOnProfitAndLossReportCompleteArgs = {
  requestId: Scalars['String']['input'];
};


export type SubscriptionOnReportOutputFileCompleteArgs = {
  requestId: Scalars['String']['input'];
};

/** A supplier-exporter company association with additional exporter-specific data */
export type SupplierExporter = {
  __typename?: 'SupplierExporter';
  /** The client change requests for the cold stores associated with this association */
  coldStoreClientChangeRequests?: Maybe<Array<ExporterColdStoreClientChangeRequest>>;
  /** The cold stores associated with this association */
  coldStores?: Maybe<Array<FoodBusinessOperator>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The exporter company in the association */
  exporter?: Maybe<Company>;
  /** Exporter codes associated with this supplier-exporter relationship */
  exporterCodes?: Maybe<Array<ExporterCode>>;
  /** The URL of the exporter company logo */
  exporterLogoImageUrl?: Maybe<Scalars['String']['output']>;
  /** The exporter food business operators associated with the child (exporter) company */
  foodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** Unique identifier for the company association */
  id?: Maybe<Scalars['Int']['output']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: Maybe<Scalars['Boolean']['output']>;
  /** The masterfile configuration for this association */
  masterfileConfig?: Maybe<MasterfileConfig>;
  /** The display name of the supplier-exporter association */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the association is facilitated by OneSwitch */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']['output']>;
  /** The type of relationship between the companies */
  relation?: Maybe<CompanyAssociationRelationTypeEnum>;
  /** The supplier company in the association */
  supplier?: Maybe<Company>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A client change request for a supplier-exporter relationship */
export type SupplierExporterClientChangeRequest = {
  __typename?: 'SupplierExporterClientChangeRequest';
  /** The cold stores associated with this association */
  coldStores?: Maybe<Array<FoodBusinessOperator>>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The exporter company if the company is known */
  exporter?: Maybe<Company>;
  /** The exporter codes for the exporter company */
  exporterCodes?: Maybe<Array<ExporterCode>>;
  /** The URL of the exporter company logo */
  exporterLogoImageUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the exporter if the company is unknown */
  exporterName?: Maybe<Scalars['String']['output']>;
  /** The ID of the FBO */
  fboId?: Maybe<Scalars['Int']['output']>;
  /** The food business operators associated with the client change request */
  foodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']['output']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the association is facilitated by OneSwitch */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']['output']>;
  /** The type of relationship between the companies */
  relation?: Maybe<Scalars['String']['output']>;
  /** The supplier company */
  supplier?: Maybe<Company>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Filter attributes for supplier exporters company associations */
export type SupplierExporterFilterAttributes = {
  /** Filter by status (for company associations or client change requests) */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by relation type */
  relation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by OneSwitch facilitation */
  oneswitchFacilitated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by supplier company IDs */
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by exporter company IDs */
  exporterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Container for supplier-exporter associations and related client change requests */
export type SupplierExporters = {
  __typename?: 'SupplierExporters';
  /** The pending client change requests for supplier-exporter associations */
  clientChangeRequests: Array<SupplierExporterClientChangeRequest>;
  /** The existing supplier-exporter associations */
  supplierExporters: Array<SupplierExporter>;
};

/** A report */
export type SwitchUnit = {
  __typename?: 'SwitchUnit';
  /** The date and time the report was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The default value used to initialise the cards */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The ID of the switch_unit */
  id?: Maybe<Scalars['ID']['output']>;
  /** The linked entity (either ReportGroup or Report) */
  linked?: Maybe<LinkedItem>;
  /** The name of the switchUnit */
  name?: Maybe<Scalars['String']['output']>;
  /** Options associated with the switch_unit */
  switchUnitOptions?: Maybe<Array<SwitchUnitOption>>;
  /** The date and time the report was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** An option linked to a switch unit */
export type SwitchUnitOption = {
  __typename?: 'SwitchUnitOption';
  /** The date and time the option was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the switch_unit_option */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the switch_unit_option */
  label?: Maybe<Scalars['String']['output']>;
  /** Optional order in which options should be rendered on the frontend */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The ID of the switch unit this option belongs to */
  switchUnitId?: Maybe<Scalars['ID']['output']>;
  /** The date and time the option was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The value of the switch_unit_option */
  value?: Maybe<Scalars['String']['output']>;
};

/** State of task completion */
export type TaskCompletion = {
  __typename?: 'TaskCompletion';
  /** Number of tasks completed */
  complete?: Maybe<Scalars['Int']['output']>;
  /** Number of tasks in progress */
  inProgress?: Maybe<Scalars['Int']['output']>;
  /** Number of tasks not started */
  notStarted?: Maybe<Scalars['Int']['output']>;
  /** Total number of tasks */
  total?: Maybe<Scalars['Int']['output']>;
};

export enum TaskLevelEnum {
  /** Task associated with a shipment */
  Shipment = 'SHIPMENT',
  /** Task associated with a container */
  Container = 'CONTAINER',
  /** Task associated with a specific client reference */
  ClientReference = 'CLIENT_REFERENCE',
  /** Task associated with a specific shipping line reference */
  ShippingLineReference = 'SHIPPING_LINE_REFERENCE',
  /** Task associated with a specific consignment reference */
  ConsignmentReference = 'CONSIGNMENT_REFERENCE'
}

export enum TaskStateEnum {
  Complete = 'complete',
  InProgress = 'in_progress',
  NotStarted = 'not_started'
}

export type TaskableChecklist = {
  __typename?: 'TaskableChecklist';
  /** Dynamic email subject for this checklist */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the task */
  id: Scalars['ID']['output'];
  /** Title of the checklist */
  title?: Maybe<Scalars['String']['output']>;
};

export type TaskableTask = {
  __typename?: 'TaskableTask';
  /** DateTime when this document was uploaded. Null if never */
  customDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DateTime when this task was completed. */
  dateOfCompletion?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The id of the Document that was uploaded against this task */
  documentId?: Maybe<Scalars['Int']['output']>;
  /** The document that was uploaded against this task */
  file?: Maybe<Document>;
  /** Whether this task requires a document */
  hasDocument?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the task */
  id: Scalars['ID']['output'];
  /** Index indicating order of tasks */
  index: Scalars['Int']['output'];
  /** List of platform-generated documents attached to this task */
  platformDocuments?: Maybe<Array<OutputFile>>;
  /** Whether this task has documents generated on platform */
  platformTask: Scalars['Boolean']['output'];
  /** State of the task */
  state?: Maybe<TaskStateEnum>;
  /** Task Level */
  taskLevel: TaskLevelEnum;
  /** The id to which this task belongs */
  taskableId: Scalars['ID']['output'];
  /** The class to which this task belongs */
  taskableType: Scalars['String']['output'];
  /** Platform generated documents that are attached to this task */
  templateOutput?: Maybe<TemplateOutput>;
  /** Title of the task */
  title: Scalars['String']['output'];
  /** DateTime when this document was uploaded. Null if never */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum TemplateFileFormatEnum {
  Pdf = 'pdf',
  Xls = 'xls'
}

/** Contains information on template generation output */
export type TemplateOutput = {
  __typename?: 'TemplateOutput';
  /** Provides further detail if state is errored */
  errorReason?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']['output']>;
  /** The documents produced from template generation */
  outputFiles?: Maybe<Array<Document>>;
  /** State of the template generation (created, processing, completed) */
  state?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the data source associated with this template output */
  templateDataSourceId?: Maybe<Scalars['String']['output']>;
  /** Data source type associated with this template output */
  templateDataSourceType?: Maybe<Scalars['String']['output']>;
  /** Document variant generated for this template output */
  templateVariant?: Maybe<Scalars['String']['output']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Terminal = {
  __typename?: 'Terminal';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Fields describing a trade country */
export type TradeCountry = {
  __typename?: 'TradeCountry';
  /** code of the trade country, eg. ZA */
  code?: Maybe<Scalars['String']['output']>;
  /** unique identifier of the trade country */
  id?: Maybe<Scalars['Int']['output']>;
  /** name of the trade country, eg. South Africa */
  name?: Maybe<Scalars['String']['output']>;
};

/** The connection type for TradeCountry. */
export type TradeCountryConnection = {
  __typename?: 'TradeCountryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TradeCountryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TradeCountry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TradeCountryEdge = {
  __typename?: 'TradeCountryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TradeCountry>;
};

export type TradeRegion = {
  __typename?: 'TradeRegion';
  code?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Array<TradeCountry>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TradeRegionAttributes = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type TransnetAccount = {
  __typename?: 'TransnetAccount';
  /** The id of the transnet account */
  id: Scalars['ID']['output'];
  /** Unique Transnet account number that identifies which company is creating the Cargo Due */
  number: Scalars['String']['output'];
  /** The sea port the transnet account belongs to */
  seaPort: SeaPort;
  /** The company the transnet account belongs to */
  user: User;
};

export type TransnetTerminal = {
  __typename?: 'TransnetTerminal';
  /** Port Terminal code */
  code?: Maybe<Scalars['String']['output']>;
  /** Port Terminal name */
  name?: Maybe<Scalars['String']['output']>;
  /** The name of the port the terminal belongs to */
  portName?: Maybe<Scalars['String']['output']>;
};

export enum TransportTypeEnum {
  /** The transport type trucking */
  Trucking = 'trucking',
  /** The transport type break_bulk */
  BreakBulk = 'break_bulk',
  /** The transport type container */
  Container = 'container',
  /** The transport type air */
  Air = 'air'
}

export type UiConfig = {
  __typename?: 'UiConfig';
  configType: Scalars['String']['output'];
  data: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  readonly: Scalars['Boolean']['output'];
  visibility: UiConfigVisibilityEnum;
};

export enum UiConfigVisibilityEnum {
  Private = 'Private',
  Company = 'Company',
  Public = 'Public'
}

/** Autogenerated return type of UpdateAddendum. */
export type UpdateAddendumPayload = {
  __typename?: 'UpdateAddendumPayload';
  /** Errors that occurred while updating the Addendum */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Basic attributes for updating an additional field */
export type UpdateAdditionalFieldAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  fieldtype: Scalars['String']['input'];
  ispackinginstruction?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateAdditionalField. */
export type UpdateAdditionalFieldPayload = {
  __typename?: 'UpdateAdditionalFieldPayload';
  additionalField?: Maybe<AdditionalField>;
};

/** Autogenerated return type of UpdateAirAddendum. */
export type UpdateAirAddendumPayload = {
  __typename?: 'UpdateAirAddendumPayload';
  /** Errors that occurred while updating the Addendum */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateAirFreightShipmentController. */
export type UpdateAirFreightShipmentControllerPayload = {
  __typename?: 'UpdateAirFreightShipmentControllerPayload';
  /** Errors that occurred while updating the Air Freight Shipment controller */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateArrivalQcCaptureDatetime. */
export type UpdateArrivalQcCaptureDatetimePayload = {
  __typename?: 'UpdateArrivalQcCaptureDatetimePayload';
  /** The updated container claim */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the note of the container claim */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateArrivalQcClaimLineItemGroupingGrade. */
export type UpdateArrivalQcClaimLineItemGroupingGradePayload = {
  __typename?: 'UpdateArrivalQcClaimLineItemGroupingGradePayload';
  /** The container claim that was updated */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the arrival QC grade of the claim line items */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateArrivalQcClaimLineItemPalletGrade. */
export type UpdateArrivalQcClaimLineItemPalletGradePayload = {
  __typename?: 'UpdateArrivalQcClaimLineItemPalletGradePayload';
  /** The container claim that was updated */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the arrival qc grade of the claim line items */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCartonConversion. */
export type UpdateCartonConversionPayload = {
  __typename?: 'UpdateCartonConversionPayload';
  cartonConversion?: Maybe<CartonConversion>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']['output']>;
  /** false if mutation failed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateCartonGroupingTransactions. */
export type UpdateCartonGroupingTransactionsPayload = {
  __typename?: 'UpdateCartonGroupingTransactionsPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

/** Autogenerated return type of UpdateClaimLineItemGroupingComment. */
export type UpdateClaimLineItemGroupingCommentPayload = {
  __typename?: 'UpdateClaimLineItemGroupingCommentPayload';
  /** Errors that occurred while updating the comment of the claim line item grouping */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateClaimLineItemGroupingDefect. */
export type UpdateClaimLineItemGroupingDefectPayload = {
  __typename?: 'UpdateClaimLineItemGroupingDefectPayload';
  /** Errors that occurred while updating the defect associated with the claim line items */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateClaimLineItemGroupingExpectedClaim. */
export type UpdateClaimLineItemGroupingExpectedClaimPayload = {
  __typename?: 'UpdateClaimLineItemGroupingExpectedClaimPayload';
  /** Errors that occurred while updating the expected claim of the claim line item grouping */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateClaimLineItemPalletDefect. */
export type UpdateClaimLineItemPalletDefectPayload = {
  __typename?: 'UpdateClaimLineItemPalletDefectPayload';
  /** Errors that occurred while updating the arrival qc grade of the claim line items */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateClaimLineItemPalletExpectedClaim. */
export type UpdateClaimLineItemPalletExpectedClaimPayload = {
  __typename?: 'UpdateClaimLineItemPalletExpectedClaimPayload';
  /** Errors that occurred while updating the expected claim of the claim line items */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCommandResult. */
export type UpdateCommandResultPayload = {
  __typename?: 'UpdateCommandResultPayload';
  result?: Maybe<Scalars['String']['output']>;
};

/** Basic attributes for a updating company */
export type UpdateCompanyAttributes = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  about?: InputMaybe<Scalars['String']['input']>;
  registrationnumber: Scalars['String']['input'];
  vatnumber: Scalars['String']['input'];
  address?: InputMaybe<AddressAttributes>;
};

/** Autogenerated return type of UpdateCompanyDetails. */
export type UpdateCompanyDetailsPayload = {
  __typename?: 'UpdateCompanyDetailsPayload';
  company?: Maybe<Company>;
};

/** Autogenerated return type of UpdateCompanyOnboardingStep. */
export type UpdateCompanyOnboardingStepPayload = {
  __typename?: 'UpdateCompanyOnboardingStepPayload';
  company?: Maybe<Company>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UpdateCompanyTradeRegions. */
export type UpdateCompanyTradeRegionsPayload = {
  __typename?: 'UpdateCompanyTradeRegionsPayload';
  company?: Maybe<Company>;
};

/** Autogenerated return type of UpdateContact. */
export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateContainerClaimGrade. */
export type UpdateContainerClaimGradePayload = {
  __typename?: 'UpdateContainerClaimGradePayload';
  /** The container claim that was updated */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the container claim grade */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateContainerClaimNote. */
export type UpdateContainerClaimNotePayload = {
  __typename?: 'UpdateContainerClaimNotePayload';
  /** The updated container claim */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the note of the claim line item grouping */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCustomField. */
export type UpdateCustomFieldPayload = {
  __typename?: 'UpdateCustomFieldPayload';
  /** The custom field */
  customField?: Maybe<CustomField>;
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCustomTaskDate. */
export type UpdateCustomTaskDatePayload = {
  __typename?: 'UpdateCustomTaskDatePayload';
  /** Errors that occurred during the update */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Tasks for the given Shipment Line Item (after update) */
  tasks?: Maybe<Array<TaskableTask>>;
};

/** Autogenerated return type of UpdateDataOutput. */
export type UpdateDataOutputPayload = {
  __typename?: 'UpdateDataOutputPayload';
  /** The updated Data Output */
  dataOutput?: Maybe<DataOutput>;
  /** Errors that occurred during the update */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateDraftEphyto. */
export type UpdateDraftEphytoPayload = {
  __typename?: 'UpdateDraftEphytoPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to update the draft */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateEphytoDocument. */
export type UpdateEphytoDocumentPayload = {
  __typename?: 'UpdateEphytoDocumentPayload';
  /** Any errors when updating the Ephyto Document */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateEphyto. */
export type UpdateEphytoPayload = {
  __typename?: 'UpdateEphytoPayload';
  /** Errors that occurred while updating the Ephyto */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateEstimates. */
export type UpdateEstimatesPayload = {
  __typename?: 'UpdateEstimatesPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

/** Autogenerated return type of UpdateExportDocument. */
export type UpdateExportDocumentPayload = {
  __typename?: 'UpdateExportDocumentPayload';
  exportDocument?: Maybe<ExportDocument>;
};

/** Basic attributes for updating a FarmVariety */
export type UpdateFarmVarietyAttributes = {
  companyId: Scalars['Int']['input'];
  hectares?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  packingend: Scalars['String']['input'];
  packingstart: Scalars['String']['input'];
  peakcount?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateFarmVariety. */
export type UpdateFarmVarietyPayload = {
  __typename?: 'UpdateFarmVarietyPayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of UpdateFinanceRuleEnabledState. */
export type UpdateFinanceRuleEnabledStatePayload = {
  __typename?: 'UpdateFinanceRuleEnabledStatePayload';
  /** Error information when attempting to update finance rules */
  errors?: Maybe<Scalars['String']['output']>;
  /** Finance rules returned after update */
  financeRules?: Maybe<Array<FinanceRule>>;
};

/** Autogenerated return type of UpdateFinanceRule. */
export type UpdateFinanceRulePayload = {
  __typename?: 'UpdateFinanceRulePayload';
  /** Error information when attempting to update finance rules */
  errors?: Maybe<Scalars['String']['output']>;
  /** Finance rules returned after update */
  financeRules?: Maybe<Array<FinanceRule>>;
};

/** Autogenerated return type of UpdateInvoice. */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /** What went wrong when updating an invoice */
  errors?: Maybe<Scalars['String']['output']>;
  /** The invoice that was updated */
  invoice?: Maybe<Invoice>;
  /** Credit/debit notes created during account sale reconciliation */
  reconciliationDocuments?: Maybe<Array<ReconciliationDocument>>;
};

/** Autogenerated return type of UpdateInvoiceState. */
export type UpdateInvoiceStatePayload = {
  __typename?: 'UpdateInvoiceStatePayload';
  /** Return errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Return Invoice */
  invoice?: Maybe<Invoice>;
};

export type UpdateLineItemAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  varietyid: Scalars['Int']['input'];
  commodityid: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  plannedquantity?: InputMaybe<Scalars['Int']['input']>;
  plannedquantityunit?: InputMaybe<Scalars['String']['input']>;
  quantityunit?: InputMaybe<Scalars['String']['input']>;
  priceminorunit?: InputMaybe<Scalars['Int']['input']>;
  priceunit?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  sizecounts: Array<Scalars['String']['input']>;
  pack: Scalars['String']['input'];
  priceterm: Scalars['String']['input'];
  additionalfields: Scalars['String']['input'];
  palletstack: Scalars['Int']['input'];
  unlimited: Scalars['Boolean']['input'];
  targetmarket?: InputMaybe<Scalars['String']['input']>;
  targetregion: Scalars['String']['input'];
  targetcountry?: InputMaybe<Scalars['String']['input']>;
  packingweek?: InputMaybe<Scalars['String']['input']>;
  startweek?: InputMaybe<Scalars['String']['input']>;
  endweek?: InputMaybe<Scalars['String']['input']>;
  incoterm: Scalars['String']['input'];
  grade?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  mark?: InputMaybe<Scalars['String']['input']>;
  referencenumber?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  batchnumber?: InputMaybe<Scalars['String']['input']>;
  inventorycode?: InputMaybe<Scalars['String']['input']>;
  orderid?: InputMaybe<Scalars['Int']['input']>;
  lineitemgroupingid?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  stateupdate?: InputMaybe<Array<Scalars['String']['input']>>;
  newsellerid?: InputMaybe<Scalars['Int']['input']>;
  departureportid?: InputMaybe<Scalars['Int']['input']>;
  destinationportid?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLineItemGroupingAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  cumulativequantity?: InputMaybe<Scalars['Int']['input']>;
  quantitytype?: InputMaybe<Scalars['String']['input']>;
  commonfields: Array<Scalars['String']['input']>;
  lineitems: Array<UpdateLineItemAttributes>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateLineItems. */
export type UpdateLineItemsPayload = {
  __typename?: 'UpdateLineItemsPayload';
  errors?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<LineItem>>;
};

/** Autogenerated return type of UpdateLoadOutInstruction. */
export type UpdateLoadOutInstructionPayload = {
  __typename?: 'UpdateLoadOutInstructionPayload';
  errors?: Maybe<Array<LoadOutInstructionError>>;
  loadOutInstruction?: Maybe<LoadOutInstruction>;
};

/** Autogenerated return type of UpdateLoadOutInstructionsFromSlis. */
export type UpdateLoadOutInstructionsFromSlisPayload = {
  __typename?: 'UpdateLoadOutInstructionsFromSlisPayload';
  loadOutInstructions?: Maybe<Array<LoadOutInstruction>>;
};

/** Autogenerated return type of UpdateNetReturnProgram. */
export type UpdateNetReturnProgramPayload = {
  __typename?: 'UpdateNetReturnProgramPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  netReturnProgram?: Maybe<NetReturnProgram>;
};

/** Autogenerated return type of UpdateOrchardSeasons. */
export type UpdateOrchardSeasonsPayload = {
  __typename?: 'UpdateOrchardSeasonsPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

/** Autogenerated return type of UpdateOrchardYields. */
export type UpdateOrchardYieldsPayload = {
  __typename?: 'UpdateOrchardYieldsPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

export type UpdateOrderAttributes = {
  id: Scalars['Int']['input'];
  ispackhouserun: Scalars['Boolean']['input'];
  commonfields?: InputMaybe<Array<Scalars['String']['input']>>;
  lineitemgroupings?: InputMaybe<Array<UpdateLineItemGroupingAttributes>>;
};

/** Autogenerated return type of UpdateOrder. */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  errors?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of UpdateOrderProgram. */
export type UpdateOrderProgramPayload = {
  __typename?: 'UpdateOrderProgramPayload';
  /** What went wrong when updating an order program */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The order program that was updated */
  orderProgram?: Maybe<OrderProgram>;
};

/** Autogenerated return type of UpdatePackInstructionLineItemPriority. */
export type UpdatePackInstructionLineItemPriorityPayload = {
  __typename?: 'UpdatePackInstructionLineItemPriorityPayload';
  /** Errors that occurred while updating the priority of the pack instruction line item */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdatePayment. */
export type UpdatePaymentPayload = {
  __typename?: 'UpdatePaymentPayload';
  /** What went wrong when updating a payment */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The payment that was updated */
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of UpdateReportGroup. */
export type UpdateReportGroupPayload = {
  __typename?: 'UpdateReportGroupPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']['output']>;
  /** The report group */
  reportGroup?: Maybe<ReportGroup>;
};

/** Autogenerated return type of UpdateShipmentDocument. */
export type UpdateShipmentDocumentPayload = {
  __typename?: 'UpdateShipmentDocumentPayload';
  shipmentDocument?: Maybe<ShipmentDocument>;
};

/** Autogenerated return type of UpdateShipmentLineItem. */
export type UpdateShipmentLineItemPayload = {
  __typename?: 'UpdateShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shipmentLineItem?: Maybe<ShipmentLineItem>;
};

/** Autogenerated return type of UpdateShipment. */
export type UpdateShipmentPayload = {
  __typename?: 'UpdateShipmentPayload';
  /**
   * A list of error messages encountered during the mutation execution.
   *                              Null if the update is successful.
   */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The updated shipment object. Null if the update fails. */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of UpdateTasksDates. */
export type UpdateTasksDatesPayload = {
  __typename?: 'UpdateTasksDatesPayload';
  /** Error information when attempting to update task dates */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateUiConfig. */
export type UpdateUiConfigPayload = {
  __typename?: 'UpdateUiConfigPayload';
  config?: Maybe<UiConfig>;
};

/** Basic attributes for a updating UserFeedItem */
export type UpdateUserFeedItemAttributes = {
  id: Scalars['Int']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserFeedItem. */
export type UpdateUserFeedItemPayload = {
  __typename?: 'UpdateUserFeedItemPayload';
  userFeedItem?: Maybe<UserFeedItem>;
};

/** Autogenerated return type of UpdateUserFeedItems. */
export type UpdateUserFeedItemsPayload = {
  __typename?: 'UpdateUserFeedItemsPayload';
  userFeedItems?: Maybe<Array<UserFeedItem>>;
};

/** Autogenerated return type of UpdateUserNotifications. */
export type UpdateUserNotificationsPayload = {
  __typename?: 'UpdateUserNotificationsPayload';
  /** The errors that occurred while updating the user notifications */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The updated user */
  user?: Maybe<User>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user?: Maybe<User>;
};

/** Autogenerated return type of UploadClaimFiles. */
export type UploadClaimFilesPayload = {
  __typename?: 'UploadClaimFilesPayload';
  /** The updated container claim */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred during upload */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UploadCompanyCertificate. */
export type UploadCompanyCertificatePayload = {
  __typename?: 'UploadCompanyCertificatePayload';
  certificate?: Maybe<CompanyCertificate>;
};

/** Autogenerated return type of UploadCompanyLogo. */
export type UploadCompanyLogoPayload = {
  __typename?: 'UploadCompanyLogoPayload';
  company?: Maybe<Company>;
};

/** Autogenerated return type of UploadEphytoDocument. */
export type UploadEphytoDocumentPayload = {
  __typename?: 'UploadEphytoDocumentPayload';
  /** Ephyto docs on ephyto returned to update UI */
  ephytoDocuments?: Maybe<Array<EphytoDocument>>;
  /** Error information when attempting to upload documents */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UploadEtlDocument. */
export type UploadEtlDocumentPayload = {
  __typename?: 'UploadEtlDocumentPayload';
  document?: Maybe<EtlDocument>;
};

/** Autogenerated return type of UploadExportDocument. */
export type UploadExportDocumentPayload = {
  __typename?: 'UploadExportDocumentPayload';
  errors?: Maybe<Scalars['String']['output']>;
  shipmentLineItem?: Maybe<ShipmentLineItem>;
};

/** Autogenerated return type of UploadFarmVarietyImage. */
export type UploadFarmVarietyImagePayload = {
  __typename?: 'UploadFarmVarietyImagePayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of UploadInvoiceDocuments. */
export type UploadInvoiceDocumentsPayload = {
  __typename?: 'UploadInvoiceDocumentsPayload';
  /** Errors that occurred during upload */
  errors: Array<Scalars['String']['output']>;
  /** The updated invoice with attached documents */
  invoice?: Maybe<Invoice>;
  /** Warnings about replaced files */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UploadOrderShipmentDocument. */
export type UploadOrderShipmentDocumentPayload = {
  __typename?: 'UploadOrderShipmentDocumentPayload';
  order?: Maybe<Order>;
};

/** Autogenerated return type of UploadStockFileMutation. */
export type UploadStockFileMutationPayload = {
  __typename?: 'UploadStockFileMutationPayload';
  errors?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UploadTaskDocument. */
export type UploadTaskDocumentPayload = {
  __typename?: 'UploadTaskDocumentPayload';
  /** Error information when attempting to upload documents */
  errors?: Maybe<Scalars['String']['output']>;
  /** Task returned to update UI */
  task?: Maybe<TaskableTask>;
};

/** Autogenerated return type of UploadTaskDocumentPerSli. */
export type UploadTaskDocumentPerSliPayload = {
  __typename?: 'UploadTaskDocumentPerSliPayload';
  /** Errors that occurred during the update */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Tasks for the given Shipment Line Item (after update) */
  tasks?: Maybe<Array<TaskableTask>>;
};

/** Autogenerated return type of UploadUserAvatar. */
export type UploadUserAvatarPayload = {
  __typename?: 'UploadUserAvatarPayload';
  user?: Maybe<User>;
};

/** Autogenerated return type of UpsertCertificateTransportInstruction. */
export type UpsertCertificateTransportInstructionPayload = {
  __typename?: 'UpsertCertificateTransportInstructionPayload';
  /** The CTI together with the state of the file generation */
  certificateTransportInstruction?: Maybe<CertificateTransportInstruction>;
  /** Errors received if upsert fails */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpsertCommercialTerm. */
export type UpsertCommercialTermPayload = {
  __typename?: 'UpsertCommercialTermPayload';
  /** The commercial term that was upserted */
  commercialTerm?: Maybe<CommercialTerm>;
  /** Errors that occurred while upserting the commercial term */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UpsertCurrencyExchangeRate. */
export type UpsertCurrencyExchangeRatePayload = {
  __typename?: 'UpsertCurrencyExchangeRatePayload';
  /** The currency exchange rate that was set */
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** Errors that occurred while setting the exchange rate */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UpsertFinanceRule. */
export type UpsertFinanceRulePayload = {
  __typename?: 'UpsertFinanceRulePayload';
  /** The errors that occurred */
  errors?: Maybe<Array<FinanceRuleError>>;
  /** The finance rules that were created or updated */
  financeRules?: Maybe<Array<FinanceRule>>;
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']['output']>;
  avatarFile?: Maybe<Document>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['Int']['output']>;
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  notifyBrowserPush?: Maybe<Scalars['Boolean']['output']>;
  notifyEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Aggregates all email recipients for sent emails by the user */
  pastEmailRecipients?: Maybe<Array<Scalars['String']['output']>>;
  permissions?: Maybe<Permissions>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useV2?: Maybe<Scalars['Boolean']['output']>;
};

export type UserFeedItem = {
  __typename?: 'UserFeedItem';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notifiable?: Maybe<NotifiableUnion>;
  read?: Maybe<Scalars['Boolean']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for UserFeedItem. */
export type UserFeedItemConnection = {
  __typename?: 'UserFeedItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserFeedItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserFeedItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserFeedItemEdge = {
  __typename?: 'UserFeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserFeedItem>;
};

export type Variety = {
  __typename?: 'Variety';
  /** The commodity record associated with the variety */
  commodity?: Maybe<Commodity>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for this variety */
  id?: Maybe<Scalars['Int']['output']>;
  /** The full name of the variety, including sub-commodity and variety code */
  name?: Maybe<Scalars['String']['output']>;
  /** The sub commodity record associated with the variety */
  subCommodity?: Maybe<SubCommodity>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The variety code stored on the variety */
  varietyCode?: Maybe<Scalars['String']['output']>;
  /** The name of the variety */
  varietyName?: Maybe<Scalars['String']['output']>;
};

export type VarietyAttributes = {
  /** The ID of the passed Variety */
  id: Scalars['ID']['input'];
  /** Name of the variety */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VatType = {
  __typename?: 'VatType';
  /** Description of the VAT Type */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the VAT Type */
  id: Scalars['ID']['output'];
  /** The name of the VAT Type */
  name?: Maybe<Scalars['String']['output']>;
  /** Percentage of the VAT Type */
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type VatTypeAttributes = {
  /** The ID of the passed Vat Type */
  id: Scalars['ID']['input'];
  /** Name of the Vat Type */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Vessel = {
  __typename?: 'Vessel';
  destination?: Maybe<Scalars['String']['output']>;
  eta?: Maybe<Scalars['String']['output']>;
  finalDestination?: Maybe<Scalars['String']['output']>;
  finalEta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

export type VesselAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  vesselname?: InputMaybe<Scalars['String']['input']>;
};

/** Returns the vessel information of pallets belonging to that particular vessel. */
export type VesselMillerFilter = {
  __typename?: 'VesselMillerFilter';
  /** ID of the vessel */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the vessel */
  name?: Maybe<Scalars['String']['output']>;
  /**  The number of pallets on the vessel */
  totalPallets?: Maybe<Scalars['Int']['output']>;
  /** The ETA of the vessel */
  vesselEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Visit = {
  __typename?: 'Visit';
  /** The arrival date of the visit */
  arrivalDate?: Maybe<Scalars['String']['output']>;
  /** The arrival number of the visit */
  arrivalNumber?: Maybe<Scalars['String']['output']>;
  /** The departure date of the visit */
  departureDate?: Maybe<Scalars['String']['output']>;
  /** The IMO number of the vessel */
  imoNumber?: Maybe<Scalars['String']['output']>;
  /** The port of the visit */
  port?: Maybe<Scalars['String']['output']>;
  /** The vessel call sign */
  vesselCallSign?: Maybe<Scalars['String']['output']>;
  /** The vessel name */
  vesselName?: Maybe<Scalars['String']['output']>;
  /** The voyage number in of the visit */
  voyageNumberIn?: Maybe<Scalars['String']['output']>;
  /** The voyage number out of the visit */
  voyageNumberOut?: Maybe<Scalars['String']['output']>;
};

export type Voyage = {
  __typename?: 'Voyage';
  arrivalTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  departureTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locations?: Maybe<Array<Location>>;
  portOfDestination?: Maybe<SeaPort>;
  portOfOrigin?: Maybe<SeaPort>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vesselCallSign?: Maybe<Scalars['String']['output']>;
  vesselImo?: Maybe<Scalars['String']['output']>;
  vesselMmsi?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
  voyageNumber?: Maybe<Scalars['String']['output']>;
};

/** Payload emitted when a WhatsApp message fails to deliver */
export type WhatsappInteractionStatus = {
  __typename?: 'WhatsappInteractionStatus';
  /** The ID of the buyer that received the WhatsApp message that failed to deliver */
  buyerId: Scalars['String']['output'];
  /** The name of the buyer that received the WhatsApp message that failed to deliver */
  buyerName: Scalars['String']['output'];
  /** WhatsappInteraction ID that failed to deliver */
  id: Scalars['String']['output'];
  /** The recipient of the WhatsApp message that failed to deliver */
  offerRecipientId: Scalars['String']['output'];
};

/** Autogenerated return type of WontPackLineItems. */
export type WontPackLineItemsPayload = {
  __typename?: 'WontPackLineItemsPayload';
  orders?: Maybe<Array<Order>>;
};

/** Deal sheet fields for an order that is a deal sheet */
export type YieldDealSheetDetail = {
  __typename?: 'YieldDealSheetDetail';
  /** When the record was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Deal number */
  dealNumber?: Maybe<Scalars['String']['output']>;
  /** Gross sale */
  grossSale?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Associated order id */
  orderId: Scalars['ID']['output'];
  /** Payment terms */
  paymentTerms?: Maybe<Scalars['String']['output']>;
  /** Total buyer price */
  totalBuyerPrice?: Maybe<Scalars['Float']['output']>;
  /** Total producer price */
  totalProducerPrice?: Maybe<Scalars['Float']['output']>;
  /** The transport cost bearer */
  transportCostBearer?: Maybe<CompanyPersonaEnum>;
  /** Transport details for trucking */
  transportDetails?: Maybe<Scalars['JSON']['output']>;
  /** The transport organiser */
  transportOrganiser?: Maybe<CompanyPersonaEnum>;
  /** When the record was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** VAT */
  vat?: Maybe<Scalars['Float']['output']>;
};

/** Deal sheet fields for a line item that is part of a deal sheet */
export type YieldDealSheetLineItemDetail = {
  __typename?: 'YieldDealSheetLineItemDetail';
  /** Additional fees as key-value */
  additionalFees?: Maybe<Scalars['Json']['output']>;
  /** Commission */
  commission?: Maybe<Scalars['Float']['output']>;
  /** When the record was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Discount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Associated line item id */
  lineItemId: Scalars['ID']['output'];
  /** Pallet price */
  palletPrice?: Maybe<Scalars['Float']['output']>;
  /** Producer price per unit */
  producerPricePerUnit?: Maybe<Scalars['Float']['output']>;
  /** Sale price per unit */
  salePricePerUnit?: Maybe<Scalars['Float']['output']>;
  /** When the record was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};
